export const storesData = [
      {
        "id": 3180455,
        "identifier": "DE004117",
        "googlePlaceId": "ChIJPUOt_x5-sUcRUZPHWFHL99Y",
        "lat": 53.692663,
        "lng": 9.654724,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Uetersen",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Reuterstraße 115",
        "zip": "25436",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180456,
        "identifier": "DE013013",
        "googlePlaceId": "ChIJq7-G8UY_uUcRZ2AFsIFiFh4",
        "lat": 51.36525,
        "lng": 7.62025,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Iserlohn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "An Pater und Nonne 3A",
        "zip": "58642",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180457,
        "identifier": "DE036120",
        "googlePlaceId": "ChIJ4-5KSrdDCEcRMwSe4Tkuv0o",
        "lat": 51.439968,
        "lng": 14.246923,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hoyerswerda",
        "province": "Sachsen",
        "streetAndNumber": "Teschenstraße 1",
        "zip": "02977",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180458,
        "identifier": "DE010069",
        "googlePlaceId": "ChIJyZMGFlRZo0cRQGusI7UmSbg",
        "lat": 50.838612,
        "lng": 9.989726,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Philippsthal (Werra)",
        "province": "Hessen",
        "streetAndNumber": "Ulsterstraße 6",
        "zip": "36269",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180459,
        "identifier": "DE025051",
        "googlePlaceId": "ChIJPWNusqt4t0cRIGomBuKP2FU",
        "lat": 52.552617,
        "lng": 7.532264,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lengerich",
        "province": "Niedersachsen",
        "streetAndNumber": "Lütemannskamp 4",
        "zip": "49838",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180461,
        "identifier": "DE036117",
        "googlePlaceId": "ChIJRbNhgKRACEcRYnMcEanVPeI",
        "lat": 51.444885,
        "lng": 14.102303,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lauta",
        "province": "Sachsen",
        "streetAndNumber": "Friedensstraße 8",
        "zip": "02991",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180462,
        "identifier": "DE032131",
        "googlePlaceId": "ChIJQRWwUpG6uUcRmE18UiOALiI",
        "lat": 51.972514,
        "lng": 7.6112,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Münster",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Catharina-Müller-Straße 6",
        "zip": "48149",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180463,
        "identifier": "DE004124",
        "googlePlaceId": "ChIJgX8uWFbZs0cRf121jBxBLmA",
        "lat": 53.798843,
        "lng": 9.435066,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Glückstadt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Wiebeke-Kruse-Straße 5-7",
        "zip": "25348",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180464,
        "identifier": "DE016137",
        "googlePlaceId": "ChIJz1Mkv7-KrUcR9aCg3zSxAsc",
        "lat": 53.963373,
        "lng": 10.860446,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübeck",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Nordmeerstraße 100",
        "zip": "23570",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180465,
        "identifier": "DE005142",
        "googlePlaceId": "ChIJrYfQsFUDu0cRqWEk5z0g9DA",
        "lat": 51.575261,
        "lng": 9.243021,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Borgentreich",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Emmerkertorstraße 28",
        "zip": "34434",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180466,
        "identifier": "DE004035",
        "googlePlaceId": "ChIJ85MEE19Cs0cR239wMtGOj30",
        "lat": 54.79569,
        "lng": 9.4739,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Flensburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Engelsbyer Straße 33",
        "zip": "24943",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180468,
        "identifier": "DE006068",
        "googlePlaceId": "ChIJCQNWm435r0cRVrnrweP0d5k",
        "lat": 52.320473,
        "lng": 10.396822,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wendeburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Büssingstraße 1",
        "zip": "38176",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180470,
        "identifier": "DE005062",
        "googlePlaceId": "ChIJqe9CjCWYuUcRQF7iY7-UBZc",
        "lat": 51.924114,
        "lng": 7.839647,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Everswinkel",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Alverskirchener Straße 24",
        "zip": "48351",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180471,
        "identifier": "DE036122",
        "googlePlaceId": "ChIJ6wpx0VN0CEcREkqJjoK4Kb0",
        "lat": 51.781552,
        "lng": 14.31807,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Cottbus",
        "province": "Brandenburg",
        "streetAndNumber": "Limberger Straße 1",
        "zip": "03044",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180472,
        "identifier": "DE015006",
        "googlePlaceId": "ChIJzfBQQMBQtkcRFo2_WVBzUTc",
        "lat": 53.299713,
        "lng": 7.593169,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hesel",
        "province": "Niedersachsen",
        "streetAndNumber": "Im Brink 8",
        "zip": "26835",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180473,
        "identifier": "DE024085",
        "googlePlaceId": "ChIJBwowZ4lRqEcRM7EkazmsRg0",
        "lat": 52.542501,
        "lng": 13.378109,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Gerichtstraße 2-3",
        "zip": "13347",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3180474,
        "identifier": "DE002039",
        "googlePlaceId": "ChIJzZvgPTGpvkcRnZ43kl0OkZQ",
        "lat": 50.971212,
        "lng": 7.865066,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wenden",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hauptstraße 15-19",
        "zip": "57482",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180475,
        "identifier": "DE001062",
        "googlePlaceId": "ChIJW1MWYarmuEcRVB5X1TTjtlQ",
        "lat": 51.548957,
        "lng": 7.148858,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herne",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Resser Straße 29",
        "zip": "44653",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180477,
        "identifier": "DE004009",
        "googlePlaceId": "ChIJs_AY_zB-sUcROYIgCp7a3xU",
        "lat": 53.68079,
        "lng": 9.671806,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Uetersen",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Gerberstraße 1",
        "zip": "25436",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180478,
        "identifier": "DE024031",
        "googlePlaceId": "ChIJc9vy_RmdqUcRMgmGctvIxJA",
        "lat": 53.116528,
        "lng": 13.499411,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Templin",
        "province": "Brandenburg",
        "streetAndNumber": "Vietmannsdorfer Straße 2",
        "zip": "17268",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180479,
        "identifier": "DE005144",
        "googlePlaceId": "ChIJUzSz8X9ivEcR4LrSE-Fm5jg",
        "lat": 50.806979,
        "lng": 8.777234,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Marburg",
        "province": "Hessen",
        "streetAndNumber": "Erlenring 9",
        "zip": "35037",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180480,
        "identifier": "DE036060",
        "googlePlaceId": "ChIJIbxfP0xCp0cRvI-AcexK4EE",
        "lat": 50.912565,
        "lng": 13.043897,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Frankenberg/Sa.",
        "province": "Sachsen",
        "streetAndNumber": "Badstraße 2 a",
        "zip": "09669",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180481,
        "identifier": "DE005146",
        "googlePlaceId": "ChIJBeAx_LZivEcR6uhQVO2HdFo",
        "lat": 50.84253,
        "lng": 8.76878,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Marburg",
        "province": "Hessen",
        "streetAndNumber": "Tom-Mutters-Straße 9",
        "zip": "35041",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180482,
        "identifier": "DE004041",
        "googlePlaceId": "ChIJZz8o8aVCs0cRqnD-8O1r3hE",
        "lat": 54.77892,
        "lng": 9.415276,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Flensburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Friesische Straße 156",
        "zip": "24937",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180483,
        "identifier": "DE004148",
        "googlePlaceId": "ChIJ5c3FDzl_skcRr-pg5EuUMFg",
        "lat": 54.218523,
        "lng": 10.89847,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lensahn",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Dieselstraße 4",
        "zip": "23738",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180484,
        "identifier": "DE020016",
        "googlePlaceId": "ChIJtWPKosJYqEcRtyjah9lzsoY",
        "lat": 52.418798,
        "lng": 13.157362,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Königstraße 56 - 57",
        "zip": "14109",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180485,
        "identifier": "DE032088",
        "googlePlaceId": "ChIJ17DHYc7guEcR1J1CPK28L4U",
        "lat": 51.495301,
        "lng": 7.145784,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Günnigfelder Straße 56-58",
        "zip": "44866",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3180486,
        "identifier": "DE020043",
        "googlePlaceId": "ChIJQXWsvzhWqEcR3Gga0uzwYOs",
        "lat": 52.539359,
        "lng": 13.196749,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Galenstraße 35",
        "zip": "13597",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180487,
        "identifier": "DE002089",
        "googlePlaceId": "ChIJqTxLhe9BvEcRdyCSjrI9nZs",
        "lat": 50.697959,
        "lng": 8.404326,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Mittenaar",
        "province": "Hessen",
        "streetAndNumber": "An der B 255 3",
        "zip": "35756",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180488,
        "identifier": "DE003031",
        "googlePlaceId": "ChIJlVbr_ySOsUcRKVx2tvSKcZ8",
        "lat": 53.500662,
        "lng": 9.999927,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Dratelnstraße 23-25",
        "zip": "21109",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180489,
        "identifier": "DE021068",
        "googlePlaceId": "ChIJCfPEaQBZpkcRJtKIagNfWdo",
        "lat": 51.375583,
        "lng": 12.359869,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Max-Liebermann-Straße 19f",
        "zip": "04157",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180490,
        "identifier": "DE005112",
        "googlePlaceId": "ChIJZbJQCngUukcRie9jzfA17H8",
        "lat": 52.12676,
        "lng": 8.68366,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herford",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Waltgeristraße 93",
        "zip": "32049",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180492,
        "identifier": "DE024055",
        "googlePlaceId": "ChIJ1zTKYrw1qEcRHjugY25n3pk",
        "lat": 52.534886,
        "lng": 13.696472,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neuenhagen",
        "province": "Brandenburg",
        "streetAndNumber": "Carl-Schmäcke-Straße 29",
        "zip": "15366",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180493,
        "identifier": "DE031066",
        "googlePlaceId": "ChIJ2V7gCn6XpkcRLi38G1eKens",
        "lat": 51.148744,
        "lng": 11.824118,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Naumburg (Saale)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Franz-Julius-Hoeltz-Straße 3",
        "zip": "06618",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180494,
        "identifier": "DE004074",
        "googlePlaceId": "ChIJCe2TYcyOs0cRBs7Lk_tOO-E",
        "lat": 54.207739,
        "lng": 9.085904,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wesseln",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Am Ruthenstrom 2",
        "zip": "25746",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180495,
        "identifier": "DE024126",
        "googlePlaceId": "ChIJ6c0shuPRB0cR9mrFU4D6Un0",
        "lat": 51.954049,
        "lng": 14.703332,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Guben",
        "province": "Brandenburg",
        "streetAndNumber": "Karl-Marx-Straße 92",
        "zip": "03172",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180496,
        "identifier": "DE021060",
        "googlePlaceId": "ChIJfQwRyS3ToEcRUlGVqEVHNE8",
        "lat": 50.673132,
        "lng": 12.464173,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zwickau",
        "province": "Sachsen",
        "streetAndNumber": "Am Kreuzberg 69",
        "zip": "08064",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180497,
        "identifier": "DE003013",
        "googlePlaceId": "ChIJTXLqONfrsUcR2gobe1aLcas",
        "lat": 53.351959,
        "lng": 10.221334,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Winsen",
        "province": "Niedersachsen",
        "streetAndNumber": "Zum Torfmoor 13",
        "zip": "21423",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180498,
        "identifier": "DE010044",
        "googlePlaceId": "ChIJN6fRDg8_u0cRr4k2G8Yukqc",
        "lat": 51.331768,
        "lng": 9.456342,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kassel",
        "province": "Hessen",
        "streetAndNumber": "Wolfhager Straße 274",
        "zip": "34130",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180499,
        "identifier": "DE004121",
        "googlePlaceId": "ChIJ1zke50Lls0cRvIR-dtp1tVM",
        "lat": 53.9,
        "lng": 9.125642,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Brunsbüttel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Max-Planck-Straße 1-7",
        "zip": "25541",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180500,
        "identifier": "DE015011",
        "googlePlaceId": "ChIJY7O20Sqyt0cRN1gZ4nAYjZ4",
        "lat": 53.079798,
        "lng": 7.388686,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Papenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Stadtpark 24",
        "zip": "26871",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180501,
        "identifier": "DE015075",
        "googlePlaceId": "ChIJn4Z1-UPPtkcRCuYYF_P1bz8",
        "lat": 53.335043,
        "lng": 8.463568,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Brake (Unterweser)",
        "province": "Niedersachsen",
        "streetAndNumber": "Weserstraße 80",
        "zip": "26919",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180502,
        "identifier": "DE024016",
        "googlePlaceId": "ChIJt3UrotpMqEcR4nCDlx4micI",
        "lat": 52.6051017,
        "lng": 13.5246326,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ahrensfelde",
        "province": "Brandenburg",
        "streetAndNumber": "Bucher Weg 2",
        "zip": "16356",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180503,
        "identifier": "DE016148",
        "googlePlaceId": "ChIJGySeLS8KskcRr9GgOlxtoLE",
        "lat": 53.871188,
        "lng": 10.744708,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübeck",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Grootkoppel 5-7",
        "zip": "23566",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180504,
        "identifier": "DE021104",
        "googlePlaceId": "ChIJy6lqhUNkpkcRgU8b4uHrmVw",
        "lat": 51.511152,
        "lng": 12.051077,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Landsberg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Saarbrücker Straße 1",
        "zip": "06188",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180505,
        "identifier": "DE026007",
        "googlePlaceId": "ChIJt0MZoAQNr0cRo9MMQoB1-e0",
        "lat": 52.52941,
        "lng": 11.411353,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gardelegen",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Stendaler Straße 89",
        "zip": "39638",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180506,
        "identifier": "DE016029",
        "googlePlaceId": "ChIJ_wWgFb_7sUcRgDddhmEuS5g",
        "lat": 53.513458,
        "lng": 10.49503,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwarzenbek",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hans-Koch-Ring 4",
        "zip": "21493",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180507,
        "identifier": "DE020013",
        "googlePlaceId": "ChIJvzsfwdsyqUcRFq79wg3G1tg",
        "lat": 52.953663,
        "lng": 12.39727,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kyritz",
        "province": "Brandenburg",
        "streetAndNumber": "Pritzwalker Straße 46 b",
        "zip": "16866",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180510,
        "identifier": "DE003101",
        "googlePlaceId": "ChIJ8bgItb5bsUcRw02n9Q5Ceso",
        "lat": 53.625104,
        "lng": 9.090002,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lamstedt",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Galgenberg 1",
        "zip": "21769",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180512,
        "identifier": "DE020089",
        "googlePlaceId": "ChIJ324yl1hQqEcRZPS7UMyx1NE",
        "lat": 52.493398,
        "lng": 13.332398,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Prager Platz 1-3",
        "zip": "10779",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180513,
        "identifier": "DE020022",
        "googlePlaceId": "ChIJo6Wv4YFaqEcRmAZC0QEMk-4",
        "lat": 52.46393,
        "lng": 13.326778,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Schloßstraße 4-5",
        "zip": "12163",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180514,
        "identifier": "DE025028",
        "googlePlaceId": "ChIJqerU4Zeht0cRZYBOqrGwLNQ",
        "lat": 52.838758,
        "lng": 7.521754,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sögel",
        "province": "Niedersachsen",
        "streetAndNumber": "Knippers Kohlenhof 3",
        "zip": "49751",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180515,
        "identifier": "DE024051",
        "googlePlaceId": "ChIJy9SSvOeyqUcRSZq0K8HcLsw",
        "lat": 52.640651,
        "lng": 13.514909,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Zepernicker Straße 10",
        "zip": "13125",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180516,
        "identifier": "DE003076",
        "googlePlaceId": "ChIJhc_OCPPxsUcRZV5g3HYtvHc",
        "lat": 53.486548,
        "lng": 10.288662,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Börnsen",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Zwischen den Kreiseln 10",
        "zip": "21039",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180517,
        "identifier": "DE016098",
        "googlePlaceId": "ChIJ9Wdo5daFsUcRHFg1Y_NBKkc",
        "lat": 53.58693,
        "lng": 9.87753,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Luruper Hauptstraße 79",
        "zip": "22547",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180518,
        "identifier": "DE025089",
        "googlePlaceId": "ChIJp4ZjmaDluUcRL_kTDssWXxA",
        "lat": 52.280964,
        "lng": 8.066584,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Osnabrück",
        "province": "Niedersachsen",
        "streetAndNumber": "Bohmter Straße 64-64c",
        "zip": "49074",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180521,
        "identifier": "DE026001",
        "googlePlaceId": "ChIJ_S3vj9ySpUcRwGx7QljuUlg",
        "lat": 51.944062,
        "lng": 11.429063,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Egeln",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Am Busbahnhof 1",
        "zip": "39435",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180522,
        "identifier": "DE013062",
        "googlePlaceId": "ChIJ5W4CbHIjuUcRtJqN06eDsfM",
        "lat": 51.380402,
        "lng": 7.391826,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wetter (Ruhr)",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Schöntaler Straße 44b",
        "zip": "58300",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180523,
        "identifier": "DE005117",
        "googlePlaceId": "ChIJdZIvDQoNukcRIyGf4IAmrk4",
        "lat": 52.219948,
        "lng": 8.705491,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Löhne-Mennighüffen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lübbecker Straße 159 a",
        "zip": "32584",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180524,
        "identifier": "DE015037",
        "googlePlaceId": "ChIJJ_wDYDK4tkcRQBWvd4Jpf0M",
        "lat": 53.477414,
        "lng": 8.470957,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nordenham",
        "province": "Niedersachsen",
        "streetAndNumber": "Mittelweg 105",
        "zip": "26954",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180525,
        "identifier": "DE036111",
        "googlePlaceId": "ChIJj70V31tGp0cRxcZUqUmP45I",
        "lat": 50.834626,
        "lng": 12.918988,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Chemnitz",
        "province": "Sachsen",
        "streetAndNumber": "Theaterstraße 7",
        "zip": "09111",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180526,
        "identifier": "DE002009",
        "googlePlaceId": "ChIJY7CzhqlJuUcRjjfQjm2MsD4",
        "lat": 51.217801,
        "lng": 7.653633,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lüdenscheid",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bräuckenstraße 83",
        "zip": "58511",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180527,
        "identifier": "DE004147",
        "googlePlaceId": "ChIJ7SQcoO1vskcRAM6d1MwhUTw",
        "lat": 54.127956,
        "lng": 10.622633,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eutin",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Johann-Specht-Straße 5 A",
        "zip": "23701",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180528,
        "identifier": "DE031037",
        "googlePlaceId": "ChIJbT6QiKuSpEcRzetiyTezWZ4",
        "lat": 51.211892,
        "lng": 10.463521,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Mühlhausen",
        "province": "Thüringen",
        "streetAndNumber": "Kreuzgraben 5",
        "zip": "99974",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180530,
        "identifier": "DE005091",
        "googlePlaceId": "ChIJrw3_VWFtukcR5vJonBLEKpc",
        "lat": 52.197676,
        "lng": 8.811244,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Oeynhausen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Weserstraße 17",
        "zip": "32545",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180531,
        "identifier": "DE006094",
        "googlePlaceId": "ChIJ85G1dVMPsEcRS73WY-sKSFo",
        "lat": 52.369819,
        "lng": 9.973004,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lehrte",
        "province": "Niedersachsen",
        "streetAndNumber": "Iltener Straße 11-15",
        "zip": "31275",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180532,
        "identifier": "DE006160",
        "googlePlaceId": "ChIJp0nOU19jsEcRB41sRRIq2YQ",
        "lat": 52.512811,
        "lng": 9.451549,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neustadt am Rübenberge",
        "province": "Niedersachsen",
        "streetAndNumber": "Erika-Najork-Straße 2",
        "zip": "31535",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180533,
        "identifier": "DE020007",
        "googlePlaceId": "ChIJfV1jLJBPqEcRUDDgrKffSsA",
        "lat": 52.465608,
        "lng": 13.422191,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Silbersteinstraße 146",
        "zip": "12051",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180534,
        "identifier": "DE026056",
        "googlePlaceId": "ChIJ0VZ25X6LpUcRDLKK8RxdED0",
        "lat": 52.063474,
        "lng": 11.449317,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wanzleben-Börde",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Bucher Weg 10",
        "zip": "39164",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180536,
        "identifier": "DE005046",
        "googlePlaceId": "ChIJT-yOhoL-ukcRb7c4LZitIM0",
        "lat": 51.71318,
        "lng": 9.181062,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Brakel",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Sudheimer Weg 5",
        "zip": "33034",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180537,
        "identifier": "DE004133",
        "googlePlaceId": "ChIJicyRGEbUs0cRAwB3WxyQXjQ",
        "lat": 53.742528,
        "lng": 9.710996,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Elmshorn",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Ramskamp 102",
        "zip": "25337",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180538,
        "identifier": "DE010081",
        "googlePlaceId": "ChIJc25cbrcupUcR7DDBvoEmmaU",
        "lat": 51.68094,
        "lng": 10.109563,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Katlenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Albrechtshäuser Weg 1",
        "zip": "37191",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180539,
        "identifier": "DE031076",
        "googlePlaceId": "ChIJSVmCtGzPpkcRtsJFl03770U",
        "lat": 50.867273,
        "lng": 12.078588,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gera",
        "province": "Thüringen",
        "streetAndNumber": "Hinter dem Südbahnhof 1",
        "zip": "07548",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180540,
        "identifier": "DE016110",
        "googlePlaceId": "ChIJlQa0DcMJskcRl1UaxL2-3vE",
        "lat": 53.83814,
        "lng": 10.75918,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lüdersdorf",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Bahnhofstraße 2",
        "zip": "23923",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180541,
        "identifier": "DE003080",
        "googlePlaceId": "ChIJxypEtBParUcRDOqDQqjaLjA",
        "lat": 53.64451,
        "lng": 11.424314,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwerin",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Güstrower Straße 34",
        "zip": "19055",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180542,
        "identifier": "DE021007",
        "googlePlaceId": "ChIJI0ELQf5XpkcRgSqomcfm1Tk",
        "lat": 51.367029,
        "lng": 12.385414,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Delitzscher Straße 61",
        "zip": "04129",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180544,
        "identifier": "DE026005",
        "googlePlaceId": "ChIJP1kgmTb0pUcRqGo6emYZFwo",
        "lat": 52.083767,
        "lng": 11.600049,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Magdeburg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Salbker Chaussee 67-71",
        "zip": "39118",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180545,
        "identifier": "DE016086",
        "googlePlaceId": "ChIJA1Z_rqCIsUcRAc1UBGCn9k4",
        "lat": 53.599955,
        "lng": 9.958472,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Grelckstraße 2",
        "zip": "22529",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180546,
        "identifier": "DE036007",
        "googlePlaceId": "ChIJTzUmht_hCUcRJRnxMLPo4cU",
        "lat": 50.857989292747,
        "lng": 13.320831864451,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Brand-Erbisdorf",
        "province": "Sachsen",
        "streetAndNumber": "Großhartmannsdorfer Straße 13a",
        "zip": "09618",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180547,
        "identifier": "DE031025",
        "googlePlaceId": "ChIJ0crSJjp1o0cRKKo5o9s-nw4",
        "lat": 50.584958,
        "lng": 10.413407,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Meiningen",
        "province": "Thüringen",
        "streetAndNumber": "Leipziger Straße 82",
        "zip": "98617",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180548,
        "identifier": "DE005022",
        "googlePlaceId": "ChIJKwCLMhQ9ukcRv-hHm1g-DL4",
        "lat": 52.026558,
        "lng": 8.528028,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Große-Kurfürsten-Straße 66",
        "zip": "33615",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180551,
        "identifier": "DE002084",
        "googlePlaceId": "ChIJyeksZkAtuUcRF1gFW80Hm48",
        "lat": 51.135839,
        "lng": 7.340941,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hückeswagen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Stahlschmidtsbrücke 15",
        "zip": "42499",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180552,
        "identifier": "DE010002",
        "googlePlaceId": "ChIJT9KCBF0hpUcRlgsHLLORmQY",
        "lat": 51.649795,
        "lng": 10.331592,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herzberg am Harz",
        "province": "Niedersachsen",
        "streetAndNumber": "Bahnhofstraße 2",
        "zip": "37412",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180553,
        "identifier": "DE002093",
        "googlePlaceId": "ChIJY8aELLAcvEcRmUBVctvyhow",
        "lat": 50.894986,
        "lng": 8.035531,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Siegen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Känerbergstraße 16",
        "zip": "57076",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180555,
        "identifier": "DE004103",
        "googlePlaceId": "ChIJX5MyNb5XskcRjdhvakFidJs",
        "lat": 54.329084,
        "lng": 10.198443,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Schönkirchener Straße 80 b",
        "zip": "24149",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180556,
        "identifier": "DE006057",
        "googlePlaceId": "ChIJ43Q7Gn_-r0cRvIXBQwBI5eU",
        "lat": 52.340436,
        "lng": 10.25734,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Peine",
        "province": "Niedersachsen",
        "streetAndNumber": "Caroline-Herschel-Straße 1",
        "zip": "31228",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180557,
        "identifier": "DE005052",
        "googlePlaceId": "ChIJB_De8e87ukcRyaAenkC0mLc",
        "lat": 51.951949,
        "lng": 8.570157,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hansestraße 1",
        "zip": "33689",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180558,
        "identifier": "DE010100",
        "googlePlaceId": "ChIJAXHars_oukcRTrksz73ONrM",
        "lat": 51.842754,
        "lng": 9.465697,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Holzminden",
        "province": "Niedersachsen",
        "streetAndNumber": "Kopernikusstraße 13",
        "zip": "37603",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180559,
        "identifier": "DE003102",
        "googlePlaceId": "ChIJ3YNCh--XsUcRBdNQDE3Zg24",
        "lat": 53.338399,
        "lng": 9.87946,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Buchholz in der Nordheide",
        "province": "Niedersachsen",
        "streetAndNumber": "Hamburger Straße 85",
        "zip": "21244",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180560,
        "identifier": "DE001048",
        "googlePlaceId": "ChIJu_MOpzDjuEcRtaPIOw5e_SE",
        "lat": 51.620706,
        "lng": 7.205172,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Recklinghausen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Oerweg 50",
        "zip": "45657",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180561,
        "identifier": "DE010113",
        "googlePlaceId": "ChIJgVLj9kglpUcRG0LDqfnZ5cM",
        "lat": 51.736196,
        "lng": 10.23831,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Osterode am Harz",
        "province": "Niedersachsen",
        "streetAndNumber": "Lindenstraße 26",
        "zip": "37520",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180562,
        "identifier": "DE024019",
        "googlePlaceId": "ChIJ1Z_Bsm94B0cRuojdKt7HypU",
        "lat": 52.527983,
        "lng": 14.36516,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Seelow",
        "province": "Brandenburg",
        "streetAndNumber": "Diedersdorfer Straße 12B",
        "zip": "15306",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180563,
        "identifier": "DE031018",
        "googlePlaceId": "ChIJQ3__s9U9pEcR9yblVtaRegI",
        "lat": 51.18199,
        "lng": 11.250714,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kölleda",
        "province": "Thüringen",
        "streetAndNumber": "Weimarische Straße 1 A",
        "zip": "99625",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180564,
        "identifier": "DE010102",
        "googlePlaceId": "ChIJN34XlauUukcRFaziyom77OQ",
        "lat": 51.981809,
        "lng": 9.504167,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bodenwerder",
        "province": "Niedersachsen",
        "streetAndNumber": "Ernst-Reuter-Straße 6",
        "zip": "37619",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180565,
        "identifier": "DE013105",
        "googlePlaceId": "ChIJl9x07aTxu0cRNcg66w23kz4",
        "lat": 51.184199,
        "lng": 8.320793,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schmallenberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Alter Bahnhof 26",
        "zip": "57392",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180566,
        "identifier": "DE001016",
        "googlePlaceId": "ChIJGQB62zPhuEcRffOxh5YNyD0",
        "lat": 51.523487,
        "lng": 7.153335,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herne",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Berliner Straße 12",
        "zip": "44652",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180567,
        "identifier": "DE020080",
        "googlePlaceId": "ChIJgTFDBFlLqUcRGf_DrWWLU8Q",
        "lat": 53.163946,
        "lng": 12.493521,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wittstock",
        "province": "Brandenburg",
        "streetAndNumber": "Röbeler Straße 1",
        "zip": "16909",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180568,
        "identifier": "DE006030",
        "googlePlaceId": "ChIJYbQJhw-qukcRW1uqmIxEBMk",
        "lat": 52.262355,
        "lng": 10.073558,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hohenhameln",
        "province": "Niedersachsen",
        "streetAndNumber": "Meierkamp 2",
        "zip": "31249",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180570,
        "identifier": "DE036036",
        "googlePlaceId": "ChIJE-IcNDDOCUcR4b1ssicWG80",
        "lat": 51.09867,
        "lng": 13.687891,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Radebeul",
        "province": "Sachsen",
        "streetAndNumber": "Meißner Straße 47A",
        "zip": "01445",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180571,
        "identifier": "DE007008",
        "googlePlaceId": "ChIJH-NFpVHXsEcRKvX092V59io",
        "lat": 52.986199,
        "lng": 8.786094,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Weyhe",
        "province": "Niedersachsen",
        "streetAndNumber": "Bremer Straße 50",
        "zip": "28844",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180572,
        "identifier": "DE029072",
        "googlePlaceId": "ChIJ0wK_txn5q0cRhGLK1xGx6Js",
        "lat": 53.516167,
        "lng": 12.681856,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Waren (Müritz)",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "F.-Wilhelm-Raiffeisen-Straße 1b",
        "zip": "17192",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180573,
        "identifier": "DE005049",
        "googlePlaceId": "ChIJibuqZ5U8ukcRs8fAdjw3i7o",
        "lat": 51.988408,
        "lng": 8.513318,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hauptstraße 53",
        "zip": "33647",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180574,
        "identifier": "DE005148",
        "googlePlaceId": "ChIJ4cG1NVaKvEcRf_qraX3z7Qk",
        "lat": 50.724036,
        "lng": 8.796019,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ebsdorfergrund",
        "province": "Hessen",
        "streetAndNumber": "Hachborner Straße 2B",
        "zip": "35085",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180575,
        "identifier": "DE013028",
        "googlePlaceId": "ChIJe6QpolhxuUcRVD2VugvcuYc",
        "lat": 51.660976,
        "lng": 7.833664,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamm",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Werler Straße 244",
        "zip": "59063",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180576,
        "identifier": "DE020100",
        "googlePlaceId": "ChIJWbAJLgNGqEcRr95DGP-gfN0",
        "lat": 52.442209,
        "lng": 13.505704,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Sterndamm 140",
        "zip": "12487",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180577,
        "identifier": "DE025047",
        "googlePlaceId": "ChIJvZOrJ7iVt0cRBxw7J_7xXF0",
        "lat": 52.793876,
        "lng": 7.226432,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Haren (Ems)",
        "province": "Niedersachsen",
        "streetAndNumber": "Rütenbrocker Straße 24",
        "zip": "49733",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180578,
        "identifier": "DE026023",
        "googlePlaceId": "ChIJU_bBZg76pUcRtqNl0MSGFj4",
        "lat": 52.016391,
        "lng": 11.733053,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schönebeck",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Schillerstraße 11",
        "zip": "39218",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180579,
        "identifier": "DE029038",
        "googlePlaceId": "ChIJxRsLWXeuq0cRLaKRvpw5usk",
        "lat": 53.859458,
        "lng": 13.693947,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Anklam",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Silostraße 3A",
        "zip": "17389",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180580,
        "identifier": "DE025074",
        "googlePlaceId": "ChIJm0SFWubRuUcRtu7CjuV2YEk",
        "lat": 52.296102,
        "lng": 7.593287,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hörstel",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Dürerstraße 11",
        "zip": "48477",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180581,
        "identifier": "DE020030",
        "googlePlaceId": "ChIJy5ZcypJWqEcRvoM46nj5kQk",
        "lat": 52.541142,
        "lng": 13.24854,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Paulsternstraße 20",
        "zip": "13599",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180582,
        "identifier": "DE013046",
        "googlePlaceId": "ChIJT0-Qd5Hku0cRFWcXtk2L6fw",
        "lat": 52.550582,
        "lng": 13.44236,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eslohe",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Tölckestraße 6",
        "zip": "59889",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180585,
        "identifier": "DE006163",
        "googlePlaceId": "ChIJRS-NDvaEsEcRY53Febyao4A",
        "lat": 52.4615,
        "lng": 9.144593,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rehburg-Loccum",
        "province": "Niedersachsen",
        "streetAndNumber": "Leeser Straße 33",
        "zip": "31547",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180586,
        "identifier": "DE010056",
        "googlePlaceId": "ChIJPaOY3AaQvEcR3z1Ii69LPGc",
        "lat": 50.82671,
        "lng": 9.010932,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stadtallendorf",
        "province": "Hessen",
        "streetAndNumber": "Herrenwaldstraße 6b",
        "zip": "35260",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180587,
        "identifier": "DE002092",
        "googlePlaceId": "ChIJBzW5HJ4cvEcRmI2pOWCa9ak",
        "lat": 50.87709,
        "lng": 8.043362,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Siegen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Marienborner Straße 259",
        "zip": "57074",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180588,
        "identifier": "DE002011",
        "googlePlaceId": "ChIJQ2smzlcquUcRBJX8--w3x5k",
        "lat": 51.166919,
        "lng": 7.202483,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Remscheid",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Burger Straße 85a",
        "zip": "42859",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180589,
        "identifier": "DE025083",
        "googlePlaceId": "ChIJmcMA60NHuEcRmKUEjFmW1iI",
        "lat": 52.140314,
        "lng": 7.212252,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Metelen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Schöppingener Straße 12",
        "zip": "48629",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180590,
        "identifier": "DE025039",
        "googlePlaceId": "ChIJH0_GDfRDt0cRO0H5jrZMHao",
        "lat": 52.664852,
        "lng": 8.118048,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dinklage",
        "province": "Niedersachsen",
        "streetAndNumber": "Quakenbrücker Straße 6",
        "zip": "49413",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180591,
        "identifier": "DE020042",
        "googlePlaceId": "ChIJQWSEVahFqEcRUdDYMWs6qBc",
        "lat": 52.418995,
        "lng": 13.422102,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Marienfelder Chaussee 29",
        "zip": "12349",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180592,
        "identifier": "DE004100",
        "googlePlaceId": "ChIJIydSYK-ms0cRLcjS41e3stg",
        "lat": 54.323417,
        "lng": 9.628805,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rendsburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Friedrichstädter Straße 57A",
        "zip": "24768",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180593,
        "identifier": "DE026076",
        "googlePlaceId": "ChIJUYMLM6x0pkcR-AANZFP9uUI",
        "lat": 51.748467,
        "lng": 11.949059,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Köthen (Anhalt)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Konrad-Adenauer-Allee 3",
        "zip": "06366",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180594,
        "identifier": "DE031043",
        "googlePlaceId": "ChIJBT8DQx2KpEcRCaMheWyLK3Q",
        "lat": 51.104709,
        "lng": 10.658163,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Langensalza",
        "province": "Thüringen",
        "streetAndNumber": "Tonnaer Straße 36A",
        "zip": "99947",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180595,
        "identifier": "DE007034",
        "googlePlaceId": "ChIJQ2xrpfQxt0cRTB5qxzsosfw",
        "lat": 52.898986,
        "lng": 8.417463,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wildeshausen",
        "province": "Niedersachsen",
        "streetAndNumber": "Dr.-Dürr-Straße 12",
        "zip": "27793",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180596,
        "identifier": "DE031047",
        "googlePlaceId": "ChIJm-M2PwCbpkcR2CdmctkUpUk",
        "lat": 51.220107,
        "lng": 11.772655,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Freyburg (Unstrut)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Friedhofsweg 2",
        "zip": "06632",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180597,
        "identifier": "DE020031",
        "googlePlaceId": "ChIJAwdY2B5FqEcR_MhgTsqXUns",
        "lat": 52.418826,
        "lng": 13.391576,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Richard-Tauber-Damm 6",
        "zip": "12277",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180598,
        "identifier": "DE010108",
        "googlePlaceId": "ChIJla056wZSpUcRv-dJ4YtZu20",
        "lat": 52.092767,
        "lng": 10.218832,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Baddeckenstedt",
        "province": "Niedersachsen",
        "streetAndNumber": "Heinrich-Nordhoff-Straße 3",
        "zip": "38271",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180599,
        "identifier": "DE016008",
        "googlePlaceId": "ChIJNX6qi22JsUcRq0Cx8jdEX4o",
        "lat": 53.607619,
        "lng": 10.05612,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Steilshooper Straße 317",
        "zip": "22309",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180600,
        "identifier": "DE021122",
        "googlePlaceId": "ChIJ28cDoxeJp0cRrnUmSWvQghE",
        "lat": 51.465588,
        "lng": 13.534478,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Elsterwerda",
        "province": "Brandenburg",
        "streetAndNumber": "Lauchhammer Straße 60",
        "zip": "04910",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180601,
        "identifier": "DE003009",
        "googlePlaceId": "ChIJM2msydBesUcRL23r0rJzrfs",
        "lat": 53.68363,
        "lng": 9.160865,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hemmoor",
        "province": "Niedersachsen",
        "streetAndNumber": "Otto-Peschel-Straße 14-16",
        "zip": "21745",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180602,
        "identifier": "DE013093",
        "googlePlaceId": "ChIJBWjKXl31u0cRq9qUNtj_rnk",
        "lat": 51.054498,
        "lng": 8.393915,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Berleburg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Poststraße 59",
        "zip": "57319",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180603,
        "identifier": "DE001059",
        "googlePlaceId": "ChIJyVDIU4XkuEcRzF0SGIvYMyQ",
        "lat": 51.602695,
        "lng": 7.156325,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Zum alten Schacht 4",
        "zip": "45699",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180604,
        "identifier": "DE010106",
        "googlePlaceId": "ChIJP0_Db3G7ukcRfXdokRTKAo0",
        "lat": 52.089959,
        "lng": 9.787862,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gronau (Leine)",
        "province": "Niedersachsen",
        "streetAndNumber": "Bethelner Landstraße 24",
        "zip": "31028",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180605,
        "identifier": "DE002037",
        "googlePlaceId": "ChIJk-um1wtFuUcRkYnBPE1OJS0",
        "lat": 51.282208824386,
        "lng": 7.7891692852452,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neuenrade",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bahnhofstraße 28",
        "zip": "58809",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180607,
        "identifier": "DE029089",
        "googlePlaceId": "ChIJ6d_CymLmrUcRCOyQ7q5Ui6g",
        "lat": 53.701698,
        "lng": 11.112146,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gadebusch",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Johann-Stelling-Straße 22 d",
        "zip": "19205",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180608,
        "identifier": "DE025099",
        "googlePlaceId": "ChIJgUTgNzfhuUcRg1x1EHcOt38",
        "lat": 52.355866,
        "lng": 7.998947,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wallenhorst",
        "province": "Niedersachsen",
        "streetAndNumber": "Hansastraße 5",
        "zip": "49134",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180609,
        "identifier": "DE016138",
        "googlePlaceId": "ChIJo2CHtRcMskcRs3moFzOfXvY",
        "lat": 53.887988,
        "lng": 10.648366,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stockelsdorf",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Rathausmarkt 3 b",
        "zip": "23617",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180610,
        "identifier": "DE026031",
        "googlePlaceId": "ChIJ3Snix0S1qEcRWKDFOlUxvAI",
        "lat": 52.409218,
        "lng": 12.151116,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Genthin",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Bergzower Straße 6",
        "zip": "39307",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180611,
        "identifier": "DE007088",
        "googlePlaceId": "ChIJGZ7OwJbTtkcRGPNrcIMKznM",
        "lat": 53.198104,
        "lng": 8.572399,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Schwaneweder Straße 27",
        "zip": "28779",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180613,
        "identifier": "DE015067",
        "googlePlaceId": "ChIJiTyWlL_ftkcRU5zABYKn3BY",
        "lat": 53.182644,
        "lng": 8.229794,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oldenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Stubbenweg 31",
        "zip": "26125",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180614,
        "identifier": "DE016031",
        "googlePlaceId": "ChIJBXKwX2qMsUcRALen1vcNJPU",
        "lat": 53.557462,
        "lng": 10.102968,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Querkamp 69",
        "zip": "22119",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180615,
        "identifier": "DE004077",
        "googlePlaceId": "ChIJedZM6Dtgs0cRUH4jmk4vT8s",
        "lat": 54.762367,
        "lng": 9.169578,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schafflund",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hauptstraße 96",
        "zip": "24980",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180616,
        "identifier": "DE010079",
        "googlePlaceId": "ChIJgzddcftDu0cR2lJvldFpwqU",
        "lat": 51.210877,
        "lng": 9.449096,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Edermünde",
        "province": "Hessen",
        "streetAndNumber": "Zur Mühle 10",
        "zip": "34295",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180617,
        "identifier": "DE004039",
        "googlePlaceId": "ChIJs45-hTTzs0cR1UzbucroUCc",
        "lat": 54.091284,
        "lng": 9.079204,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Meldorf",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Raiffeisenplatz 14",
        "zip": "25704",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180618,
        "identifier": "DE029042",
        "googlePlaceId": "ChIJUW3dknw_rEcREDuJLJW5SxM",
        "lat": 53.809585,
        "lng": 12.191132,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Güstrow",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Ebereschenweg 1e",
        "zip": "18273",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180619,
        "identifier": "DE005006",
        "googlePlaceId": "ChIJIyt2y5E_ukcRzsEkchcDqbE",
        "lat": 52.011085,
        "lng": 8.700366,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leopoldshöhe",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bürgermeister-Brinkmann-Weg 4",
        "zip": "33818",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180620,
        "identifier": "DE013069",
        "googlePlaceId": "ChIJHeVzZGBgvEcRePqw3dsGN6I",
        "lat": 50.709226,
        "lng": 8.697303,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Fronhausen",
        "province": "Hessen",
        "streetAndNumber": "Im Boden 2-4",
        "zip": "35112",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180621,
        "identifier": "DE029055",
        "googlePlaceId": "ChIJffEWgSJWrEcRCEkomF2INqg",
        "lat": 54.16939,
        "lng": 12.083483,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rostock",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Lortzingstraße 19a",
        "zip": "18119",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180623,
        "identifier": "DE031079",
        "googlePlaceId": "ChIJxZASGLa5pkcRVfRjd1OPA68",
        "lat": 50.964539,
        "lng": 11.884642,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eisenberg",
        "province": "Thüringen",
        "streetAndNumber": "Saasaer Straße 1",
        "zip": "07607",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180624,
        "identifier": "DE021048",
        "googlePlaceId": "ChIJ9TqVKBBTpkcRz6ApnFvc_u0",
        "lat": 51.457591,
        "lng": 12.613735,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eilenburg",
        "province": "Sachsen",
        "streetAndNumber": "Bergstraße 32",
        "zip": "04838",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180625,
        "identifier": "DE005066",
        "googlePlaceId": "ChIJ19QxPDSQuUcR0jo77IkjpRQ",
        "lat": 51.95709,
        "lng": 8.005889,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Warendorf",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Sassenberger Straße 57",
        "zip": "48231",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180627,
        "identifier": "DE005007",
        "googlePlaceId": "ChIJn6JnZZhLukcRfZbAUKVw1eg",
        "lat": 51.748904,
        "lng": 8.718594,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Paderborn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hatzfelder Straße 22-24",
        "zip": "33104",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180628,
        "identifier": "DE006105",
        "googlePlaceId": "ChIJ5eWxvG2vukcRm2G-5K_ZQq8",
        "lat": 52.167875,
        "lng": 9.934141,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hildesheim",
        "province": "Niedersachsen",
        "streetAndNumber": "Ernst-Morsch-Straße 9",
        "zip": "31137",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180629,
        "identifier": "DE015005",
        "googlePlaceId": "ChIJqQkh--i5tkcRzQsYjldlyoY",
        "lat": 53.503926,
        "lng": 8.479322,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nordenham",
        "province": "Niedersachsen",
        "streetAndNumber": "Atenser Allee 142",
        "zip": "26954",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180631,
        "identifier": "DE032054",
        "googlePlaceId": "ChIJdxaMb8IduUcR9v3ugH6zSGI",
        "lat": 51.555316,
        "lng": 7.293073,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Castrop-Rauxel",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Landwehrbach 7",
        "zip": "44575",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180632,
        "identifier": "DE036095",
        "googlePlaceId": "ChIJT7jGaiJHp0cRq5GiDrJobdA",
        "lat": 50.864013,
        "lng": 12.902503,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Chemnitz",
        "province": "Sachsen",
        "streetAndNumber": "Bornaer Straße 148",
        "zip": "09114",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180633,
        "identifier": "DE024026",
        "googlePlaceId": "ChIJa8Iai7QnqkcRBt_yJZlYL3c",
        "lat": 53.320032,
        "lng": 13.857246,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Prenzlau",
        "province": "Brandenburg",
        "streetAndNumber": "Kietzstraße 20",
        "zip": "17291",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180634,
        "identifier": "DE015046",
        "googlePlaceId": "ChIJIcFfo37itkcRtaUxlkf0Ydk",
        "lat": 53.127967,
        "lng": 7.981068,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Edewecht",
        "province": "Niedersachsen",
        "streetAndNumber": "Bahnhofstraße 5",
        "zip": "26188",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180635,
        "identifier": "DE016068",
        "googlePlaceId": "ChIJo4QUsgMaskcR6GX6Bia8Ldg",
        "lat": 53.800714,
        "lng": 10.40208,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Oldesloe",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Lily-Braun-Straße 18 - 22",
        "zip": "23843",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180636,
        "identifier": "DE026065",
        "googlePlaceId": "ChIJVaLnJLcWpkcR_xo5eC2BxYw",
        "lat": 51.824557,
        "lng": 12.242406,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dessau-Roßlau",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Franzstraße 159",
        "zip": "06842",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180637,
        "identifier": "DE032118",
        "googlePlaceId": "ChIJ2SeUULO1uUcRsN010Py76tU",
        "lat": 52.081555,
        "lng": 7.476727,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nordwalde",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Felix-Fraling-Straße 16",
        "zip": "48356",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180638,
        "identifier": "DE020027",
        "googlePlaceId": "ChIJKyBDxyFWqEcRKG3oEcL8ILs",
        "lat": 52.546077,
        "lng": 13.177967,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Salchendorfer Weg 1",
        "zip": "13583",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180639,
        "identifier": "DE005114",
        "googlePlaceId": "ChIJsQJuuIUSukcRQh2HCQxbK8g",
        "lat": 52.200554,
        "lng": 8.729089,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Löhne",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Albert-Schweitzer-Straße 37",
        "zip": "32584",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180640,
        "identifier": "DE001056",
        "googlePlaceId": "ChIJDy_f62ZQuEcRcJr1gsW5ASY",
        "lat": 51.937661,
        "lng": 7.166548,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Coesfeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hansestraße 6",
        "zip": "48653",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180641,
        "identifier": "DE036042",
        "googlePlaceId": "ChIJtTnUig7RCUcR3iFI2KdRZcY",
        "lat": 51.113217,
        "lng": 13.613052,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Radebeul",
        "province": "Sachsen",
        "streetAndNumber": "Weinböhlaer Straße 9",
        "zip": "01445",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180644,
        "identifier": "DE004042",
        "googlePlaceId": "ChIJYz50pQ4zskcRg-htpBA-tS4",
        "lat": 53.911997,
        "lng": 9.880446,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Bramstedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hamburger Straße 36-38",
        "zip": "24576",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180645,
        "identifier": "DE004026",
        "googlePlaceId": "ChIJbdJh06xVskcRmTMLU8MGjxw",
        "lat": 54.322075,
        "lng": 10.05399,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Kurt-Schumacher-Platz 4",
        "zip": "24109",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180646,
        "identifier": "DE007043",
        "googlePlaceId": "ChIJt_ghUmcpsUcRhKPhTXdGTic",
        "lat": 53.13469,
        "lng": 8.736747,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Ritterhuder Heerstraße 6",
        "zip": "28239",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180647,
        "identifier": "DE006109",
        "googlePlaceId": "ChIJdV_gZhCuukcRjMMEuZ6b1NY",
        "lat": 52.120519,
        "lng": 9.989734,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hildesheim",
        "province": "Niedersachsen",
        "streetAndNumber": "In der Schratwanne 36",
        "zip": "31141",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180648,
        "identifier": "DE020088",
        "googlePlaceId": "ChIJNQZis2VQqEcRqjk7Uoi1ZwM",
        "lat": 52.4787,
        "lng": 13.335889,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Wexstraße 16-18",
        "zip": "10715",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180649,
        "identifier": "DE016044",
        "googlePlaceId": "ChIJN9Y3_SiBsUcRLNULy90iLt0",
        "lat": 53.634574,
        "lng": 9.837821,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Halstenbek",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hartkirchener Chaussee 14",
        "zip": "25469",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180650,
        "identifier": "DE016123",
        "googlePlaceId": "ChIJ78IGPQ0MskcRQ_Mvd-RSjv4",
        "lat": 53.892888,
        "lng": 10.667209,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübeck",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Friedhofsallee 144",
        "zip": "23554",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180651,
        "identifier": "DE025071",
        "googlePlaceId": "ChIJK-xL2JLouUcRQJl087Fq924",
        "lat": 52.242333,
        "lng": 7.963308,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hasbergen",
        "province": "Niedersachsen",
        "streetAndNumber": "Feuerwache 16",
        "zip": "49205",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180652,
        "identifier": "DE005009",
        "googlePlaceId": "ChIJCzzTC0Q0ukcRSTprDmBzonA",
        "lat": 51.767006,
        "lng": 8.562695,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Delbrück",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Brenkenkamp 10",
        "zip": "33129",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180653,
        "identifier": "DE025042",
        "googlePlaceId": "ChIJ4fYsVgNnt0cRbNM3vyaWZXs",
        "lat": 52.550164,
        "lng": 7.949566,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bersenbrück",
        "province": "Niedersachsen",
        "streetAndNumber": "Bramscher Straße 46-48",
        "zip": "49593",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180654,
        "identifier": "DE003067",
        "googlePlaceId": "ChIJrQ0YSRTysUcRNxg-cz0iM5A",
        "lat": 53.489788,
        "lng": 10.253897,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wentorf bei Hamburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Am Casinopark 14",
        "zip": "21465",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180655,
        "identifier": "DE026082",
        "googlePlaceId": "ChIJ1-dxO0vOpUcRycZCc4_P7Mk",
        "lat": 51.585737,
        "lng": 11.50207,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Klostermansfeld",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Am Vogts Garten 2a",
        "zip": "06308",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180656,
        "identifier": "DE005098",
        "googlePlaceId": "ChIJVyJLLTl7ukcRB7eiVNU814M",
        "lat": 52.198296,
        "lng": 9.081726,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rinteln",
        "province": "Niedersachsen",
        "streetAndNumber": "Große Tonkuhle 3",
        "zip": "31737",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180657,
        "identifier": "DE020079",
        "googlePlaceId": "ChIJDzI8aU5LqUcRJX2M7jv2bs8",
        "lat": 53.156313,
        "lng": 12.479631,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wittstock",
        "province": "Brandenburg",
        "streetAndNumber": "Papenbrucher Chaussee 2",
        "zip": "16909",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180658,
        "identifier": "DE013012",
        "googlePlaceId": "ChIJI_lwyah0uUcRgmVnW0cgsvo",
        "lat": 51.687763,
        "lng": 7.745436,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamm",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Dahlhof 2",
        "zip": "59075",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180659,
        "identifier": "DE016058",
        "googlePlaceId": "ChIJHeXlxEADskcRTMlmqOYCfCc",
        "lat": 53.691275,
        "lng": 10.501851,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sandesneben",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hauptstraße 1",
        "zip": "23898",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180660,
        "identifier": "DE031034",
        "googlePlaceId": "ChIJ3WyX28UzoUcRv1CwdY_d7s0",
        "lat": 50.659284,
        "lng": 11.994637,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zeulenroda-Triebes",
        "province": "Thüringen",
        "streetAndNumber": "Meinersdorfer Straße 8",
        "zip": "07937",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180661,
        "identifier": "DE001064",
        "googlePlaceId": "ChIJsdx-sWvmuEcRxJc5lmqA0CA",
        "lat": 51.537063,
        "lng": 7.07238,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gelsenkirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kurt-Schumacher-Straße 192",
        "zip": "45881",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180662,
        "identifier": "DE003023",
        "googlePlaceId": "ChIJX6eEd7SPsUcRa5CXzESWapU",
        "lat": 53.519952,
        "lng": 9.984776,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Ernst-August-Stieg 7",
        "zip": "21107",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180663,
        "identifier": "DE005095",
        "googlePlaceId": "ChIJK3CxlmsbukcRQa_E4zDcn60",
        "lat": 52.202804,
        "lng": 8.461412,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rödinghausen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bruchstraße 193",
        "zip": "32289",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180664,
        "identifier": "DE016125",
        "googlePlaceId": "ChIJocM-tW8pskcR1xy-9zunQN4",
        "lat": 53.731003,
        "lng": 9.904368,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Quickborn",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Bahnhofstraße 94",
        "zip": "25451",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180665,
        "identifier": "DE007027",
        "googlePlaceId": "ChIJlUF7AEnTtkcRXJUq9m75550",
        "lat": 53.184372,
        "lng": 8.618189,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Hammersbecker Straße 87",
        "zip": "28755",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180666,
        "identifier": "DE036001",
        "googlePlaceId": "ChIJydO8vB_CCUcRQaAq0gwGv6o",
        "lat": 50.896801,
        "lng": 13.68909,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dippoldiswalde",
        "province": "Sachsen",
        "streetAndNumber": "Gewerbering 5",
        "zip": "01744",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180667,
        "identifier": "DE013019",
        "googlePlaceId": "ChIJESSqe8houUcRI43d4XlFAZs",
        "lat": 51.493662,
        "lng": 7.864916,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wickede",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Christian-Liebrecht-Straße 3a",
        "zip": "58739",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180669,
        "identifier": "DE010074",
        "googlePlaceId": "ChIJ3cwKcV0ru0cR4qfSO2y0i-g",
        "lat": 51.5281,
        "lng": 9.88108,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Göttingen",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Kauf Park 2",
        "zip": "37079",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180670,
        "identifier": "DE010017",
        "googlePlaceId": "ChIJJ8Z9Z4NHu0cRW5tmfCpYexA",
        "lat": 51.284986,
        "lng": 9.546676,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lohfelden",
        "province": "Hessen",
        "streetAndNumber": "Faustmühlenweg 30",
        "zip": "34253",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180671,
        "identifier": "DE025045",
        "googlePlaceId": "ChIJQzjerLLhuUcR_YV77M9Eq10",
        "lat": 52.401227,
        "lng": 7.990224,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bramsche",
        "province": "Niedersachsen",
        "streetAndNumber": "Meyers Tannen 8",
        "zip": "49565",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180673,
        "identifier": "DE025060",
        "googlePlaceId": "ChIJX7rKulp2t0cRx25qGwleqx0",
        "lat": 52.68458,
        "lng": 7.607838,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herzlake",
        "province": "Niedersachsen",
        "streetAndNumber": "Löninger Straße 10",
        "zip": "49770",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180674,
        "identifier": "DE031056",
        "googlePlaceId": "ChIJ-7nkmR58pEcR2pRD1JIscqk",
        "lat": 50.945425,
        "lng": 10.685204,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gotha",
        "province": "Thüringen",
        "streetAndNumber": "Coburger Platz 2",
        "zip": "99867",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180675,
        "identifier": "DE013081",
        "googlePlaceId": "ChIJ64IFM5o8uUcR_Q33PvhCqV4",
        "lat": 51.369279,
        "lng": 7.463178,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hagen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Zollstraße 1",
        "zip": "58089",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180677,
        "identifier": "DE015050",
        "googlePlaceId": "ChIJ8wlyZIcTtkcRikbxPNcVrI8",
        "lat": 53.60191,
        "lng": 7.291868,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hage",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Edenhof 1",
        "zip": "26524",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180678,
        "identifier": "DE006173",
        "googlePlaceId": "ChIJ-V7_--abukcRuGSeZdU_TYw",
        "lat": 52.212712,
        "lng": 9.570652,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Springe",
        "province": "Niedersachsen",
        "streetAndNumber": "Osttangente 6",
        "zip": "31832",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3180680,
        "identifier": "DE005027",
        "googlePlaceId": "ChIJSSBjINgfukcR2WUrTTBWSI4",
        "lat": 52.100019,
        "lng": 8.296558,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Borgholzhausen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bahnhofstraße 19",
        "zip": "33829",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180681,
        "identifier": "DE001020",
        "googlePlaceId": "ChIJ4RjliQHnuEcRcYb_EorGB7c",
        "lat": 51.508694,
        "lng": 7.094763,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gelsenkirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kloster/Ahstraße",
        "zip": "45879",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180683,
        "identifier": "DE025080",
        "googlePlaceId": "ChIJvS6HCCLCuUcRcBo6rkL8iRo",
        "lat": 52.192396,
        "lng": 7.845923,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lengerich",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Tecklenburger Straße 12",
        "zip": "49525",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180684,
        "identifier": "DE002083",
        "googlePlaceId": "ChIJQbC4k2YVvEcRdxG3qzwylBQ",
        "lat": 50.724442,
        "lng": 8.2893,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dillenburg",
        "province": "Hessen",
        "streetAndNumber": "Rolfesstraße 3",
        "zip": "35683",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180685,
        "identifier": "DE016017",
        "googlePlaceId": "ChIJmzi8J3WGsUcRZsZhBxEo_28",
        "lat": 53.588183,
        "lng": 9.922553,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Randstraße 77",
        "zip": "22525",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180686,
        "identifier": "DE016158",
        "googlePlaceId": "ChIJGToksJ53skcRDqmSwQl3OCg",
        "lat": 54.103988,
        "lng": 10.834792,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neustadt in Holstein",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Rettiner Weg 77",
        "zip": "23730",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180688,
        "identifier": "DE036006",
        "googlePlaceId": "ChIJFWXQ5_Zfp0cR9La-PvmFGmo",
        "lat": 50.9048,
        "lng": 13.33724,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Freiberg",
        "province": "Sachsen",
        "streetAndNumber": "Olbernhauer Straße 72",
        "zip": "09599",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180690,
        "identifier": "DE029033",
        "googlePlaceId": "ChIJnzO9zCHbq0cRvaJEAQzQK1g",
        "lat": 53.49479199092,
        "lng": 13.32104507124,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Burg Stargard",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Dewitzer Chaussee 11",
        "zip": "17094",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180691,
        "identifier": "DE002110",
        "googlePlaceId": "ChIJ5Z5I9P0nuUcRO_5A7c7bXvI",
        "lat": 51.29397,
        "lng": 7.20153,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Märkische Straße 277",
        "zip": "42281",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180692,
        "identifier": "DE001003",
        "googlePlaceId": "ChIJTeEO9kAeuUcRAzAt5M9UAck",
        "lat": 51.518371,
        "lng": 7.281195,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Amtmann-Ibing-Straße 9",
        "zip": "44805",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180693,
        "identifier": "DE010011",
        "googlePlaceId": "ChIJQwHR3_JUo0cRIYPJXmJHEto",
        "lat": 50.879821,
        "lng": 9.688066,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Hersfeld",
        "province": "Hessen",
        "streetAndNumber": "Homberger Straße 142",
        "zip": "36251",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180694,
        "identifier": "DE026030",
        "googlePlaceId": "ChIJr-ua1SWtr0cRci6H7mEzVuo",
        "lat": 52.85172,
        "lng": 11.166496,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Salzwedel",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Schillerstraße 11",
        "zip": "29410",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180695,
        "identifier": "DE036059",
        "googlePlaceId": "ChIJgXfYpAngCUcRnDyXmyOR9B8",
        "lat": 50.914849,
        "lng": 13.365601,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Freiberg",
        "province": "Sachsen",
        "streetAndNumber": "Dresdner Straße 31d",
        "zip": "09599",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180696,
        "identifier": "DE029073",
        "googlePlaceId": "ChIJY-DFKCNVqUcRIymwUAiR6ZA",
        "lat": 53.387546,
        "lng": 12.617671,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Röbel",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Am Hafen 11",
        "zip": "17207",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180697,
        "identifier": "DE007069",
        "googlePlaceId": "ChIJR-JoFxwEsUcRRtuMNKMv2NE",
        "lat": 53.120535,
        "lng": 9.422318,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rotenburg (Wümme)",
        "province": "Niedersachsen",
        "streetAndNumber": "Waldweg 1-5",
        "zip": "27356",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180698,
        "identifier": "DE036043",
        "googlePlaceId": "ChIJpbD3EkX5CUcR46_AKFPWwZk",
        "lat": 50.651104,
        "lng": 13.351255,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Olbernhau",
        "province": "Sachsen",
        "streetAndNumber": "Dörfelstraße 4",
        "zip": "09526",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180699,
        "identifier": "DE026049",
        "googlePlaceId": "ChIJBQ9JsJlfr0cRcGDZS7hXYYQ",
        "lat": 52.15085,
        "lng": 11.58756,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Magdeburg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Olvenstedter Scheid 52",
        "zip": "39130",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180700,
        "identifier": "DE007049",
        "googlePlaceId": "ChIJlzjgTILZsEcR6_opd4KN0x4",
        "lat": 52.98177,
        "lng": 8.85157,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Weyhe",
        "province": "Niedersachsen",
        "streetAndNumber": "Lahauser Straße 2a",
        "zip": "28844",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180701,
        "identifier": "DE001044",
        "googlePlaceId": "ChIJm7elESLvuEcR-spaUgWkeGg",
        "lat": 51.578907,
        "lng": 7.005265,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gladbeck",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Buersche Straße 83",
        "zip": "45964",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180702,
        "identifier": "DE002105",
        "googlePlaceId": "ChIJL7SslMr4u0cRGZKkfkbwmzM",
        "lat": 51.088592,
        "lng": 8.106972,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kirchhundem",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Herrntroper Straße 76",
        "zip": "57399",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180703,
        "identifier": "DE015065",
        "googlePlaceId": "ChIJ-9SoOl07tkcRpUuQoeJBzFw",
        "lat": 53.428641,
        "lng": 7.109127,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Krummhörn",
        "province": "Niedersachsen",
        "streetAndNumber": "Handelsstraße 2",
        "zip": "26736",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180704,
        "identifier": "DE010068",
        "googlePlaceId": "ChIJc_6BUexru0cRVWQAOZ48r_o",
        "lat": 51.249262,
        "lng": 9.269362,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Emstal",
        "province": "Hessen",
        "streetAndNumber": "Kasseler Straße 96",
        "zip": "34308",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180705,
        "identifier": "DE025038",
        "googlePlaceId": "ChIJi4kqFZ1pt0cRebJKOMxvvlA",
        "lat": 52.681659,
        "lng": 7.959512,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Quakenbrück",
        "province": "Niedersachsen",
        "streetAndNumber": "Bremer Straße 4",
        "zip": "49610",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180706,
        "identifier": "DE010025",
        "googlePlaceId": "ChIJf5xlAkOPvEcRgzy_t3U_yQo",
        "lat": 50.825787,
        "lng": 8.9149,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kirchhain",
        "province": "Hessen",
        "streetAndNumber": "Frankfurter Straße 7",
        "zip": "35274",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180707,
        "identifier": "DE004099",
        "googlePlaceId": "ChIJJcmnsqJGskcR3CakkEtYcWQ",
        "lat": 54.076425,
        "lng": 10.227807,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bornhöved",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Kieler Tor 42",
        "zip": "24619",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180708,
        "identifier": "DE005038",
        "googlePlaceId": "ChIJ87kKUzMjukcRZpdZIjU9t80",
        "lat": 51.9976,
        "lng": 8.487386,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Carl-Severing-Straße 85",
        "zip": "33649",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180709,
        "identifier": "DE005044",
        "googlePlaceId": "ChIJ06UTFps-ukcRQmgpCSTt93k",
        "lat": 51.992581,
        "lng": 8.607207,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Oerlinghauser Straße 10",
        "zip": "33699",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180710,
        "identifier": "DE004085",
        "googlePlaceId": "ChIJ2ajnp_CQs0cRJvzcq82_2ZA",
        "lat": 54.219449,
        "lng": 9.276515,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Tellingstedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hauptstraße 5 b",
        "zip": "25782",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180711,
        "identifier": "DE007013",
        "googlePlaceId": "ChIJl_7SvmxIt0cRIVVtGly1HU8",
        "lat": 52.734959,
        "lng": 8.280931,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Vechta",
        "province": "Niedersachsen",
        "streetAndNumber": "Falkenweg 6a",
        "zip": "49377",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180712,
        "identifier": "DE025043",
        "googlePlaceId": "ChIJk0P8-LDyt0cRTl9GXUBF4Ak",
        "lat": 52.648396,
        "lng": 7.095465,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Twist",
        "province": "Niedersachsen",
        "streetAndNumber": "Overbergstraße 18",
        "zip": "49767",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180713,
        "identifier": "DE003098",
        "googlePlaceId": "ChIJs6Xh-K-UsUcRenqKFHkDJGE",
        "lat": 53.385603,
        "lng": 10.105365,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stelle",
        "province": "Niedersachsen",
        "streetAndNumber": "Harburger Straße 25",
        "zip": "21435",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180714,
        "identifier": "DE001002",
        "googlePlaceId": "ChIJbSwDfADhuEcRtVPvubCDcyw",
        "lat": 51.506763,
        "lng": 7.19306,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Riemker Straße 13",
        "zip": "44809",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180715,
        "identifier": "DE004113",
        "googlePlaceId": "ChIJLeIAkOmAsUcR_owX6rwOvog",
        "lat": 53.653703,
        "lng": 9.823546,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rellingen",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Grüner Weg 3",
        "zip": "25462",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180716,
        "identifier": "DE013018",
        "googlePlaceId": "ChIJ89DlT0gTuUcRt6-ZU1BUQts",
        "lat": 51.536498,
        "lng": 7.680433,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Unna",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Weberstraße 3",
        "zip": "59423",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180717,
        "identifier": "DE003025",
        "googlePlaceId": "ChIJpyd4y4fysUcRxhLa7wglGPE",
        "lat": 53.483623,
        "lng": 10.213434,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Neuer Weg 37b",
        "zip": "21029",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180718,
        "identifier": "DE001004",
        "googlePlaceId": "ChIJsWZ1Ow-LuEcRY5P_ra_OEdk",
        "lat": 51.767601,
        "lng": 6.836903,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Raesfeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Leinenweberstraße 19",
        "zip": "46348",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180719,
        "identifier": "DE003081",
        "googlePlaceId": "ChIJpWjhj9YzrkcRgs1h39nnIMI",
        "lat": 52.986714,
        "lng": 10.756594,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rosche",
        "province": "Niedersachsen",
        "streetAndNumber": "Lüchower Straße 10",
        "zip": "29571",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180720,
        "identifier": "DE003014",
        "googlePlaceId": "ChIJQ5uI7CxCsUcR_IK4fSiQtRY",
        "lat": 53.487132,
        "lng": 9.139979,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremervörde",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Bahnhof Süd 7",
        "zip": "27432",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180721,
        "identifier": "DE025070",
        "googlePlaceId": "ChIJla6nhErpuUcRb6Ip2ILyU4c",
        "lat": 52.1982459,
        "lng": 7.986041,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hagen am Teutoburger Wald",
        "province": "Niedersachsen",
        "streetAndNumber": "Hüttenstraße 16",
        "zip": "49170",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180722,
        "identifier": "DE010014",
        "googlePlaceId": "ChIJucr5pWPTpEcReDVNrxn4Dss",
        "lat": 51.511729722581,
        "lng": 9.9404218732221,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Göttingen",
        "province": "Niedersachsen",
        "streetAndNumber": "Benzstraße 4",
        "zip": "37083",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180724,
        "identifier": "DE020090",
        "googlePlaceId": "ChIJ9bKlikBQqEcRJIPWSwCZzFo",
        "lat": 52.486164,
        "lng": 13.356855,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Richard-von-Weizsäcker-Platz 2",
        "zip": "10827",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180725,
        "identifier": "DE024124",
        "googlePlaceId": "ChIJl1d3mFLtB0cRbCI6SDNN27g",
        "lat": 52.182589,
        "lng": 14.240419,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Beeskow",
        "province": "Brandenburg",
        "streetAndNumber": "Fürstenwalder Straße 10B",
        "zip": "15848",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180726,
        "identifier": "DE025003",
        "googlePlaceId": "ChIJWQPD4Pmct0cRgjaurJCOGvA",
        "lat": 52.676365,
        "lng": 7.492507,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Haselünne",
        "province": "Niedersachsen",
        "streetAndNumber": "Lähdener Straße 2",
        "zip": "49740",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180727,
        "identifier": "DE025097",
        "googlePlaceId": "ChIJVemIPus1uEcRmz3HUb7BkuY",
        "lat": 52.147033,
        "lng": 7.332046,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Steinfurt",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bahnhofstraße 43",
        "zip": "48565",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180728,
        "identifier": "DE021102",
        "googlePlaceId": "ChIJi81qb8E4pkcR3V38X9yZbDM",
        "lat": 51.725012,
        "lng": 12.431754,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gräfenhainichen",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Barbaraweg 3",
        "zip": "06773",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180729,
        "identifier": "DE010110",
        "googlePlaceId": "ChIJ7R6h8EjLukcRnv8dISWndKw",
        "lat": 51.867662,
        "lng": 10.017884,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Gandersheim",
        "province": "Niedersachsen",
        "streetAndNumber": "Neue Straße 37",
        "zip": "37581",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180730,
        "identifier": "DE016033",
        "googlePlaceId": "ChIJN7N4EgfzsUcR4cKDAmalOkU",
        "lat": 53.523807,
        "lng": 10.229259,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Glinde",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Gutenbergstraße 3a",
        "zip": "21509",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180731,
        "identifier": "DE002022",
        "googlePlaceId": "ChIJzSLu3YIsuUcRMaLXryKl26Y",
        "lat": 51.153459,
        "lng": 7.263644,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Remscheid",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Eichholz 2",
        "zip": "42897",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180732,
        "identifier": "DE029081",
        "googlePlaceId": "ChIJ9QyHRkO_rUcRqS-AUZkXeJw",
        "lat": 53.903709,
        "lng": 11.403775,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wismar",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Zierower Landstraße 4",
        "zip": "23968",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180733,
        "identifier": "DE036061",
        "googlePlaceId": "ChIJucFkVmG5CUcRQ87cWn1V6nA",
        "lat": 50.957022,
        "lng": 13.952625,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Pirna",
        "province": "Sachsen",
        "streetAndNumber": "Struppener Straße 2a",
        "zip": "01796",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180734,
        "identifier": "DE029063",
        "googlePlaceId": "ChIJicLb14XxrEcRrCioTSjp8pA",
        "lat": 54.293332,
        "lng": 12.353252,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dierhagen",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Strandstraße 28",
        "zip": "18347",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180735,
        "identifier": "DE006065",
        "googlePlaceId": "ChIJZVLYJn83sEcRIarzpzFeOVo",
        "lat": 52.801031,
        "lng": 9.967309,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bergen",
        "province": "Niedersachsen",
        "streetAndNumber": "Celler Straße 62",
        "zip": "29303",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180736,
        "identifier": "DE005057",
        "googlePlaceId": "ChIJGYmEHj4pukcRlKUFB5ghh-c",
        "lat": 51.837143,
        "lng": 8.301228,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rheda-Wiedenbrück",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Westring 143",
        "zip": "33378",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180738,
        "identifier": "DE005019",
        "googlePlaceId": "ChIJDf23vDvSu0cRkQd-dyk6Z7M",
        "lat": 51.654195,
        "lng": 8.346166,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lippstadt",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Planckstraße 10",
        "zip": "59557",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180739,
        "identifier": "DE029053",
        "googlePlaceId": "ChIJIUPld9xZrEcRlvWIe-0pFrc",
        "lat": 54.109446,
        "lng": 12.162703,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rostock",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Hinrichsdorfer Straße 8",
        "zip": "18146",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180740,
        "identifier": "DE005081",
        "googlePlaceId": "ChIJk9zCgM84ukcRGnLgw8n6Vpw",
        "lat": 51.9476,
        "lng": 8.657458,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oerlinghausen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Kalkofen 7",
        "zip": "33813",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180741,
        "identifier": "DE031082",
        "googlePlaceId": "ChIJDdvQjLPboEcRY4u1vV-oaPE",
        "lat": 50.474394,
        "lng": 12.366747,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Falkenstein",
        "province": "Sachsen",
        "streetAndNumber": "Ferdinand-Lassalle-Straße 21",
        "zip": "08223",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180742,
        "identifier": "DE001093",
        "googlePlaceId": "ChIJe83fu4dBuEcRxoPvqXY7Lew",
        "lat": 52.068152,
        "lng": 7.009957,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ahaus",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Coesfelder Straße 68",
        "zip": "48683",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180743,
        "identifier": "DE013045",
        "googlePlaceId": "ChIJ36OCOBhquUcRMZJqCkPBacc",
        "lat": 51.446109,
        "lng": 7.761983,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Menden (Sauerland)",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Stuckenacker 5",
        "zip": "58708",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180744,
        "identifier": "DE015016",
        "googlePlaceId": "ChIJSwt-tMfftkcRMTUtcyI_K08",
        "lat": 53.140653,
        "lng": 8.177411,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oldenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Bloherfelder Straße 97",
        "zip": "26129",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180745,
        "identifier": "DE013076",
        "googlePlaceId": "ChIJAx_1XntguUcRnt5mxW1xXyo",
        "lat": 51.416881,
        "lng": 8.045361,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Arnsberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wannestraße 2",
        "zip": "59823",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180746,
        "identifier": "DE013058",
        "googlePlaceId": "ChIJxTs3dSwjuUcRcn4neRsuUj0",
        "lat": 51.401124,
        "lng": 7.431566,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herdecke",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Stiftsstraße 11",
        "zip": "58313",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180747,
        "identifier": "DE006033",
        "googlePlaceId": "ChIJT_siVxMMsEcRNOxh_QI-NYQ",
        "lat": 52.38868,
        "lng": 9.85597,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Anderter Straße 16-18",
        "zip": "30629",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180748,
        "identifier": "DE002021",
        "googlePlaceId": "ChIJqdAaAcPRuEcRTXit3Irzf88",
        "lat": 51.246272,
        "lng": 6.983662,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Mettmann",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Flurstraße 20",
        "zip": "40822",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180749,
        "identifier": "DE007006",
        "googlePlaceId": "ChIJJ5gDFH4nsUcRHtX4lQlXEig",
        "lat": 53.059843,
        "lng": 8.887846,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Osenbrückstraße 5",
        "zip": "28309",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180754,
        "identifier": "DE025061",
        "googlePlaceId": "ChIJ96VaUek5uEcR4MRlSJHNceo",
        "lat": 52.211091,
        "lng": 7.194593,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ochtrup",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Laurenzstraße 41",
        "zip": "48607",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180755,
        "identifier": "DE020076",
        "googlePlaceId": "ChIJjU7Ai2BFqEcRR3kxybprrC8",
        "lat": 52.41235,
        "lng": 13.36075,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Hildburghauser Straße 3",
        "zip": "12279",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180756,
        "identifier": "DE004137",
        "googlePlaceId": "ChIJsU8zSY9_skcRQil1Qprhgkw",
        "lat": 54.290984,
        "lng": 10.890847,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oldenburg in Holstein",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Göhler Straße 1-15",
        "zip": "23758",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180757,
        "identifier": "DE029086",
        "googlePlaceId": "ChIJn26QMJPFrUcRY6yt1_aHE1c",
        "lat": 53.774378,
        "lng": 11.477635,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Kleinen",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Viechelner Chaussee 8",
        "zip": "23996",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180758,
        "identifier": "DE026073",
        "googlePlaceId": "ChIJhw15EQjBpUcRLL7jJPe2JMs",
        "lat": 51.759475,
        "lng": 11.451326,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Aschersleben",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Magdeburger Straße 17",
        "zip": "06449",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180759,
        "identifier": "DE036088",
        "googlePlaceId": "ChIJLzCti4W2oEcRrBdiRlZP4Is",
        "lat": 50.55011,
        "lng": 12.774362,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwarzenberg",
        "province": "Sachsen",
        "streetAndNumber": "Roter Mühlenweg 28",
        "zip": "08340",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180760,
        "identifier": "DE003008",
        "googlePlaceId": "ChIJ1aoT19iMsUcRgK1g8ILSqgc",
        "lat": 53.525488,
        "lng": 10.150599,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Kandinskyallee 4-12",
        "zip": "22115",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180761,
        "identifier": "DE006073",
        "googlePlaceId": "ChIJi_orJ29ssEcRhyKf7ysFgd8",
        "lat": 52.548025,
        "lng": 9.74851,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wedemark",
        "province": "Niedersachsen",
        "streetAndNumber": "Wedemarkstraße 100",
        "zip": "30900",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180762,
        "identifier": "DE036050",
        "googlePlaceId": "ChIJD1uiIGfPCUcReaDdFwvxwWs",
        "lat": 51.049271,
        "lng": 13.735278,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Webergasse 1",
        "zip": "01067",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180763,
        "identifier": "DE002090",
        "googlePlaceId": "ChIJebkc2pccvEcREzHkkEDIal8",
        "lat": 50.88252,
        "lng": 8.02821,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Siegen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hagener Straße 9",
        "zip": "57072",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3180765,
        "identifier": "DE003024",
        "googlePlaceId": "ChIJ4fzwEJMrrkcRy-X19qyUkWg",
        "lat": 52.985352,
        "lng": 10.546878,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Uelzen",
        "province": "Niedersachsen",
        "streetAndNumber": "Nordallee 3",
        "zip": "29525",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180766,
        "identifier": "DE010073",
        "googlePlaceId": "ChIJeVFJEj6avEcRAu4b7Gz8a7E",
        "lat": 50.847192,
        "lng": 9.098572,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neustadt (Hessen)",
        "province": "Hessen",
        "streetAndNumber": "Am Kaufpark 1",
        "zip": "35279",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180768,
        "identifier": "DE004118",
        "googlePlaceId": "ChIJQwsyEJ54sUcR540Wzpa8QJ0",
        "lat": 53.577802,
        "lng": 9.706433,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wedel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Feldstraße 5",
        "zip": "22880",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180769,
        "identifier": "DE021011",
        "googlePlaceId": "ChIJKbwW9AT0pkcRs8Omx2ZnDKk",
        "lat": 51.305171,
        "lng": 12.226189,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Markranstädt",
        "province": "Sachsen",
        "streetAndNumber": "Leipziger Straße 34",
        "zip": "04420",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180770,
        "identifier": "DE007016",
        "googlePlaceId": "ChIJs_glBrc-t0cRK0DOLTtYZKQ",
        "lat": 52.833864,
        "lng": 8.163381,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Emstek",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Mühlencenter 10",
        "zip": "49685",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180771,
        "identifier": "DE007090",
        "googlePlaceId": "ChIJm4Kk0jIosUcRPzajPdN_lpE",
        "lat": 53.080117,
        "lng": 8.770976,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Dötlinger Straße 10-12",
        "zip": "28197",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180772,
        "identifier": "DE025069",
        "googlePlaceId": "ChIJ__JeifvuuUcR6xyfuy4r4D4",
        "lat": 52.209977,
        "lng": 8.038175,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Georgsmarienhütte",
        "province": "Niedersachsen",
        "streetAndNumber": "Malberger Straße 1",
        "zip": "49124",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180773,
        "identifier": "DE031032",
        "googlePlaceId": "ChIJaXr55EoNpEcRrqgQw5zwPwQ",
        "lat": 50.970401,
        "lng": 11.059879,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Erfurt",
        "province": "Thüringen",
        "streetAndNumber": "Hermsdorfer Straße 4",
        "zip": "99099",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180774,
        "identifier": "DE032089",
        "googlePlaceId": "ChIJPVpIuwQguUcRL5ga1JSHDJg",
        "lat": 51.453722,
        "lng": 7.247913,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Markstraße 139",
        "zip": "44803",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180775,
        "identifier": "DE005093",
        "googlePlaceId": "ChIJf031jOA8ukcRTp1LJgGJL1U",
        "lat": 52.00802,
        "lng": 8.519786,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "An der Tonkuhle 2",
        "zip": "33617",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180776,
        "identifier": "DE015040",
        "googlePlaceId": "ChIJw6bbJDdCtkcRyug2afu4BUw",
        "lat": 53.469861,
        "lng": 7.457529,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Aurich",
        "province": "Niedersachsen",
        "streetAndNumber": "Dreekamp 10",
        "zip": "26605",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180777,
        "identifier": "DE001072",
        "googlePlaceId": "ChIJPZJiUxfouEcRapDcP8sJZOY",
        "lat": 51.484079,
        "lng": 7.009333,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lierfeldstraße 5",
        "zip": "45326",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180779,
        "identifier": "DE031063",
        "googlePlaceId": "ChIJ5ZA1CY4goUcRplwNJfsIsEk",
        "lat": 50.42534,
        "lng": 12.1716,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oelsnitz",
        "province": "Sachsen",
        "streetAndNumber": "Willy-Brandt-Ring 2",
        "zip": "08606",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180780,
        "identifier": "DE029069",
        "googlePlaceId": "ChIJz6Ajo_IdrEcRjtAVe_PL4lU",
        "lat": 53.46437,
        "lng": 12.2659,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Plau am See",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Quetziner Straße 19b",
        "zip": "19395",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180781,
        "identifier": "DE005092",
        "googlePlaceId": "ChIJL-U_JZc8ukcRljxAEypJxOw",
        "lat": 51.981259,
        "lng": 8.516558,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Briloner Straße 3",
        "zip": "33647",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180782,
        "identifier": "DE010085",
        "googlePlaceId": "ChIJDTRwgjlHu0cRNFVDJyKMYO0",
        "lat": 51.272451,
        "lng": 9.500039,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Fuldabrück",
        "province": "Hessen",
        "streetAndNumber": "Ostring 40-44",
        "zip": "34277",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180783,
        "identifier": "DE026040",
        "googlePlaceId": "ChIJtZyUVOz1pUcRetZvFAaCl_Q",
        "lat": 52.115371627476,
        "lng": 11.619183606475,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Magdeburg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Ackerstrasse 2",
        "zip": "39112",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180784,
        "identifier": "DE029010",
        "googlePlaceId": "ChIJIZDErl3zrEcRR8wmzSQjE5M",
        "lat": 54.237896,
        "lng": 12.434972,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ribnitz-Damgarten",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Rostocker Landweg 1b",
        "zip": "18311",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180785,
        "identifier": "DE024123",
        "googlePlaceId": "ChIJ0-7qpLchqEcREvupKiDYCl8",
        "lat": 52.250572,
        "lng": 13.92436,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Storkow",
        "province": "Brandenburg",
        "streetAndNumber": "Goethestraße 2",
        "zip": "15859",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180786,
        "identifier": "DE013044",
        "googlePlaceId": "ChIJJ1Yf8ddYuUcRYzBxlaM7WnU",
        "lat": 51.314904,
        "lng": 8.010022,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sundern",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Röhre 32",
        "zip": "59846",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180787,
        "identifier": "DE029066",
        "googlePlaceId": "ChIJ2SmCcWiprUcRDdI5S2RKu2E",
        "lat": 54.145362,
        "lng": 11.769097,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kühlungsborn",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Gewerbegebiet Fulgengrund 4",
        "zip": "18225",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180788,
        "identifier": "DE005056",
        "googlePlaceId": "ChIJR4RnOHA9ukcRf1bGsdkfBb0",
        "lat": 52.038423,
        "lng": 8.545294,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Beckhausstraße 64",
        "zip": "33611",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180789,
        "identifier": "DE032058",
        "googlePlaceId": "ChIJOVjnAUMHuUcRKY2av6iztck",
        "lat": 51.772903,
        "lng": 7.451085,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lüdinghausen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Geschwister-Scholl-Straße 26",
        "zip": "59348",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180790,
        "identifier": "DE025103",
        "googlePlaceId": "ChIJZZi7QK34uUcRqMVlnmajdJs",
        "lat": 52.321489,
        "lng": 8.348366,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Essen",
        "province": "Niedersachsen",
        "streetAndNumber": "Lerchenstraße 27",
        "zip": "49152",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180791,
        "identifier": "DE010010",
        "googlePlaceId": "ChIJ1TG8Zehfu0cRmx3Dc1drshQ",
        "lat": 51.033398405903,
        "lng": 9.3994675871513,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Homberg (Efze)",
        "province": "Hessen",
        "streetAndNumber": "Kasseler Straße 3",
        "zip": "34576",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180792,
        "identifier": "DE015048",
        "googlePlaceId": "ChIJQRDYchs6tkcRNVv1BO_mQmw",
        "lat": 53.361379,
        "lng": 7.167463,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Emden",
        "province": "Niedersachsen",
        "streetAndNumber": "Thüringer Straße 9",
        "zip": "26723",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180793,
        "identifier": "DE013008",
        "googlePlaceId": "ChIJPUuIiYaduUcRsGtpnCMasX0",
        "lat": 51.759876,
        "lng": 7.908521,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ahlen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Ostbredenstraße 77",
        "zip": "59229",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180794,
        "identifier": "DE007066",
        "googlePlaceId": "ChIJTVzDImQosUcRyIjzyCo1pdk",
        "lat": 53.101032,
        "lng": 8.815213,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Hemmstraße 353-357",
        "zip": "28215",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180795,
        "identifier": "DE006131",
        "googlePlaceId": "ChIJVxwoJDv2r0cRMzVe7A31zE0",
        "lat": 52.248478,
        "lng": 10.479494,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Braunschweig",
        "province": "Niedersachsen",
        "streetAndNumber": "Elbestraße 22",
        "zip": "38120",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180796,
        "identifier": "DE016094",
        "googlePlaceId": "ChIJq6p6C5WFsUcRStD7cmQHDnw",
        "lat": 53.562264,
        "lng": 9.915575,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Paul-Dessau-Straße 6",
        "zip": "22761",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180797,
        "identifier": "DE032007",
        "googlePlaceId": "ChIJMZsUB4UbuUcRW3PHEbFp8QI",
        "lat": 51.570129,
        "lng": 7.383378,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Siegburgstraße 20",
        "zip": "44359",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180798,
        "identifier": "DE004017",
        "googlePlaceId": "ChIJQcoDgwFLskcRJod6pEQKS6Q",
        "lat": 54.071457,
        "lng": 9.939656,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neumünster",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Wasbeker Straße 330",
        "zip": "24537",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180799,
        "identifier": "DE025036",
        "googlePlaceId": "ChIJuSvx8zjguUcRA1Ez-W9dfkA",
        "lat": 52.413975,
        "lng": 7.975748,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bramsche",
        "province": "Niedersachsen",
        "streetAndNumber": "Lindenstraße 31",
        "zip": "49565",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180800,
        "identifier": "DE016114",
        "googlePlaceId": "ChIJcSzq5x4JskcRduCqWZK4i2w",
        "lat": 53.83168,
        "lng": 10.691327,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübeck",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Alexander-Fleming-Straße 1",
        "zip": "23562",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180801,
        "identifier": "DE001015",
        "googlePlaceId": "ChIJC05XZ5n6uEcR5QIZWDJ5T3U",
        "lat": 51.66519,
        "lng": 7.082326,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Marl",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Zechenstraße 47",
        "zip": "45772",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3180802,
        "identifier": "DE006162",
        "googlePlaceId": "ChIJ3e3kGa94sEcRYpSBL-aUhoU",
        "lat": 52.335591,
        "lng": 9.403542,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Nenndorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Piepmühle 5",
        "zip": "31542",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180803,
        "identifier": "DE031051",
        "googlePlaceId": "ChIJtzjD-Pr_pEcRBU_pXuAjxaE",
        "lat": 51.51495,
        "lng": 10.803678,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nordhausen",
        "province": "Thüringen",
        "streetAndNumber": "Stolberger Straße 134",
        "zip": "99734",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180805,
        "identifier": "DE013029",
        "googlePlaceId": "ChIJy1WPy7hiuUcRpWTcVcNqDMs",
        "lat": 51.556715,
        "lng": 8.107724,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Soest",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kaiser-Otto-Weg 7",
        "zip": "59494",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180806,
        "identifier": "DE026018",
        "googlePlaceId": "ChIJOfIg-GJer0cRjtAi9GQNCkw",
        "lat": 52.202297,
        "lng": 11.619544,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Barleben",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Breiteweg 51",
        "zip": "39179",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180807,
        "identifier": "DE002068",
        "googlePlaceId": "ChIJm7RKW1HWuEcR5Z3JcvrvFVY",
        "lat": 51.249276,
        "lng": 7.134452,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Steinbecker Meile 6",
        "zip": "42117",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180808,
        "identifier": "DE024106",
        "googlePlaceId": "ChIJeTxB98tIqEcRcuqn2IQUjGQ",
        "lat": 52.469281,
        "lng": 13.512509,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Rummelsburger Straße 16",
        "zip": "12459",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180809,
        "identifier": "DE007040",
        "googlePlaceId": "ChIJhdQAhp4nsUcRKZ_C8sNPmz4",
        "lat": 53.076585,
        "lng": 8.883151,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Vahrer Straße 279-281",
        "zip": "28329",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180810,
        "identifier": "DE002076",
        "googlePlaceId": "ChIJ4XMevc1FuUcRqWuFXDVxFVg",
        "lat": 51.297598,
        "lng": 7.74784,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Altena",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Altenaer Straße 29",
        "zip": "58762",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180812,
        "identifier": "DE015014",
        "googlePlaceId": "ChIJoxXH9YzrtkcRNRjngvy_NhQ",
        "lat": 53.394681,
        "lng": 8.130314,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Varel",
        "province": "Niedersachsen",
        "streetAndNumber": "Bürgermeister-Heidenreich-Straße 1A",
        "zip": "26316",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180813,
        "identifier": "DE020099",
        "googlePlaceId": "ChIJ-QDZTmJPqEcR4uOBFK9sTA8",
        "lat": 52.452277,
        "lng": 13.455729,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Späthstraße 14-15",
        "zip": "12359",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180814,
        "identifier": "DE036086",
        "googlePlaceId": "ChIJgbKVzTbcCEcRMiD-cAnT9Dc",
        "lat": 51.158198,
        "lng": 14.983572,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Görlitz",
        "province": "Sachsen",
        "streetAndNumber": "Pontestraße 10",
        "zip": "02826",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180815,
        "identifier": "DE020106",
        "googlePlaceId": "ChIJh56-csM-qEcRfxwVZnk4cRg",
        "lat": 52.324898,
        "lng": 13.636646,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wildau",
        "province": "Brandenburg",
        "streetAndNumber": "Friedrich-Engels-Straße 79",
        "zip": "15745",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180816,
        "identifier": "DE015079",
        "googlePlaceId": "ChIJXZIh0a4UtkcR8ywRHRTdQ-U",
        "lat": 53.592512,
        "lng": 7.346637,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Großheide",
        "province": "Niedersachsen",
        "streetAndNumber": "Coldinner Straße 11",
        "zip": "26532",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180817,
        "identifier": "DE026016",
        "googlePlaceId": "ChIJw-bWAQRdr0cRsCINUVe7roE",
        "lat": 52.262242,
        "lng": 11.640256,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wolmirstedt",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Rogätzer Straße 33",
        "zip": "39326",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180818,
        "identifier": "DE007004",
        "googlePlaceId": "ChIJg0QaGE7UsEcRe9zsbNLh44c",
        "lat": 53.026818,
        "lng": 8.65259,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Delmenhorst",
        "province": "Niedersachsen",
        "streetAndNumber": "Annenheider Straße 181",
        "zip": "27755",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180819,
        "identifier": "DE004082",
        "googlePlaceId": "ChIJ70Biix9HskcRp7BXaRQPp1Y",
        "lat": 54.043136,
        "lng": 10.215375,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Trappenkamp",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Gablonzer Straße 5",
        "zip": "24610",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180820,
        "identifier": "DE001031",
        "googlePlaceId": "ChIJebQtySNkuEcRuBdtLqGC5IY",
        "lat": 51.933332,
        "lng": 6.807711,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Südlohn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Pfarrer-Becker-Straße 7",
        "zip": "46354",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180821,
        "identifier": "DE007017",
        "googlePlaceId": "ChIJ7byx9fEVt0cRP8azpUBhl98",
        "lat": 52.84319,
        "lng": 8.050719,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Cloppenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Emsteker Straße 30",
        "zip": "49661",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180822,
        "identifier": "DE004059",
        "googlePlaceId": "ChIJf27rluP4skcRDmkmbVOug6w",
        "lat": 54.396107,
        "lng": 10.173448,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Brauner Berg 9",
        "zip": "24159",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180823,
        "identifier": "DE024054",
        "googlePlaceId": "ChIJJcs_ghdOqEcRIgcTVa-geFg",
        "lat": 52.521679,
        "lng": 13.423893,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Berolinastraße 7",
        "zip": "10178",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180824,
        "identifier": "DE032042",
        "googlePlaceId": "ChIJKZHdpWEBuUcR81Hr476qvn4",
        "lat": 51.70772,
        "lng": 7.378532,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Olfen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Marktplatz 3",
        "zip": "59399",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180825,
        "identifier": "DE004049",
        "googlePlaceId": "ChIJBSbK4Z2ms0cRsv3xFKlcQxQ",
        "lat": 54.312443,
        "lng": 9.644313,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rendsburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Schleswiger Chaussee 45",
        "zip": "24768",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180826,
        "identifier": "DE015077",
        "googlePlaceId": "ChIJO69SzxFEtkcR0YmDUqFWVXM",
        "lat": 53.40729,
        "lng": 7.440273,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ihlow",
        "province": "Niedersachsen",
        "streetAndNumber": "2. Kompanieweg 8",
        "zip": "26632",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180827,
        "identifier": "DE006066",
        "googlePlaceId": "ChIJ10bq4Ij_r0cR9LTKXs_XHy8",
        "lat": 52.264436,
        "lng": 10.215988,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ilsede",
        "province": "Niedersachsen",
        "streetAndNumber": "Eichstraße 18-20",
        "zip": "31241",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180828,
        "identifier": "DE002042",
        "googlePlaceId": "ChIJWyTkvBs0uUcRflFsSEZcf4s",
        "lat": 51.18365,
        "lng": 7.503543,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Halver",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bahnhofstraße 28",
        "zip": "58553",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180829,
        "identifier": "DE032083",
        "googlePlaceId": "ChIJW1ACD-MfuUcR1N_fIz6GHbg",
        "lat": 51.472757,
        "lng": 7.244254,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lindengraben 14",
        "zip": "44803",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180830,
        "identifier": "DE016014",
        "googlePlaceId": "ChIJ5xnTwnOJsUcRLhIotBBJZ_k",
        "lat": 53.611544,
        "lng": 10.058562,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Schreyerring 6",
        "zip": "22309",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180831,
        "identifier": "DE036003",
        "googlePlaceId": "ChIJYb9c5FDPCUcRbxkGF2M3cyI",
        "lat": 51.046311,
        "lng": 13.756872,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Straßburger Platz 1",
        "zip": "01307",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180832,
        "identifier": "DE020040",
        "googlePlaceId": "ChIJr-0ajTRFqEcRuEZdp0qPlUM",
        "lat": 52.43462,
        "lng": 13.36734,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Haynauer Straße 76-80",
        "zip": "12249",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180833,
        "identifier": "DE025090",
        "googlePlaceId": "ChIJCUWfRdfluUcRqDj6WN_MaBk",
        "lat": 52.295274,
        "lng": 8.016227,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Osnabrück",
        "province": "Niedersachsen",
        "streetAndNumber": "Pagenstecherstraße 144",
        "zip": "49090",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180834,
        "identifier": "DE016054",
        "googlePlaceId": "ChIJV-_HcnYfskcRZyJARDFERU0",
        "lat": 53.679453,
        "lng": 10.260962,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ahrensburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Carl-Backhaus-Straße 44",
        "zip": "22926",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180835,
        "identifier": "DE003062",
        "googlePlaceId": "ChIJFe3soXGXsUcRDeadftT4TAg",
        "lat": 53.379379,
        "lng": 9.89789,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rosengarten",
        "province": "Niedersachsen",
        "streetAndNumber": "Bremer Straße 51",
        "zip": "21224",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180836,
        "identifier": "DE020037",
        "googlePlaceId": "ChIJH4rbJzhaqEcRK3JAHNj8UH0",
        "lat": 52.439201,
        "lng": 13.271348,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Sundgauer Straße 83-85",
        "zip": "14169",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "09:00",
            "to1": "18:30"
          },
          {
            "dayOfWeek": 2,
            "from1": "09:00",
            "to1": "18:30"
          },
          {
            "dayOfWeek": 3,
            "from1": "09:00",
            "to1": "18:30"
          },
          {
            "dayOfWeek": 4,
            "from1": "09:00",
            "to1": "18:30"
          },
          {
            "dayOfWeek": 5,
            "from1": "09:00",
            "to1": "18:30"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "16:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180837,
        "identifier": "DE026003",
        "googlePlaceId": "ChIJSd7zoJkwr0cRQFoe56euPTg",
        "lat": 52.547894,
        "lng": 11.966259,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Tangermünde",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Kirschallee 11",
        "zip": "39590",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180838,
        "identifier": "DE036033",
        "googlePlaceId": "ChIJSWiFCbNEp0cRVJC8S5gxpF8",
        "lat": 50.850092,
        "lng": 13.077051,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Flöha",
        "province": "Sachsen",
        "streetAndNumber": "Augustusburger Straße 75",
        "zip": "09557",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180839,
        "identifier": "DE032055",
        "googlePlaceId": "ChIJM4uzUOUcuUcRxZUNrkwzTgc",
        "lat": 51.591848,
        "lng": 7.338534,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Castrop-Rauxel",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Marktplatz Ickern 2",
        "zip": "44581",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180840,
        "identifier": "DE006026",
        "googlePlaceId": "ChIJI-hv9iR1sEcRqmKK2X7pKFg",
        "lat": 52.338109,
        "lng": 9.718339,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Tillystraße 30",
        "zip": "30459",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180843,
        "identifier": "DE021103",
        "googlePlaceId": "ChIJb-FjqahkpkcRbzZBovqG2Eo",
        "lat": 51.49826,
        "lng": 11.984106,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Halle",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Hermesstraße 7",
        "zip": "06114",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180844,
        "identifier": "DE005088",
        "googlePlaceId": "ChIJnwEcFYPKu0cRoxJdLmwxoiQ",
        "lat": 51.673558,
        "lng": 8.605103,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Salzkotten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Wallgraben 14",
        "zip": "33154",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180845,
        "identifier": "DE006060",
        "googlePlaceId": "ChIJa_npmq-gukcRAl56QdMcRRA",
        "lat": 52.285471,
        "lng": 9.820972,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Laatzen",
        "province": "Niedersachsen",
        "streetAndNumber": "Hildesheimer Straße 350",
        "zip": "30880",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180846,
        "identifier": "DE016006",
        "googlePlaceId": "ChIJv_2msY-FsUcRrnhQlQEtnwE",
        "lat": 53.555178,
        "lng": 9.928714,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Bahrenfelder Straße 188",
        "zip": "22765",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180847,
        "identifier": "DE036097",
        "googlePlaceId": "ChIJ_UVJfy5Gp0cRTbG5pacP3AE",
        "lat": 50.809302,
        "lng": 12.891509,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Chemnitz",
        "province": "Sachsen",
        "streetAndNumber": "Dr.-Salvador-Allende-Straße 1",
        "zip": "09119",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180848,
        "identifier": "DE013030",
        "googlePlaceId": "ChIJfaAv4_HXu0cR4Fls4xejtn8",
        "lat": 51.579369,
        "lng": 8.160271,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Sassendorf",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Schützenstraße 65",
        "zip": "59505",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180849,
        "identifier": "DE016003",
        "googlePlaceId": "ChIJOS3m8O6KsUcRWJeTWgSBhGY",
        "lat": 53.623034,
        "lng": 10.167189,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Meiendorfer Straße 98",
        "zip": "22145",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180850,
        "identifier": "DE002051",
        "googlePlaceId": "ChIJxf11MHvKvkcRcQZsLaMG4YA",
        "lat": 51.05417,
        "lng": 7.544957,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Marienheide",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Gummersbacher Straße 137a",
        "zip": "51709",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180851,
        "identifier": "DE029087",
        "googlePlaceId": "ChIJU-1-mC1IrEcRAF0Jr8IDZFc",
        "lat": 53.845627,
        "lng": 11.973771,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bützow",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Wismarsche Straße 2",
        "zip": "18246",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180852,
        "identifier": "DE031011",
        "googlePlaceId": "ChIJ6QfbWli5o0cR052zgHyy0U4",
        "lat": 50.421192,
        "lng": 10.729838,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hildburghausen",
        "province": "Thüringen",
        "streetAndNumber": "Coburger Straße 26",
        "zip": "98646",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180853,
        "identifier": "DE005147",
        "googlePlaceId": "ChIJ9WnegqN2u0cRg9nxvfc_qiM",
        "lat": 51.24106,
        "lng": 9.010243,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Waldeck",
        "province": "Hessen",
        "streetAndNumber": "Nieder-Werber Straße 6",
        "zip": "34513",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180855,
        "identifier": "DE007086",
        "googlePlaceId": "ChIJ__8_CdLpsEcR3OKD-n2VaFw",
        "lat": 52.82942,
        "lng": 8.9903,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bruchhausen-Vilsen",
        "province": "Niedersachsen",
        "streetAndNumber": "Lange Straße 12-14",
        "zip": "27305",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180856,
        "identifier": "DE020048",
        "googlePlaceId": "ChIJw6HPW3FZqEcR4CsTFf_DE4M",
        "lat": 52.428125,
        "lng": 13.214864,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Potsdamer Chaussee 33",
        "zip": "14129",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180857,
        "identifier": "DE004058",
        "googlePlaceId": "ChIJG5zf-81TskcRY-R-LJdXhvY",
        "lat": 54.240762,
        "lng": 10.054511,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Flintbek",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Eiderkamp 1",
        "zip": "24220",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180858,
        "identifier": "DE029052",
        "googlePlaceId": "ChIJQX9O4rZZrEcRqOt8wuSqldw",
        "lat": 54.114608,
        "lng": 12.189582,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rostock",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Goorstorfer Straße 50",
        "zip": "18146",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180859,
        "identifier": "DE002007",
        "googlePlaceId": "ChIJe6vc7ipIuUcRUI7DihcfwZw",
        "lat": 51.22734,
        "lng": 7.606816,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lüdenscheid",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hohe Steinert 5",
        "zip": "58509",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180860,
        "identifier": "DE016139",
        "googlePlaceId": "ChIJlwyf9j13skcROyzG6vBqgqw",
        "lat": 54.096447,
        "lng": 10.79245,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neustadt in Holstein",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Sierksdorfer Straße 19",
        "zip": "23730",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180862,
        "identifier": "DE004044",
        "googlePlaceId": "ChIJrcU5SoTetEcRtfLAtpbVHrI",
        "lat": 54.905026,
        "lng": 8.31625,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sylt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Keitumer Landstraße 21",
        "zip": "25980",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180863,
        "identifier": "DE024073",
        "googlePlaceId": "ChIJF4N08mhVqEcR3-9AgWqX3Ww",
        "lat": 52.62713,
        "lng": 13.225459,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Hennigsdorfer Straße 167",
        "zip": "13503",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180864,
        "identifier": "DE036067",
        "googlePlaceId": "ChIJY1Fb10xVCEcRncmkO_U9eKc",
        "lat": 51.180242917791,
        "lng": 14.403729401939,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bautzen",
        "province": "Sachsen",
        "streetAndNumber": "Dresdener Straße 68",
        "zip": "02625",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180865,
        "identifier": "DE031081",
        "googlePlaceId": "ChIJFT9Ef0TMpkcROTOzVaVugQM",
        "lat": 50.780114,
        "lng": 12.040182,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Weida",
        "province": "Thüringen",
        "streetAndNumber": "Am Schafberge 2",
        "zip": "07570",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180866,
        "identifier": "DE003115",
        "googlePlaceId": "ChIJt-LeYluDrkcR4gVeOid620U",
        "lat": 53.420444,
        "lng": 11.820741,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Parchim",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Juri-Gagarin-Ring 8",
        "zip": "19370",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180867,
        "identifier": "DE005045",
        "googlePlaceId": "ChIJz51qk31DukcRg2CfysbIjww",
        "lat": 51.943046,
        "lng": 8.87207,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Detmold",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Arminstraße 27",
        "zip": "32756",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180868,
        "identifier": "DE020096",
        "googlePlaceId": "ChIJEbNmju5FqEcRJxm5kLlMzxo",
        "lat": 52.434903,
        "lng": 13.466297,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Rudower Straße 116",
        "zip": "12351",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180869,
        "identifier": "DE031009",
        "googlePlaceId": "ChIJWaa0F3Lno0cRMYupIpkxu-I",
        "lat": 50.492686,
        "lng": 11.160238,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neuhaus am Rennweg",
        "province": "Thüringen",
        "streetAndNumber": "Sonneberger Straße 246",
        "zip": "98724",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180870,
        "identifier": "DE031002",
        "googlePlaceId": "ChIJowkkLFCNo0cR6nrzpnz5F1U",
        "lat": 50.67618601,
        "lng": 10.92871954,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ilmenau",
        "province": "Thüringen",
        "streetAndNumber": "Johann-Friedrich-Böttger-Straße 17",
        "zip": "98693",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180871,
        "identifier": "DE006155",
        "googlePlaceId": "ChIJK6pzL8idukcRvgFIy_7Fu_I",
        "lat": 52.281437,
        "lng": 9.575643,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wennigsen",
        "province": "Niedersachsen",
        "streetAndNumber": "Degerser Straße 34",
        "zip": "30974",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180872,
        "identifier": "DE020093",
        "googlePlaceId": "ChIJ8UM352xPqEcRM8TN1wEjjLA",
        "lat": 52.470158,
        "lng": 13.461715,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Grenzallee 4 L",
        "zip": "12057",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180873,
        "identifier": "DE024008",
        "googlePlaceId": "ChIJ5Ve3NWlJqEcRTIJhJYnHTX4",
        "lat": 52.510392,
        "lng": 13.56262,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Dingolfinger Straße 1",
        "zip": "12683",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180875,
        "identifier": "DE006034",
        "googlePlaceId": "ChIJDQTpfikksEcR0xnn_47VlUw",
        "lat": 52.727623,
        "lng": 10.22816,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eschede",
        "province": "Niedersachsen",
        "streetAndNumber": "Celler Straße 50a",
        "zip": "29348",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180877,
        "identifier": "DE029084",
        "googlePlaceId": "ChIJPaShju-TrUcRdtM41dg7FgQ",
        "lat": 53.98766,
        "lng": 11.197161,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ostseebad Boltenhagen",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Kastanienallee 1",
        "zip": "23946",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180878,
        "identifier": "DE036070",
        "googlePlaceId": "ChIJXzuNRXLKCUcRNjGA9C39Js0",
        "lat": 51.129115593322,
        "lng": 13.917215476448,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Radeberg",
        "province": "Sachsen",
        "streetAndNumber": "An der Ziegelei 2",
        "zip": "01454",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180879,
        "identifier": "DE024113",
        "googlePlaceId": "ChIJIbgqoLswqEcRKWJqmRPw7pM",
        "lat": 52.43004774,
        "lng": 13.75331278,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Erkner",
        "province": "Brandenburg",
        "streetAndNumber": "Julius-Rütgers-Straße 1a",
        "zip": "15537",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180880,
        "identifier": "DE007065",
        "googlePlaceId": "ChIJ_TZWmO3StkcRJYfdrsXF8Qc",
        "lat": 53.227605,
        "lng": 8.597881,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwanewede",
        "province": "Niedersachsen",
        "streetAndNumber": "Ritterkamp 42",
        "zip": "28790",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180881,
        "identifier": "DE026084",
        "googlePlaceId": "ChIJ6yhIURhFpUcREPeW_ZO1hC0",
        "lat": 52.0512,
        "lng": 10.3748,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Salzgitter",
        "province": "Niedersachsen",
        "streetAndNumber": "Breslauer Straße 11-15",
        "zip": "38259",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180882,
        "identifier": "DE029080",
        "googlePlaceId": "ChIJ2cbBWaHHrUcRnLFZw0L2m2I",
        "lat": 53.885907,
        "lng": 11.462217,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wismar",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Am Dreweswäldchen 19",
        "zip": "23970",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180883,
        "identifier": "DE036038",
        "googlePlaceId": "ChIJ24mzwivGCUcRxiEpkWscvGE",
        "lat": 51.02863,
        "lng": 13.81224,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Löwenhainer Straße 2",
        "zip": "01279",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180884,
        "identifier": "DE004146",
        "googlePlaceId": "ChIJuYQTynZvskcR3P947cK2wGY",
        "lat": 54.129603,
        "lng": 10.58036,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eutin",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Plöner Landstraße 8-10",
        "zip": "23701",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180885,
        "identifier": "DE016016",
        "googlePlaceId": "ChIJr8hG8EmJsUcRf5ld--DOgak",
        "lat": 53.587905,
        "lng": 10.043757,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Krüsistraße 7",
        "zip": "22305",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180886,
        "identifier": "DE031085",
        "googlePlaceId": "ChIJL1MzZjPhoEcRkk_eLfYkeBU",
        "lat": 50.331949,
        "lng": 12.253514,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Adorf",
        "province": "Sachsen",
        "streetAndNumber": "Elster Straße 77",
        "zip": "08626",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180887,
        "identifier": "DE025034",
        "googlePlaceId": "ChIJufDSLQKRt0cREr1TtzR68PI",
        "lat": 52.691783,
        "lng": 7.272404,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Meppen",
        "province": "Niedersachsen",
        "streetAndNumber": "Schullendamm 64B",
        "zip": "49716",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180888,
        "identifier": "DE025037",
        "googlePlaceId": "ChIJwWjdJklyt0cRsec3K6P6Xtw",
        "lat": 52.7322,
        "lng": 7.75764,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Löningen",
        "province": "Niedersachsen",
        "streetAndNumber": "Angelbecker Straße 1",
        "zip": "49624",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180889,
        "identifier": "DE036083",
        "googlePlaceId": "ChIJcbvqVkZJCEcRSKFioRDlDR4",
        "lat": 51.271359,
        "lng": 14.103714,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kamenz",
        "province": "Sachsen",
        "streetAndNumber": "Uferstraße 4",
        "zip": "01917",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180890,
        "identifier": "DE001081",
        "googlePlaceId": "ChIJ35djIIHnuEcRk3yht3SG2JM",
        "lat": 51.473317,
        "lng": 7.073381,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Mörgekenweg 8",
        "zip": "45309",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180892,
        "identifier": "DE036099",
        "googlePlaceId": "ChIJJ6ccXNUwp0cRa5bSPgcgTVc",
        "lat": 51.162312,
        "lng": 13.491992,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Meißen",
        "province": "Sachsen",
        "streetAndNumber": "Elisabethstraße 1",
        "zip": "01662",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180893,
        "identifier": "DE036087",
        "googlePlaceId": "ChIJT_P6dopVCEcR5Ztrnbf262g",
        "lat": 51.186835,
        "lng": 14.440322,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bautzen",
        "province": "Sachsen",
        "streetAndNumber": "Gesundbrunnenring 4",
        "zip": "02625",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180895,
        "identifier": "DE006151",
        "googlePlaceId": "ChIJy63p1CFxsEcRGOoygTzI4uQ",
        "lat": 52.420096,
        "lng": 9.595365,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Garbsen",
        "province": "Niedersachsen",
        "streetAndNumber": "Planetenring 33",
        "zip": "30823",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180896,
        "identifier": "DE016126",
        "googlePlaceId": "ChIJLaC6UHYpskcRXljWDwhrYj0",
        "lat": 53.721266,
        "lng": 9.900511,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Quickborn",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Güttloh 6",
        "zip": "25451",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180898,
        "identifier": "DE002102",
        "googlePlaceId": "ChIJP5zs36QavEcRGlLojSiaZUU",
        "lat": 50.882463,
        "lng": 8.141988,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Netphen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kälberhof 21",
        "zip": "57250",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180899,
        "identifier": "DE002006",
        "googlePlaceId": "ChIJSWp0sJ_TuEcR7oZ0Enlr020",
        "lat": 51.179731,
        "lng": 7.033342,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Solingen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Weyerstraße 306",
        "zip": "42719",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180900,
        "identifier": "DE036079",
        "googlePlaceId": "ChIJK8-NobbdCEcRDLSKvYaPU58",
        "lat": 51.168925,
        "lng": 14.971033,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Görlitz",
        "province": "Sachsen",
        "streetAndNumber": "Nieskyer Straße 100",
        "zip": "02828",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180902,
        "identifier": "DE005029",
        "googlePlaceId": "ChIJHWpbHORTukcR0SCsEbBlDaE",
        "lat": 51.755955,
        "lng": 8.953236,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Altenbeken",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hüttenstraße 67",
        "zip": "33184",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180903,
        "identifier": "DE005089",
        "googlePlaceId": "ChIJ7wvpfOI9ukcRM3ZGQhEyXdg",
        "lat": 52.03236,
        "lng": 8.609402,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Amtmann-Bullrich-Straße 23",
        "zip": "33719",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180904,
        "identifier": "DE026060",
        "googlePlaceId": "ChIJq10VDZCQpUcRHcOIFwk6anE",
        "lat": 51.94082,
        "lng": 11.232561,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gröningen",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Magdeburger Straße 20",
        "zip": "39397",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180906,
        "identifier": "DE032121",
        "googlePlaceId": "ChIJW17yhYqvuUcR-KdPDuf5-p4",
        "lat": 51.923996,
        "lng": 7.577708,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Münster",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Weseler Straße 651",
        "zip": "48163",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180908,
        "identifier": "DE013092",
        "googlePlaceId": "ChIJZQBuNYCeu0cRFAgtHlQkKQY",
        "lat": 51.264036,
        "lng": 8.865846,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Korbach",
        "province": "Hessen",
        "streetAndNumber": "Südring 30",
        "zip": "34497",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180909,
        "identifier": "DE031050",
        "googlePlaceId": "ChIJCyBocAWmpkcR7iCU11rZ2W4",
        "lat": 50.946905,
        "lng": 11.604476,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Jena",
        "province": "Thüringen",
        "streetAndNumber": "Altenburger Straße 1",
        "zip": "07743",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180910,
        "identifier": "DE013099",
        "googlePlaceId": "ChIJubLK-3huvEcRuosAaBkDz20",
        "lat": 50.840045,
        "lng": 8.467455,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Steffenberg",
        "province": "Hessen",
        "streetAndNumber": "Kaufpark Steffenberg 3",
        "zip": "35239",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180911,
        "identifier": "DE032049",
        "googlePlaceId": "ChIJSWrLQi75uEcRi9B2DRXmm5Y",
        "lat": 51.750526,
        "lng": 7.195066,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Haltern am See",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lohausstraße 17",
        "zip": "45721",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180912,
        "identifier": "DE005041",
        "googlePlaceId": "ChIJCZaURXo7ukcRhDLVtJ6FtSo",
        "lat": 51.959293,
        "lng": 8.521615,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Windelsbleicher Straße 239a",
        "zip": "33659",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180913,
        "identifier": "DE003057",
        "googlePlaceId": "ChIJuUI3XXrYsUcRbEDGEaIEi7Q",
        "lat": 53.135024,
        "lng": 10.494906,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bienenbüttel",
        "province": "Niedersachsen",
        "streetAndNumber": "Rübenbaum 1",
        "zip": "29553",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180914,
        "identifier": "DE036022",
        "googlePlaceId": "ChIJnZyjqV2Dp0cRgk4WMvbKyiM",
        "lat": 51.335253,
        "lng": 13.340705,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zeithain",
        "province": "Sachsen",
        "streetAndNumber": "Teninger Straße 5",
        "zip": "01619",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180915,
        "identifier": "DE020062",
        "googlePlaceId": "ChIJwYlfV0PAqEcRDK3IfovJhtc",
        "lat": 52.403008,
        "lng": 12.569109,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Brandenburg an der Havel",
        "province": "Brandenburg",
        "streetAndNumber": "Geschwister-Scholl-Straße 30",
        "zip": "14776",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180916,
        "identifier": "DE006126",
        "googlePlaceId": "ChIJza64ULn2r0cRAsjlTa-i6oE",
        "lat": 52.304568,
        "lng": 10.51709,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Braunschweig",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Denkmal 4",
        "zip": "38112",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180917,
        "identifier": "DE021072",
        "googlePlaceId": "ChIJ2zNvcFcqp0cR_7cHiT-jmYI",
        "lat": 50.734676,
        "lng": 12.372898,
        "name": "ALDI",
        "country": "DE",
        "city": "Werdau",
        "province": "Sachsen",
        "streetAndNumber": "Uferstraße 3",
        "zip": "08412",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180918,
        "identifier": "DE006020",
        "googlePlaceId": "ChIJ7UqmBfigukcRNoiw-pcmve0",
        "lat": 52.265742,
        "lng": 9.770397,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Pattensen",
        "province": "Niedersachsen",
        "streetAndNumber": "Johann-Koch-Straße 2",
        "zip": "30982",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180920,
        "identifier": "DE036091",
        "googlePlaceId": "ChIJfXQ1Rm_JoEcRHKriJhtmrhU",
        "lat": 50.563587,
        "lng": 12.637292,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zschorlau",
        "province": "Sachsen",
        "streetAndNumber": "Am Kuchenhaus 12",
        "zip": "08321",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "18:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180921,
        "identifier": "DE004125",
        "googlePlaceId": "ChIJt9Khfqh4sUcRc3Moh2aLCHc",
        "lat": 53.59301,
        "lng": 9.71059,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wedel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Am Marienhof 1-3",
        "zip": "22880",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180922,
        "identifier": "DE002074",
        "googlePlaceId": "ChIJTdKtYN7WuEcRR6ZZJ3SPz8I",
        "lat": 51.253944,
        "lng": 7.10036,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Benrather Straße 14",
        "zip": "42115",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180923,
        "identifier": "DE021118",
        "googlePlaceId": "ChIJp_KqR7E8CEcRsEIgMQ9JGds",
        "lat": 51.467668,
        "lng": 13.869456,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwarzheide",
        "province": "Brandenburg",
        "streetAndNumber": "Schipkauer Straße 13",
        "zip": "01987",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180924,
        "identifier": "DE010088",
        "googlePlaceId": "ChIJ0etOsGqCvEcRcDk-0eBOSF0",
        "lat": 50.982042,
        "lng": 8.971515,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gemünden",
        "province": "Hessen",
        "streetAndNumber": "Ellnröder Straße 27",
        "zip": "35285",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180925,
        "identifier": "DE010026",
        "googlePlaceId": "ChIJK1vQAWg_u0cRywwSe-sgizM",
        "lat": 51.311446,
        "lng": 9.464419,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kassel",
        "province": "Hessen",
        "streetAndNumber": "Wittrockstraße 3",
        "zip": "34121",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180926,
        "identifier": "DE024011",
        "googlePlaceId": "ChIJL7QJRH9JqEcRmw6JWXEd2ys",
        "lat": 52.517074,
        "lng": 13.590015,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Gülzower Straße 74",
        "zip": "12619",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180927,
        "identifier": "DE002030",
        "googlePlaceId": "ChIJC_EzY35UuUcRzh7GM-0jGq8",
        "lat": 51.122273,
        "lng": 7.901741,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Attendorn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Zollstock 51",
        "zip": "57439",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "closed": true
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180928,
        "identifier": "DE003002",
        "googlePlaceId": "ChIJnd1WdseOsUcRvUy4EaZpruE",
        "lat": 53.562993,
        "lng": 10.033564,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Lübecker Straße 116-124",
        "zip": "22087",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180929,
        "identifier": "DE007053",
        "googlePlaceId": "ChIJPy01DXccsUcRFPYUFTJ8vO4",
        "lat": 53.115706,
        "lng": 9.233574,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sottrum",
        "province": "Niedersachsen",
        "streetAndNumber": "Große Straße 36",
        "zip": "27367",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180931,
        "identifier": "DE001070",
        "googlePlaceId": "ChIJ43_pmb_kuEcR8jFfmtzbKNY",
        "lat": 51.61684,
        "lng": 7.144787,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Scherlebecker Straße 256",
        "zip": "45701",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180932,
        "identifier": "DE025073",
        "googlePlaceId": "ChIJV2skQrrPuUcRHM0Wc8zw2-c",
        "lat": 52.256874,
        "lng": 7.62989,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hörstel",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Heinrich-Niemeyer-Straße 66",
        "zip": "48477",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180933,
        "identifier": "DE020026",
        "googlePlaceId": "ChIJ8WXhcedaqEcRKKfOXEqa2ug",
        "lat": 52.42982,
        "lng": 13.330163,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Lankwitzer Straße 20-24",
        "zip": "12209",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180934,
        "identifier": "DE031026",
        "googlePlaceId": "ChIJkS34BAEnoUcRAaUQOX2zbXU",
        "lat": 50.492707,
        "lng": 12.151542,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Plauen",
        "province": "Sachsen",
        "streetAndNumber": "Äußere Reichenbacher Straße 64",
        "zip": "08529",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180935,
        "identifier": "DE021119",
        "googlePlaceId": "ChIJwcBc8ZLzp0cRAPGbMSzgJj8",
        "lat": 51.637048,
        "lng": 13.564231,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Doberlug-Kirchhain",
        "province": "Brandenburg",
        "streetAndNumber": "Gerberstraße 16-23",
        "zip": "03253",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180936,
        "identifier": "DE036025",
        "googlePlaceId": "ChIJkYh8B5DPCUcR9nEpWByVZiI",
        "lat": 51.051081,
        "lng": 13.713555,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Löbtauer Straße 40",
        "zip": "01159",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180937,
        "identifier": "DE026011",
        "googlePlaceId": "ChIJV9IzX57vrkcREl7oKrEQp6E",
        "lat": 53.00298,
        "lng": 11.721616,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wittenberge",
        "province": "Brandenburg",
        "streetAndNumber": "Lenzener Chaussee 19",
        "zip": "19322",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180938,
        "identifier": "DE002020",
        "googlePlaceId": "ChIJPwm6b2nTuEcRmPLSGu9Hbcg",
        "lat": 51.152068,
        "lng": 7.022351,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Solingen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Friedenstraße 94a",
        "zip": "42699",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180939,
        "identifier": "DE032133",
        "googlePlaceId": "ChIJ69LzRnm6uUcRVOjteO5tcNo",
        "lat": 51.994537,
        "lng": 7.602991,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Münster",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Idenbrockplatz 27/28",
        "zip": "48159",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180940,
        "identifier": "DE003087",
        "googlePlaceId": "ChIJE6glMOJSsUcRffzME7bz1yw",
        "lat": 53.628092,
        "lng": 8.809215,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Geestland",
        "province": "Niedersachsen",
        "streetAndNumber": "Handelspark 21",
        "zip": "27624",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180941,
        "identifier": "DE005058",
        "googlePlaceId": "ChIJmwqPX6AlukcRtxHj5OZfooU",
        "lat": 51.917312,
        "lng": 8.3704681,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gütersloh",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Haegestraße 6-8",
        "zip": "33330",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180942,
        "identifier": "DE010015",
        "googlePlaceId": "ChIJo6TXA546u0cRqR6eUqRheog",
        "lat": 51.418661810768,
        "lng": 9.6645738970276,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hann. Münden",
        "province": "Niedersachsen",
        "streetAndNumber": "Steinweg 73",
        "zip": "34346",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180943,
        "identifier": "DE024060",
        "googlePlaceId": "ChIJN-vVl9pNqEcRDTURompARz4",
        "lat": 52.545586,
        "lng": 13.463704,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Chopinstraße 28",
        "zip": "13088",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180944,
        "identifier": "DE004135",
        "googlePlaceId": "ChIJcXcZ00peskcR7NAyWM1meMo",
        "lat": 54.289191,
        "lng": 10.429759,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Selent",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Kieler Straße 5",
        "zip": "24238",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180946,
        "identifier": "DE004065",
        "googlePlaceId": "ChIJ2SozouCAs0cRYGqibBIV-94",
        "lat": 54.378515,
        "lng": 9.073121,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Friedrichstadt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Van-Wouwer-Straße 1-3",
        "zip": "25840",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180947,
        "identifier": "DE004055",
        "googlePlaceId": "ChIJpcQDAdGls0cRXtmaL6XCZn0",
        "lat": 54.301693,
        "lng": 9.673829,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rendsburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Konrad-Adenauer-Straße 3",
        "zip": "24768",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180948,
        "identifier": "DE005020",
        "googlePlaceId": "ChIJET1dIYMlukcRU_5Rklbhj3M",
        "lat": 51.901973,
        "lng": 8.397697,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gütersloh",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kampstraße 20/22",
        "zip": "33332",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180949,
        "identifier": "DE007061",
        "googlePlaceId": "ChIJ5dGWZAL_s0cRCcUc9NXJ4ME",
        "lat": 53.807089,
        "lng": 8.887758,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Otterndorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Cuxhavener Straße 42-44",
        "zip": "21762",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180950,
        "identifier": "DE007078",
        "googlePlaceId": "ChIJC3Aw-AmxtkcRKct9BH9wJHc",
        "lat": 53.558121,
        "lng": 8.594143,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremerhaven",
        "province": "Bremen",
        "streetAndNumber": "Stresemannstraße 150",
        "zip": "27576",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180951,
        "identifier": "DE020023",
        "googlePlaceId": "ChIJ5b7P36FQqEcRo4xhdhzRUY8",
        "lat": 52.473331,
        "lng": 13.290462,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Warnemünder Straße 8",
        "zip": "14199",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180952,
        "identifier": "DE006004",
        "googlePlaceId": "ChIJnz0psk6Sr0cRzZ3Cap8fd6I",
        "lat": 52.41929,
        "lng": 10.78441,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wolfsburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Porschestraße 102",
        "zip": "38440",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180953,
        "identifier": "DE005110",
        "googlePlaceId": "ChIJDzIoNyEaukcR9LA3B1v4-cA",
        "lat": 52.138881,
        "lng": 8.4811,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Spenge",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Mühlenburger Straße 5 - 7",
        "zip": "32139",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180954,
        "identifier": "DE005040",
        "googlePlaceId": "ChIJF-Ps4wPIu0cRQmIR5ugqZK8",
        "lat": 51.54552,
        "lng": 8.564587,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Büren",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Fürstenberger Straße 26",
        "zip": "33142",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180955,
        "identifier": "DE005134",
        "googlePlaceId": "ChIJQwbWfMRkukcRaZsXIB70lnc",
        "lat": 52.168863,
        "lng": 9.066571,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rinteln",
        "province": "Niedersachsen",
        "streetAndNumber": "Braasstraße 1c",
        "zip": "31737",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180956,
        "identifier": "DE001019",
        "googlePlaceId": "ChIJdYJ_ct7muEcRbDz70cxpEn4",
        "lat": 51.514415,
        "lng": 7.122055,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gelsenkirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wanner Straße 186",
        "zip": "45888",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180957,
        "identifier": "DE005060",
        "googlePlaceId": "ChIJl6beNbcjukcRA_lHEAnthWI",
        "lat": 52.007768,
        "lng": 8.412317,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Steinhagen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bahnhofstraße 25",
        "zip": "33803",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180958,
        "identifier": "DE004024",
        "googlePlaceId": "ChIJ25acP_JVskcR66VeNl7Dki0",
        "lat": 54.353224,
        "lng": 10.092636,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Steekberg 1",
        "zip": "24107",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180959,
        "identifier": "DE031038",
        "googlePlaceId": "ChIJq6pqi4RtpEcRJT2VeojGDd8",
        "lat": 51.004717,
        "lng": 11.003977,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Erfurt",
        "province": "Thüringen",
        "streetAndNumber": "Berliner Platz 4",
        "zip": "99091",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180960,
        "identifier": "DE036051",
        "googlePlaceId": "ChIJ6Z7_fEnPCUcREvF2_URWwcA",
        "lat": 51.056539,
        "lng": 13.765143,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Pfotenhauerstraße 7b",
        "zip": "01307",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180961,
        "identifier": "DE005125",
        "googlePlaceId": "ChIJN1lLJsl2ukcRBVPB36DHXes",
        "lat": 52.285764,
        "lng": 8.951988,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Minden",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Gneisenaustraße 4",
        "zip": "32423",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180962,
        "identifier": "DE013039",
        "googlePlaceId": "ChIJKd92doRCuUcRI8qAGhJ54kM",
        "lat": 51.416391,
        "lng": 7.827945,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Menden (Sauerland)",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Heinrich-Böll-Straße 3",
        "zip": "58710",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180963,
        "identifier": "DE020004",
        "googlePlaceId": "ChIJjy8upyFaqEcRizSc7nMTV1U",
        "lat": 52.449581,
        "lng": 13.253458,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Wilskistraße 47B",
        "zip": "14169",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180964,
        "identifier": "DE015003",
        "googlePlaceId": "ChIJv0Fm6N9NtkcRdqANPbPiCx0",
        "lat": 53.242882,
        "lng": 7.460285,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leer (Ostfriesland)",
        "province": "Niedersachsen",
        "streetAndNumber": "Ringstraße 19",
        "zip": "26789",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180965,
        "identifier": "DE020015",
        "googlePlaceId": "ChIJy3GijrZFqEcRk0X6DPnJxxE",
        "lat": 52.386166,
        "lng": 13.401807,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Zescher Straße 3-5",
        "zip": "12307",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180966,
        "identifier": "DE026074",
        "googlePlaceId": "ChIJjd3Pag3BpUcREsDXtEYVS64",
        "lat": 51.74994,
        "lng": 11.45873,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Aschersleben",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Eislebener Straße 3",
        "zip": "06449",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180967,
        "identifier": "DE032046",
        "googlePlaceId": "ChIJ74sZl26nuUcRwiIjMzro0Q4",
        "lat": 51.790214,
        "lng": 7.615255,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ascheberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lüdinghauser Straße 14",
        "zip": "59387",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180970,
        "identifier": "DE032056",
        "googlePlaceId": "ChIJJ46x8qYduUcRByGtvIvFrkc",
        "lat": 51.579815,
        "lng": 7.303417,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Castrop-Rauxel",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wartburgstraße 69A",
        "zip": "44579",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180971,
        "identifier": "DE007096",
        "googlePlaceId": "ChIJs9T_QtK4sEcR7CmU_S6Pbnk",
        "lat": 52.685484,
        "lng": 8.811611,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sulingen",
        "province": "Niedersachsen",
        "streetAndNumber": "Bismarckstraße 2-4",
        "zip": "27232",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180972,
        "identifier": "DE004003",
        "googlePlaceId": "ChIJw-eWaNhCskcRZRXpmLKrZGI",
        "lat": 54.153734,
        "lng": 10.357725,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ascheberg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Plöner Chaussee 74",
        "zip": "24326",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180974,
        "identifier": "DE002049",
        "googlePlaceId": "ChIJCWmebFrSuEcRamSexSLNVHs",
        "lat": 51.186471,
        "lng": 6.992486,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Haan",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Düsseldorfer Straße 49",
        "zip": "42781",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180975,
        "identifier": "DE001085",
        "googlePlaceId": "ChIJt6BYouXCuEcR3C-ifYK1pmo",
        "lat": 51.443004,
        "lng": 6.981174,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Keplerstraße 88-92",
        "zip": "45147",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180976,
        "identifier": "DE020081",
        "googlePlaceId": "ChIJTdBL6qk9qUcR-xarhzutgsU",
        "lat": 52.915062,
        "lng": 12.805393,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neuruppin",
        "province": "Brandenburg",
        "streetAndNumber": "Trenckmannstraße 16",
        "zip": "16816",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180977,
        "identifier": "DE024029",
        "googlePlaceId": "ChIJE1UvwYrKqUcRoP31FB_4ToI",
        "lat": 52.63281,
        "lng": 13.742264,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Werneuchen",
        "province": "Brandenburg",
        "streetAndNumber": "Freienwalder Straße 45 b",
        "zip": "16356",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180978,
        "identifier": "DE029067",
        "googlePlaceId": "ChIJyUb3OzFXrEcRI16fyhu8APY",
        "lat": 54.0939,
        "lng": 12.107319,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rostock",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Werftstraße 50",
        "zip": "18057",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180979,
        "identifier": "DE005086",
        "googlePlaceId": "ChIJCXPCIEV0ukcR_varRnSz2Rs",
        "lat": 52.312428,
        "lng": 8.885931,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Minden",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Stiftsallee 128",
        "zip": "32425",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180980,
        "identifier": "DE007011",
        "googlePlaceId": "ChIJHRVOlhIosUcRjKz5U9NPHcU",
        "lat": 53.084573,
        "lng": 8.814213,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Theodor-Heuss-Allee 6",
        "zip": "28215",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180981,
        "identifier": "DE032030",
        "googlePlaceId": "ChIJM06cT0cWuUcR7-Pud5zYztQ",
        "lat": 51.464445,
        "lng": 7.52481,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wittbräucker Straße 372",
        "zip": "44267",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:30"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:30"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:30"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:30"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:30"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:30"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180982,
        "identifier": "DE005074",
        "googlePlaceId": "ChIJrwkabFovukcRj61pJF0O9yM",
        "lat": 51.887846,
        "lng": 8.357361,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gütersloh",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hans-Böckler-Straße 32",
        "zip": "33334",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180985,
        "identifier": "DE032075",
        "googlePlaceId": "ChIJLXpfFSIfuUcRbeaIPqnnfaY",
        "lat": 51.491551,
        "lng": 7.308258,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Werner Hellweg 517-521",
        "zip": "44894",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180986,
        "identifier": "DE007021",
        "googlePlaceId": "ChIJzzpWIW3YsEcRH8C6HEM3EKk",
        "lat": 53.048267,
        "lng": 8.848728,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Steinsetzerstraße 11",
        "zip": "28279",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180987,
        "identifier": "DE031029",
        "googlePlaceId": "ChIJ98KC9MxIpEcRX59QhmNoFCM",
        "lat": 51.353666,
        "lng": 11.098821,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Frankenhausen",
        "province": "Thüringen",
        "streetAndNumber": "Bahnhofstraße 1-3",
        "zip": "06567",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180988,
        "identifier": "DE032115",
        "googlePlaceId": "ChIJQxD6QfxIuEcRUuKe1YxAPCg",
        "lat": 52.08997,
        "lng": 7.233117,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schöppingen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Amtsstraße 31",
        "zip": "48624",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180989,
        "identifier": "DE003027",
        "googlePlaceId": "ChIJ24-X8fyQsUcRorvdEt3S670",
        "lat": 53.443959,
        "lng": 9.955198,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Beutnerring 21",
        "zip": "21077",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180990,
        "identifier": "DE002008",
        "googlePlaceId": "ChIJtxWNoKG2vkcR5ZgUd8pE6Lw",
        "lat": 51.010636,
        "lng": 7.630833,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bergneustadt",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kölner Straße 2-14",
        "zip": "51702",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180991,
        "identifier": "DE032074",
        "googlePlaceId": "ChIJZTjjbacXuUcRG9nB5APDzIY",
        "lat": 51.483092,
        "lng": 7.495044,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Gildenstraße 65",
        "zip": "44263",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180993,
        "identifier": "DE010022",
        "googlePlaceId": "ChIJczrAAUgru0cRc0lRWvMQsHk",
        "lat": 51.540839,
        "lng": 9.89763,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Göttingen",
        "province": "Niedersachsen",
        "streetAndNumber": "Industriestraße 9",
        "zip": "37079",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180994,
        "identifier": "DE013038",
        "googlePlaceId": "ChIJ6yYhbS1CuUcRpKRYy42U1u4",
        "lat": 51.384587,
        "lng": 7.76882,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hemer",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bahnhofstraße 4-8",
        "zip": "58675",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180995,
        "identifier": "DE032036",
        "googlePlaceId": "ChIJLzmdHeYCuUcRrfaeywJQKIA",
        "lat": 51.64991,
        "lng": 7.327037,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Datteln",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Rudolf-Diesel-Straße 3",
        "zip": "45711",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180996,
        "identifier": "DE003056",
        "googlePlaceId": "ChIJvT8UXHORsUcRY02qMPxr0ks",
        "lat": 53.443595,
        "lng": 9.992462,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Rönneburger Straße 5",
        "zip": "21079",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180997,
        "identifier": "DE016072",
        "googlePlaceId": "ChIJgW85QHOHsUcRgviXFWpI_rE",
        "lat": 53.655012,
        "lng": 9.90787,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bönningstedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Kieler Straße 66-68",
        "zip": "25474",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180998,
        "identifier": "DE020025",
        "googlePlaceId": "ChIJscAI7ZxFqEcRU2CtXWP8iQU",
        "lat": 52.440208,
        "lng": 13.433967,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Buckower Damm 50",
        "zip": "12349",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3180999,
        "identifier": "DE029074",
        "googlePlaceId": "ChIJ4dE-dBJgqUcRuBYiAep2zao",
        "lat": 53.349667,
        "lng": 13.076581,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neustrelitz",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Kühlhausberg 15",
        "zip": "17235",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3181001,
        "identifier": "DE026072",
        "googlePlaceId": "ChIJf5ReWLXgpUcRGzGYb-arzSo",
        "lat": 51.794784,
        "lng": 11.745336,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bernburg (Saale)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Karlstraße 1",
        "zip": "06406",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181002,
        "identifier": "DE021044",
        "googlePlaceId": "ChIJ9bYzxZkNp0cRXB0m0XJUP0c",
        "lat": 51.156452471249,
        "lng": 12.915759122729,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leisnig",
        "province": "Sachsen",
        "streetAndNumber": "Wilhelm-Ostwald-Straße 8",
        "zip": "04703",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181003,
        "identifier": "DE026093",
        "googlePlaceId": "ChIJuRC8RABvpUcRB0Rp3bfq9Xs",
        "lat": 51.968696,
        "lng": 10.719681,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Osterwieck",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Bahnhofstraße 18a",
        "zip": "38835",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181004,
        "identifier": "DE021050",
        "googlePlaceId": "ChIJY8RFD3LlpkcRv8DNIHV_o9A",
        "lat": 51.151671,
        "lng": 12.287607,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Groitzsch",
        "province": "Sachsen",
        "streetAndNumber": "Schusterstraße 1",
        "zip": "04539",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181005,
        "identifier": "DE010035",
        "googlePlaceId": "ChIJnbgKjP5Pu0cR4YXdBGcvTQM",
        "lat": 51.128832,
        "lng": 9.549157,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Melsungen",
        "province": "Hessen",
        "streetAndNumber": "Bahnhofstraße 4",
        "zip": "34212",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181006,
        "identifier": "DE002088",
        "googlePlaceId": "ChIJs_Y8-n9AvEcR5pHV8MUxAs0",
        "lat": 50.671749,
        "lng": 8.307563,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herborn",
        "province": "Hessen",
        "streetAndNumber": "Konrad-Adenauer-Straße 37",
        "zip": "35745",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181007,
        "identifier": "DE010071",
        "googlePlaceId": "ChIJeUY2fqvPukcRJuYH8uOu71g",
        "lat": 51.81678,
        "lng": 9.83685,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Einbeck",
        "province": "Niedersachsen",
        "streetAndNumber": "Hansestraße 1A",
        "zip": "37574",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181008,
        "identifier": "DE010077",
        "googlePlaceId": "ChIJnV6UufOjvEcR7r80OTMfC0Q",
        "lat": 50.873702,
        "lng": 9.333678,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neukirchen",
        "province": "Hessen",
        "streetAndNumber": "Niederrheinische Straße 40",
        "zip": "34626",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181009,
        "identifier": "DE032050",
        "googlePlaceId": "ChIJ-xLx5i-puUcRjMBof9BOI8w",
        "lat": 51.859206,
        "lng": 7.491733,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Senden",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Grete-Schött-Ring 17",
        "zip": "48308",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181010,
        "identifier": "DE020039",
        "googlePlaceId": "ChIJU-nacrRPqEcR_vyqKKTzmI4",
        "lat": 52.492294,
        "lng": 13.430539,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Liberdastraße 5",
        "zip": "12047",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3181011,
        "identifier": "DE016052",
        "googlePlaceId": "ChIJK029fuMnskcR_Y8FSR7Fb1Y",
        "lat": 53.680698,
        "lng": 9.994068,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Norderstedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Ohechaussee 26-32",
        "zip": "22848",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181012,
        "identifier": "DE021095",
        "googlePlaceId": "ChIJOb5kNZl8pkcRNyAwJCZbbxo",
        "lat": 51.492903,
        "lng": 11.932036,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Halle (Saale)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Blücherstraße 36",
        "zip": "06120",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181013,
        "identifier": "DE026010",
        "googlePlaceId": "ChIJM37ZgDaar0cRyTvDg4NbC_s",
        "lat": 52.428241,
        "lng": 10.994576,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oebisfelde",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Niendorfer Straße 2A",
        "zip": "39646",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181014,
        "identifier": "DE002034",
        "googlePlaceId": "ChIJCzSrHxdQuUcRAr8ieRrKxVs",
        "lat": 51.2354,
        "lng": 7.839779,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Plettenberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lennestraße 59",
        "zip": "58840",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181015,
        "identifier": "DE020017",
        "googlePlaceId": "ChIJE6kb7kZFqEcRqgWyxNLDEyQ",
        "lat": 52.441307,
        "lng": 13.390582,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Alt-Mariendorf 16",
        "zip": "12107",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181016,
        "identifier": "DE001073",
        "googlePlaceId": "ChIJwTDLSsPCuEcR1_dxCBLeYI4",
        "lat": 51.442908,
        "lng": 6.994847,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Papestraße 42",
        "zip": "45147",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181017,
        "identifier": "DE021062",
        "googlePlaceId": "ChIJM-orPTYsp0cRW02w_CbqZjg",
        "lat": 50.739347,
        "lng": 12.49555,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zwickau",
        "province": "Sachsen",
        "streetAndNumber": "Angerstraße 21",
        "zip": "08058",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181018,
        "identifier": "DE001095",
        "googlePlaceId": "ChIJi4iB2KpCuEcRGInF17pUREM",
        "lat": 51.987439,
        "lng": 6.941371,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stadtlohn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Breul 91",
        "zip": "48703",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181019,
        "identifier": "DE001058",
        "googlePlaceId": "ChIJnUP60_7BuEcRTw_HvF3IY04",
        "lat": 51.474801,
        "lng": 6.914347,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Frintroper Straße 422",
        "zip": "45359",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181021,
        "identifier": "DE015012",
        "googlePlaceId": "ChIJCWdcp-w5tkcRiUNMWbOwzvc",
        "lat": 53.367033,
        "lng": 7.202309,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Emden",
        "province": "Niedersachsen",
        "streetAndNumber": "Lookvenne 12",
        "zip": "26721",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181022,
        "identifier": "DE016163",
        "googlePlaceId": "ChIJp0iCW8w_skcR8WooO2_NA-E",
        "lat": 53.950142,
        "lng": 10.313336,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Segeberg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Eutiner Straße 24",
        "zip": "23795",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181023,
        "identifier": "DE013086",
        "googlePlaceId": "ChIJWaoCtcs-uUcRYpm3JUmIwvY",
        "lat": 51.35908,
        "lng": 7.563782,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hagen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Esserstraße 15",
        "zip": "58119",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181024,
        "identifier": "DE007104",
        "googlePlaceId": "ChIJ5bHrTluMsEcRUMKUVjN_LmQ",
        "lat": 52.633792,
        "lng": 9.224885,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nienburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Ziegelkampstraße 30",
        "zip": "31582",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181025,
        "identifier": "DE003066",
        "googlePlaceId": "ChIJy3-TBQvesUcR5f5mbjQDYfg",
        "lat": 53.260228,
        "lng": 10.436969,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lüneburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Wulf-Werum-Straße 2",
        "zip": "21337",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181026,
        "identifier": "DE020052",
        "googlePlaceId": "ChIJ7_q0p27zqEcRMNcX0qP_prg",
        "lat": 52.363689,
        "lng": 12.939201,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Werder",
        "province": "Brandenburg",
        "streetAndNumber": "Apfelweg 4",
        "zip": "14542",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181027,
        "identifier": "DE036078",
        "googlePlaceId": "ChIJlaG7BS49CUcR0MjnH3p1CgI",
        "lat": 50.900849,
        "lng": 14.818402,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zittau",
        "province": "Sachsen",
        "streetAndNumber": "Leipziger Straße 35",
        "zip": "02763",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181028,
        "identifier": "DE024028",
        "googlePlaceId": "ChIJtTdKMBbsqUcRpN4kZzx5xcc",
        "lat": 53.016012,
        "lng": 14.014199,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Angermünde",
        "province": "Brandenburg",
        "streetAndNumber": "Schwedter Straße 21",
        "zip": "16278",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181029,
        "identifier": "DE029078",
        "googlePlaceId": "ChIJ7-2ior1BqUcRvp7O1Z002JU",
        "lat": 53.099999,
        "lng": 12.899206,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rheinsberg",
        "province": "Brandenburg",
        "streetAndNumber": "Paulshorster Straße 18",
        "zip": "16831",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181031,
        "identifier": "DE025050",
        "googlePlaceId": "ChIJQQNfXAouuEcRJVcO3lP9xp8",
        "lat": 52.321048,
        "lng": 7.352251,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Salzbergen",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Gillenbrink 2",
        "zip": "48499",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181032,
        "identifier": "DE021073",
        "googlePlaceId": "ChIJn82xELMtp0cRMcotkvVdYR8",
        "lat": 50.719462,
        "lng": 12.513598,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zwickau",
        "province": "Sachsen",
        "streetAndNumber": "Lerchenweg 3",
        "zip": "08066",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181033,
        "identifier": "DE006102",
        "googlePlaceId": "ChIJlaQsmNu8ukcRTAHlVgREkJ8",
        "lat": 52.115234,
        "lng": 9.727331,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Elze",
        "province": "Niedersachsen",
        "streetAndNumber": "Sehlder Straße 19",
        "zip": "31008",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181034,
        "identifier": "DE003085",
        "googlePlaceId": "ChIJmUHvsbjtsUcRnukr_MhvJJA",
        "lat": 53.444611,
        "lng": 10.230685,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Neuengammer Hausdeich 205",
        "zip": "21039",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181035,
        "identifier": "DE002097",
        "googlePlaceId": "ChIJq9Ktise1vkcRtbwhDqpKejM",
        "lat": 51.037806,
        "lng": 7.59173,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gummersbach",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Beckestraße 57",
        "zip": "51647",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181036,
        "identifier": "DE021043",
        "googlePlaceId": "ChIJT4KGbLjCpkcRqyfs02HwE40",
        "lat": 51.057471,
        "lng": 12.13371,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zeitz",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Donaliesstraße 51",
        "zip": "06712",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181037,
        "identifier": "DE015064",
        "googlePlaceId": "ChIJY129GIGqt0cRLtxWM_Ho11s",
        "lat": 53.103445978378,
        "lng": 7.6759289641009,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Saterland",
        "province": "Niedersachsen",
        "streetAndNumber": "Florianstraße 1",
        "zip": "26683",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181038,
        "identifier": "DE002091",
        "googlePlaceId": "ChIJfVHd9GMcvEcREpic7CzdqNc",
        "lat": 50.857215,
        "lng": 8.019517,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Siegen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Leimbachstraße 185",
        "zip": "57074",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181039,
        "identifier": "DE026087",
        "googlePlaceId": "ChIJx2GCQjdqpUcRx6LGiHsAa1M",
        "lat": 51.954527,
        "lng": 10.567852,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Vienenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Wiedelaher Straße 10A",
        "zip": "38690",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181040,
        "identifier": "DE032078",
        "googlePlaceId": "ChIJs5YR4L3guEcRXdHcQds0Nvw",
        "lat": 51.480906,
        "lng": 7.159014,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Dickebankstraße 59",
        "zip": "44866",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181041,
        "identifier": "DE016022",
        "googlePlaceId": "ChIJDXEhLDiKsUcRBCcMc11ZEgM",
        "lat": 53.624664,
        "lng": 10.115106,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Pezolddamm 156-158",
        "zip": "22159",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181042,
        "identifier": "DE025104",
        "googlePlaceId": "ChIJVcJBuPr-uUcRY77CaH_Wp4Q",
        "lat": 52.359368,
        "lng": 8.303436,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bohmte",
        "province": "Niedersachsen",
        "streetAndNumber": "Osnabrücker Straße 4a",
        "zip": "49163",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181043,
        "identifier": "DE004107",
        "googlePlaceId": "ChIJVbXqvuWbtEcR8COmBk9lVG4",
        "lat": 54.679728,
        "lng": 8.927015,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Langenhorn",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Dorfstraße 4",
        "zip": "25842",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181044,
        "identifier": "DE029088",
        "googlePlaceId": "ChIJC0NFyDYyrEcRVbC3pSwamcI",
        "lat": 53.712023,
        "lng": 11.823003,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sternberg",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Goethestraße 14",
        "zip": "19406",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181045,
        "identifier": "DE021032",
        "googlePlaceId": "ChIJr7ey9okdp0cR_ESQV6OWlCg",
        "lat": 51.124035,
        "lng": 12.506722,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Borna",
        "province": "Sachsen",
        "streetAndNumber": "Leipziger Straße 10",
        "zip": "04552",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181046,
        "identifier": "DE036028",
        "googlePlaceId": "ChIJiZBGU4TFCUcR3KO3WXhlybs",
        "lat": 51.036915,
        "lng": 13.713927,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Chemnitzer Straße 28",
        "zip": "01187",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181047,
        "identifier": "DE016134",
        "googlePlaceId": "ChIJM63KAcMOskcRmVAX4yrm2xs",
        "lat": 53.844873,
        "lng": 10.633385,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübeck",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Brüder-Grimm-Ring 9",
        "zip": "23560",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181048,
        "identifier": "DE004102",
        "googlePlaceId": "ChIJv1foXo1WskcRc46YWdst7G8",
        "lat": 54.305457,
        "lng": 10.122878,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Stormarnstraße 29",
        "zip": "24113",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181049,
        "identifier": "DE036012",
        "googlePlaceId": "ChIJmR_SK77HCUcRRtOpDroBFps",
        "lat": 51.005777,
        "lng": 13.836266,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Pirnaer Landstraße 196",
        "zip": "01257",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181051,
        "identifier": "DE013033",
        "googlePlaceId": "ChIJ5UzJ8r5AuUcRMJmbnJcKKf8",
        "lat": 51.366727,
        "lng": 7.665689,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Iserlohn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Untergrüner Straße 208",
        "zip": "58644",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181052,
        "identifier": "DE031058",
        "googlePlaceId": "ChIJJVblOLkapEcRnEBqB-glCuw",
        "lat": 50.98175,
        "lng": 11.311301,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Weimar",
        "province": "Thüringen",
        "streetAndNumber": "Jean-Sibelius-Straße 24",
        "zip": "99427",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181053,
        "identifier": "DE005021",
        "googlePlaceId": "ChIJpe3Ym3O6u0cR0j3yDzyGDI4",
        "lat": 51.523053,
        "lng": 8.705868,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Wünnenberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Zinsdorfer Weg 31",
        "zip": "33181",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181054,
        "identifier": "DE003050",
        "googlePlaceId": "ChIJBQsgeJLgsUcRXhq1dfB7q54",
        "lat": 53.293412,
        "lng": 10.491627,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Scharnebeck",
        "province": "Niedersachsen",
        "streetAndNumber": "Röthenkuhlen 85",
        "zip": "21379",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181055,
        "identifier": "DE031014",
        "googlePlaceId": "ChIJ4bEnMH9VpEcRMEjk6AnaS4A",
        "lat": 51.482713,
        "lng": 10.80865,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nordhausen",
        "province": "Thüringen",
        "streetAndNumber": "Uthleber Weg 21",
        "zip": "99734",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181056,
        "identifier": "DE021094",
        "googlePlaceId": "ChIJx5HKuJCTpkcR0sgMylmXhuA",
        "lat": 51.219547,
        "lng": 11.968405,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Weißenfels",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Merseburger Str. 142",
        "zip": "06667",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181057,
        "identifier": "DE002010",
        "googlePlaceId": "ChIJf5oBwnwpuUcRY-hCfQEZ9so",
        "lat": 51.211893,
        "lng": 7.237028,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Remscheid",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kreuzbergstraße 14",
        "zip": "42899",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181058,
        "identifier": "DE001018",
        "googlePlaceId": "ChIJ_y7MUTjduEcR4jBHTspex7I",
        "lat": 51.449507,
        "lng": 7.03457,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Steeler Straße 187",
        "zip": "45138",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181059,
        "identifier": "DE001042",
        "googlePlaceId": "ChIJo46raVniuEcRT1qffkCpAiY",
        "lat": 51.582983,
        "lng": 7.233108,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Recklinghausen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Waldschlösschen 30",
        "zip": "45663",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181060,
        "identifier": "DE001067",
        "googlePlaceId": "ChIJr94b1v7luEcRY2hHSx_CCvQ",
        "lat": 51.560683,
        "lng": 7.05085,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gelsenkirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Emil-Zimmermann-Allee 20",
        "zip": "45897",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181061,
        "identifier": "DE020071",
        "googlePlaceId": "ChIJI1cA_wr2qEcRL3h0GswvixQ",
        "lat": 52.40896,
        "lng": 13.078399,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Potsdam",
        "province": "Brandenburg",
        "streetAndNumber": "Berliner Straße 47/48",
        "zip": "14467",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181063,
        "identifier": "DE016038",
        "googlePlaceId": "ChIJ89OE3zgvskcRpr3c4-8Pn2k",
        "lat": 53.770756,
        "lng": 9.985614,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Henstedt-Ulzburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Dammstücken 25-27",
        "zip": "24558",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181064,
        "identifier": "DE004031",
        "googlePlaceId": "ChIJpwgfucNLskcRqoLs570xjtM",
        "lat": 54.081216,
        "lng": 9.995166,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neumünster",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Goethestraße 11",
        "zip": "24534",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181065,
        "identifier": "DE013073",
        "googlePlaceId": "ChIJERTIGe5puUcRmb-mENeZjR4",
        "lat": 51.43802,
        "lng": 7.787698,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Menden (Sauerland)",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Untere Promenade 12",
        "zip": "58706",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181067,
        "identifier": "DE006064",
        "googlePlaceId": "ChIJXWpnrJSRr0cR0BVAuDalpPw",
        "lat": 52.397982,
        "lng": 10.837182,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wolfsburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Hehlinger Straße 21",
        "zip": "38446",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181068,
        "identifier": "DE002108",
        "googlePlaceId": "ChIJxVM0tWIouUcR7HSA0c5kVuQ",
        "lat": 51.280631,
        "lng": 7.241938,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Dahler Straße 72",
        "zip": "42389",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181069,
        "identifier": "DE016011",
        "googlePlaceId": "ChIJQxiXICCLsUcR9qSqwIbJCh0",
        "lat": 53.607617,
        "lng": 10.172234,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Sieker Landstraße 29",
        "zip": "22143",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181070,
        "identifier": "DE007100",
        "googlePlaceId": "ChIJcZdRJIXVtkcROG7Hu34Pe0U",
        "lat": 53.094883,
        "lng": 8.531978,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ganderkesee",
        "province": "Niedersachsen",
        "streetAndNumber": "Stedinger Straße 44A",
        "zip": "27777",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181071,
        "identifier": "DE031036",
        "googlePlaceId": "ChIJ-VHe23ybpEcRlgTsBzwghEQ",
        "lat": 50.975909,
        "lng": 10.337784,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eisenach",
        "province": "Thüringen",
        "streetAndNumber": "Altstadtstraße 2-4",
        "zip": "99817",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181074,
        "identifier": "DE016135",
        "googlePlaceId": "ChIJP2JfE18JskcRMxYo15xZk5w",
        "lat": 53.868694,
        "lng": 10.695149,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübeck",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Kanalstraße 76",
        "zip": "23552",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181075,
        "identifier": "DE021017",
        "googlePlaceId": "ChIJLRo1JAQvpkcRjeRrHlUDIYk",
        "lat": 51.889064,
        "lng": 12.664499,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lutherstadt Wittenberg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Berliner Chaussee 75",
        "zip": "06886",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3181076,
        "identifier": "DE010083",
        "googlePlaceId": "ChIJx9YPzwm6pEcRgGQPPMeSxaM",
        "lat": 51.157877,
        "lng": 9.999551,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wehretal",
        "province": "Hessen",
        "streetAndNumber": "Landstraße 123",
        "zip": "37287",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181077,
        "identifier": "DE025087",
        "googlePlaceId": "ChIJfwVObmzluUcRquxQGEqOcW0",
        "lat": 52.272733,
        "lng": 8.085778,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Osnabrück",
        "province": "Niedersachsen",
        "streetAndNumber": "Heiligenweg 2",
        "zip": "49084",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181078,
        "identifier": "DE025023",
        "googlePlaceId": "ChIJy9O5rAk_uEcRMBIUHTFgfkQ",
        "lat": 52.180628,
        "lng": 7.044826,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gronau (Westfalen)",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Auf der Sunhaar 25",
        "zip": "48599",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181079,
        "identifier": "DE036119",
        "googlePlaceId": "ChIJDRzTcql0CEcRL9aeJ3Ki7bQ",
        "lat": 51.752058,
        "lng": 14.261367,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kolkwitz",
        "province": "Brandenburg",
        "streetAndNumber": "Berliner Straße 113d",
        "zip": "03099",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181080,
        "identifier": "DE026100",
        "googlePlaceId": "ChIJX_RR_4agpUcRher-1dOhJpE",
        "lat": 51.805093,
        "lng": 10.943458,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Blankenburg (Harz)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Lerchenbreite 32",
        "zip": "38889",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181081,
        "identifier": "DE021006",
        "googlePlaceId": "ChIJx0PzLZD4pkcRy8cxzj3wseU",
        "lat": 51.346004,
        "lng": 12.444847,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Riesaer Straße 30",
        "zip": "04328",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181082,
        "identifier": "DE036101",
        "googlePlaceId": "ChIJyybdBi1Lp0cRXZotF2onD3o",
        "lat": 50.64237,
        "lng": 12.817382,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zwönitz",
        "province": "Sachsen",
        "streetAndNumber": "Wehrgasse 1B",
        "zip": "08297",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181083,
        "identifier": "DE025078",
        "googlePlaceId": "ChIJCT2YC6fEuUcR6jZ4ZyZLbUw",
        "lat": 52.26194,
        "lng": 7.780826,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ibbenbüren",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Ibbenbürener Straße 36",
        "zip": "49479",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181084,
        "identifier": "DE025004",
        "googlePlaceId": "ChIJZazOgHwduEcRs6SKitVnhmg",
        "lat": 52.498105,
        "lng": 6.890896,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Uelsen",
        "province": "Niedersachsen",
        "streetAndNumber": "Gölenkamper Straße 5",
        "zip": "49843",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181085,
        "identifier": "DE004104",
        "googlePlaceId": "ChIJczsd_JZZskcRUeVluRFedpI",
        "lat": 54.279008,
        "lng": 10.246731,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwentinental",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Lütjenburger Straße 2",
        "zip": "24223",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181086,
        "identifier": "DE010034",
        "googlePlaceId": "ChIJo5el2IZLu0cRINGzDemRSJs",
        "lat": 51.199244,
        "lng": 9.728605,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hessisch Lichtenau",
        "province": "Hessen",
        "streetAndNumber": "Leipziger Straße 116",
        "zip": "37235",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181087,
        "identifier": "DE005082",
        "googlePlaceId": "ChIJW_wzkB4WukcR45mTnzBt7TM",
        "lat": 52.051561,
        "lng": 8.594297,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Rabenhof 78",
        "zip": "33609",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181088,
        "identifier": "DE005105",
        "googlePlaceId": "ChIJfVevJntMukcRfAMhqMZU1c8",
        "lat": 51.745319,
        "lng": 8.757392,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Paderborn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Ingolstädter Weg 13",
        "zip": "33102",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181089,
        "identifier": "DE031046",
        "googlePlaceId": "ChIJV_nF4J-Ko0cRpYDp3BSHuvU",
        "lat": 50.829796,
        "lng": 10.967918,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Arnstadt",
        "province": "Thüringen",
        "streetAndNumber": "Stadtilmer Straße 100",
        "zip": "99310",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181090,
        "identifier": "DE036063",
        "googlePlaceId": "ChIJE9vj4vd9p0cRTgTjrAfmb50",
        "lat": 51.158279,
        "lng": 13.470521,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Meißen",
        "province": "Sachsen",
        "streetAndNumber": "Neumarkt 42",
        "zip": "01662",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181091,
        "identifier": "DE004091",
        "googlePlaceId": "ChIJlbOf6gozskcRdpBx8yBvTBk",
        "lat": 53.915887,
        "lng": 9.889735,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Bramstedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Lohstücker Weg 16",
        "zip": "24576",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181092,
        "identifier": "DE005078",
        "googlePlaceId": "ChIJDW6h-I7ruUcRJF9r36tr0aI",
        "lat": 52.148838,
        "lng": 7.963128,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lienen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lengericher Straße 31",
        "zip": "49536",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181093,
        "identifier": "DE013024",
        "googlePlaceId": "ChIJLR_kxoGCuUcR3tt3jAUI1fA",
        "lat": 51.749217,
        "lng": 8.019499,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Beckum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Cheruskerstraße 14",
        "zip": "59269",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181094,
        "identifier": "DE025015",
        "googlePlaceId": "ChIJ_W050cB_t0cR11SP-LO4Mlw",
        "lat": 52.481485,
        "lng": 7.54335,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Freren",
        "province": "Niedersachsen",
        "streetAndNumber": "Beestener Straße 6",
        "zip": "49832",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181095,
        "identifier": "DE005023",
        "googlePlaceId": "ChIJo3BHMezLu0cRPa9XAeDUeLc",
        "lat": 51.644898,
        "lng": 8.507278,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Geseke",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lindenweg 5",
        "zip": "59590",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181097,
        "identifier": "DE021108",
        "googlePlaceId": "ChIJz8g4vahjpkcRgHTpd9kvBzw",
        "lat": 51.454559,
        "lng": 12.016957,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Halle",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Leipziger Chaussee 147",
        "zip": "06112",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181098,
        "identifier": "DE002077",
        "googlePlaceId": "ChIJR5CUdGSsvkcROBsDul3SXUg",
        "lat": 51.035722,
        "lng": 7.856279,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Olpe",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Westfälische Straße 94",
        "zip": "57462",
        "businessId": 1312729,
        "addressExtra": "Bilsteiner Straße 5",
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181099,
        "identifier": "DE007085",
        "googlePlaceId": "ChIJCVRbvXogsUcRrFCgL6Zjmho",
        "lat": 53.058515,
        "lng": 9.010273,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oyten",
        "province": "Niedersachsen",
        "streetAndNumber": "Hauptstraße 118-120",
        "zip": "28876",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181100,
        "identifier": "DE024125",
        "googlePlaceId": "ChIJu9PgK4-4B0cRF5wG2bia2nQ",
        "lat": 52.147586,
        "lng": 14.638178,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eisenhüttenstadt",
        "province": "Brandenburg",
        "streetAndNumber": "Karl-Marx-Straße 34",
        "zip": "15890",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181101,
        "identifier": "DE003011",
        "googlePlaceId": "ChIJG2VfWYKbsUcRXhkl7YLamGY",
        "lat": 53.462937,
        "lng": 9.797808,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neu Wulmstorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Hauptstraße 45-51",
        "zip": "21629",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181102,
        "identifier": "DE010115",
        "googlePlaceId": "ChIJ8zQYdQlHpUcRlKcog1YoV8o",
        "lat": 51.934475,
        "lng": 10.346442,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Langelsheim",
        "province": "Niedersachsen",
        "streetAndNumber": "Lange Straße 62",
        "zip": "38685",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181103,
        "identifier": "DE036089",
        "googlePlaceId": "ChIJ01PpzXo5p0cRP_H7VoCEWrk",
        "lat": 50.868757,
        "lng": 12.750915,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Niederfrohna",
        "province": "Sachsen",
        "streetAndNumber": "Limbacher Straße 81",
        "zip": "09243",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181104,
        "identifier": "DE005100",
        "googlePlaceId": "ChIJwej2SMxoukcRztpI12PDpDA",
        "lat": 52.104485,
        "lng": 8.934132,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kalletal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Fassensteg 4",
        "zip": "32689",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181105,
        "identifier": "DE032004",
        "googlePlaceId": "ChIJK0Mdtj0ZuUcRTZPzVQxkk5M",
        "lat": 51.507153,
        "lng": 7.381222,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Schulte-Heuthaus-Straße 54",
        "zip": "44379",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181106,
        "identifier": "DE036047",
        "googlePlaceId": "ChIJh6dTm4LFCUcRzt3ejt7l3MU",
        "lat": 51.037353,
        "lng": 13.703791,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Tharandter Straße 40",
        "zip": "01159",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181108,
        "identifier": "DE016024",
        "googlePlaceId": "ChIJx2hs2luPsUcR-QT68fHQD_A",
        "lat": 53.56893,
        "lng": 9.954617,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Eimsbütteler Chaussee 85",
        "zip": "20259",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181109,
        "identifier": "DE010117",
        "googlePlaceId": "ChIJrfMW3otApUcR99Hq8yx2OEs",
        "lat": 51.914047,
        "lng": 10.444863,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Goslar",
        "province": "Niedersachsen",
        "streetAndNumber": "Liebigstraße 6",
        "zip": "38640",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181110,
        "identifier": "DE003110",
        "googlePlaceId": "ChIJW5m9IynarUcRW-sZPOUGF_Q",
        "lat": 53.634541,
        "lng": 11.387538,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwerin",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Lessingstraße 33b",
        "zip": "19059",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181111,
        "identifier": "DE003043",
        "googlePlaceId": "ChIJdzE0UT2MsUcRUIpFC9z3cG8",
        "lat": 53.551019,
        "lng": 10.074773,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Horner Landstraße 110",
        "zip": "22111",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181112,
        "identifier": "DE004020",
        "googlePlaceId": "ChIJyV71yUSWtEcRlgQ62G90WPs",
        "lat": 54.790358,
        "lng": 8.827619,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Niebüll",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hauptstraße 75",
        "zip": "25899",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181113,
        "identifier": "DE020014",
        "googlePlaceId": "ChIJG6f3WoVaqEcRvC1kxJBhJPY",
        "lat": 52.458301,
        "lng": 13.327628,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Bergstraße 93-97",
        "zip": "12169",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181114,
        "identifier": "DE036124",
        "googlePlaceId": "ChIJASnPIa9DCEcRY-PuZfhIXyw",
        "lat": 51.43921,
        "lng": 14.26126,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hoyerswerda",
        "province": "Sachsen",
        "streetAndNumber": "Albert-Einstein-Straße 1A",
        "zip": "02977",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3181115,
        "identifier": "DE001089",
        "googlePlaceId": "ChIJ273IAevCuEcRwJ0zJr0BNUk",
        "lat": 51.450909,
        "lng": 6.989613,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Schederhofstraße 125",
        "zip": "45145",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181116,
        "identifier": "DE010043",
        "googlePlaceId": "ChIJF6kgKbbepEcRHocHQaCe4Gw",
        "lat": 51.50995,
        "lng": 10.2501,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Duderstadt",
        "province": "Niedersachsen",
        "streetAndNumber": "Zur Feilenfabrik 2",
        "zip": "37115",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181117,
        "identifier": "DE021117",
        "googlePlaceId": "ChIJ1SYJMvKFp0cRLDb3kCIzvxY",
        "lat": 51.408882,
        "lng": 13.445965,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gröditz",
        "province": "Sachsen",
        "streetAndNumber": "Hauptstraße 10",
        "zip": "01609",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181118,
        "identifier": "DE026096",
        "googlePlaceId": "ChIJ1Wie64cMpUcRpENAG9xVKbI",
        "lat": 51.822781,
        "lng": 10.807107,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wernigerode",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Mühlental 42",
        "zip": "38855",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181119,
        "identifier": "DE031061",
        "googlePlaceId": "ChIJy8S1oMH_pEcRNzL9Xnxp1gw",
        "lat": 51.50807,
        "lng": 10.779854,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nordhausen",
        "province": "Thüringen",
        "streetAndNumber": "Wilhelm-Raabe-Straße 1",
        "zip": "99734",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181120,
        "identifier": "DE016093",
        "googlePlaceId": "ChIJKW2sCL2IsUcRq6_kJNIHzKo",
        "lat": 53.598267,
        "lng": 9.97248,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Osterfeldstraße 39",
        "zip": "22529",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181121,
        "identifier": "DE004045",
        "googlePlaceId": "ChIJazbP43pns0cRkol9X_qDdnU",
        "lat": 54.771072,
        "lng": 9.322195,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Handewitt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Wiesharder Markt 14a",
        "zip": "24983",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181122,
        "identifier": "DE013037",
        "googlePlaceId": "ChIJ0UP8Dw9BuUcRaLrbAbgNN5w",
        "lat": 51.379856,
        "lng": 7.716987,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Iserlohn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Im Wiesengrund 14",
        "zip": "58636",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181123,
        "identifier": "DE016021",
        "googlePlaceId": "ChIJ3ZoOLYuLsUcR9CAp-jZb74M",
        "lat": 53.574511,
        "lng": 10.09887,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Gustav-Adolf-Straße 92",
        "zip": "22043",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181124,
        "identifier": "DE013096",
        "googlePlaceId": "ChIJDesRynB4vEcRoEtfsqBZws0",
        "lat": 51.020115,
        "lng": 8.666791,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Allendorf (Eder)",
        "province": "Hessen",
        "streetAndNumber": "Ringstraße 11",
        "zip": "35108",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181125,
        "identifier": "DE021010",
        "googlePlaceId": "ChIJhWobR3n4pkcRg_gGiyUfVJc",
        "lat": 51.357169,
        "lng": 12.425981,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Löbauer Straße 68-70",
        "zip": "04347",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181126,
        "identifier": "DE003114",
        "googlePlaceId": "ChIJ33KEikXBsUcR6tfobpP_xTg",
        "lat": 53.227257,
        "lng": 10.16039,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Salzhausen",
        "province": "Niedersachsen",
        "streetAndNumber": "Alte Baumschule 2",
        "zip": "21376",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181127,
        "identifier": "DE005102",
        "googlePlaceId": "ChIJyztiQiIoukcRfSsyWiqcqkc",
        "lat": 51.88059,
        "lng": 8.23806,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herzebrock",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Clarholzer Straße 30",
        "zip": "33442",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181128,
        "identifier": "DE016131",
        "googlePlaceId": "ChIJ-3-M9KoOskcReteEDndAn-w",
        "lat": 53.871289,
        "lng": 10.665772,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübeck",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Ziegelstraße 2 b",
        "zip": "23556",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181129,
        "identifier": "DE007050",
        "googlePlaceId": "ChIJJ6E0FPvXsEcRoexs6nQzIpw",
        "lat": 53.057783,
        "lng": 8.809348,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Volkmannstraße 2",
        "zip": "28201",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181130,
        "identifier": "DE020058",
        "googlePlaceId": "ChIJnXjhaJv5qEcRMIyP6R-HXds",
        "lat": 52.532737,
        "lng": 13.060184,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dallgow-Döberitz",
        "province": "Brandenburg",
        "streetAndNumber": "Artilleriepark 2",
        "zip": "14624",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181131,
        "identifier": "DE032071",
        "googlePlaceId": "ChIJN0vPOBcduUcRYC4BPhuFgLQ",
        "lat": 51.599442,
        "lng": 7.312137,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Castrop-Rauxel",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lambertstraße 2A",
        "zip": "44581",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181132,
        "identifier": "DE021015",
        "googlePlaceId": "ChIJb3sUDLWqp0cRajAzUV56qZg",
        "lat": 51.36059,
        "lng": 12.615839,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Machern",
        "province": "Sachsen",
        "streetAndNumber": "Gartenallee 4",
        "zip": "04827",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181134,
        "identifier": "DE010099",
        "googlePlaceId": "ChIJMZIsEv3kukcRMBnyyv0siwM",
        "lat": 51.774681,
        "lng": 9.359752,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Höxter",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Pfennigbreite 38",
        "zip": "37671",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181135,
        "identifier": "DE015001",
        "googlePlaceId": "ChIJb-q8TOiTtkcRLmygWjR0n_o",
        "lat": 53.535655,
        "lng": 8.125581,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wilhelmshaven",
        "province": "Niedersachsen",
        "streetAndNumber": "Gökerstraße 111 c",
        "zip": "26384",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181136,
        "identifier": "DE010013",
        "googlePlaceId": "ChIJcRnown_WukcRSFgVGCat3jo",
        "lat": 51.651201,
        "lng": 9.835683,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hardegsen",
        "province": "Niedersachsen",
        "streetAndNumber": "Göttinger Straße 18",
        "zip": "37181",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181137,
        "identifier": "DE032034",
        "googlePlaceId": "ChIJ65MjF3YiuUcRBA9_H6Jbldw",
        "lat": 51.450579,
        "lng": 7.365512,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Witten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Dortmunder Straße 99",
        "zip": "58453",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181138,
        "identifier": "DE015038",
        "googlePlaceId": "ChIJNz3kBgmRtkcRZ_f34TFAyO8",
        "lat": 53.578141,
        "lng": 8.112172,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wilhelmshaven",
        "province": "Niedersachsen",
        "streetAndNumber": "Flutstraße 99",
        "zip": "26388",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181140,
        "identifier": "DE024015",
        "googlePlaceId": "ChIJXermS8rEqUcRieJ447TdY9Q",
        "lat": 52.795154,
        "lng": 14.040711,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Freienwalde (Oder)",
        "province": "Brandenburg",
        "streetAndNumber": "Eduardshof 1",
        "zip": "16259",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181141,
        "identifier": "DE013005",
        "googlePlaceId": "ChIJ--bLSwaDuUcRL9YIJZBvshs",
        "lat": 51.798973,
        "lng": 8.033185,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Beckum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Haselnussweg 2",
        "zip": "59269",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181142,
        "identifier": "DE016074",
        "googlePlaceId": "ChIJt6QSYesgskcRT7rHg_VZo58",
        "lat": 53.678364,
        "lng": 10.144214,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ammersbek",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Ferdinand-Harten-Straße 3-5",
        "zip": "22949",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181143,
        "identifier": "DE007094",
        "googlePlaceId": "ChIJkW4xxXTPsEcRTmnfd0dqcSg",
        "lat": 52.850924,
        "lng": 8.727204,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bassum",
        "province": "Niedersachsen",
        "streetAndNumber": "Bremer Straße 34-38",
        "zip": "27211",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181144,
        "identifier": "DE036053",
        "googlePlaceId": "ChIJncEqW0VQp0cRDQCsAusuAlA",
        "lat": 50.748885,
        "lng": 13.074285,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zschopau",
        "province": "Sachsen",
        "streetAndNumber": "Waldkirchener Straße 15",
        "zip": "09405",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181145,
        "identifier": "DE026095",
        "googlePlaceId": "ChIJHUBR0L1epUcRFg3QhINGesc",
        "lat": 52.163899,
        "lng": 10.514078,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wolfenbüttel",
        "province": "Niedersachsen",
        "streetAndNumber": "Grauhofstraße 1",
        "zip": "38304",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181146,
        "identifier": "DE005097",
        "googlePlaceId": "ChIJUSqOJsptukcRxThSjjc9dhQ",
        "lat": 52.161826,
        "lng": 8.849591,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Vlotho",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Meyra-Straße 1",
        "zip": "32602",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181147,
        "identifier": "DE006029",
        "googlePlaceId": "ChIJYZX27mlwsEcRb-R-nGaCp68",
        "lat": 52.459186,
        "lng": 9.577564,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Garbsen",
        "province": "Niedersachsen",
        "streetAndNumber": "Hauptstraße 223",
        "zip": "30826",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181148,
        "identifier": "DE036074",
        "googlePlaceId": "ChIJCeAzkGYdCUcR8NhZne54UA8",
        "lat": 51.08958,
        "lng": 14.668202,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Löbau",
        "province": "Sachsen",
        "streetAndNumber": "Ahornallee 2",
        "zip": "02708",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181149,
        "identifier": "DE005083",
        "googlePlaceId": "ChIJFz3EYJOVuUcRcqD3sVYpjxU",
        "lat": 52.037504,
        "lng": 7.852502,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ostbevern",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wischhausstraße 57",
        "zip": "48346",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181150,
        "identifier": "DE004061",
        "googlePlaceId": "ChIJw58a8CIuskcRt7y_gCZCS-Q",
        "lat": 53.837261,
        "lng": 9.956454,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kaltenkirchen",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Funkenberg 1",
        "zip": "24568",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181151,
        "identifier": "DE031059",
        "googlePlaceId": "ChIJO6UPK6OopkcRNnUK60U8KZE",
        "lat": 50.92873,
        "lng": 11.584491,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Jena",
        "province": "Thüringen",
        "streetAndNumber": "Leutragraben 1",
        "zip": "07743",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181152,
        "identifier": "DE024100",
        "googlePlaceId": "ChIJ748hRy1JqEcREoZXpihC1wQ",
        "lat": 52.495863,
        "lng": 13.519427,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Sewanstraße 259",
        "zip": "10319",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3181153,
        "identifier": "DE016088",
        "googlePlaceId": "ChIJq314LWOPsUcRwYWjcrnA2f4",
        "lat": 53.551499,
        "lng": 9.943752,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Große Bergstraße 152-162",
        "zip": "22767",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181154,
        "identifier": "DE031042",
        "googlePlaceId": "ChIJi1jhhaOHo0cRofPgJd8kP8c",
        "lat": 50.820219,
        "lng": 10.700314,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ohrdruf",
        "province": "Thüringen",
        "streetAndNumber": "Zur Alten Ziegelei 1",
        "zip": "99885",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181155,
        "identifier": "DE001050",
        "googlePlaceId": "ChIJIw7HVADjuEcR3lSzzY-xMec",
        "lat": 51.553454,
        "lng": 7.203628,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herne",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Forellstraße 101-113",
        "zip": "44629",
        "businessId": 1312729,
        "addressExtra": "Kaiserquartier",
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181156,
        "identifier": "DE003047",
        "googlePlaceId": "ChIJH3G8-_lksUcRiWBqaqBOZ70",
        "lat": 53.593731,
        "lng": 9.423192,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stade",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Steinkamp 3",
        "zip": "21684",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181158,
        "identifier": "DE007092",
        "googlePlaceId": "ChIJc0ykVe-xtkcRqP8wMrEoA_w",
        "lat": 53.589204,
        "lng": 8.618448,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremerhaven",
        "province": "Bremen",
        "streetAndNumber": "Hans-Böckler-Straße 38",
        "zip": "27578",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181159,
        "identifier": "DE032060",
        "googlePlaceId": "ChIJz4Na8ZUZuUcRrOdcVqVZ7go",
        "lat": 51.511373,
        "lng": 7.434018,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Joachimstraße 4",
        "zip": "44147",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181160,
        "identifier": "DE021030",
        "googlePlaceId": "ChIJpe84-Xi5p0cRp_Hpy2UkrKs",
        "lat": 51.56106,
        "lng": 13.00642,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Torgau",
        "province": "Sachsen",
        "streetAndNumber": "Elbstraße 14",
        "zip": "04860",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181161,
        "identifier": "DE016061",
        "googlePlaceId": "ChIJm-9cWZ79sUcREOyRrfZ7fKs",
        "lat": 53.484578,
        "lng": 10.616882,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Büchen",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Möllner Straße 22 a",
        "zip": "21514",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181163,
        "identifier": "DE026009",
        "googlePlaceId": "ChIJocFEF8BcrkcRZYt2qMroHs4",
        "lat": 53.139538,
        "lng": 11.262185,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dömitz",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Werderstraße 25C",
        "zip": "19303",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181164,
        "identifier": "DE029022",
        "googlePlaceId": "ChIJ1fckr1byq0cReJvoYV5RHFU",
        "lat": 53.688711,
        "lng": 12.915176,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stavenhagen",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Werdohler Straße 3",
        "zip": "17153",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181165,
        "identifier": "DE025067",
        "googlePlaceId": "ChIJ3xXqkbTLuUcRdmGVhFslZi8",
        "lat": 52.168008,
        "lng": 7.501149,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Emsdetten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Borghorster Straße 165",
        "zip": "48282",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181166,
        "identifier": "DE003090",
        "googlePlaceId": "ChIJF1h19PETsUcREU_6SY87s3E",
        "lat": 53.305614,
        "lng": 9.269979,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zeven",
        "province": "Niedersachsen",
        "streetAndNumber": "Nord-West-Ring 5",
        "zip": "27404",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181167,
        "identifier": "DE004043",
        "googlePlaceId": "ChIJIcUSiOaAsUcRPRHy6zUl8HQ",
        "lat": 53.646836,
        "lng": 9.816031,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Pinneberg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Rellinger Straße 25-27",
        "zip": "25421",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181168,
        "identifier": "DE002025",
        "googlePlaceId": "ChIJmVG0N0pIuUcRPN9_nzu_0fc",
        "lat": 51.229304,
        "lng": 7.633875,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lüdenscheid",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Altenaer Straße 81-83",
        "zip": "58507",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181169,
        "identifier": "DE004051",
        "googlePlaceId": "ChIJLaOVCZlWskcRB0eVEk7UpsI",
        "lat": 54.29937,
        "lng": 10.104464,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hamburger Chaussee 180",
        "zip": "24113",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181170,
        "identifier": "DE016009",
        "googlePlaceId": "ChIJtSAa_WGJsUcRej3rvaA3hNM",
        "lat": 53.599053,
        "lng": 10.077521,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Haldesdorfer Straße 86",
        "zip": "22179",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181171,
        "identifier": "DE010055",
        "googlePlaceId": "ChIJmcoEv8O5pEcRSB_nGNnKAIk",
        "lat": 51.194412,
        "lng": 10.031386,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eschwege",
        "province": "Hessen",
        "streetAndNumber": "Niederhoner Straße 58A",
        "zip": "37269",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181172,
        "identifier": "DE005064",
        "googlePlaceId": "ChIJHw-sR00jukcRnhs0I2Yc3cE",
        "lat": 51.982525,
        "lng": 8.48245,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Gütersloher Straße 243",
        "zip": "33649",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181173,
        "identifier": "DE025012",
        "googlePlaceId": "ChIJb_qjA7UsuEcRAPSlMjARyas",
        "lat": 52.36238,
        "lng": 7.473414,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Spelle",
        "province": "Niedersachsen",
        "streetAndNumber": "Bernard-Krone-Straße 5",
        "zip": "48480",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181174,
        "identifier": "DE031083",
        "googlePlaceId": "ChIJN3--KrAroUcRgCa8ATN0iSs",
        "lat": 50.651979,
        "lng": 12.224327,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Greiz",
        "province": "Thüringen",
        "streetAndNumber": "Reichenbacher Straße 105",
        "zip": "07973",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181175,
        "identifier": "DE007023",
        "googlePlaceId": "ChIJKdddjV5It0cR6CFUIKGPcxw",
        "lat": 52.717193,
        "lng": 8.287798,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Vechta",
        "province": "Niedersachsen",
        "streetAndNumber": "Diepholzer Straße 1",
        "zip": "49377",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181176,
        "identifier": "DE007068",
        "googlePlaceId": "ChIJERdFU_QDsUcR5fFxbL44wgU",
        "lat": 53.101574,
        "lng": 9.398188,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rotenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Grafeler Damm 1",
        "zip": "27356",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3181177,
        "identifier": "DE006041",
        "googlePlaceId": "ChIJHbhJ-k7-r0cRGlaf0uh5SMI",
        "lat": 52.309511,
        "lng": 10.232057,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Peine",
        "province": "Niedersachsen",
        "streetAndNumber": "Ilseder Straße 58",
        "zip": "31226",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181179,
        "identifier": "DE002063",
        "googlePlaceId": "ChIJARtOSGQquUcREVh2i-cdixk",
        "lat": 51.176369,
        "lng": 7.180107,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Remscheid",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kippdorfstraße 4",
        "zip": "42857",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181180,
        "identifier": "DE006056",
        "googlePlaceId": "ChIJoyEk8RVzsEcRNyO4fOvbnmM",
        "lat": 52.412827,
        "lng": 9.735056,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Vahrenwalder Straße 252",
        "zip": "30179",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181181,
        "identifier": "DE005118",
        "googlePlaceId": "ChIJy8hWIZtzukcRa8d5BG4UXPI",
        "lat": 52.272711,
        "lng": 8.887787,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Minden",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Mindener Straße 123",
        "zip": "32429",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181183,
        "identifier": "DE024063",
        "googlePlaceId": "ChIJ67e2O0G3qUcR_x0B4WGJ5Rg",
        "lat": 52.754147,
        "lng": 13.672259,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Biesenthal",
        "province": "Brandenburg",
        "streetAndNumber": "Bahnhofstraße 77",
        "zip": "16359",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181184,
        "identifier": "DE007062",
        "googlePlaceId": "ChIJRxCT1ObasEcRlcor1IpvjLA",
        "lat": 52.915113,
        "lng": 8.82665,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Syke",
        "province": "Niedersachsen",
        "streetAndNumber": "Zum Hachepark 3",
        "zip": "28857",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181185,
        "identifier": "DE010048",
        "googlePlaceId": "ChIJXwJ_6NfUpEcRRWpCJfrqHhE",
        "lat": 51.557997,
        "lng": 9.930832,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Göttingen",
        "province": "Niedersachsen",
        "streetAndNumber": "Werner-von-Siemens-Straße 5",
        "zip": "37077",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181186,
        "identifier": "DE029079",
        "googlePlaceId": "ChIJS8n8ClINqUcREthfq_O5dK4",
        "lat": 53.002114,
        "lng": 13.160347,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gransee",
        "province": "Brandenburg",
        "streetAndNumber": "Zu den Binnenhufen 1",
        "zip": "16775",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181187,
        "identifier": "DE004080",
        "googlePlaceId": "ChIJD_5lsftVskcRXxLeRcwxGE4",
        "lat": 54.354037,
        "lng": 10.104722,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Torfmoorkamp 10",
        "zip": "24106",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181189,
        "identifier": "DE007047",
        "googlePlaceId": "ChIJL-xR-RfYsEcRVkzjds2nVro",
        "lat": 53.043447,
        "lng": 8.831698,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Arsterdamm 94A",
        "zip": "28277",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181190,
        "identifier": "DE015036",
        "googlePlaceId": "ChIJbymfF-pPtkcRjIP3SbpCh28",
        "lat": 53.308732,
        "lng": 7.486373,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Moormerland",
        "province": "Niedersachsen",
        "streetAndNumber": "Rudolf-Eucken-Straße 3",
        "zip": "26802",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181191,
        "identifier": "DE015032",
        "googlePlaceId": "ChIJx3UKyHzdtkcReJM_EmHyP38",
        "lat": 53.246864,
        "lng": 8.186903,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rastede",
        "province": "Niedersachsen",
        "streetAndNumber": "Raiffeisenstraße 52",
        "zip": "26180",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181192,
        "identifier": "DE026038",
        "googlePlaceId": "ChIJKUHtyglfr0cRu4VKYNvrJDY",
        "lat": 52.158281,
        "lng": 11.613767,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Magdeburg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Olvenstedter Graseweg 37",
        "zip": "39128",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181193,
        "identifier": "DE006120",
        "googlePlaceId": "ChIJMU0c29f1r0cRpzWkE43I-Oo",
        "lat": 52.266655,
        "lng": 10.528433,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Braunschweig",
        "province": "Niedersachsen",
        "streetAndNumber": "Wilhelmstraße 98",
        "zip": "38100",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181194,
        "identifier": "DE005127",
        "googlePlaceId": "ChIJ5zJO-Ch6ukcRhTQmSu4ik58",
        "lat": 52.265687,
        "lng": 9.070634,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bückeburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Kreuzbreite 19",
        "zip": "31675",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181195,
        "identifier": "DE026028",
        "googlePlaceId": "ChIJj_3zyX6Qr0cRu6ZLtBn5Jt4",
        "lat": 52.40734,
        "lng": 10.93111,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Velpke",
        "province": "Niedersachsen",
        "streetAndNumber": "An der Bascheriede 4",
        "zip": "38458",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181196,
        "identifier": "DE001055",
        "googlePlaceId": "ChIJWelmCnpQuEcROujd2oYqO44",
        "lat": 51.942316,
        "lng": 7.153105,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Coesfeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Borkener Straße 73",
        "zip": "48653",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181197,
        "identifier": "DE001054",
        "googlePlaceId": "ChIJ-8IKfbrjuEcRjdUB4Mj9A3Q",
        "lat": 51.576359,
        "lng": 7.198463,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Recklinghausen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Salentinstraße 160",
        "zip": "45661",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181198,
        "identifier": "DE036005",
        "googlePlaceId": "ChIJh21mXWhqp0cRxOGGZha2Sg8",
        "lat": 50.97827,
        "lng": 12.981048,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Mittweida",
        "province": "Sachsen",
        "streetAndNumber": "Chemnitzer Straße 28E",
        "zip": "09648",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181199,
        "identifier": "DE015019",
        "googlePlaceId": "ChIJZ7D83WyMtkcRg-gGr1Ir9og",
        "lat": 53.537232,
        "lng": 7.939512,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schortens",
        "province": "Niedersachsen",
        "streetAndNumber": "Mühlenweg 61",
        "zip": "26419",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "from1": "10:00",
            "to1": "18:00"
          }
        ]
      },
      {
        "id": 3181200,
        "identifier": "DE036016",
        "googlePlaceId": "ChIJ4cumSietoEcRRst5LdB8jFw",
        "lat": 50.599333,
        "lng": 13.020566,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Annaberg-Buchholz",
        "province": "Sachsen",
        "streetAndNumber": "Gewerbering 2",
        "zip": "09456",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181201,
        "identifier": "DE006067",
        "googlePlaceId": "ChIJ25x5S-cLsEcRntHiYFXLpvs",
        "lat": 52.356757,
        "lng": 9.853537,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Ohefeldweg 15",
        "zip": "30559",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181202,
        "identifier": "DE004028",
        "googlePlaceId": "ChIJO09VeTUAs0cRkIe4HZECZiY",
        "lat": 54.414287,
        "lng": 9.982993,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gettorf",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Ravensberg 4C",
        "zip": "24214",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181203,
        "identifier": "DE006053",
        "googlePlaceId": "ChIJCT8TnKlxsEcRSXu7R2H8uyo",
        "lat": 52.44304,
        "lng": 9.60991,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Garbsen",
        "province": "Niedersachsen",
        "streetAndNumber": "Siemensstraße 1-3",
        "zip": "30827",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181204,
        "identifier": "DE020044",
        "googlePlaceId": "ChIJe3mj1J5ZqEcR0bwpc_Hzvms",
        "lat": 52.43968,
        "lng": 13.216939,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Breisgauer Straße 1b",
        "zip": "14129",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181205,
        "identifier": "DE021067",
        "googlePlaceId": "ChIJXXZIjMFXpkcRKHlhF1__4io",
        "lat": 51.378105,
        "lng": 12.416528,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Tauchaer Straße 10",
        "zip": "04357",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181206,
        "identifier": "DE021045",
        "googlePlaceId": "ChIJG8YVDlz3pkcRK8mTqXxwkN4",
        "lat": 51.301387,
        "lng": 12.316792,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Gerhard-Ellrodt-Straße 30",
        "zip": "04249",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181207,
        "identifier": "DE006088",
        "googlePlaceId": "ChIJJT8KKoA5ZUERyVHB5h5Bfd0",
        "lat": 52.383758,
        "lng": 10.533706,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Meine",
        "province": "Niedersachsen",
        "streetAndNumber": "Bahnhofstraße 15",
        "zip": "38527",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181208,
        "identifier": "DE003070",
        "googlePlaceId": "ChIJR1w_1nOdsUcRaCGpho_Fod0",
        "lat": 53.481529,
        "lng": 9.694157,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Buxtehude",
        "province": "Niedersachsen",
        "streetAndNumber": "Westmoor 2h",
        "zip": "21614",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181209,
        "identifier": "DE016069",
        "googlePlaceId": "ChIJJws4z4KLsUcRZdWuUv3JEaQ",
        "lat": 53.579003,
        "lng": 10.129367,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Jenfelder Allee 70",
        "zip": "22043",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181210,
        "identifier": "DE003029",
        "googlePlaceId": "ChIJnbJpW76WsUcRs6_-vvLPFmc",
        "lat": 53.386891,
        "lng": 9.975067,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Seevetal",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Göhlenbach 33",
        "zip": "21218",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181211,
        "identifier": "DE006072",
        "googlePlaceId": "ChIJERem-wVmsEcRFwoPqUvSeUQ",
        "lat": 52.582155,
        "lng": 9.586951,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neustadt am Rübenberge",
        "province": "Niedersachsen",
        "streetAndNumber": "Abbenser Straße 10",
        "zip": "31535",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181212,
        "identifier": "DE007046",
        "googlePlaceId": "ChIJ_W6KEqrhsEcRDT7EB-_elY8",
        "lat": 52.999947,
        "lng": 9.099752,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Achim",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Lahof 1",
        "zip": "28832",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181213,
        "identifier": "DE032111",
        "googlePlaceId": "ChIJt2F-F5KyuUcRMpiapxx2fg4",
        "lat": 51.974556,
        "lng": 7.410807,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Havixbeck",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Blickallee 40",
        "zip": "48329",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181214,
        "identifier": "DE016065",
        "googlePlaceId": "ChIJDQD-jxyLsUcR_lg68p1f4Xs",
        "lat": 53.604949,
        "lng": 10.158108,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Schweriner Straße 8-12",
        "zip": "22143",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181215,
        "identifier": "DE001051",
        "googlePlaceId": "ChIJc2XxMJLCuEcRH-3pk5KrXeQ",
        "lat": 51.460022,
        "lng": 6.983714,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Altendorfer Straße 226",
        "zip": "45143",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181216,
        "identifier": "DE002050",
        "googlePlaceId": "ChIJMXynVsjTuEcR_28ZKn56WBU",
        "lat": 51.202233,
        "lng": 7.020541,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Haan",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Landstraße 1",
        "zip": "42781",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181218,
        "identifier": "DE006157",
        "googlePlaceId": "ChIJB84gYX6WukcRgvg68MemFa8",
        "lat": 52.065157,
        "lng": 9.584168,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Salzhemmendorf",
        "province": "Niedersachsen",
        "streetAndNumber": "An der Kalkröse 2",
        "zip": "31020",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181219,
        "identifier": "DE013061",
        "googlePlaceId": "ChIJnR-dQEdzuUcRt5epOZp7CEI",
        "lat": 51.661644,
        "lng": 7.743371,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamm",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Dortmunder Straße 253",
        "zip": "59077",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181220,
        "identifier": "DE010116",
        "googlePlaceId": "ChIJ7xixlb5ApUcRf_Jbjznrh7Y",
        "lat": 51.916635,
        "lng": 10.417708,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Goslar",
        "province": "Niedersachsen",
        "streetAndNumber": "Hildesheimer Straße 29",
        "zip": "38640",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181221,
        "identifier": "DE004072",
        "googlePlaceId": "ChIJARO96YFWskcR2Js37kmDSDk",
        "lat": 54.313171,
        "lng": 10.098537,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Mühlendamm 1",
        "zip": "24113",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181222,
        "identifier": "DE003036",
        "googlePlaceId": "ChIJdzeg94iOsUcRGTi5PaPNltc",
        "lat": 53.535728,
        "lng": 10.037076,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Billhorner Röhrendamm 145-147",
        "zip": "20539",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181223,
        "identifier": "DE013014",
        "googlePlaceId": "ChIJHcP_zkeguUcRE40ZWAmC7Dk",
        "lat": 51.797112,
        "lng": 7.731941,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Drensteinfurt",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Raiffeisenstraße 4",
        "zip": "48317",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181225,
        "identifier": "DE006134",
        "googlePlaceId": "ChIJH1vgpGj4r0cR8B0cSBFGWHc",
        "lat": 52.264747,
        "lng": 10.364005,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Vechelde",
        "province": "Niedersachsen",
        "streetAndNumber": "Bodelschwinghstraße 8",
        "zip": "38159",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181226,
        "identifier": "DE006003",
        "googlePlaceId": "ChIJEWAmMNpysEcRwsROUleadvI",
        "lat": 52.435202,
        "lng": 9.756133,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Langenhagen",
        "province": "Niedersachsen",
        "streetAndNumber": "Erich-Ollenhauer-Straße 13",
        "zip": "30851",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181227,
        "identifier": "DE024108",
        "googlePlaceId": "ChIJg824hUJIqEcRKqdmIZT55U4",
        "lat": 52.457865,
        "lng": 13.579023,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Elcknerplatz 8",
        "zip": "12555",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181228,
        "identifier": "DE026043",
        "googlePlaceId": "ChIJB9rEFX_RqEcRq8NInfU5s7g",
        "lat": 52.618319,
        "lng": 12.351215,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rathenow",
        "province": "Brandenburg",
        "streetAndNumber": "Rudolf-Breitscheid-Straße 36",
        "zip": "14712",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181229,
        "identifier": "DE025010",
        "googlePlaceId": "ChIJw_PwbrYhuEcRY0-DWlRJ70w",
        "lat": 52.441879,
        "lng": 7.083326,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nordhorn",
        "province": "Niedersachsen",
        "streetAndNumber": "Wietmarscher Straße 8",
        "zip": "48531",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181230,
        "identifier": "DE020049",
        "googlePlaceId": "ChIJfVQ8yr-KqEcRLh_qJXfV8Qs",
        "lat": 52.305899,
        "lng": 13.029051,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Michendorf",
        "province": "Brandenburg",
        "streetAndNumber": "Luckenwalder Straße 2",
        "zip": "14552",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181231,
        "identifier": "DE026046",
        "googlePlaceId": "ChIJx24l_ONirkcRrEVGkqtD_UI",
        "lat": 53.327283,
        "lng": 11.502029,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ludwigslust",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Neue Torstraße 13a",
        "zip": "19288",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181232,
        "identifier": "DE031070",
        "googlePlaceId": "ChIJycfm0q71pEcRF_20xipBtKE",
        "lat": 51.480331,
        "lng": 11.315159,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sangerhausen",
        "province": "Thüringen",
        "streetAndNumber": "Oststraße 2",
        "zip": "06526",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181233,
        "identifier": "DE015013",
        "googlePlaceId": "ChIJ3e9Lf3vftkcR4jRAK1eCI1Q",
        "lat": 53.113264,
        "lng": 8.2125,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oldenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Cloppenburger Straße 293",
        "zip": "26133",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181234,
        "identifier": "DE003059",
        "googlePlaceId": "ChIJCz2GxLzysUcRXukeZsEej78",
        "lat": 53.488677,
        "lng": 10.184428,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Friedrich-Frank-Bogen 170",
        "zip": "21033",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181235,
        "identifier": "DE026053",
        "googlePlaceId": "ChIJxXYWSlHhrkcRyAOoQRuEnsw",
        "lat": 52.887951,
        "lng": 11.724306,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Seehausen (Altmark)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Arendseer Straße 49",
        "zip": "39615",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181236,
        "identifier": "DE005106",
        "googlePlaceId": "ChIJ135r2mTSu0cRCno5rf7Nv4o",
        "lat": 51.673877,
        "lng": 8.373443,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lippstadt",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Mondschein 29",
        "zip": "59557",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181237,
        "identifier": "DE010105",
        "googlePlaceId": "ChIJ84pfrE-4ukcR5B19dj8gLmI",
        "lat": 51.987553,
        "lng": 9.804699,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Alfeld (Leine)",
        "province": "Niedersachsen",
        "streetAndNumber": "Neue Wiese 13",
        "zip": "31061",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181238,
        "identifier": "DE004015",
        "googlePlaceId": "ChIJgWDcUzZds0cRwot39yU0BmQ",
        "lat": 54.798071,
        "lng": 9.397024,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Harrislee",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Marktallee 1",
        "zip": "24955",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181239,
        "identifier": "DE021040",
        "googlePlaceId": "ChIJ62cYd1tbpkcRjGEkdCT8ArE",
        "lat": 51.525719,
        "lng": 12.344534,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Delitzsch",
        "province": "Sachsen",
        "streetAndNumber": "Eisenbahnstraße 25",
        "zip": "04509",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181240,
        "identifier": "DE024061",
        "googlePlaceId": "ChIJ-2kiUMmzqUcRjs8gmIsNAHE",
        "lat": 52.680936,
        "lng": 13.556627,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bernau bei Berlin",
        "province": "Brandenburg",
        "streetAndNumber": "Potsdamer Straße 1",
        "zip": "16321",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181241,
        "identifier": "DE003033",
        "googlePlaceId": "ChIJYx3LN34jsUcRLN4aPk4LDv4",
        "lat": 53.184774,
        "lng": 8.981135,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Grasberg",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Langenmoor 1",
        "zip": "28879",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181242,
        "identifier": "DE015020",
        "googlePlaceId": "ChIJ4b8BWjBitkcR2Qxctk5Q6BM",
        "lat": 53.585468,
        "lng": 7.771094,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wittmund",
        "province": "Niedersachsen",
        "streetAndNumber": "Esenser Straße 58",
        "zip": "26409",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181243,
        "identifier": "DE026047",
        "googlePlaceId": "ChIJ098SGx1fr0cRJrXpOPYWSEk",
        "lat": 52.169663,
        "lng": 11.625143,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Magdeburg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Hanns-Eisler-Platz 11",
        "zip": "39128",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181244,
        "identifier": "DE016132",
        "googlePlaceId": "ChIJBbBxT7MOskcRLvcZG_tZ8k8",
        "lat": 53.856504,
        "lng": 10.665462,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübeck",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hansering 9-19",
        "zip": "23558",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181245,
        "identifier": "DE005111",
        "googlePlaceId": "ChIJL7I_lRIVukcR6nJpPQlahSw",
        "lat": 52.063582,
        "lng": 8.692068,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Salzuflen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Bexterholz 2",
        "zip": "32107",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181246,
        "identifier": "DE013100",
        "googlePlaceId": "ChIJNQb3kg9zvEcRiWKySxoudSs",
        "lat": 50.928888,
        "lng": 8.424694,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Laasphe",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Ludwig-Koch-Straße 4",
        "zip": "57334",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181247,
        "identifier": "DE013023",
        "googlePlaceId": "ChIJoVPs_f4kuUcRmU_amYMA3pc",
        "lat": 51.328302,
        "lng": 7.367012,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gevelsberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hagener Straße 220",
        "zip": "58285",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181248,
        "identifier": "DE036024",
        "googlePlaceId": "ChIJm4ULr1zFCUcRyH7Tx12xlFs",
        "lat": 51.040471,
        "lng": 13.668363,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Kesselsdorfer Straße 160",
        "zip": "01169",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181249,
        "identifier": "DE013003",
        "googlePlaceId": "ChIJV8GFd9liuUcR4g9XrCQyiqo",
        "lat": 51.560954,
        "lng": 8.08534,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Soest",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Boleweg 14",
        "zip": "59494",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181250,
        "identifier": "DE003089",
        "googlePlaceId": "ChIJXWSdLveMsUcRGYL1Hx984tE",
        "lat": 53.538793,
        "lng": 10.1231,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Möllner Landstraße 131",
        "zip": "22117",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181251,
        "identifier": "DE015034",
        "googlePlaceId": "ChIJo-DpjCkXtkcRcQEUzGnfuRo",
        "lat": 53.60196,
        "lng": 7.183797,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Norden",
        "province": "Niedersachsen",
        "streetAndNumber": "Gewerbestraße 13A",
        "zip": "26506",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181252,
        "identifier": "DE024095",
        "googlePlaceId": "ChIJ1QtBFr1RqEcRdovvLZRzEWc",
        "lat": 52.52424,
        "lng": 13.36405,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Invalidenstraße 59",
        "zip": "10557",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181253,
        "identifier": "DE020109",
        "googlePlaceId": "ChIJN0ZJecA9qEcRhX5Sc8KHGXQ",
        "lat": 52.29615,
        "lng": 13.682744,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Königs Wusterhausen",
        "province": "Brandenburg",
        "streetAndNumber": "Iris - Hahs - Hoffstetter - Straße 1",
        "zip": "15712",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181255,
        "identifier": "DE001083",
        "googlePlaceId": "ChIJUeyVC6vCuEcRp7R-AbrHCSE",
        "lat": 51.46958,
        "lng": 7.02107,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Katzenbruchstraße 78",
        "zip": "45141",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181257,
        "identifier": "DE025100",
        "googlePlaceId": "ChIJI0O1KqbmuUcR5-7XRdxbbvE",
        "lat": 52.334015,
        "lng": 8.02486,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wallenhorst",
        "province": "Niedersachsen",
        "streetAndNumber": "Osnabrücker Straße 11a",
        "zip": "49134",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181258,
        "identifier": "DE001088",
        "googlePlaceId": "ChIJ1-oyyf7nuEcR4RPidZpqFe4",
        "lat": 51.476405,
        "lng": 7.031767,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Twentmannstraße 7-11",
        "zip": "45141",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181259,
        "identifier": "DE005013",
        "googlePlaceId": "ChIJPz1vufhMukcRiiuAllzN3G8",
        "lat": 51.734326,
        "lng": 8.788303,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Paderborn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Senefelderstraße 13",
        "zip": "33100",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181260,
        "identifier": "DE016128",
        "googlePlaceId": "ChIJRX_q7H0JskcRI0gJps1g_44",
        "lat": 53.86685,
        "lng": 10.72201,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübeck",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Kantstraße 22",
        "zip": "23566",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181261,
        "identifier": "DE001023",
        "googlePlaceId": "ChIJpZ2NIrPluEcRVl1G3WUelv8",
        "lat": 51.581851,
        "lng": 7.10518,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gelsenkirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hertener Straße 53",
        "zip": "45892",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181262,
        "identifier": "DE007098",
        "googlePlaceId": "ChIJzcBnw5wCtEcRsC0pSnBLH64",
        "lat": 53.778793,
        "lng": 8.616296,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wurster Nordseeküste",
        "province": "Niedersachsen",
        "streetAndNumber": "Feuerweg 6 e",
        "zip": "27639",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181263,
        "identifier": "DE015010",
        "googlePlaceId": "ChIJQZ-KmbzjtkcRihPA5E666tE",
        "lat": 53.181472,
        "lng": 8.007776,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Zwischenahn",
        "province": "Niedersachsen",
        "streetAndNumber": "Langenhof 30a",
        "zip": "26160",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "from1": "10:00",
            "to1": "18:00"
          }
        ]
      },
      {
        "id": 3181264,
        "identifier": "DE001082",
        "googlePlaceId": "ChIJw0DDwQnDuEcR8kNKN_-1xzY",
        "lat": 51.420434,
        "lng": 6.960433,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Fulerumer Straße 221-223",
        "zip": "45149",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181265,
        "identifier": "DE003046",
        "googlePlaceId": "ChIJ4_CyneNhsUcRBR3rjs2wJ24",
        "lat": 53.714195,
        "lng": 9.377539,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Drochtersen",
        "province": "Niedersachsen",
        "streetAndNumber": "Sietwender Straße 66",
        "zip": "21706",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181266,
        "identifier": "DE020054",
        "googlePlaceId": "ChIJr2yHgPPjqEcRP5SWUQZ1LLI",
        "lat": 52.609999,
        "lng": 12.859303,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nauen",
        "province": "Brandenburg",
        "streetAndNumber": "Schillerstraße 1",
        "zip": "14641",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181267,
        "identifier": "DE024058",
        "googlePlaceId": "ChIJL5xYcMlOqEcR0hz_BThs9fo",
        "lat": 52.504793,
        "lng": 13.515097,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Alfred-Kowalke-Straße 2",
        "zip": "10315",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181268,
        "identifier": "DE032116",
        "googlePlaceId": "ChIJ6b-N2chLuEcRK7CVrduwOZo",
        "lat": 52.083632,
        "lng": 7.312011,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Horstmar",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Warnsveldallee 2",
        "zip": "48612",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181269,
        "identifier": "DE010065",
        "googlePlaceId": "ChIJbeB5PphAu0cRgOJLktMvwhw",
        "lat": 51.292122,
        "lng": 9.457294,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kassel",
        "province": "Hessen",
        "streetAndNumber": "Glockenbruchweg 84",
        "zip": "34134",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181271,
        "identifier": "DE021100",
        "googlePlaceId": "ChIJg9Rz2NlDpkcRNH6v9BmwVYQ",
        "lat": 51.624721,
        "lng": 12.333532,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bitterfeld-Wolfen",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Mühlstraße 13",
        "zip": "06749",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181272,
        "identifier": "DE004001",
        "googlePlaceId": "ChIJt4ynClFrs0cRvcxPkr_89Nw",
        "lat": 54.76869,
        "lng": 9.43385,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Flensburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Schleswiger Straße 130",
        "zip": "24941",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181273,
        "identifier": "DE020082",
        "googlePlaceId": "ChIJ3X8a31U8qUcRg7o8fkdh3FY",
        "lat": 52.916799,
        "lng": 12.78483,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neuruppin",
        "province": "Brandenburg",
        "streetAndNumber": "Neustädter Straße 28",
        "zip": "16816",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181274,
        "identifier": "DE032059",
        "googlePlaceId": "ChIJxVNSc6oDuUcRvKBg2yMl2sA",
        "lat": 51.665719,
        "lng": 7.347322,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Datteln",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bülowstraße 80",
        "zip": "45711",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181275,
        "identifier": "DE006161",
        "googlePlaceId": "ChIJzeew3r5ksEcRMxTiWnoqBHI",
        "lat": 52.511848,
        "lng": 9.476591,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neustadt am Rübenberge",
        "province": "Niedersachsen",
        "streetAndNumber": "Rudolf-Diesel-Ring 34",
        "zip": "31535",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181276,
        "identifier": "DE031054",
        "googlePlaceId": "ChIJ3-6bI79ypEcR7_L3TIkodH8",
        "lat": 50.974102,
        "lng": 11.033369,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Erfurt",
        "province": "Thüringen",
        "streetAndNumber": "Augustmauer 4",
        "zip": "99084",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181277,
        "identifier": "DE026064",
        "googlePlaceId": "ChIJd83yCaQQpkcRxEwIbSodEC4",
        "lat": 51.888613,
        "lng": 12.232363,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dessau-Roßlau",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Magdeburger Straße 38a",
        "zip": "06862",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181278,
        "identifier": "DE026022",
        "googlePlaceId": "ChIJKRZBrZHkpUcRx7CCqVNN8ew",
        "lat": 51.912133,
        "lng": 11.774521,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Calbe (Saale)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Ziegeleistraße 16",
        "zip": "39240",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181279,
        "identifier": "DE006170",
        "googlePlaceId": "ChIJ-QTt7x-MukcR6vkNkR7E024",
        "lat": 52.075103,
        "lng": 9.329411,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hameln",
        "province": "Niedersachsen",
        "streetAndNumber": "Werkstraße 17",
        "zip": "31789",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181280,
        "identifier": "DE025006",
        "googlePlaceId": "ChIJ25MPhP9Pt0cRaDvpkSOTpTs",
        "lat": 52.591308,
        "lng": 8.218373,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Steinfeld (Oldenburg)",
        "province": "Niedersachsen",
        "streetAndNumber": "Große Straße 74",
        "zip": "49439",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181281,
        "identifier": "DE025041",
        "googlePlaceId": "ChIJCwuQcfc-uEcRnldcugwvsD0",
        "lat": 52.204889,
        "lng": 7.052468,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gronau (Westfalen)",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Ochtruper Straße 143",
        "zip": "48599",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181282,
        "identifier": "DE016007",
        "googlePlaceId": "ChIJ82Bjx--GsUcRKwu44T33nT0",
        "lat": 53.620139,
        "lng": 9.888052,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Pinneberger Chaussee 130",
        "zip": "22523",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181283,
        "identifier": "DE026008",
        "googlePlaceId": "ChIJIwdvdaIar0cR_RVBnea85QI",
        "lat": 52.660962,
        "lng": 11.547657,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bismark (Altmark)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Döllnitzer Straße 7a",
        "zip": "39629",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181284,
        "identifier": "DE007029",
        "googlePlaceId": "ChIJRZiDwrE1t0cRF43PDEbsAPM",
        "lat": 52.782798,
        "lng": 8.430457,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Goldenstedt",
        "province": "Niedersachsen",
        "streetAndNumber": "Vechtaer Straße 1",
        "zip": "49424",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181285,
        "identifier": "DE013088",
        "googlePlaceId": "ChIJZ-p8LcgkuUcReRYHclrI4Z4",
        "lat": 51.339471,
        "lng": 7.39557,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hagen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Enneper Straße 146a",
        "zip": "58135",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181286,
        "identifier": "DE005037",
        "googlePlaceId": "ChIJvz59z9QZukcR2nVcqxRlwGg",
        "lat": 52.097258,
        "lng": 8.513195,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Beckendorfstraße 3",
        "zip": "33739",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181288,
        "identifier": "DE006069",
        "googlePlaceId": "ChIJ9Zp8FvAXsEcRwu78ujSSgpQ",
        "lat": 52.605379,
        "lng": 10.056481,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Celle",
        "province": "Niedersachsen",
        "streetAndNumber": "An der Hasenbahn 3",
        "zip": "29225",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181290,
        "identifier": "DE021101",
        "googlePlaceId": "ChIJtYKJJWZ7pkcRacQ7l9zFkv0",
        "lat": 51.508308,
        "lng": 11.9356,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Halle",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Dölauer Straße 80",
        "zip": "06120",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181292,
        "identifier": "DE005036",
        "googlePlaceId": "ChIJP4BdgUmPuUcRHzB96M8X2og",
        "lat": 51.92925,
        "lng": 8.125806,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Beelen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lilienweg 2",
        "zip": "48361",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181293,
        "identifier": "DE006070",
        "googlePlaceId": "ChIJyT_J8YuSr0cRGNH3z-1HMro",
        "lat": 52.401854,
        "lng": 10.749093,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wolfsburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Suhler Straße 6",
        "zip": "38444",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181294,
        "identifier": "DE003035",
        "googlePlaceId": "ChIJ7bfd3e4LsUcReS4jIlpf8-A",
        "lat": 53.285167,
        "lng": 9.505214,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sittensen",
        "province": "Niedersachsen",
        "streetAndNumber": "Stader Straße 11",
        "zip": "27419",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181295,
        "identifier": "DE006152",
        "googlePlaceId": "ChIJP03Pj7aCukcR4NTiA0eC4Y4",
        "lat": 52.30391,
        "lng": 9.486891,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Barsinghausen",
        "province": "Niedersachsen",
        "streetAndNumber": "Bunsenstraße 8",
        "zip": "30890",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181296,
        "identifier": "DE006052",
        "googlePlaceId": "ChIJNx0SJiDvr0cR1WaS5kGgGqg",
        "lat": 52.468958,
        "lng": 10.541208,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gifhorn",
        "province": "Niedersachsen",
        "streetAndNumber": "Braunschweiger Straße 106",
        "zip": "38518",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181297,
        "identifier": "DE016028",
        "googlePlaceId": "ChIJH2BOdPQfskcRF80i8tPkCyY",
        "lat": 53.666435,
        "lng": 10.231465,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ahrensburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Bogenstraße 30",
        "zip": "22926",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181298,
        "identifier": "DE020086",
        "googlePlaceId": "ChIJ03eU0_1RqEcRm37gf5J5_ks",
        "lat": 52.507079,
        "lng": 13.313775,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Wilmersdorfer Straße 36-37",
        "zip": "10625",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181300,
        "identifier": "DE013091",
        "googlePlaceId": "ChIJcd-SOIGNu0cR_MHeqhsV58U",
        "lat": 51.196802,
        "lng": 8.53208,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Winterberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Neue Mitte 3",
        "zip": "59955",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181301,
        "identifier": "DE016133",
        "googlePlaceId": "ChIJn-r5HjkJskcRHtEhhlIfaZo",
        "lat": 53.846687,
        "lng": 10.681132,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübeck",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Kronsforder Allee 70C",
        "zip": "23560",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181302,
        "identifier": "DE021084",
        "googlePlaceId": "ChIJHw65qJ33pkcR9RvbyII3OXA",
        "lat": 51.32853,
        "lng": 12.34492,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Nonnenstraße 13-15",
        "zip": "04229",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181304,
        "identifier": "DE002028",
        "googlePlaceId": "ChIJ0wAUKaZHuUcRsQTckzsc9q0",
        "lat": 51.303254,
        "lng": 7.665937,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Altena",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bahnhofstraße 60",
        "zip": "58762",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181306,
        "identifier": "DE002004",
        "googlePlaceId": "ChIJJw2qU44wuUcR1gagI19j01k",
        "lat": 51.263988,
        "lng": 7.462162,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Breckerfeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Windmühlenstraße 28",
        "zip": "58339",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181307,
        "identifier": "DE010003",
        "googlePlaceId": "ChIJuZY9y2POukcRT99UdZZT-h0",
        "lat": 51.815267,
        "lng": 9.879088,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Einbeck",
        "province": "Niedersachsen",
        "streetAndNumber": "Grimsehlstraße 42",
        "zip": "37574",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181310,
        "identifier": "DE006108",
        "googlePlaceId": "ChIJ_dxVXfuvukcRGI9o-MYnNYg",
        "lat": 52.125752,
        "lng": 9.90986,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hildesheim",
        "province": "Niedersachsen",
        "streetAndNumber": "Robert-Bosch-Straße 101",
        "zip": "31139",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181311,
        "identifier": "DE036084",
        "googlePlaceId": "ChIJWZuH3tjdCEcRAaOF64rAtac",
        "lat": 51.148409,
        "lng": 14.946594,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Görlitz",
        "province": "Sachsen",
        "streetAndNumber": "Reichenbacher Straße 106",
        "zip": "02827",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181312,
        "identifier": "DE024066",
        "googlePlaceId": "ChIJOaE6V5JLqEcRsykiPqgeQ8I",
        "lat": 52.549624,
        "lng": 13.563823,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Jan-Petersen-Straße 16",
        "zip": "12679",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181313,
        "identifier": "DE032019",
        "googlePlaceId": "ChIJYVyTj4gWuUcRLEymJtHzoKE",
        "lat": 51.485707,
        "lng": 7.553027,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wittbräucker Straße 53a",
        "zip": "44287",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181314,
        "identifier": "DE020003",
        "googlePlaceId": "ChIJV0_Di-b3qEcRbIvN8fSmOR8",
        "lat": 52.47084,
        "lng": 13.12483,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Ritterfelddamm 200",
        "zip": "14089",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181315,
        "identifier": "DE007019",
        "googlePlaceId": "ChIJl7RWArkVt0cRQvPht2A5xH0",
        "lat": 52.834838198513,
        "lng": 8.0264655107316,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Cloppenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Anemonenstraße 2",
        "zip": "49661",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181316,
        "identifier": "DE025084",
        "googlePlaceId": "ChIJGwSWKXbbuUcRR9Y8lY_YRFk",
        "lat": 52.318919,
        "lng": 7.776611,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Mettingen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Recker Straße 5",
        "zip": "49497",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181317,
        "identifier": "DE025019",
        "googlePlaceId": "ChIJ89cuOjA7uEcRWLCfp732bnc",
        "lat": 52.30564,
        "lng": 7.168882,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Bentheim",
        "province": "Niedersachsen",
        "streetAndNumber": "Heinrich-Böll-Straße 3",
        "zip": "48455",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181318,
        "identifier": "DE005119",
        "googlePlaceId": "ChIJyawi6FF5ukcRiV_8UDBktc4",
        "lat": 52.273932,
        "lng": 9.131721,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Obernkirchen",
        "province": "Niedersachsen",
        "streetAndNumber": "Neumarktstraße 47",
        "zip": "31683",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181319,
        "identifier": "DE006093",
        "googlePlaceId": "ChIJOdFLEwPGr0cRS5mCilfNjtU",
        "lat": 52.729856,
        "lng": 10.717556,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wittingen",
        "province": "Niedersachsen",
        "streetAndNumber": "Celler Straße 35",
        "zip": "29378",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181320,
        "identifier": "DE004142",
        "googlePlaceId": "ChIJ33tmHrVkrUcRhX3NE3a5Rdo",
        "lat": 54.444388,
        "lng": 11.182001,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Burg auf Fehmarn",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Ehlers Kamp 8",
        "zip": "23769",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181321,
        "identifier": "DE001065",
        "googlePlaceId": "ChIJFTd5gsTpuEcRr3J0oqp_Ulc",
        "lat": 51.489717,
        "lng": 6.956665,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Alte Bottroper Straße 98",
        "zip": "45356",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181322,
        "identifier": "DE025093",
        "googlePlaceId": "ChIJjf4aqW7vuUcR5y_P8eumYsU",
        "lat": 52.242724,
        "lng": 8.035997,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Osnabrück",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Wulfter Turm 2",
        "zip": "49082",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181323,
        "identifier": "DE021066",
        "googlePlaceId": "ChIJ2_ju1-gvpkcRW5l0Osykmgo",
        "lat": 51.865283,
        "lng": 12.630152,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lutherstadt Wittenberg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Dessauer Straße 3-4",
        "zip": "06886",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181324,
        "identifier": "DE004005",
        "googlePlaceId": "ChIJQTKysDhrs0cRZVHWj78QJ_I",
        "lat": 54.695452788714,
        "lng": 9.5878164089189,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Mittelangeln",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Westerfeld 1",
        "zip": "24986",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181325,
        "identifier": "DE036009",
        "googlePlaceId": "ChIJLWVhWT2dp0cRyiqrsUN_T6s",
        "lat": 51.298558,
        "lng": 13.265925,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Riesa",
        "province": "Sachsen",
        "streetAndNumber": "Riesapark 2",
        "zip": "01587",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181326,
        "identifier": "DE025064",
        "googlePlaceId": "ChIJZWSCdNLkuUcRo7_JJ5V8KFU",
        "lat": 52.305485,
        "lng": 8.12623,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Belm",
        "province": "Niedersachsen",
        "streetAndNumber": "Bremer Straße 76",
        "zip": "49191",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181327,
        "identifier": "DE003018",
        "googlePlaceId": "ChIJ5WjNIX4rrkcRTrS1KYa4Bh8",
        "lat": 52.960706,
        "lng": 10.557367,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Uelzen",
        "province": "Niedersachsen",
        "streetAndNumber": "Veerßer Straße 59",
        "zip": "29525",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181328,
        "identifier": "DE006164",
        "googlePlaceId": "ChIJnTwRwMh9sEcR3PeiTGH-FbQ",
        "lat": 52.435631,
        "lng": 9.356233,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hagenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Bergmannstraße 1",
        "zip": "31558",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181329,
        "identifier": "DE016150",
        "googlePlaceId": "ChIJ8Su3phILskcRe9CWiMcXtHI",
        "lat": 53.922689,
        "lng": 10.723361,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sereetz",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "An der Au 1",
        "zip": "23611",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181330,
        "identifier": "DE021069",
        "googlePlaceId": "ChIJn-RQooNYpkcRBiYqTspqDv8",
        "lat": 51.374894,
        "lng": 12.321048,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Georg-Schumann-Straße 363",
        "zip": "04159",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181332,
        "identifier": "DE001098",
        "googlePlaceId": "ChIJj-2AwCVvuEcRm5BSOUQn0As",
        "lat": 52.029903,
        "lng": 6.824497,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Vreden",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Up de Hacke 19",
        "zip": "48691",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181333,
        "identifier": "DE013021",
        "googlePlaceId": "ChIJY2JLE_8VuUcRCl_vo9_RzfA",
        "lat": 51.440558,
        "lng": 7.55946,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwerte",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Margot-Röttger-Rath-Straße 3",
        "zip": "58239",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181334,
        "identifier": "DE004081",
        "googlePlaceId": "ChIJIz2Fpz1vs0cREFa9_q9LL8M",
        "lat": 54.66396,
        "lng": 9.40326,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Tarp",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Dorfstraße 15",
        "zip": "24963",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181336,
        "identifier": "DE015026",
        "googlePlaceId": "ChIJnxBS_0LytkcRsOT3LltnQW8",
        "lat": 53.415256,
        "lng": 7.968537,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zetel",
        "province": "Niedersachsen",
        "streetAndNumber": "Neuenburger Straße 21",
        "zip": "26340",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181337,
        "identifier": "DE021058",
        "googlePlaceId": "ChIJiVHmHN4Zp0cRgiSlJq7hHpo",
        "lat": 51.054766,
        "lng": 12.700664,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Geithain",
        "province": "Sachsen",
        "streetAndNumber": "Colditzer Straße 6",
        "zip": "04643",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181339,
        "identifier": "DE006047",
        "googlePlaceId": "ChIJ3QnMq_EKsEcRjLOlT7Fis3A",
        "lat": 52.327446,
        "lng": 9.782945,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Hildesheimer Straße 401",
        "zip": "30519",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181340,
        "identifier": "DE005076",
        "googlePlaceId": "ChIJsczPl7jyuUcRhicXQEdS3_w",
        "lat": 52.098121,
        "lng": 8.098623,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Laer",
        "province": "Niedersachsen",
        "streetAndNumber": "Grüner Weg 1",
        "zip": "49196",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181341,
        "identifier": "DE001006",
        "googlePlaceId": "ChIJ-7EE_5teuEcR6Nd9FvcsqCg",
        "lat": 51.893785,
        "lng": 6.989152,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Velen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Alte Gärtnerei 4",
        "zip": "46342",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "19:30"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "19:30"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "19:30"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "19:30"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "19:30"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "19:30"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181342,
        "identifier": "DE001010",
        "googlePlaceId": "ChIJqWCNDwXjuEcRtODLXxVHTbE",
        "lat": 51.598169,
        "lng": 7.206657,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Recklinghausen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Werkstättenstraße 7",
        "zip": "45659",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181344,
        "identifier": "DE015021",
        "googlePlaceId": "ChIJzzBRPNc5tkcRuz_9TDl4RDk",
        "lat": 53.359848,
        "lng": 7.216601,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Emden",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Südbahnhof 42",
        "zip": "26725",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181345,
        "identifier": "DE024118",
        "googlePlaceId": "ChIJlcpgSTKIB0cR6pv5YnW8GBY",
        "lat": 52.336772,
        "lng": 14.077238,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Fürstenwalde",
        "province": "Brandenburg",
        "streetAndNumber": "Alte Langewahler Chaussee 4",
        "zip": "15517",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181346,
        "identifier": "DE015017",
        "googlePlaceId": "ChIJOYKZo-sEt0cRRjV58QSvmi4",
        "lat": 53.023738,
        "lng": 7.859301,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Friesoythe",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Bahnhof 3",
        "zip": "26169",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181347,
        "identifier": "DE031071",
        "googlePlaceId": "ChIJSRg5QQRNpEcR1Lua9T0JStA",
        "lat": 51.462521,
        "lng": 11.071518,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Südharz",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Hallesche Straße 69",
        "zip": "06536",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181348,
        "identifier": "DE031017",
        "googlePlaceId": "ChIJd2J2WXCApEcRwJ-6ROC5OQY",
        "lat": 50.900011,
        "lng": 10.563695,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Waltershausen",
        "province": "Thüringen",
        "streetAndNumber": "Ohrdrufer Straße 3",
        "zip": "99880",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181349,
        "identifier": "DE003105",
        "googlePlaceId": "ChIJU3nFqmjXrUcRmBJ3i9DyuaQ",
        "lat": 53.597298,
        "lng": 11.439578,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwerin",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Am Grünen Tal 25",
        "zip": "19063",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181350,
        "identifier": "DE003005",
        "googlePlaceId": "ChIJE7S63pznsUcRPJ8PgDOTwcM",
        "lat": 53.296584,
        "lng": 10.382358,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bardowick",
        "province": "Niedersachsen",
        "streetAndNumber": "Vor der Westermarsch 1",
        "zip": "21357",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181351,
        "identifier": "DE006018",
        "googlePlaceId": "ChIJCaAUmLbCr0cRiNnAD_G65i0",
        "lat": 52.594361,
        "lng": 10.544841,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wesendorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Wittinger Straße 44",
        "zip": "29392",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181352,
        "identifier": "DE013082",
        "googlePlaceId": "ChIJp8jzj2c7uUcRkmwEtDG2tKA",
        "lat": 51.353755,
        "lng": 7.451492,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hagen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wehringhauser Straße 81-85",
        "zip": "58089",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181353,
        "identifier": "DE006027",
        "googlePlaceId": "ChIJT6053B3-r0cRlGBNCg41TYk",
        "lat": 52.330833,
        "lng": 10.204478,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Peine",
        "province": "Niedersachsen",
        "streetAndNumber": "Vöhrumer Straße 36-40",
        "zip": "31228",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181354,
        "identifier": "DE024007",
        "googlePlaceId": "ChIJU-10ZjlMqEcRlQYG5i0N8m0",
        "lat": 52.548119,
        "lng": 13.50381,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Hauptstraße 9",
        "zip": "13055",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181355,
        "identifier": "DE032028",
        "googlePlaceId": "ChIJ5XSfi6AWuUcRgOxDMAUaGgU",
        "lat": 51.505518,
        "lng": 7.570852,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Schleefstraße 15-19",
        "zip": "44287",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181356,
        "identifier": "DE029077",
        "googlePlaceId": "ChIJ-di5z2hvqUcRCASF4pgdEXI",
        "lat": 53.170706,
        "lng": 13.140083,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Fürstenberg/Havel",
        "province": "Brandenburg",
        "streetAndNumber": "Hans-Günter-Bock-Straße 6",
        "zip": "16798",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181358,
        "identifier": "DE003015",
        "googlePlaceId": "ChIJifxRTRubsUcRZ8phbqZAHaw",
        "lat": 53.473019752387,
        "lng": 9.8422202809728,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Cuxhavener Straße 402",
        "zip": "21149",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181359,
        "identifier": "DE013072",
        "googlePlaceId": "ChIJPTy0_Up8uUcRm9-iFfKqi14",
        "lat": 51.633845,
        "lng": 8.097725,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lippetal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Bahnhof 3",
        "zip": "59510",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181360,
        "identifier": "DE020105",
        "googlePlaceId": "ChIJXazeVLs4qEcR1fgItuhL1tA",
        "lat": 52.364049,
        "lng": 13.591652,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schulzendorf",
        "province": "Brandenburg",
        "streetAndNumber": "Ernst-Thälmann-Straße 124",
        "zip": "15732",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181362,
        "identifier": "DE026086",
        "googlePlaceId": "ChIJ_awZkBtFpUcRXwQyJHlo4zk",
        "lat": 52.045957,
        "lng": 10.374961,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Salzgitter",
        "province": "Niedersachsen",
        "streetAndNumber": "Hinter dem Salze 11",
        "zip": "38259",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181364,
        "identifier": "DE015062",
        "googlePlaceId": "ChIJy7jhighttkcRVj33Ko1pL5A",
        "lat": 53.645926,
        "lng": 7.430513,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dornum",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Bensjücht 1",
        "zip": "26553",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181365,
        "identifier": "DE031010",
        "googlePlaceId": "ChIJHTNB2vZ7pEcRGEDoYFPu7gk",
        "lat": 50.953467,
        "lng": 10.715323,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gotha",
        "province": "Thüringen",
        "streetAndNumber": "Oststraße 54-56",
        "zip": "99867",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181366,
        "identifier": "DE032126",
        "googlePlaceId": "ChIJgcpwbjujuUcRCyMqJywShog",
        "lat": 51.923034,
        "lng": 7.726838,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Münster",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Münsterstraße 40-42",
        "zip": "48167",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181367,
        "identifier": "DE006081",
        "googlePlaceId": "ChIJDyQBzf0XsEcRRuDrim75Omc",
        "lat": 52.6165303,
        "lng": 10.0628356,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Celle",
        "province": "Niedersachsen",
        "streetAndNumber": "Itagstraße 22",
        "zip": "29221",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3181368,
        "identifier": "DE029029",
        "googlePlaceId": "ChIJzVNT-RHAq0cRmkEVl1YdglM",
        "lat": 53.689213,
        "lng": 13.248821,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Altentreptow",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Grüner Gang 10",
        "zip": "17087",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181369,
        "identifier": "DE020029",
        "googlePlaceId": "ChIJtWjXZANQqEcR1G3Qdl3feBM",
        "lat": 52.468268,
        "lng": 13.373992,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Schöneberger Straße 28",
        "zip": "12103",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181370,
        "identifier": "DE020104",
        "googlePlaceId": "ChIJZXMZZ0NHqEcR48CO2UED0Pk",
        "lat": 52.36813,
        "lng": 13.56237,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schönefeld",
        "province": "Brandenburg",
        "streetAndNumber": "Am Pechpfuhl 8",
        "zip": "12529",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181371,
        "identifier": "DE002080",
        "googlePlaceId": "ChIJO9Vn7GvWuEcRY5FeLCfTHbc",
        "lat": 51.228725,
        "lng": 7.145232,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Küllenhahner Straße 67",
        "zip": "42349",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181372,
        "identifier": "DE020033",
        "googlePlaceId": "ChIJAxAa-BxbqEcRHnP5kTLQiwU",
        "lat": 52.41998,
        "lng": 13.314605,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Hildburghauser Straße 248",
        "zip": "12207",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181373,
        "identifier": "DE003104",
        "googlePlaceId": "ChIJk1G6RLjZrUcRxErrWQrCOJY",
        "lat": 53.601149,
        "lng": 11.387188,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwerin",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Grabenstraße 9",
        "zip": "19061",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181374,
        "identifier": "DE032112",
        "googlePlaceId": "ChIJ34FYPpO3uUcRpfnvAViwPOA",
        "lat": 52.093834738018,
        "lng": 7.606219880514,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Greven",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kardinal-von-Galen-Straße 4",
        "zip": "48268",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181375,
        "identifier": "DE002085",
        "googlePlaceId": "ChIJv2XZ6wcVvEcR0_Tlt5VVWUs",
        "lat": 50.751594,
        "lng": 8.277459,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dillenburg",
        "province": "Hessen",
        "streetAndNumber": "Kasseler Straße 34",
        "zip": "35683",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181376,
        "identifier": "DE020046",
        "googlePlaceId": "ChIJx5Noi4OJqEcRrkJsnNY8rq4",
        "lat": 52.238398,
        "lng": 12.970143,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Beelitz",
        "province": "Brandenburg",
        "streetAndNumber": "Clara-Zetkin-Straße 36a",
        "zip": "14547",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181377,
        "identifier": "DE006122",
        "googlePlaceId": "ChIJN-Ozg8X1r0cRySCbtgh2q20",
        "lat": 52.263394,
        "lng": 10.544609,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Braunschweig",
        "province": "Niedersachsen",
        "streetAndNumber": "Kastanienallee 21/22",
        "zip": "38102",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181378,
        "identifier": "DE024081",
        "googlePlaceId": "ChIJqbEofOxTqEcR7BO0ieLwSsM",
        "lat": 52.570694,
        "lng": 13.328034,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Ollenhauerstraße 106",
        "zip": "13403",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181379,
        "identifier": "DE006036",
        "googlePlaceId": "ChIJhTOMZojjr0cRa2mljo1owt4",
        "lat": 52.474157,
        "lng": 10.368127,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Meinersen",
        "province": "Niedersachsen",
        "streetAndNumber": "Gifhorner Straße 10",
        "zip": "38536",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181380,
        "identifier": "DE005043",
        "googlePlaceId": "ChIJSVkgmEcCcEERu2iUu9qzDNk",
        "lat": 51.927488,
        "lng": 8.599089,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Beckhof 80",
        "zip": "33689",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181381,
        "identifier": "DE032113",
        "googlePlaceId": "ChIJiUsdh-S3uUcRx2zoiueWQy0",
        "lat": 52.109483,
        "lng": 7.613349,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Greven",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Saerbecker Straße 128",
        "zip": "48268",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181382,
        "identifier": "DE032068",
        "googlePlaceId": "ChIJX7poQWYXuUcR9ecvCC3FavQ",
        "lat": 51.50492,
        "lng": 7.47629,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Märkische Straße 86-88",
        "zip": "44141",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181384,
        "identifier": "DE024121",
        "googlePlaceId": "ChIJTepSZUCYB0cRdA2Q27YytLo",
        "lat": 52.344148,
        "lng": 14.526704,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Frankfurt (Oder)",
        "province": "Brandenburg",
        "streetAndNumber": "August- Bebel- Straße 1A",
        "zip": "15234",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181385,
        "identifier": "DE005140",
        "googlePlaceId": "ChIJhaPCwj6ku0cR1Qy1M_DPSu4",
        "lat": 51.465252,
        "lng": 8.858521,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Marsberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bahnstraße 7",
        "zip": "34431",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181386,
        "identifier": "DE032005",
        "googlePlaceId": "ChIJl20jiXYauUcReU_t4HfBzis",
        "lat": 51.555559,
        "lng": 7.474412,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lüdinghauser Straße 18",
        "zip": "44339",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181387,
        "identifier": "DE032024",
        "googlePlaceId": "ChIJ0ckSa_IhuUcRuApVdsGZbtQ",
        "lat": 51.43791,
        "lng": 7.32566,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Witten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Herbeder Straße 10-12",
        "zip": "58455",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3181388,
        "identifier": "DE004109",
        "googlePlaceId": "ChIJk3Zp3Q3Es0cRi5uorB8kn18",
        "lat": 53.954872,
        "lng": 9.49234,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Itzehoe",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Lise-Meitner-Straße 16",
        "zip": "25524",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181389,
        "identifier": "DE004122",
        "googlePlaceId": "ChIJgWnxTvrxs0cR0GPnriK3r1E",
        "lat": 53.988437,
        "lng": 9.111574,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sankt Michaelisdonn",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Johannssenstraße 19",
        "zip": "25693",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181390,
        "identifier": "DE029071",
        "googlePlaceId": "ChIJr4qCSqL4q0cR77nDg7sYPRE",
        "lat": 53.520972,
        "lng": 12.648938,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Waren",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Warendorfer Straße 8",
        "zip": "17192",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "from1": "12:00",
            "to1": "18:00"
          }
        ]
      },
      {
        "id": 3181391,
        "identifier": "DE026054",
        "googlePlaceId": "ChIJVddVqWHXrkcRQrgmszHJoDA",
        "lat": 52.836592,
        "lng": 12.082174,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Havelberg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Pritzwalker Straße 66",
        "zip": "39539",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181392,
        "identifier": "DE013085",
        "googlePlaceId": "ChIJ6dV3CS45uUcRY0ldX7RYm8Y",
        "lat": 51.349608,
        "lng": 7.5722,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hagen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bahnstraße 11",
        "zip": "58119",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181393,
        "identifier": "DE021033",
        "googlePlaceId": "ChIJRR_i4MSrp0cRuMYmWsC6fCI",
        "lat": 51.384817,
        "lng": 12.725647,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wurzen",
        "province": "Sachsen",
        "streetAndNumber": "Nischwitzer Breite 1",
        "zip": "04808",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181394,
        "identifier": "DE006079",
        "googlePlaceId": "ChIJjQY2U63sr0cRB9ugh0PoHKY",
        "lat": 52.463121,
        "lng": 10.720496,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Weyhausen",
        "province": "Niedersachsen",
        "streetAndNumber": "Laischeweg 2",
        "zip": "38554",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181395,
        "identifier": "DE007015",
        "googlePlaceId": "ChIJpQw-rVEosUcR59ISp48Huyw",
        "lat": 53.10105,
        "lng": 8.786971,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Waller Heerstraße 101",
        "zip": "28219",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181396,
        "identifier": "DE004139",
        "googlePlaceId": "ChIJRZLzkvqBskcRpZeba1kLESg",
        "lat": 54.364299,
        "lng": 10.967059,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Heiligenhafen",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Höhenweg 2",
        "zip": "23774",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181397,
        "identifier": "DE003042",
        "googlePlaceId": "ChIJDdWY6VPysUcR8BzcKFMVQKI",
        "lat": 53.511514,
        "lng": 10.236475,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Reinbek",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Am Ladenzentrum 5",
        "zip": "21465",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181398,
        "identifier": "DE001012",
        "googlePlaceId": "ChIJ99qhGX_vuEcRaHgUC1zV8Cc",
        "lat": 51.596219,
        "lng": 7.050779,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gelsenkirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Polsumer Straße 133",
        "zip": "45896",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181399,
        "identifier": "DE005099",
        "googlePlaceId": "ChIJsRhL3YVDukcRsAH6gNR35yM",
        "lat": 51.951707,
        "lng": 8.854816,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Detmold",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Klingenbergstraße 25",
        "zip": "32758",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181400,
        "identifier": "DE006050",
        "googlePlaceId": "ChIJ5YmTeaKNr0cR5MkN97yNTNc",
        "lat": 52.362972,
        "lng": 10.750451,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wolfsburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Plantage 86F",
        "zip": "38444",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181401,
        "identifier": "DE032073",
        "googlePlaceId": "ChIJQY8atsEPuUcRApr3qnFibVw",
        "lat": 51.629569,
        "lng": 7.527682,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lünen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Cappenberger Straße 98",
        "zip": "44534",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181402,
        "identifier": "DE006103",
        "googlePlaceId": "ChIJOYnahFOuukcRdB-a2U42kco",
        "lat": 52.147837,
        "lng": 9.963803,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hildesheim",
        "province": "Niedersachsen",
        "streetAndNumber": "Gravelottestraße 1",
        "zip": "31134",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181403,
        "identifier": "DE016164",
        "googlePlaceId": "ChIJgYQljosVskcRf-ENdjtBs6s",
        "lat": 53.927555,
        "lng": 10.330474,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Segeberg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Anny-Schröder-Weg 2",
        "zip": "23795",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181405,
        "identifier": "DE010005",
        "googlePlaceId": "ChIJcWE0Y9rYukcRdcFXWFKcY9k",
        "lat": 51.661425,
        "lng": 9.630051,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Uslar",
        "province": "Niedersachsen",
        "streetAndNumber": "Wiesenstr. 26",
        "zip": "37170",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181406,
        "identifier": "DE003044",
        "googlePlaceId": "ChIJff_3ylKzsUcRMJxtUr62uX0",
        "lat": 52.982805,
        "lng": 9.840333,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Soltau",
        "province": "Niedersachsen",
        "streetAndNumber": "Böhmheide 45",
        "zip": "29614",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181407,
        "identifier": "DE001049",
        "googlePlaceId": "ChIJ753kg7LouEcRckjPNhakrO0",
        "lat": 51.554602,
        "lng": 7.031806,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gelsenkirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Braukämper Straße 107",
        "zip": "45899",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181408,
        "identifier": "DE004119",
        "googlePlaceId": "ChIJ9-TgvdHws0cR_bEXZnASVAc",
        "lat": 53.956155,
        "lng": 9.006602,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Marne",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Königstraße 59",
        "zip": "25709",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181409,
        "identifier": "DE006071",
        "googlePlaceId": "ChIJmwCAXhwdsEcR-BAb6cAHCbw",
        "lat": 52.463223,
        "lng": 10.196977,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Uetze",
        "province": "Niedersachsen",
        "streetAndNumber": "Burgdorfer Straße 23",
        "zip": "31311",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181410,
        "identifier": "DE001061",
        "googlePlaceId": "ChIJGxVwPxLyuEcRfjDKXLxhAbg",
        "lat": 51.659458,
        "lng": 6.942777,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dorsten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Klosterstraße 107",
        "zip": "46282",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181411,
        "identifier": "DE002096",
        "googlePlaceId": "ChIJ3VUUxesDvEcRFKW6GknXqjQ",
        "lat": 50.970255,
        "lng": 8.048186,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kreuztal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Marburger Straße 388",
        "zip": "57223",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181412,
        "identifier": "DE025049",
        "googlePlaceId": "ChIJMf-pw-prt0cRW-6MfxQtjsA",
        "lat": 52.714742,
        "lng": 7.938364,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen (Oldenburg)",
        "province": "Niedersachsen",
        "streetAndNumber": "Lange Straße 97",
        "zip": "49632",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181413,
        "identifier": "DE004002",
        "googlePlaceId": "ChIJlVYCXT1zs0cReAKUOqGCf2s",
        "lat": 54.529897,
        "lng": 9.530772,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schleswig",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Flensburger Straße 174",
        "zip": "24837",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181414,
        "identifier": "DE029068",
        "googlePlaceId": "ChIJVQgYjTKerkcRImE7NtRzEoU",
        "lat": 53.464015,
        "lng": 12.047078,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübz",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "An der Brücke 1",
        "zip": "19386",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181415,
        "identifier": "DE007107",
        "googlePlaceId": "ChIJx1W0RNWnsEcRriHApBzOO58",
        "lat": 52.430443,
        "lng": 8.622431,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rahden",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Eisenbahnstraße 14",
        "zip": "32369",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181416,
        "identifier": "DE024010",
        "googlePlaceId": "ChIJiUYq8Y9OqEcRJdb5WvvZd94",
        "lat": 52.52273,
        "lng": 13.48391,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Josef-Orlopp-Straße 22-24",
        "zip": "10367",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181417,
        "identifier": "DE031087",
        "googlePlaceId": "ChIJHYtNdxsqoUcRu99KYCbUPcs",
        "lat": 50.621181,
        "lng": 12.26493,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Mylau",
        "province": "Sachsen",
        "streetAndNumber": "Braustraße 1",
        "zip": "08499",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181418,
        "identifier": "DE013020",
        "googlePlaceId": "ChIJv4Uhsc1ruUcRA6KqKzwdw0g",
        "lat": 51.472451,
        "lng": 7.764007,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Fröndenberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bruayplatz 2",
        "zip": "58730",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:30"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:30"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:30"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:30"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:30"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:30"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181419,
        "identifier": "DE024119",
        "googlePlaceId": "ChIJW8q-CPiYB0cRkSKhGofYwqA",
        "lat": 52.360563,
        "lng": 14.523052,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Frankfurt (Oder)",
        "province": "Brandenburg",
        "streetAndNumber": "Spitzkrugring 2",
        "zip": "15234",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181420,
        "identifier": "DE006132",
        "googlePlaceId": "ChIJewKMyh72r0cRSHmRq7hxnJ0",
        "lat": 52.2411,
        "lng": 10.493285,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Braunschweig",
        "province": "Niedersachsen",
        "streetAndNumber": "Neckarstraße 1",
        "zip": "38120",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181422,
        "identifier": "DE020114",
        "googlePlaceId": "ChIJvzMjLkYMqEcR4QZRcpVedR4",
        "lat": 52.042832,
        "lng": 13.504604,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Baruth",
        "province": "Brandenburg",
        "streetAndNumber": "Rudolf-Breitscheid-Straße 27",
        "zip": "15837",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181423,
        "identifier": "DE021008",
        "googlePlaceId": "ChIJr8KIA4z3pkcRCCj_Jp1KOTw",
        "lat": 51.341423,
        "lng": 12.361327,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Elsterstraße 51 - 57",
        "zip": "04109",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181424,
        "identifier": "DE024065",
        "googlePlaceId": "ChIJwyVY1k5SqEcRaKDQOC1btdk",
        "lat": 52.572967,
        "lng": 13.381552,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Straße vor Schönholz 21",
        "zip": "13158",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3181425,
        "identifier": "DE015047",
        "googlePlaceId": "ChIJBd5ATV7ttkcRKLyqIlHoK74",
        "lat": 53.392053002233,
        "lng": 8.0089520912485,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bockhorn",
        "province": "Niedersachsen",
        "streetAndNumber": "Alte Bahnlinie 4",
        "zip": "26345",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181426,
        "identifier": "DE032041",
        "googlePlaceId": "ChIJt-K9nkojuUcRGx9iXfwCZbs",
        "lat": 51.439091,
        "lng": 7.352776,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Witten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Arthur-Imhausen-Straße 26",
        "zip": "58453",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181427,
        "identifier": "DE003016",
        "googlePlaceId": "ChIJKx72uTwksUcRb0ttK_Omas4",
        "lat": 53.153942,
        "lng": 8.934707,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lilienthal",
        "province": "Niedersachsen",
        "streetAndNumber": "Falkenberger Landstraße 89",
        "zip": "28865",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181428,
        "identifier": "DE021037",
        "googlePlaceId": "ChIJB8v3fwwupkcRjv_sIafd3uc",
        "lat": 51.861044,
        "lng": 12.717831,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zahna-Elster",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Marktstraße 4",
        "zip": "06895",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181429,
        "identifier": "DE010090",
        "googlePlaceId": "ChIJHd3dBVmfvEcRNrW2juom5Ug",
        "lat": 50.910623,
        "lng": 9.243747,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwalmstadt",
        "province": "Hessen",
        "streetAndNumber": "Ernst-Ihle-Straße 10",
        "zip": "34613",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181430,
        "identifier": "DE010045",
        "googlePlaceId": "ChIJLzeYEekspUcRpytuPTknUFw",
        "lat": 51.708459,
        "lng": 10.005094,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Northeim",
        "province": "Niedersachsen",
        "streetAndNumber": "Nordhäuser Weg 3",
        "zip": "37154",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181431,
        "identifier": "DE007111",
        "googlePlaceId": "ChIJOxQ7mhcIukcRcZXQZhxtyEE",
        "lat": 52.376118,
        "lng": 8.630478,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Espelkamp",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Gerhard-Wetzel-Straße 11",
        "zip": "32339",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181432,
        "identifier": "DE036008",
        "googlePlaceId": "ChIJ5dzJVPpxp0cRJOlJJtNk0gw",
        "lat": 51.13392603,
        "lng": 13.09707506,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Döbeln",
        "province": "Sachsen",
        "streetAndNumber": "Grimmaische Straße 67",
        "zip": "04720",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3181434,
        "identifier": "DE003096",
        "googlePlaceId": "ChIJP_Ka5_LysUcRh-FSbWjec2U",
        "lat": 53.496951,
        "lng": 10.208832,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Am Beckerkamp 29 a",
        "zip": "21031",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181435,
        "identifier": "DE013077",
        "googlePlaceId": "ChIJsXIBcqtxvEcRc4uzpD8uJhk",
        "lat": 50.905102,
        "lng": 8.534875,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Biedenkopf",
        "province": "Hessen",
        "streetAndNumber": "Am Seewasem 3",
        "zip": "35216",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181436,
        "identifier": "DE010086",
        "googlePlaceId": "ChIJ-SmiaTSsvEcRiB4yRDPJ38k",
        "lat": 50.831929,
        "lng": 9.573424,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kirchheim",
        "province": "Hessen",
        "streetAndNumber": "Stockäcker 4",
        "zip": "36275",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181437,
        "identifier": "DE024040",
        "googlePlaceId": "ChIJ94fj-6i4qUcRJhSM6X638yk",
        "lat": 52.835657,
        "lng": 13.81591,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eberswalde",
        "province": "Brandenburg",
        "streetAndNumber": "Bergerstraße 113",
        "zip": "16225",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181438,
        "identifier": "DE005004",
        "googlePlaceId": "ChIJxWwLVGOzu0cRsVmkJrlcjQ8",
        "lat": 51.665836,
        "lng": 8.725011,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Borchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Sperenberger Straße 1",
        "zip": "33178",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181440,
        "identifier": "DE024027",
        "googlePlaceId": "ChIJhcTvx4S5qUcRAqQqzT-qD-A",
        "lat": 52.84013365,
        "lng": 13.69639815,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schorfheide",
        "province": "Brandenburg",
        "streetAndNumber": "B167 15",
        "zip": "16244",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181441,
        "identifier": "DE010040",
        "googlePlaceId": "ChIJpfMah86evEcRtMcVlS4Ds5M",
        "lat": 50.911473,
        "lng": 9.181602,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwalmstadt",
        "province": "Hessen",
        "streetAndNumber": "Wierastraße 3",
        "zip": "34613",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181442,
        "identifier": "DE005116",
        "googlePlaceId": "ChIJrSnsISVfukcR25KSeEEl014",
        "lat": 51.938676,
        "lng": 9.099594,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Blomberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Schmuckenberger Weg 2a",
        "zip": "32825",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181443,
        "identifier": "DE006051",
        "googlePlaceId": "ChIJH1GgtJlzsEcRQjkOVTJXx_0",
        "lat": 52.409723,
        "lng": 9.693536,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Fuhrenkampe 14",
        "zip": "30419",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181444,
        "identifier": "DE032015",
        "googlePlaceId": "ChIJbwXwblUXuUcRpoJzTv7E-b0",
        "lat": 51.529495,
        "lng": 7.470418,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bornstraße 160",
        "zip": "44145",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181445,
        "identifier": "DE015081",
        "googlePlaceId": "ChIJmT1_8OyztkcRhDuIP6XCz9M",
        "lat": 53.5266,
        "lng": 8.644792,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schiffdorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Zum Feldkamp 16a",
        "zip": "27619",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181447,
        "identifier": "DE021012",
        "googlePlaceId": "ChIJCcPLpjPnpkcRbWLKjFmm-Gw",
        "lat": 51.038979,
        "lng": 12.31275,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Meuselwitz",
        "province": "Thüringen",
        "streetAndNumber": "Altenburger Straße 71",
        "zip": "04610",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181448,
        "identifier": "DE005136",
        "googlePlaceId": "ChIJGXdZJl4Pu0cRGILQa1gqMsg",
        "lat": 51.493319,
        "lng": 9.13508,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Warburg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Papenheimer Straße 65",
        "zip": "34414",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181449,
        "identifier": "DE004134",
        "googlePlaceId": "ChIJE2SCc0_Ts0cRc75pxLG5Fho",
        "lat": 53.787835,
        "lng": 9.771948,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Barmstedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Küsterkamp 3",
        "zip": "25355",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181450,
        "identifier": "DE016076",
        "googlePlaceId": "ChIJbX-xipCLsUcR_ABryn2uUYQ",
        "lat": 53.582793,
        "lng": 10.116244,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Tonndorfer Hauptstraße 28",
        "zip": "22045",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181451,
        "identifier": "DE032016",
        "googlePlaceId": "ChIJqdn4BzcRuUcRYo491QwIWvo",
        "lat": 51.533775,
        "lng": 7.549673,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Oesterstraße 120",
        "zip": "44309",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181452,
        "identifier": "DE007056",
        "googlePlaceId": "ChIJWwW-6wspsUcR8wJJhGZUA5Q",
        "lat": 53.115796,
        "lng": 8.758327,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Lindenhofstraße 1 - 15",
        "zip": "28237",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181454,
        "identifier": "DE020038",
        "googlePlaceId": "ChIJzd9QVv5aqEcRk-2BgWc2CH4",
        "lat": 52.427034,
        "lng": 13.304026,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Lausanner Straße 83",
        "zip": "12205",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181455,
        "identifier": "DE006008",
        "googlePlaceId": "ChIJW4mml1KRr0cRdX047G68Jtk",
        "lat": 52.464163,
        "lng": 10.852518,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wolfsburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Alte Schulstraße 30",
        "zip": "38448",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181456,
        "identifier": "DE036092",
        "googlePlaceId": "ChIJ8wf6YRlGp0cRltRqOd9drCg",
        "lat": 50.796687,
        "lng": 12.921379,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Chemnitz",
        "province": "Sachsen",
        "streetAndNumber": "Annaberger Straße 315",
        "zip": "09125",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181457,
        "identifier": "DE036039",
        "googlePlaceId": "ChIJi4_vi8LFCUcRg9P6HNblbEc",
        "lat": 51.019498,
        "lng": 13.735563,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Bulgakowstraße 7",
        "zip": "01217",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181458,
        "identifier": "DE004083",
        "googlePlaceId": "ChIJubf-JyIRs0cRNcKSo70rHyw",
        "lat": 54.635435,
        "lng": 9.772417,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Süderbrarup",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Südertoft 2",
        "zip": "24392",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181459,
        "identifier": "DE016025",
        "googlePlaceId": "ChIJUQTxEqz7sUcRVZDs352PtUE",
        "lat": 53.501128,
        "lng": 10.470738,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwarzenbek",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hamburger Straße 31",
        "zip": "21493",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181460,
        "identifier": "DE005149",
        "googlePlaceId": "ChIJKywRE_NhvEcRYSNcn7cQn5E",
        "lat": 50.76184,
        "lng": 8.73924,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Weimar (Lahn)",
        "province": "Hessen",
        "streetAndNumber": "Herborner Straße 1",
        "zip": "35096",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181461,
        "identifier": "DE025013",
        "googlePlaceId": "ChIJ3QCSqlx8t0cRd4r9RLwRlSI",
        "lat": 52.513328,
        "lng": 7.671923,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Fürstenau",
        "province": "Niedersachsen",
        "streetAndNumber": "Parkstraße 23",
        "zip": "49584",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181462,
        "identifier": "DE004032",
        "googlePlaceId": "ChIJ8Z1C41Nzs0cRPVIEnBuQ9ic",
        "lat": 54.504325,
        "lng": 9.542592,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schleswig",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Georg-Pfingsten-Weg 5",
        "zip": "24837",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181463,
        "identifier": "DE021079",
        "googlePlaceId": "ChIJvRrS-pr5pkcRrC7rsj8UFV8",
        "lat": 51.292742,
        "lng": 12.393782,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Friederikenstraße 25",
        "zip": "04279",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181464,
        "identifier": "DE004019",
        "googlePlaceId": "ChIJwQCXp-BZskcRfl5Hmm--c5c",
        "lat": 54.284753,
        "lng": 10.221418,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwentinental",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Carl-Zeiss-Straße 2-10",
        "zip": "24223",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181465,
        "identifier": "DE029012",
        "googlePlaceId": "ChIJC69MDgD3qkcR6XorrdR1lUo",
        "lat": 53.958016,
        "lng": 14.154627,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Heringsdorf",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Labahnstraße 18",
        "zip": "17424",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181466,
        "identifier": "DE010064",
        "googlePlaceId": "ChIJs0AEKNJPo0cRRT3nZibl6wM",
        "lat": 50.758181,
        "lng": 9.808035,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eiterfeld",
        "province": "Hessen",
        "streetAndNumber": "Eisenacher Weg 5",
        "zip": "36132",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181467,
        "identifier": "DE007097",
        "googlePlaceId": "ChIJUQwm2ZIDtEcRiP2DLtDdkSk",
        "lat": 53.84272,
        "lng": 8.693442,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Cuxhaven",
        "province": "Niedersachsen",
        "streetAndNumber": "Christian-Hülsmeyer-Straße 3",
        "zip": "27472",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181468,
        "identifier": "DE005084",
        "googlePlaceId": "ChIJrwl7K1VUukcRcPDriMtdil0",
        "lat": 51.721317,
        "lng": 9.014253,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Driburg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Siedlerplatz 18",
        "zip": "33014",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181469,
        "identifier": "DE029040",
        "googlePlaceId": "ChIJge_s-MM7qkcR-xOw3OqNl4U",
        "lat": 53.507296,
        "lng": 14.005394,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Pasewalk",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Pestalozzistraße 23",
        "zip": "17309",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181470,
        "identifier": "DE016119",
        "googlePlaceId": "ChIJm-hH7a8OskcRKt0Ww50rasg",
        "lat": 53.863435,
        "lng": 10.654465,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübeck",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Ziegelstraße 109-111",
        "zip": "23556",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181471,
        "identifier": "DE016063",
        "googlePlaceId": "ChIJFx68z32LsUcRrMxSx50d5wU",
        "lat": 53.567053,
        "lng": 10.164698,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Barsbüttel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Am AKKU 7",
        "zip": "22885",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181472,
        "identifier": "DE020065",
        "googlePlaceId": "ChIJeR5kMjBOqEcRcJjqBMMfYKg",
        "lat": 52.506319,
        "lng": 13.416145,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Heinrich-Heine-Platz 8-12",
        "zip": "10179",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181473,
        "identifier": "DE004110",
        "googlePlaceId": "ChIJAzgBNBKCsUcRUUs-wxH_4r8",
        "lat": 53.584697,
        "lng": 9.726751,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wedel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Rissener Straße 125",
        "zip": "22880",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181474,
        "identifier": "DE020116",
        "googlePlaceId": "ChIJpYaEifR4qEcRtyRCa9OgfTs",
        "lat": 51.996778,
        "lng": 13.084116,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Jüterbog",
        "province": "Brandenburg",
        "streetAndNumber": "Promenade 35",
        "zip": "14913",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181476,
        "identifier": "DE001037",
        "googlePlaceId": "ChIJq0Eo2cTouEcRGSHdrmQNC0Q",
        "lat": 51.545666,
        "lng": 7.004173,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gladbeck",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Roßheidestraße 87",
        "zip": "45968",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181477,
        "identifier": "DE005124",
        "googlePlaceId": "ChIJ9YQPwJ5CukcRBxxr8OXfMPM",
        "lat": 52.020188,
        "lng": 8.911827,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lemgo",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lemgoer Straße 74",
        "zip": "32657",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181478,
        "identifier": "DE031044",
        "googlePlaceId": "ChIJqSvVNSANpEcR3V4Rhe4pv_M",
        "lat": 50.950304,
        "lng": 11.076022,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Erfurt",
        "province": "Thüringen",
        "streetAndNumber": "Am Drosselberg 47",
        "zip": "99097",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181479,
        "identifier": "DE036103",
        "googlePlaceId": "ChIJXSHBeo7LoEcRMtWQ_8yBpV0",
        "lat": 50.60084,
        "lng": 12.624953,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schneeberg",
        "province": "Sachsen",
        "streetAndNumber": "Bruno-Dost-Straße 39",
        "zip": "08289",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181480,
        "identifier": "DE025082",
        "googlePlaceId": "ChIJ5VQsfOTnuUcRMGvDgxXslBY",
        "lat": 52.272169,
        "lng": 7.915891,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lotte",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Jahnstraße 2",
        "zip": "49504",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181481,
        "identifier": "DE032109",
        "googlePlaceId": "ChIJWYc7z-pNuEcRBi0SUMmSa_k",
        "lat": 51.985236,
        "lng": 7.291976,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Billerbeck",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Darfelder Straße 36",
        "zip": "48727",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181482,
        "identifier": "DE002053",
        "googlePlaceId": "ChIJ9Ve4JwAyuUcRvsk4vwgt4HQ",
        "lat": 51.197669,
        "lng": 7.385466,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Radevormwald",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Erlenbacher Straße 1",
        "zip": "42477",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181484,
        "identifier": "DE031052",
        "googlePlaceId": "ChIJSzm-8zyNo0cRD9OJwjpzEbc",
        "lat": 50.696022,
        "lng": 10.923751,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ilmenau",
        "province": "Thüringen",
        "streetAndNumber": "Ziolkowskistraße 25",
        "zip": "98693",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181485,
        "identifier": "DE005034",
        "googlePlaceId": "ChIJeUjp-hKsu0cR6Frfr8Tnbeo",
        "lat": 51.616921,
        "lng": 8.907165,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lichtenau",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Torfbruchstraße 2b",
        "zip": "33165",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181486,
        "identifier": "DE026044",
        "googlePlaceId": "ChIJF1Z1dfnRqEcRYuVjpCEa4KM",
        "lat": 52.580077,
        "lng": 12.336263,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rathenow",
        "province": "Brandenburg",
        "streetAndNumber": "Milower Landstraße 9A",
        "zip": "14712",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181487,
        "identifier": "DE015053",
        "googlePlaceId": "ChIJ-yEFenCNtkcROxUK2Euwcr0",
        "lat": 53.503418,
        "lng": 8.012035,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sande",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Markt 6",
        "zip": "26452",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181488,
        "identifier": "DE021105",
        "googlePlaceId": "ChIJ5RD_FjRCpkcRl_luHUP7ReY",
        "lat": 51.612674,
        "lng": 12.306916,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bitterfeld-Wolfen",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Brehnaer Straße 34",
        "zip": "06749",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181489,
        "identifier": "DE021038",
        "googlePlaceId": "ChIJB3UY8pypp0cR7gMZ40k4vGw",
        "lat": 51.369821,
        "lng": 12.744664,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wurzen",
        "province": "Sachsen",
        "streetAndNumber": "Clara-Zetkin-Platz 7",
        "zip": "04808",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181490,
        "identifier": "DE006113",
        "googlePlaceId": "ChIJazZhPeRUpUcR0RqfaWd4Kb0",
        "lat": 52.212565,
        "lng": 10.195345,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Söhlde",
        "province": "Niedersachsen",
        "streetAndNumber": "Marktstraße 4",
        "zip": "31185",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181491,
        "identifier": "DE016045",
        "googlePlaceId": "ChIJ9UUN2HAAskcR0EPh113hSzE",
        "lat": 53.6369,
        "lng": 10.6927,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Mölln",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Ratzeburger Straße 36",
        "zip": "23879",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181492,
        "identifier": "DE026099",
        "googlePlaceId": "ChIJhTvz8QWkpUcRDB3-kJOZdvM",
        "lat": 51.750916,
        "lng": 11.039885,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Thale",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Otto-Schönermark-Straße 2",
        "zip": "06502",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181493,
        "identifier": "DE004062",
        "googlePlaceId": "ChIJazwPcMK8tEcRKid-KQZxFzM",
        "lat": 54.869888,
        "lng": 8.907148,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Süderlügum",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hauptstraße 6a",
        "zip": "25923",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "from1": "11:00",
            "to1": "19:00"
          }
        ]
      },
      {
        "id": 3181494,
        "identifier": "DE026048",
        "googlePlaceId": "ChIJ1WYcvadYr0cRx0_ME5HVY04",
        "lat": 52.126122,
        "lng": 11.666981,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Magdeburg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Friedrich-Ebert-Straße 73",
        "zip": "39114",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181496,
        "identifier": "DE001008",
        "googlePlaceId": "ChIJwUcSuEX6uEcRZZfD8BqfZYI",
        "lat": 51.69391,
        "lng": 7.12009,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Marl",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hammer Straße 109",
        "zip": "45772",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181497,
        "identifier": "DE013010",
        "googlePlaceId": "ChIJ1W1LrvFzuUcRvMze6fyt1lU",
        "lat": 51.667994,
        "lng": 7.817889,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamm",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Grünstraße 102",
        "zip": "59063",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181498,
        "identifier": "DE010031",
        "googlePlaceId": "ChIJ11tZw0iqpEcRH9wbR6gMSS8",
        "lat": 50.969751,
        "lng": 9.795511,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bebra",
        "province": "Hessen",
        "streetAndNumber": "Bismarckstraße 10",
        "zip": "36179",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181499,
        "identifier": "DE016149",
        "googlePlaceId": "ChIJkZvNEZQOskcREf-q9ZAeflE",
        "lat": 53.857825,
        "lng": 10.628208,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübeck",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Herrenholz 14",
        "zip": "23556",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181500,
        "identifier": "DE007024",
        "googlePlaceId": "ChIJl_cf91QnsUcRK-SQA24wThg",
        "lat": 53.058122,
        "lng": 8.934947,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Osterholzer Heerstraße 111-113",
        "zip": "28307",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181501,
        "identifier": "DE007076",
        "googlePlaceId": "ChIJCRvkHoQusUcRE4wnlXczITY",
        "lat": 53.179604,
        "lng": 8.754548,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ritterhude",
        "province": "Niedersachsen",
        "streetAndNumber": "Riesstraße 43",
        "zip": "27721",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181502,
        "identifier": "DE020094",
        "googlePlaceId": "ChIJP9AP8upFqEcRwDG9-0FoFNk",
        "lat": 52.42935,
        "lng": 13.45565,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Johannisthaler Chaussee 300",
        "zip": "12351",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181503,
        "identifier": "DE016140",
        "googlePlaceId": "ChIJP7R5hX4LskcRK_xDP4_HbQM",
        "lat": 53.91848,
        "lng": 10.694424,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Schwartau",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Eutiner Ring 14",
        "zip": "23611",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181504,
        "identifier": "DE021053",
        "googlePlaceId": "ChIJjdph_7P3pkcR43ZYPi_ialI",
        "lat": 51.343909,
        "lng": 12.177804,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leuna",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Nova Eventis",
        "zip": "06237",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "10:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "10:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "10:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "10:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "10:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "10:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181505,
        "identifier": "DE004036",
        "googlePlaceId": "ChIJ73LgEjNCs0cRbcAXVkvOxoM",
        "lat": 54.80781,
        "lng": 9.51326,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wees",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Birkenbogen 9",
        "zip": "24999",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181506,
        "identifier": "DE026069",
        "googlePlaceId": "ChIJQywwZcSepUcRaEWVQIg0wig",
        "lat": 51.897871,
        "lng": 11.061752,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Halberstadt",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Magdeburger Straße 47",
        "zip": "38820",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181508,
        "identifier": "DE004126",
        "googlePlaceId": "ChIJI25bjpKTs0cRmeLydSTpkiM",
        "lat": 54.147959,
        "lng": 9.283664,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Albersdorf",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Norderstraße 11",
        "zip": "25767",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181509,
        "identifier": "DE006104",
        "googlePlaceId": "ChIJv_URV5uuukcRLj8bL1KxQ5A",
        "lat": 52.159929,
        "lng": 10.013413,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hildesheim",
        "province": "Niedersachsen",
        "streetAndNumber": "Alte Heerstraße 8",
        "zip": "31135",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181510,
        "identifier": "DE010089",
        "googlePlaceId": "ChIJ2QNlcJBqu0cRvZoHsAdVOkk",
        "lat": 51.280086,
        "lng": 9.356666,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schauenburg",
        "province": "Hessen",
        "streetAndNumber": "Pfingstweide 2",
        "zip": "34270",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3181512,
        "identifier": "DE003055",
        "googlePlaceId": "ChIJaTeMBuSTsUcRO5m7w6ef9xc",
        "lat": 53.419058,
        "lng": 10.018964,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Seevetal",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Saal 12",
        "zip": "21217",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181514,
        "identifier": "DE026014",
        "googlePlaceId": "ChIJYTNbASv8rkcRrEJPgk2-zZM",
        "lat": 52.878694,
        "lng": 11.491341,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Arendsee (Altmark)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Bahnhofstraße 27",
        "zip": "39619",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181515,
        "identifier": "DE002087",
        "googlePlaceId": "ChIJQ8LN3BoTvEcRR87b5zraoT8",
        "lat": 50.836511,
        "lng": 8.332456,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dietzhölztal",
        "province": "Hessen",
        "streetAndNumber": "Zur Schönbuche 2",
        "zip": "35716",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181516,
        "identifier": "DE010039",
        "googlePlaceId": "ChIJJUhP6L5gu0cRJf6HZbttoPo",
        "lat": 51.046016,
        "lng": 9.279311,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Borken",
        "province": "Hessen",
        "streetAndNumber": "Gellenweg 12-14",
        "zip": "34582",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181517,
        "identifier": "DE003100",
        "googlePlaceId": "ChIJQR5Ig0WPsUcRoOaYu6HHBIM",
        "lat": 53.537400265238,
        "lng": 10.01276014763,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Lola-Rogge-Platz 38",
        "zip": "20457",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181518,
        "identifier": "DE024056",
        "googlePlaceId": "ChIJIY8AFbtSqEcRoVboAz31lYs",
        "lat": 52.612091,
        "lng": 13.434336,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Hauptstraße 37",
        "zip": "13127",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181519,
        "identifier": "DE007059",
        "googlePlaceId": "ChIJ_W02HBLWtkcRHEK78bXJSrk",
        "lat": 53.105726,
        "lng": 8.471622,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hude",
        "province": "Niedersachsen",
        "streetAndNumber": "Langenberger Straße 2 a",
        "zip": "27798",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3181520,
        "identifier": "DE004071",
        "googlePlaceId": "ChIJBTcEixBXskcRnRE7xmZfW_E",
        "lat": 54.298171,
        "lng": 10.174555,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Villacher Straße 8",
        "zip": "24147",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181521,
        "identifier": "DE029064",
        "googlePlaceId": "ChIJ6yUy0i35qkcR4NgnHZ9Hnfo",
        "lat": 54.014662,
        "lng": 14.047524,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ückeritz",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Bäderstraße 2A",
        "zip": "17459",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181522,
        "identifier": "DE010109",
        "googlePlaceId": "ChIJNxsIkJ-1ukcR5Hb-0InkLHU",
        "lat": 51.95677,
        "lng": 10.00214,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lamspringe",
        "province": "Niedersachsen",
        "streetAndNumber": "Im Kleinen Maser 3",
        "zip": "31195",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181523,
        "identifier": "DE002027",
        "googlePlaceId": "ChIJl9lRjjBLuUcRQrBtqfv3FG0",
        "lat": 51.106963,
        "lng": 7.643288,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Meinerzhagen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lindenstraße 18",
        "zip": "58540",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181524,
        "identifier": "DE016040",
        "googlePlaceId": "ChIJq0adCZYmskcROZLCoIIbIso",
        "lat": 53.736687,
        "lng": 10.083949,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Tangstedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Eichkoppeltwiete 1",
        "zip": "22889",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181525,
        "identifier": "DE029037",
        "googlePlaceId": "ChIJ49ZAClRjq0cRumF06Xl9nck",
        "lat": 54.305429,
        "lng": 13.071161,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stralsund",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Carl-Heydemann-Ring 130",
        "zip": "18437",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181526,
        "identifier": "DE015070",
        "googlePlaceId": "ChIJdYFyDhSot0cRdfhuOYVDAVc",
        "lat": 52.99033,
        "lng": 7.626698,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Esterwegen",
        "province": "Niedersachsen",
        "streetAndNumber": "Poststraße 46",
        "zip": "26897",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181527,
        "identifier": "DE016078",
        "googlePlaceId": "ChIJu0RIap8vskcRHaOJYKiM9gA",
        "lat": 53.802552,
        "lng": 10.003682,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kisdorf",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Henstedter Straße 26",
        "zip": "24629",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181528,
        "identifier": "DE007055",
        "googlePlaceId": "ChIJm9MUXfIEtEcR0p4dvubfSqY",
        "lat": 53.885087,
        "lng": 8.661383,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Cuxhaven",
        "province": "Niedersachsen",
        "streetAndNumber": "Heinrich-Grube-Weg 76",
        "zip": "27476",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181529,
        "identifier": "DE021057",
        "googlePlaceId": "ChIJiRLfvM8Wp0cRdlcuE8IovuE",
        "lat": 51.057656,
        "lng": 12.785432,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rochlitz",
        "province": "Sachsen",
        "streetAndNumber": "Geithainer Straße 21",
        "zip": "09306",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181530,
        "identifier": "DE016165",
        "googlePlaceId": "ChIJo05lmmQMskcR1Kq1w3Zb82s",
        "lat": 53.910789,
        "lng": 10.668749,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Schwartau",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Stockelsdorfer Weg 80",
        "zip": "23611",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181531,
        "identifier": "DE002016",
        "googlePlaceId": "ChIJHer047KtvkcR40x6pKS48e0",
        "lat": 51.021458,
        "lng": 7.843393,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Olpe",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "In der Trift 7",
        "zip": "57462",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181532,
        "identifier": "DE026077",
        "googlePlaceId": "ChIJvzj7ks4MpkcRLh166HsriSQ",
        "lat": 51.754004,
        "lng": 11.999279,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Köthen (Anhalt)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Schlachthofstraße 1",
        "zip": "06366",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181533,
        "identifier": "DE020108",
        "googlePlaceId": "ChIJQybtb1k-qEcRFE1Sv7kco_M",
        "lat": 52.295949,
        "lng": 13.624412,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Königs Wusterhausen",
        "province": "Brandenburg",
        "streetAndNumber": "Luckenwalder Straße 2-6",
        "zip": "15711",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181534,
        "identifier": "DE006006",
        "googlePlaceId": "ChIJf9p_y_mmukcRwS8GaEcz-Ro",
        "lat": 52.237559,
        "lng": 9.874313,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sarstedt",
        "province": "Niedersachsen",
        "streetAndNumber": "Moorberg 5",
        "zip": "31157",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181535,
        "identifier": "DE007099",
        "googlePlaceId": "ChIJnTUaRB0mt0cR4fLhRuEh6kc",
        "lat": 53.023423,
        "lng": 8.346653,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hatten",
        "province": "Niedersachsen",
        "streetAndNumber": "Hauptstraße 35",
        "zip": "26209",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181536,
        "identifier": "DE006049",
        "googlePlaceId": "ChIJO_VTx_8LsEcRZzByQZjUJHM",
        "lat": 52.374083,
        "lng": 9.865204,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Anderter Straße 101M",
        "zip": "30559",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181537,
        "identifier": "DE003060",
        "googlePlaceId": "ChIJldcuX38srkcRYm-Y2yanZ7c",
        "lat": 52.969051,
        "lng": 10.561246,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Uelzen",
        "province": "Niedersachsen",
        "streetAndNumber": "Lüneburger Straße 52-54",
        "zip": "29525",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3181538,
        "identifier": "DE005101",
        "googlePlaceId": "ChIJ8cVJNf4oukcRNdWw-t6D9Xo",
        "lat": 51.858591,
        "lng": 8.28229,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rheda-Wiedenbrück",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Herzebrocker Straße 20",
        "zip": "33378",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181539,
        "identifier": "DE006154",
        "googlePlaceId": "ChIJ3YvYJcp2sEcREujIbKPoSGA",
        "lat": 52.392521,
        "lng": 9.611636,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Seelze",
        "province": "Niedersachsen",
        "streetAndNumber": "Hannoversche Straße 77",
        "zip": "30926",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181540,
        "identifier": "DE002061",
        "googlePlaceId": "ChIJSZZ7SCEouUcRSr6L82wEMs8",
        "lat": 51.268579,
        "lng": 7.192434,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Unterdörnen 80",
        "zip": "42283",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181541,
        "identifier": "DE002082",
        "googlePlaceId": "ChIJRd1W0DJdvEcRaEE_EQR2-UA",
        "lat": 50.671818,
        "lng": 8.516447,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hohenahr",
        "province": "Hessen",
        "streetAndNumber": "Gewerbestraße 4",
        "zip": "35644",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181542,
        "identifier": "DE032038",
        "googlePlaceId": "ChIJ3bve9RwQuUcR0VZr9hitoUA",
        "lat": 51.608571,
        "lng": 7.509453,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lünen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Viktoriastraße 63",
        "zip": "44532",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181543,
        "identifier": "DE016070",
        "googlePlaceId": "ChIJ35W8roQkskcR_i4dk8mjFtw",
        "lat": 53.793627,
        "lng": 10.135781,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nahe",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Brünskamp 1",
        "zip": "23866",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181544,
        "identifier": "DE010041",
        "googlePlaceId": "ChIJwVUnomJBu0cRbD0GIEp-D0I",
        "lat": 51.25519,
        "lng": 9.4107,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Baunatal",
        "province": "Hessen",
        "streetAndNumber": "Friedrich-Ebert-Allee 3",
        "zip": "34225",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181545,
        "identifier": "DE016079",
        "googlePlaceId": "ChIJ60RVIDUeskcRZEdiiCAr8Gs",
        "lat": 53.661845,
        "lng": 10.284611,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Großhansdorf",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Eilbergweg 10",
        "zip": "22927",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181547,
        "identifier": "DE020045",
        "googlePlaceId": "ChIJabeoeF1aqEcRB0SVPuvpOYo",
        "lat": 52.445669,
        "lng": 13.294839,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Unter den Eichen 97",
        "zip": "12203",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181548,
        "identifier": "DE031080",
        "googlePlaceId": "ChIJd-X1FQBToUcRdS-ApH9V-14",
        "lat": 50.692804,
        "lng": 11.585109,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Pößneck",
        "province": "Thüringen",
        "streetAndNumber": "Saalfelder Straße 29",
        "zip": "07381",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181549,
        "identifier": "DE004084",
        "googlePlaceId": "ChIJzZROoMdXskcRE_QE-o8f6b4",
        "lat": 54.334504,
        "lng": 10.190357,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Langer Rehm 10",
        "zip": "24149",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181550,
        "identifier": "DE016034",
        "googlePlaceId": "ChIJU0dtd2zzsUcRAMuTTjz5Vh0",
        "lat": 53.542234,
        "lng": 10.216443,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Glinde",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Möllner Landstraße 108a",
        "zip": "21509",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181551,
        "identifier": "DE032010",
        "googlePlaceId": "ChIJuUYizwQRuUcRHaRRp1ZO6RM",
        "lat": 51.557668,
        "lng": 7.542662,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Droote 46",
        "zip": "44328",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181552,
        "identifier": "DE007044",
        "googlePlaceId": "ChIJW6hwQtrfsEcR-h9cJNh0M5E",
        "lat": 53.017596,
        "lng": 9.030618,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Achim",
        "province": "Niedersachsen",
        "streetAndNumber": "Embser Landstraße 4-6",
        "zip": "28832",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181554,
        "identifier": "DE029028",
        "googlePlaceId": "ChIJ85qd-3eiq0cRgr9I92FJerE",
        "lat": 53.92177,
        "lng": 13.34346,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Jarmen",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Dr.-Georg-Kohnert-Straße 22",
        "zip": "17126",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181555,
        "identifier": "DE013015",
        "googlePlaceId": "ChIJQWzSDtWeuUcRg36o13-xL_0",
        "lat": 51.8436,
        "lng": 7.833419,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sendenhorst",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Osttor 24",
        "zip": "48324",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181556,
        "identifier": "DE007010",
        "googlePlaceId": "ChIJT1EufxgosUcRYxzWU-411pE",
        "lat": 53.073636,
        "lng": 8.797371,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Westerstraße 33",
        "zip": "28199",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181557,
        "identifier": "DE001097",
        "googlePlaceId": "ChIJO_st-SlvuEcRqKl5LsbECwY",
        "lat": 52.03567,
        "lng": 6.834,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Vreden",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wüllener Straße 55a",
        "zip": "48691",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181558,
        "identifier": "DE024071",
        "googlePlaceId": "ChIJMa0M9o2sqUcRpFDRO81hYJ0",
        "lat": 52.665845,
        "lng": 13.379756,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Mühlenbecker Land",
        "province": "Brandenburg",
        "streetAndNumber": "Hauptstraße 34",
        "zip": "16567",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181560,
        "identifier": "DE003039",
        "googlePlaceId": "ChIJDcljkfoYrkcRHjmQgp59VcY",
        "lat": 53.287096,
        "lng": 10.732405,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bleckede",
        "province": "Niedersachsen",
        "streetAndNumber": "Industriestraße 36",
        "zip": "21354",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181561,
        "identifier": "DE032066",
        "googlePlaceId": "ChIJTZpkjEj5uEcR1LniGRdl-t4",
        "lat": 51.736245,
        "lng": 7.18885,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Haltern am See",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Recklinghäuser Straße 79-81",
        "zip": "45721",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181562,
        "identifier": "DE005028",
        "googlePlaceId": "ChIJ_zLgW3XTu0cRWw_1amBx1k4",
        "lat": 51.685555,
        "lng": 8.309591,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lippstadt",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Cappeler Stiftsallee 72",
        "zip": "59556",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181563,
        "identifier": "DE024112",
        "googlePlaceId": "ChIJE1kbJkU3qEcROhB6hWYcx50",
        "lat": 52.431542,
        "lng": 13.714619,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Fürstenwalder Allee 314",
        "zip": "12589",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181564,
        "identifier": "DE015057",
        "googlePlaceId": "ChIJUdKr2zaGtkcRXBYmS8UoXvo",
        "lat": 53.666925,
        "lng": 7.910632,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wangerland",
        "province": "Niedersachsen",
        "streetAndNumber": "Heinrich-Steinberg-Straße 1",
        "zip": "26434",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181566,
        "identifier": "DE002059",
        "googlePlaceId": "ChIJSYdctfzUvkcREE4-HLKdpmY",
        "lat": 51.094922,
        "lng": 7.199021,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wermelskirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Höferhof 14",
        "zip": "42929",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181567,
        "identifier": "DE001005",
        "googlePlaceId": "ChIJuUto6I1YuEcRV_-p8OTWwX8",
        "lat": 51.82655,
        "lng": 7.047754,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Reken",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Dorstener Straße 33",
        "zip": "48734",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181568,
        "identifier": "DE001036",
        "googlePlaceId": "ChIJH21oa5bmuEcRwY0e1RaztGA",
        "lat": 51.537218,
        "lng": 7.122634,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gelsenkirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Pommernstraße 17g",
        "zip": "45889",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181569,
        "identifier": "DE004136",
        "googlePlaceId": "ChIJFdah0SNiskcRFFNCwfV0PmE",
        "lat": 54.293614,
        "lng": 10.599731,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lütjenburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Königsberger Straße 7",
        "zip": "24321",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181570,
        "identifier": "DE005067",
        "googlePlaceId": "ChIJGZQX7dGGuUcRclf7iwRi1Ks",
        "lat": 51.82828,
        "lng": 8.1473,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oelde",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lindenstraße 11",
        "zip": "59302",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181571,
        "identifier": "DE031013",
        "googlePlaceId": "ChIJnWcOMABtpEcROi6VxpFP08M",
        "lat": 51.016682,
        "lng": 10.9847,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Erfurt",
        "province": "Thüringen",
        "streetAndNumber": "Scheidemantelweg 9",
        "zip": "99091",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181572,
        "identifier": "DE025030",
        "googlePlaceId": "ChIJmY7_AieGt0cRF1XXP7NmIoI",
        "lat": 52.5343,
        "lng": 7.303166,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lingen (Ems)",
        "province": "Niedersachsen",
        "streetAndNumber": "Meppener Straße 131",
        "zip": "49808",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181573,
        "identifier": "DE005109",
        "googlePlaceId": "ChIJs7c_CXhxukcRaRHzbxftv3o",
        "lat": 52.238222,
        "lng": 8.914541,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Porta Westfalica",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Fähranger 10",
        "zip": "32457",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181574,
        "identifier": "DE001022",
        "googlePlaceId": "ChIJGb1hJljvuEcRF-6mryxSowc",
        "lat": 51.575509,
        "lng": 7.04969,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gelsenkirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Horster Straße 41",
        "zip": "45897",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181575,
        "identifier": "DE021046",
        "googlePlaceId": "ChIJ0zgHmLORpkcRZ_WqtWVlZWQ",
        "lat": 51.18459,
        "lng": 11.927471,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Weißenfels",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Am Marktwege 2",
        "zip": "06667",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181576,
        "identifier": "DE020067",
        "googlePlaceId": "ChIJAVIXvj75qEcRgtmFRQrC_bM",
        "lat": 52.560244,
        "lng": 13.093679,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Falkensee",
        "province": "Brandenburg",
        "streetAndNumber": "Bahnhofstraße 68-72",
        "zip": "14612",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181577,
        "identifier": "DE006022",
        "googlePlaceId": "ChIJbe06W28YsEcRgjY9VUdIE1Q",
        "lat": 52.599173,
        "lng": 10.108991,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Celle",
        "province": "Niedersachsen",
        "streetAndNumber": "Lärchenweg 1",
        "zip": "29227",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181578,
        "identifier": "DE013049",
        "googlePlaceId": "ChIJRT6GVjXru0cRd11iKeJC0Do",
        "lat": 51.363118,
        "lng": 8.405671,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bestwig",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Borghausen 11",
        "zip": "59909",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181579,
        "identifier": "DE024003",
        "googlePlaceId": "ChIJf86JVeEyqEcRfS4PF3TE6hM",
        "lat": 52.549271,
        "lng": 13.863523,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Strausberg",
        "province": "Brandenburg",
        "streetAndNumber": "Am Annatal 59",
        "zip": "15344",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181580,
        "identifier": "DE001033",
        "googlePlaceId": "ChIJT_NduR3iuEcR7iYTApVz4Oc",
        "lat": 51.546073,
        "lng": 7.240486,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herne",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hölkeskampring 213",
        "zip": "44625",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181581,
        "identifier": "DE029025",
        "googlePlaceId": "ChIJ7wyPGyp1q0cRnaT87qZFwAE",
        "lat": 54.07863,
        "lng": 13.413805,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Greifswald",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Ernst-Thälmann-Ring 56",
        "zip": "17491",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181582,
        "identifier": "DE006150",
        "googlePlaceId": "ChIJN5v0NHN0sEcR5Zm5uFRbaIQ",
        "lat": 52.384931,
        "lng": 9.670312,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Bahndamm 17",
        "zip": "30453",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181583,
        "identifier": "DE026066",
        "googlePlaceId": "ChIJSauPGTQRpkcRfzubC9l8m7g",
        "lat": 51.835103,
        "lng": 12.228216,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dessau-Roßlau",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Kühnauer Straße 25",
        "zip": "06846",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181584,
        "identifier": "DE003052",
        "googlePlaceId": "ChIJyUKME59vsUcRs72hPBeEzHc",
        "lat": 53.522263,
        "lng": 9.395841,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Fredenbeck",
        "province": "Niedersachsen",
        "streetAndNumber": "Dinghorner Straße 12",
        "zip": "21717",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181585,
        "identifier": "DE004108",
        "googlePlaceId": "ChIJv5J62DzRs0cRr3Ob9-hWrG4",
        "lat": 53.804767,
        "lng": 9.623623,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Horst",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Horster Viereck 1",
        "zip": "25358",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181586,
        "identifier": "DE021096",
        "googlePlaceId": "ChIJdWujPyPVpUcRMgiVvHH5weA",
        "lat": 51.452941,
        "lng": 11.670595,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Seegebiet Mansfelder Land",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Schraplauer Straße",
        "zip": "06317",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181587,
        "identifier": "DE032084",
        "googlePlaceId": "ChIJLRjLa4gfuUcR1TBM3DTNJaU",
        "lat": 51.47349,
        "lng": 7.31735,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Unterstraße 52-58",
        "zip": "44892",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181588,
        "identifier": "DE024024",
        "googlePlaceId": "ChIJw92XhPpNqEcRW-qpVFELf84",
        "lat": 52.550022,
        "lng": 13.434467,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Ostseestraße 25",
        "zip": "10409",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181591,
        "identifier": "DE004138",
        "googlePlaceId": "ChIJT_w-63iAskcRdfIxTaLJN4o",
        "lat": 54.291975,
        "lng": 10.913332,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oldenburg in Holstein",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Am Vossberg 6",
        "zip": "23758",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181592,
        "identifier": "DE015082",
        "googlePlaceId": "ChIJW5iNEFG0tkcRlWCxfWShHg0",
        "lat": 53.474517,
        "lng": 8.652973,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Loxstedt",
        "province": "Niedersachsen",
        "streetAndNumber": "Parkstraße 2",
        "zip": "27612",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181593,
        "identifier": "DE025016",
        "googlePlaceId": "ChIJv8YjQduJt0cRdVVdvK4ADq8",
        "lat": 52.490394,
        "lng": 7.22635,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wietmarschen-Lohne",
        "province": "Niedersachsen",
        "streetAndNumber": "Lohner Straße 1",
        "zip": "49835",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181594,
        "identifier": "DE005137",
        "googlePlaceId": "ChIJxX5UxyYMu0cRhPaeKW317WU",
        "lat": 51.404425,
        "lng": 9.113191,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Volkmarsen",
        "province": "Hessen",
        "streetAndNumber": "Arolser Straße 19 d",
        "zip": "34471",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181595,
        "identifier": "DE029009",
        "googlePlaceId": "ChIJw1qHlMWMrEcRkmBZVVHOZqw",
        "lat": 54.254151,
        "lng": 12.488715,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ribnitz-Damgarten",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "An der Mühle 7",
        "zip": "18311",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181596,
        "identifier": "DE032039",
        "googlePlaceId": "ChIJSe2MfuAauUcRz0tN4trp8ws",
        "lat": 51.594553,
        "lng": 7.436297,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lünen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Mengeder Straße 11",
        "zip": "44536",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181597,
        "identifier": "DE006045",
        "googlePlaceId": "ChIJE0DXMNDNr0cRrvzmyK1n3_0",
        "lat": 52.833642,
        "lng": 10.675482,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Bodenteich",
        "province": "Niedersachsen",
        "streetAndNumber": "Bergstraße 7",
        "zip": "29389",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181598,
        "identifier": "DE036004",
        "googlePlaceId": "ChIJqbx4vce5CUcR2Z3v_evXewk",
        "lat": 50.973777,
        "lng": 13.930662,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Pirna",
        "province": "Sachsen",
        "streetAndNumber": "Rudolf-Renner-Straße 41a",
        "zip": "01796",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181599,
        "identifier": "DE015022",
        "googlePlaceId": "ChIJj-cV2d76tkcRP46boT7YaV4",
        "lat": 53.260012,
        "lng": 7.931466,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Westerstede",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Esch 3",
        "zip": "26655",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181600,
        "identifier": "DE021049",
        "googlePlaceId": "ChIJDyZ1wBH5pkcRTHjn3_5GE-8",
        "lat": 51.304404,
        "lng": 12.42646,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Bockstraße 1-3",
        "zip": "04289",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181601,
        "identifier": "DE029054",
        "googlePlaceId": "ChIJU71hNIFZrEcRfhxMeynp9Qo",
        "lat": 54.083895,
        "lng": 12.166644,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rostock",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Timmermansstrat 11",
        "zip": "18055",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181602,
        "identifier": "DE021081",
        "googlePlaceId": "ChIJrX4iDVTYpkcRWJgjVkJmlIs",
        "lat": 50.897428,
        "lng": 12.349844,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schmölln",
        "province": "Thüringen",
        "streetAndNumber": "Bergstraße 18",
        "zip": "04626",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181603,
        "identifier": "DE024049",
        "googlePlaceId": "ChIJ66H_YuhNqEcR4qJnupniOnI",
        "lat": 52.549591,
        "lng": 13.448078,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Börnestraße 25",
        "zip": "13086",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181604,
        "identifier": "DE032097",
        "googlePlaceId": "ChIJbxJ-a3PcuEcRrEPiZRkrWDM",
        "lat": 51.393485,
        "lng": 7.083415,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kupferdreher Straße 127",
        "zip": "45257",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181605,
        "identifier": "DE002111",
        "googlePlaceId": "ChIJa-OFexAouUcRRWwP8EJQBMc",
        "lat": 51.280639,
        "lng": 7.203599,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Klingelholl 110",
        "zip": "42281",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181606,
        "identifier": "DE024078",
        "googlePlaceId": "ChIJje76YZtTqEcRKe51FCj_42w",
        "lat": 52.588974,
        "lng": 13.334562,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Oranienburger Straße 57/58",
        "zip": "13437",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181607,
        "identifier": "DE006127",
        "googlePlaceId": "ChIJ98HygoD2r0cRWAo1kv0Cu6o",
        "lat": 52.276387,
        "lng": 10.521151,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Braunschweig",
        "province": "Niedersachsen",
        "streetAndNumber": "Hamburger Straße 279",
        "zip": "38114",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181608,
        "identifier": "DE032040",
        "googlePlaceId": "ChIJqZWgMzQQuUcR5WPqde4aJxw",
        "lat": 51.591738,
        "lng": 7.53684,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lünen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bebelstraße 163a",
        "zip": "44532",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181609,
        "identifier": "DE013009",
        "googlePlaceId": "ChIJpYdHGzB0uUcRqbk18QDrB2A",
        "lat": 51.707015,
        "lng": 7.833783,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamm",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kleine Amtsstraße 9",
        "zip": "59073",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181610,
        "identifier": "DE003012",
        "googlePlaceId": "ChIJ8S7DRGDLsUcRlCSNS65-I4M",
        "lat": 52.985809,
        "lng": 10.087692,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Munster",
        "province": "Niedersachsen",
        "streetAndNumber": "Winkelmannshof 1",
        "zip": "29633",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181611,
        "identifier": "DE025031",
        "googlePlaceId": "ChIJu7yFD1iQt0cRAN3pfE-AtYM",
        "lat": 52.691999,
        "lng": 7.300432,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Meppen",
        "province": "Niedersachsen",
        "streetAndNumber": "Hasebrinkstraße 11",
        "zip": "49716",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181612,
        "identifier": "DE004106",
        "googlePlaceId": "ChIJtRZoiv9WskcR7ohQ-eBS7T0",
        "lat": 54.316618,
        "lng": 10.174269,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Ostring 232",
        "zip": "24148",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181613,
        "identifier": "DE003083",
        "googlePlaceId": "ChIJn8DAk3zFsUcRQsyYABwvs40",
        "lat": 53.129992,
        "lng": 10.215127,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Amelinghausen",
        "province": "Niedersachsen",
        "streetAndNumber": "Grenzweg 2 a",
        "zip": "21385",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181614,
        "identifier": "DE031086",
        "googlePlaceId": "ChIJTTjj7H7aoEcRYzBr_Xjpcps",
        "lat": 50.513491,
        "lng": 12.398619,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Auerbach",
        "province": "Sachsen",
        "streetAndNumber": "Bahnhofstraße 15 a",
        "zip": "08209",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181615,
        "identifier": "DE006121",
        "googlePlaceId": "ChIJnTHn0-f1r0cRedmuhx35ra0",
        "lat": 52.25103,
        "lng": 10.535127,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Braunschweig",
        "province": "Niedersachsen",
        "streetAndNumber": "Berliner Platz 1D",
        "zip": "38102",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181616,
        "identifier": "DE010001",
        "googlePlaceId": "ChIJ2RoP_o0wu0cRYJoZRVEyh_I",
        "lat": 51.401569,
        "lng": 9.658872,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hann. Münden",
        "province": "Niedersachsen",
        "streetAndNumber": "Quedlinburger Straße 8",
        "zip": "34346",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181617,
        "identifier": "DE002018",
        "googlePlaceId": "ChIJHyIYqTDOuEcRAf5B_niJCJM",
        "lat": 51.25741,
        "lng": 6.9501,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Mettmann",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Steinesweg 6",
        "zip": "40822",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181619,
        "identifier": "DE002109",
        "googlePlaceId": "ChIJ6VOV0ePXuEcRVXIipCQLzgc",
        "lat": 51.279921,
        "lng": 7.185441,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Schützenstraße 27",
        "zip": "42281",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181620,
        "identifier": "DE029007",
        "googlePlaceId": "ChIJG5BU0T9iq0cRwlz16kxeM3g",
        "lat": 54.305738,
        "lng": 13.041973,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stralsund",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Grünhufer Bogen 13 -17",
        "zip": "18437",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181621,
        "identifier": "DE005079",
        "googlePlaceId": "ChIJFfwJMtLsuUcRubpdDv-s2gI",
        "lat": 52.094561,
        "lng": 8.002761,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Glandorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Auf dem Haarkamp 2",
        "zip": "49219",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181622,
        "identifier": "DE003068",
        "googlePlaceId": "ChIJL_qN5QPdsUcRFs1V8Okw58M",
        "lat": 53.246568,
        "lng": 10.360027,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Reppenstedt",
        "province": "Niedersachsen",
        "streetAndNumber": "Wiesenweg 9",
        "zip": "21391",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181623,
        "identifier": "DE036116",
        "googlePlaceId": "ChIJg2F8rkxvCEcR6NMBelHFkDs",
        "lat": 51.562817,
        "lng": 14.372224,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Spremberg",
        "province": "Brandenburg",
        "streetAndNumber": "Grünstraße 3",
        "zip": "03130",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181624,
        "identifier": "DE032047",
        "googlePlaceId": "ChIJFUyccf5UuEcR-aO4leLKUik",
        "lat": 51.839954,
        "lng": 7.288177,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dülmen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Münsterstraße 151",
        "zip": "48249",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181625,
        "identifier": "DE024034",
        "googlePlaceId": "ChIJnWXrouU2qEcR3mqHPoyO3zA",
        "lat": 52.473111,
        "lng": 13.713781,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schöneiche",
        "province": "Brandenburg",
        "streetAndNumber": "Woltersdorfer Straße 1",
        "zip": "15566",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181626,
        "identifier": "DE002066",
        "googlePlaceId": "ChIJnUVrGdDVuEcRaMu96H76qXk",
        "lat": 51.20406,
        "lng": 7.129324,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Unterkirchen 24",
        "zip": "42349",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181627,
        "identifier": "DE005108",
        "googlePlaceId": "ChIJ8SvBZfsTukcRna9o9ILo8FY",
        "lat": 52.138301,
        "lng": 8.650683,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hiddenhausen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Alter Kamp 8",
        "zip": "32120",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181628,
        "identifier": "DE024044",
        "googlePlaceId": "ChIJuSStkhBOqEcRGegZQ_nYIwE",
        "lat": 52.526422,
        "lng": 13.426729,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Weinstraße 9",
        "zip": "10249",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181629,
        "identifier": "DE031033",
        "googlePlaceId": "ChIJLUegVKFypEcR77BPzEY3H80",
        "lat": 50.987476,
        "lng": 11.041243,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Erfurt",
        "province": "Thüringen",
        "streetAndNumber": "Schlachthofstraße 23",
        "zip": "99085",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181630,
        "identifier": "DE005094",
        "googlePlaceId": "ChIJs-phEBtLukcR5QFRbuVUfhc",
        "lat": 51.729777,
        "lng": 8.693108,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Paderborn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wewerstraße 27",
        "zip": "33106",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181631,
        "identifier": "DE031075",
        "googlePlaceId": "ChIJURCWgQ7PpkcRx-bXVeEdx30",
        "lat": 50.861546,
        "lng": 12.087217,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gera",
        "province": "Thüringen",
        "streetAndNumber": "Braustraße 13",
        "zip": "07551",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181632,
        "identifier": "DE024109",
        "googlePlaceId": "ChIJZ_ldzuM3qEcRp4iGzZkK8nU",
        "lat": 52.446313,
        "lng": 13.621777,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Müggelseedamm 150",
        "zip": "12587",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181633,
        "identifier": "DE003077",
        "googlePlaceId": "ChIJm-E8VoJGrkcRV26rqXd8bN4",
        "lat": 53.097618,
        "lng": 11.090326,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dannenberg",
        "province": "Niedersachsen",
        "streetAndNumber": "Schützenstraße 5",
        "zip": "29451",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181634,
        "identifier": "DE016030",
        "googlePlaceId": "ChIJObvwzESMsUcRAPHepB2Ho4o",
        "lat": 53.542747,
        "lng": 10.10126,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Schiffbeker Weg 27",
        "zip": "22111",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181635,
        "identifier": "DE010012",
        "googlePlaceId": "ChIJ6R9R1FHTpEcR-q2VZTmpVRM",
        "lat": 51.50849,
        "lng": 9.90969,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rosdorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Rischenweg 11",
        "zip": "37124",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181636,
        "identifier": "DE036071",
        "googlePlaceId": "ChIJkWwbQIKqCUcR88g07KZWLOU",
        "lat": 51.095837,
        "lng": 14.390997,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wilthen",
        "province": "Sachsen",
        "streetAndNumber": "Zittauer Straße 12",
        "zip": "02681",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181637,
        "identifier": "DE036041",
        "googlePlaceId": "ChIJ0TRPHFHGCUcROtd85tPlH0c",
        "lat": 50.999679,
        "lng": 13.792689,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Fritz-Meinhardt-Straße 5",
        "zip": "01239",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181638,
        "identifier": "DE016018",
        "googlePlaceId": "ChIJ0QiguziJsUcRs_oEtrQVh6g",
        "lat": 53.600696,
        "lng": 10.041358,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Fuhlsbüttler Straße 334",
        "zip": "22307",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181639,
        "identifier": "DE007005",
        "googlePlaceId": "ChIJU7bCdTD7sEcRmOaTfIpBI5c",
        "lat": 52.914129,
        "lng": 9.254552,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Verden",
        "province": "Niedersachsen",
        "streetAndNumber": "Max-Planck-Straße 3",
        "zip": "27283",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181640,
        "identifier": "DE010047",
        "googlePlaceId": "ChIJJ5VRNSg_u0cRTaCH4PFXj0M",
        "lat": 51.338452,
        "lng": 9.488693,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kassel",
        "province": "Hessen",
        "streetAndNumber": "Niedervellmarer Straße 2",
        "zip": "34127",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181641,
        "identifier": "DE036002",
        "googlePlaceId": "ChIJf55xVfHFCUcRsh4rPkw4YOY",
        "lat": 51.036115,
        "lng": 13.740007,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Uhlandstraße 5",
        "zip": "01069",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181642,
        "identifier": "DE021019",
        "googlePlaceId": "ChIJ1SHZQiG6p0cRFnPzebqbEjA",
        "lat": 51.551908,
        "lng": 12.974736,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Torgau",
        "province": "Sachsen",
        "streetAndNumber": "Zum Großen Teich 1",
        "zip": "04860",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181643,
        "identifier": "DE021029",
        "googlePlaceId": "ChIJo2HvMJ74pkcRaLexg_nH8uY",
        "lat": 51.356801,
        "lng": 12.458929,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Goldsternstraße 58",
        "zip": "04329",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181644,
        "identifier": "DE001001",
        "googlePlaceId": "ChIJ39GmoZHnuEcR4_D0J_-bXEM",
        "lat": 51.486052,
        "lng": 7.062441,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Saatbruchstraße 55",
        "zip": "45309",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181645,
        "identifier": "DE021054",
        "googlePlaceId": "ChIJUQfuF4H5pkcRXi-9iVFmnJk",
        "lat": 51.280038,
        "lng": 12.430703,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Markkleeberg",
        "province": "Sachsen",
        "streetAndNumber": "Bornaer Chaussee 2",
        "zip": "04416",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181646,
        "identifier": "DE016103",
        "googlePlaceId": "ChIJlxHWMfvzrUcRbmj-ANgkqSE",
        "lat": 53.855776,
        "lng": 10.926449,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schönberg",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Dassower Straße 8a",
        "zip": "23923",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181647,
        "identifier": "DE016041",
        "googlePlaceId": "ChIJE_GrOUSJsUcRf1jke_bR_WM",
        "lat": 53.589503,
        "lng": 10.051582,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Bramfelder Straße 103",
        "zip": "22305",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181648,
        "identifier": "DE020041",
        "googlePlaceId": "ChIJm447r9v4qEcR7yVka_j88EQ",
        "lat": 52.561154,
        "lng": 13.128182,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Falkensee",
        "province": "Brandenburg",
        "streetAndNumber": "Spandauer Straße 112",
        "zip": "14612",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181649,
        "identifier": "DE006002",
        "googlePlaceId": "ChIJMYWmkuxzsEcRPNaj3AegH9k",
        "lat": 52.43177,
        "lng": 9.67877,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Langenhagen",
        "province": "Niedersachsen",
        "streetAndNumber": "Desbrocksriede 2 A",
        "zip": "30855",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181650,
        "identifier": "DE031007",
        "googlePlaceId": "ChIJl-j5kbyZpkcRsTKfM3qZ5do",
        "lat": 51.163443,
        "lng": 11.799628,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Naumburg (Saale)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Bahnhofstraße 39",
        "zip": "06618",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181651,
        "identifier": "DE001052",
        "googlePlaceId": "ChIJYZRSnRnjuEcRRx5fiBjGkV8",
        "lat": 51.605293,
        "lng": 7.210239,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Recklinghausen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hubertusstraße 68",
        "zip": "45657",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181652,
        "identifier": "DE010114",
        "googlePlaceId": "ChIJG_BZCVg5pUcR_VZIeNE_bhc",
        "lat": 51.82242,
        "lng": 10.3409,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Clausthal-Zellerfeld",
        "province": "Niedersachsen",
        "streetAndNumber": "Goslarsche Straße 69A",
        "zip": "38678",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181653,
        "identifier": "DE031041",
        "googlePlaceId": "ChIJrZuQ8ckGpEcR565qGNcNsJ0",
        "lat": 50.855736,
        "lng": 11.343658,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Blankenhain",
        "province": "Thüringen",
        "streetAndNumber": "Rudolstädter Straße 31b",
        "zip": "99444",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181654,
        "identifier": "DE026079",
        "googlePlaceId": "ChIJqTxxYnTcpUcRT15RrKz03EI",
        "lat": 51.794536,
        "lng": 11.602688,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Alsleben (Saale)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Ascherslebener Straße 1",
        "zip": "06425",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181655,
        "identifier": "DE003079",
        "googlePlaceId": "ChIJmTVimCqwsUcRUI2D4kLtgvs",
        "lat": 53.120331,
        "lng": 9.782562,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schneverdingen",
        "province": "Niedersachsen",
        "streetAndNumber": "Marktstraße 10",
        "zip": "29640",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181656,
        "identifier": "DE006106",
        "googlePlaceId": "ChIJ2UAVTIClukcRRpn8ghWS8dA",
        "lat": 52.160422,
        "lng": 9.903526,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hildesheim",
        "province": "Niedersachsen",
        "streetAndNumber": "Runde Wiese 6",
        "zip": "31137",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181658,
        "identifier": "DE001045",
        "googlePlaceId": "ChIJOei4bivxuEcRelZvVk_hC_8",
        "lat": 51.725955,
        "lng": 7.026836,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dorsten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wulfener Markt 350",
        "zip": "46286",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181659,
        "identifier": "DE032035",
        "googlePlaceId": "ChIJK1zFL9gCuUcRbfVLdCR2ixI",
        "lat": 51.635300251452,
        "lng": 7.332868854787,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Datteln",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Castroper Straße 239",
        "zip": "45711",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181660,
        "identifier": "DE036027",
        "googlePlaceId": "ChIJU0bddxhcp0cRHTw8nGTZPOk",
        "lat": 50.864808,
        "lng": 13.177386,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oederan",
        "province": "Sachsen",
        "streetAndNumber": "Freiberger Straße 31",
        "zip": "09569",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181662,
        "identifier": "DE005104",
        "googlePlaceId": "ChIJ7SI7SttqukcRc7g8LpVH8fw",
        "lat": 52.068694,
        "lng": 8.753006,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Salzuflen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Uferstraße 18",
        "zip": "32108",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181664,
        "identifier": "DE007064",
        "googlePlaceId": "ChIJaxHxNX8EtEcRRuZmxVi7Q88",
        "lat": 53.860483,
        "lng": 8.674523,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Cuxhaven",
        "province": "Niedersachsen",
        "streetAndNumber": "Brockeswalder Chaussee 52",
        "zip": "27474",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181665,
        "identifier": "DE013006",
        "googlePlaceId": "ChIJp2caWZmEuUcRpZ8HWqB0UBE",
        "lat": 51.83871,
        "lng": 8.02979,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ennigerloh",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Ostenfelder Straße 5-7",
        "zip": "59320",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181666,
        "identifier": "DE021076",
        "googlePlaceId": "ChIJH36T7jotp0cRm767tIoTP54",
        "lat": 50.687345,
        "lng": 12.497992,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zwickau",
        "province": "Sachsen",
        "streetAndNumber": "Muldestraße 55",
        "zip": "08056",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181667,
        "identifier": "DE029002",
        "googlePlaceId": "ChIJhYPX6mlCq0cRkDVR7q61r30",
        "lat": 54.408456,
        "lng": 13.415614,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bergen",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Ruschwitzstraße 56",
        "zip": "18528",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181668,
        "identifier": "DE004060",
        "googlePlaceId": "ChIJV-tZju3Cs0cRgnledm4EHy4",
        "lat": 53.924694,
        "lng": 9.381797,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wilster",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Am Steindamm 9 b",
        "zip": "25554",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181669,
        "identifier": "DE026067",
        "googlePlaceId": "ChIJZZn6NisRpkcRIwgxAV_zgsE",
        "lat": 51.846599,
        "lng": 12.239969,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dessau-Roßlau",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Roßlauer Allee 4",
        "zip": "06844",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181670,
        "identifier": "DE029003",
        "googlePlaceId": "ChIJ0-emh1STrEcRYfg2WzutyRM",
        "lat": 54.392079,
        "lng": 12.54162,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Born am Darß",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Bäderstraße 3",
        "zip": "18375",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181673,
        "identifier": "DE031023",
        "googlePlaceId": "ChIJqzRUimL-o0cRgLBdVf7fOv4",
        "lat": 50.722687,
        "lng": 11.353605,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rudolstadt",
        "province": "Thüringen",
        "streetAndNumber": "Oststraße 31-33",
        "zip": "07407",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181674,
        "identifier": "DE010038",
        "googlePlaceId": "ChIJnZ3qVcTUpEcRJ_HikATJAUE",
        "lat": 51.545211,
        "lng": 9.929997,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Göttingen",
        "province": "Niedersachsen",
        "streetAndNumber": "Weender Landstraße 59",
        "zip": "37075",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181675,
        "identifier": "DE002060",
        "googlePlaceId": "ChIJo2qpcAfXuEcRStcE52xaId0",
        "lat": 51.26368,
        "lng": 7.13114,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Briller Straße 179",
        "zip": "42105",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181676,
        "identifier": "DE013002",
        "googlePlaceId": "ChIJ36XZSCV9uUcR7p2Sh7ViiBU",
        "lat": 51.58469,
        "lng": 8.09953,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Soest",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bergenring 5",
        "zip": "59494",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181677,
        "identifier": "DE001078",
        "googlePlaceId": "ChIJG3ufS4bduEcRfDk9au2W37Q",
        "lat": 51.46734,
        "lng": 7.08814,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Korthover Weg 57-59",
        "zip": "45307",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181678,
        "identifier": "DE032114",
        "googlePlaceId": "ChIJoTKY0O7JuUcRv-zwLdZei0g",
        "lat": 52.12915,
        "lng": 7.54926,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Greven",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Steinfurter Straße 5",
        "zip": "48268",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181680,
        "identifier": "DE036081",
        "googlePlaceId": "ChIJy-JTKNkDCUcRejwKlBJBIEg",
        "lat": 51.060723,
        "lng": 14.499599,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oppach",
        "province": "Sachsen",
        "streetAndNumber": "Bautzener Straße 7a",
        "zip": "02736",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181681,
        "identifier": "DE013094",
        "googlePlaceId": "ChIJ94itn7eau0cRe-P8wbmjEYE",
        "lat": 51.215608,
        "lng": 8.660658,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Medebach",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Vopeliusstraße 2-4",
        "zip": "59964",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181682,
        "identifier": "DE032077",
        "googlePlaceId": "ChIJj1mKzrnguEcRB1i_GCLNuvw",
        "lat": 51.483634,
        "lng": 7.147922,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hansastraße 41",
        "zip": "44866",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181683,
        "identifier": "DE016049",
        "googlePlaceId": "ChIJUZBXE3UgskcRpmwyaC0nft4",
        "lat": 53.652665,
        "lng": 10.187125,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Buchenkamp 94",
        "zip": "22359",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181684,
        "identifier": "DE025081",
        "googlePlaceId": "ChIJ5QaDpfPBuUcRiuY4f79Ux_M",
        "lat": 52.178561,
        "lng": 7.846882,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lengerich",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "In den Rietbroken 39",
        "zip": "49525",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181685,
        "identifier": "DE007079",
        "googlePlaceId": "ChIJ-_bDTymutkcRXCy6edamdSc",
        "lat": 53.607291,
        "lng": 8.595182,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Geestland (Langen)",
        "province": "Niedersachsen",
        "streetAndNumber": "Leher Landstraße 4h",
        "zip": "27607",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181686,
        "identifier": "DE006042",
        "googlePlaceId": "ChIJUY0jSj5AsEcRlBi0gJtxEvA",
        "lat": 52.65727,
        "lng": 9.82125,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wietze",
        "province": "Niedersachsen",
        "streetAndNumber": "Nienburger Straße 49",
        "zip": "29323",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181687,
        "identifier": "DE001013",
        "googlePlaceId": "ChIJ52WxJm_huEcRwIdxtlj57qc",
        "lat": 51.53273,
        "lng": 7.18526,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herne",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Dorstener Straße 263-265",
        "zip": "44653",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181688,
        "identifier": "DE029044",
        "googlePlaceId": "ChIJ950k2qFHqkcR9wRiujZ0V28",
        "lat": 53.629635,
        "lng": 14.02399,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Torgelow",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Ukranenstraße 1",
        "zip": "17358",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181689,
        "identifier": "DE029001",
        "googlePlaceId": "ChIJWz6vrZlHq0cRCqkLc-WYAzM",
        "lat": 54.511635,
        "lng": 13.61836,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Saßnitz",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Mukraner Straße 1b",
        "zip": "18546",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181690,
        "identifier": "DE007026",
        "googlePlaceId": "ChIJPYy6QvstsUcRkgjNwDLwYD0",
        "lat": 53.232908,
        "lng": 8.753185,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Osterholz-Scharmbeck",
        "province": "Niedersachsen",
        "streetAndNumber": "Hördorfer Weg 45",
        "zip": "27711",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181691,
        "identifier": "DE005115",
        "googlePlaceId": "ChIJw_aJ11oUukcRDHKGrUUOK2k",
        "lat": 52.098302,
        "lng": 8.673955,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herford",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lockhauser Straße 113",
        "zip": "32052",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181692,
        "identifier": "DE026004",
        "googlePlaceId": "ChIJE5Cga7KSrkcRCzMPXYqn-Z0",
        "lat": 53.162019,
        "lng": 11.745962,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Karstädt",
        "province": "Brandenburg",
        "streetAndNumber": "Postliner Straße 15a",
        "zip": "19357",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181693,
        "identifier": "DE026039",
        "googlePlaceId": "ChIJ-bAR56PwpUcR5HLv8D1l5c4",
        "lat": 52.016832,
        "lng": 11.712771,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schönebeck (Elbe)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Magdeburger Straße 238",
        "zip": "39218",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181694,
        "identifier": "DE029019",
        "googlePlaceId": "ChIJIYvGbfw9q0cRlGQDEX82lw8",
        "lat": 54.36492,
        "lng": 13.704639,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sellin",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Zum Mönchguter Tor 1",
        "zip": "18586",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181695,
        "identifier": "DE029039",
        "googlePlaceId": "ChIJWRylmsvJq0cRst8pZV_pJEM",
        "lat": 53.67287,
        "lng": 13.562731,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Friedland",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Pasewalker Straße",
        "zip": "17098",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181696,
        "identifier": "DE024077",
        "googlePlaceId": "ChIJVdUOf11UqEcRK39pkGzhkIw",
        "lat": 52.591878,
        "lng": 13.286755,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Buddestraße 32",
        "zip": "13507",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181697,
        "identifier": "DE004016",
        "googlePlaceId": "ChIJ_____1hWskcR1zT-wJoIK18",
        "lat": 54.314578,
        "lng": 10.146353,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Augustenstraße 30a-32",
        "zip": "24143",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181698,
        "identifier": "DE029036",
        "googlePlaceId": "ChIJ34wmXU3Dq0cRQyfHk-a7wpo",
        "lat": 53.523485,
        "lng": 13.256793,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neubrandenburg",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Platanenstraße 14",
        "zip": "17033",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181699,
        "identifier": "DE005050",
        "googlePlaceId": "ChIJ1wmbIDVbukcRnzj7oUWid0Y",
        "lat": 51.91483,
        "lng": 8.911835,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Detmold",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Remmighauser Straße 109 a",
        "zip": "32760",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181700,
        "identifier": "DE010111",
        "googlePlaceId": "ChIJ47i_hWo2pUcRRT6cwSnPLQE",
        "lat": 51.896937,
        "lng": 10.182882,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Seesen",
        "province": "Niedersachsen",
        "streetAndNumber": "Braunschweiger Straße 36",
        "zip": "38723",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181702,
        "identifier": "DE032061",
        "googlePlaceId": "ChIJxxKb3ESruUcRLRDLECbuG08",
        "lat": 51.86454,
        "lng": 7.361043,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dülmen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Weseler Straße 10-12",
        "zip": "48249",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181703,
        "identifier": "DE003004",
        "googlePlaceId": "ChIJY5Ra0DPqsUcRBP2mJCYeaAI",
        "lat": 53.33930750968,
        "lng": 10.204192098818,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Winsen (Luhe)",
        "province": "Niedersachsen",
        "streetAndNumber": "Winsener Landstraße 13-15",
        "zip": "21423",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181704,
        "identifier": "DE010103",
        "googlePlaceId": "ChIJnQ4jau7HukcRDmAgR48pqIs",
        "lat": 51.94053,
        "lng": 9.817276,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Delligsen",
        "province": "Niedersachsen",
        "streetAndNumber": "Carlstraße 2",
        "zip": "31073",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181705,
        "identifier": "DE003032",
        "googlePlaceId": "ChIJOS2Kl-ATsUcRKruvGDBoX5A",
        "lat": 53.29272,
        "lng": 9.28168,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zeven",
        "province": "Niedersachsen",
        "streetAndNumber": "Auf der Worth 9",
        "zip": "27404",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181706,
        "identifier": "DE016023",
        "googlePlaceId": "ChIJoak_gY4fskcR_p3ypVs1EiU",
        "lat": 53.67453,
        "lng": 10.238635,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ahrensburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Große Straße 26",
        "zip": "22926",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181707,
        "identifier": "DE007095",
        "googlePlaceId": "ChIJ2QZ6RkPJsEcRpU6chDeGgFg",
        "lat": 52.800406,
        "lng": 8.638884,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Twistringen",
        "province": "Niedersachsen",
        "streetAndNumber": "Große Straße 38",
        "zip": "27239",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181708,
        "identifier": "DE001047",
        "googlePlaceId": "ChIJ62_Ak0vduEcRQcciWlWBji8",
        "lat": 51.45634,
        "lng": 7.025246,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Natorpstraße 26-30",
        "zip": "45139",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181712,
        "identifier": "DE006140",
        "googlePlaceId": "ChIJSfjogt1QpUcRN_JpVP2J_GA",
        "lat": 52.145147,
        "lng": 10.315369,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Salzgitter",
        "province": "Niedersachsen",
        "streetAndNumber": "Leibnizstraße 2",
        "zip": "38228",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181713,
        "identifier": "DE013011",
        "googlePlaceId": "ChIJEcaG029mvEcRbXVFADVp8xU",
        "lat": 50.76857,
        "lng": 8.586808,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gladenbach",
        "province": "Hessen",
        "streetAndNumber": "Kirchbergstraße 6",
        "zip": "35075",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181714,
        "identifier": "DE001071",
        "googlePlaceId": "ChIJZTtuEmnouEcRexcJT4DjdyQ",
        "lat": 51.502443,
        "lng": 7.009801,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wilhelm-Nieswandt-Allee 198",
        "zip": "45326",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181716,
        "identifier": "DE010066",
        "googlePlaceId": "ChIJm-1SN8tYo0cR7f7G3oVHzxw",
        "lat": 50.892458,
        "lng": 10.013144,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Heringen (Werra)",
        "province": "Hessen",
        "streetAndNumber": "Im langen Roth 3",
        "zip": "36266",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181717,
        "identifier": "DE032080",
        "googlePlaceId": "ChIJt9oPn3bguEcR8Ux_LHi-5Fc",
        "lat": 51.46651,
        "lng": 7.20423,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "An der Landwehr 22",
        "zip": "44795",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181718,
        "identifier": "DE021121",
        "googlePlaceId": "ChIJs6cdURseCEcR1qTwr6TY9oE",
        "lat": 51.634628,
        "lng": 13.706858,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Finsterwalde",
        "province": "Brandenburg",
        "streetAndNumber": "Berliner Straße 20b",
        "zip": "03238",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181719,
        "identifier": "DE002104",
        "googlePlaceId": "ChIJQ7zTWB7-u0cRlsDJ13vWc3E",
        "lat": 51.139675,
        "lng": 8.013239,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lennestadt",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kölner Straße 86c",
        "zip": "57368",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "closed": true
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181720,
        "identifier": "DE036034",
        "googlePlaceId": "ChIJ42CUqyjGCUcR-ENvcqkOmBc",
        "lat": 51.030005,
        "lng": 13.804157,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Enderstraße 59",
        "zip": "01277",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181721,
        "identifier": "DE006074",
        "googlePlaceId": "ChIJ214Thfo9sEcROL7jaxT5nSU",
        "lat": 52.634391,
        "lng": 9.975219,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hambühren",
        "province": "Niedersachsen",
        "streetAndNumber": "Hehlenbruchweg 4",
        "zip": "29313",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181722,
        "identifier": "DE025020",
        "googlePlaceId": "ChIJoVuwQMA5uEcRacP9MUdXEME",
        "lat": 52.205124,
        "lng": 7.18782,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ochtrup",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bahnhofstraße 37",
        "zip": "48607",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181723,
        "identifier": "DE006101",
        "googlePlaceId": "ChIJV6QGvSGvukcRoEpcz2DLVNY",
        "lat": 52.162892,
        "lng": 9.964908,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hildesheim",
        "province": "Niedersachsen",
        "streetAndNumber": "Drispenstedter Straße 4",
        "zip": "31135",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181724,
        "identifier": "DE020011",
        "googlePlaceId": "ChIJZbv48OJPqEcRMaj_ooV726k",
        "lat": 52.471526,
        "lng": 13.384773,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Hoeppnerstraße 3-13",
        "zip": "12101",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181725,
        "identifier": "DE002029",
        "googlePlaceId": "ChIJiRLZxBg3uUcRZ1mL3A5Y6AI",
        "lat": 51.237223,
        "lng": 7.529374,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schalksmühle",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hälverstraße 51",
        "zip": "58579",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181726,
        "identifier": "DE001025",
        "googlePlaceId": "ChIJ0aPa7_fxuEcRp8P3WLlMdzg",
        "lat": 51.658129,
        "lng": 6.965818,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dorsten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Voßkamp 7",
        "zip": "46282",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181727,
        "identifier": "DE006112",
        "googlePlaceId": "ChIJH_B3b52kukcRuIqJtKCG7ss",
        "lat": 52.155497,
        "lng": 9.790032,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nordstemmen",
        "province": "Niedersachsen",
        "streetAndNumber": "Lange Maße 5",
        "zip": "31171",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181728,
        "identifier": "DE004089",
        "googlePlaceId": "ChIJp3Yy9gwEYkEREXWaGsvsg-0",
        "lat": 54.307444,
        "lng": 9.33209,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Erfde",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Heidkoppel 2",
        "zip": "24803",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181729,
        "identifier": "DE007007",
        "googlePlaceId": "ChIJ54H2IVXWsEcRHhLBzvzUCgc",
        "lat": 53.026758,
        "lng": 8.754013,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stuhr",
        "province": "Niedersachsen",
        "streetAndNumber": "Stuhrer Landstraße 142c",
        "zip": "28816",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181732,
        "identifier": "DE021004",
        "googlePlaceId": "ChIJheH5tmv4pkcRtUgxgI-F9Wg",
        "lat": 51.345124,
        "lng": 12.404653,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Konradstraße 27",
        "zip": "04315",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181733,
        "identifier": "DE003040",
        "googlePlaceId": "ChIJJUamBcLdsUcRrRaNmmB6oLs",
        "lat": 53.260041,
        "lng": 10.410605,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lüneburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Auf dem Schmaarkamp 15",
        "zip": "21339",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181734,
        "identifier": "DE020018",
        "googlePlaceId": "ChIJuznaD55PqEcROCIhghYHNU0",
        "lat": 52.468737,
        "lng": 13.44383,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Karl-Marx-Straße 231-235",
        "zip": "12055",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181735,
        "identifier": "DE024117",
        "googlePlaceId": "ChIJj8VyevcnqEcRmWz5OdLYcr4",
        "lat": 52.366189,
        "lng": 14.071065,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Fürstenwalde",
        "province": "Brandenburg",
        "streetAndNumber": "Ehrenfried-Jopp-Straße 57",
        "zip": "15517",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181736,
        "identifier": "DE007014",
        "googlePlaceId": "ChIJGavp-jUosUcRHlzrHQmRM-E",
        "lat": 53.087748,
        "lng": 8.780877,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Konsul-Smidt-Straße 8",
        "zip": "28217",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181737,
        "identifier": "DE015044",
        "googlePlaceId": "ChIJqWp0kzKxt0cR5GhgW7aPIeo",
        "lat": 53.048807,
        "lng": 7.326687,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Papenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Zu den Emsauen 2",
        "zip": "26871",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181738,
        "identifier": "DE016142",
        "googlePlaceId": "ChIJzceD8kgpskcRr2cGdIinkj8",
        "lat": 53.750286,
        "lng": 9.917146,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ellerau",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Berliner Damm 1",
        "zip": "25479",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181739,
        "identifier": "DE016026",
        "googlePlaceId": "ChIJgZqGDZWFsUcRMoj-OHgDLgE",
        "lat": 53.564884,
        "lng": 9.908313,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Bahrenfelder Kirchenweg 80",
        "zip": "22761",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181740,
        "identifier": "DE032037",
        "googlePlaceId": "ChIJyWyvbO8PuUcR9XJjuE256Uk",
        "lat": 51.623626,
        "lng": 7.514594,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lünen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Borker Straße 86-90",
        "zip": "44534",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181741,
        "identifier": "DE010093",
        "googlePlaceId": "ChIJ2VtexYWOvEcRA42HOvKFM-g",
        "lat": 50.763041,
        "lng": 8.92248,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Amöneburg",
        "province": "Hessen",
        "streetAndNumber": "Homberger Straße 15",
        "zip": "35287",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181742,
        "identifier": "DE032032",
        "googlePlaceId": "ChIJ8fwcX8kEuUcRcLaIT1on7zY",
        "lat": 51.62343,
        "lng": 7.42024,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Waltrop",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Schwarzbach 8",
        "zip": "45731",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181743,
        "identifier": "DE007037",
        "googlePlaceId": "ChIJSR3SmMogsUcRCwg_wY8cnUQ",
        "lat": 53.07823,
        "lng": 8.94307,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Schevemoorer Landstraße 14-20",
        "zip": "28325",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181746,
        "identifier": "DE029015",
        "googlePlaceId": "ChIJG1VnV0p_q0cRwFtDxDkz9To",
        "lat": 54.098855,
        "lng": 13.038132,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Grimmen",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Vietlipper Damm 1-3",
        "zip": "18507",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181747,
        "identifier": "DE010084",
        "googlePlaceId": "ChIJu0yYKqXUpEcRPaqj4aUsD3g",
        "lat": 51.526501,
        "lng": 9.924914,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Göttingen",
        "province": "Niedersachsen",
        "streetAndNumber": "Leinestraße 49",
        "zip": "37073",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181749,
        "identifier": "DE021080",
        "googlePlaceId": "ChIJKbEna4ksp0cRthEydyd7H5M",
        "lat": 50.721029,
        "lng": 12.471469,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zwickau",
        "province": "Sachsen",
        "streetAndNumber": "Marienthaler Straße 8",
        "zip": "08060",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181750,
        "identifier": "DE036104",
        "googlePlaceId": "ChIJMwaiM4FGp0cRE_cfFkiVsJ0",
        "lat": 50.839856,
        "lng": 12.951238,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Chemnitz",
        "province": "Sachsen",
        "streetAndNumber": "Heinrich-Schütz-Straße 55",
        "zip": "09130",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181751,
        "identifier": "DE005047",
        "googlePlaceId": "ChIJzXt5bImMuUcRVXtMp9aZAkk",
        "lat": 52.041043,
        "lng": 8.145869,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Versmold",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wirusstraße 10",
        "zip": "33775",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181752,
        "identifier": "DE036035",
        "googlePlaceId": "ChIJG9GEElDOCUcRy965r1GyneI",
        "lat": 51.096919,
        "lng": 13.719772,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Döbelner Straße 132",
        "zip": "01129",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181753,
        "identifier": "DE013064",
        "googlePlaceId": "ChIJE2GrpNx2uUcRIyqCSQRq2_k",
        "lat": 51.688753,
        "lng": 7.886301,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamm",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Moritz-Bacharach-Straße 7",
        "zip": "59071",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181754,
        "identifier": "DE010107",
        "googlePlaceId": "ChIJ5Wzcj8WzukcRQhAz8wQLOq4",
        "lat": 52.053326,
        "lng": 10.001511,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Salzdetfurth",
        "province": "Niedersachsen",
        "streetAndNumber": "Bodenburger Straße 9a",
        "zip": "31162",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181755,
        "identifier": "DE031040",
        "googlePlaceId": "ChIJP__AJAt1pEcRBx7Bs2lwQeQ",
        "lat": 50.847756,
        "lng": 10.956371,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Arnstadt",
        "province": "Thüringen",
        "streetAndNumber": "Ichtershäuser Straße 47-49",
        "zip": "99310",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181756,
        "identifier": "DE026015",
        "googlePlaceId": "ChIJIwrUNhNQr0cRtJ0MQpGhOGo",
        "lat": 52.259298,
        "lng": 11.846488,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Burg (bei Magdeburg)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Zibbeklebener Straße 7",
        "zip": "39288",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181758,
        "identifier": "DE005063",
        "googlePlaceId": "ChIJRQh4Zn4wukcRutTmdz8gzvI",
        "lat": 51.879796,
        "lng": 8.504445,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Verl",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Westfalenweg 8",
        "zip": "33415",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3181759,
        "identifier": "DE024083",
        "googlePlaceId": "ChIJm7OhB9dTqEcRQruMUhzPDv8",
        "lat": 52.55245,
        "lng": 13.34801,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Müllerstraße 128",
        "zip": "13349",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181760,
        "identifier": "DE005135",
        "googlePlaceId": "ChIJTclzTUsPukcRqCHeoh-H60s",
        "lat": 52.303704,
        "lng": 8.604217,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübbecke",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Strubbergstraße 9",
        "zip": "32312",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181761,
        "identifier": "DE024099",
        "googlePlaceId": "ChIJ_ZJGWudOqEcRG6Pwgg_mFog",
        "lat": 52.49656,
        "lng": 13.486858,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Hauptstraße 36",
        "zip": "10317",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181764,
        "identifier": "DE001014",
        "googlePlaceId": "ChIJxdiPLwceuUcRYw6LKaB_CSM",
        "lat": 51.54165,
        "lng": 7.266156,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herne",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Mont-Cenis-Straße 351",
        "zip": "44627",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181765,
        "identifier": "DE007022",
        "googlePlaceId": "ChIJm3T_j-CysEcRYvNpCToygLo",
        "lat": 52.609086,
        "lng": 8.485198,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rehden",
        "province": "Niedersachsen",
        "streetAndNumber": "Nienburger Straße 38",
        "zip": "49453",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3181766,
        "identifier": "DE010036",
        "googlePlaceId": "ChIJh8JSX8Q4u0cREef_wwVGJYw",
        "lat": 51.325532,
        "lng": 9.518647,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kassel",
        "province": "Hessen",
        "streetAndNumber": "Fuldatalstraße 14",
        "zip": "34125",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181767,
        "identifier": "DE036126",
        "googlePlaceId": "ChIJD2h-9wtDCEcRmXHevtiFucU",
        "lat": 51.429902,
        "lng": 14.271107,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hoyerswerda",
        "province": "Sachsen",
        "streetAndNumber": "Ziolkowskistraße 18",
        "zip": "02977",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181768,
        "identifier": "DE029017",
        "googlePlaceId": "ChIJPShLDtVyrEcRTbRD7X1rdaM",
        "lat": 53.775591,
        "lng": 12.568017,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Teterow",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Poggestraße 2A",
        "zip": "17166",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181769,
        "identifier": "DE016073",
        "googlePlaceId": "ChIJzzqp2QuPsUcRhWlAzFnXoHE",
        "lat": 53.575583,
        "lng": 9.95217,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Osterstraße 119",
        "zip": "20259",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181770,
        "identifier": "DE016147",
        "googlePlaceId": "ChIJc_PgrBN0skcRiwQDW3vb1Eo",
        "lat": 54.021991,
        "lng": 10.751086,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Scharbeutz",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Seestraße 63",
        "zip": "23683",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181771,
        "identifier": "DE031055",
        "googlePlaceId": "ChIJR-JIsqhqpEcRkU4iMmmWmeg",
        "lat": 51.149642,
        "lng": 11.114151,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sömmerda",
        "province": "Thüringen",
        "streetAndNumber": "Erfurter Straße 46",
        "zip": "99610",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181773,
        "identifier": "DE013095",
        "googlePlaceId": "ChIJh7bPFR6Bu0cRO1xIcOVG7vg",
        "lat": 51.057614,
        "lng": 8.782877,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Frankenberg",
        "province": "Hessen",
        "streetAndNumber": "Röddenauer Straße 20",
        "zip": "35066",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181774,
        "identifier": "DE024098",
        "googlePlaceId": "ChIJMV3iTMNOqEcRpl4XCXHCGU0",
        "lat": 52.499561,
        "lng": 13.495014,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Rummelsburger Straße 98",
        "zip": "10319",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181775,
        "identifier": "DE006016",
        "googlePlaceId": "ChIJP75j-knFr0cRGuq8mZwTQBA",
        "lat": 52.73116,
        "lng": 10.603339,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hankensbüttel",
        "province": "Niedersachsen",
        "streetAndNumber": "Hindenburgstraße 1",
        "zip": "29386",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181776,
        "identifier": "DE006129",
        "googlePlaceId": "ChIJ-6BjgIr2r0cRjpobwcvs_40",
        "lat": 52.277452,
        "lng": 10.506404,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Braunschweig",
        "province": "Niedersachsen",
        "streetAndNumber": "Celler Straße 81",
        "zip": "38114",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181777,
        "identifier": "DE002048",
        "googlePlaceId": "ChIJ91fiRnYluUcRv52j2zKD91Q",
        "lat": 51.298487,
        "lng": 7.356808,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ennepetal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Milsper Straße 222",
        "zip": "58256",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181779,
        "identifier": "DE036098",
        "googlePlaceId": "ChIJ77wSxJvNoEcRNEiKFCHZwYQ",
        "lat": 50.619851,
        "lng": 12.511241,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kirchberg",
        "province": "Sachsen",
        "streetAndNumber": "Lengenfelder Straße 41",
        "zip": "08107",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181780,
        "identifier": "DE007032",
        "googlePlaceId": "ChIJT7ZliJ2SsEcRqN-qM8SCYFo",
        "lat": 52.663385,
        "lng": 9.156092,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Marklohe",
        "province": "Niedersachsen",
        "streetAndNumber": "Lemker Nordfeld 4",
        "zip": "31608",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181781,
        "identifier": "DE006141",
        "googlePlaceId": "ChIJk-fUdbFQpUcRNon3Rs2UzOE",
        "lat": 52.156883,
        "lng": 10.34838,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Salzgitter",
        "province": "Niedersachsen",
        "streetAndNumber": "Schlosserstr. 1",
        "zip": "38229",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181782,
        "identifier": "DE002047",
        "googlePlaceId": "ChIJASvYiNUkuUcRWMQjowaRyhQ",
        "lat": 51.306423,
        "lng": 7.390187,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ennepetal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hagener Straße 2",
        "zip": "58256",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181783,
        "identifier": "DE003010",
        "googlePlaceId": "ChIJfWKOTamOsUcRLa1kkhI3ps0",
        "lat": 53.568667,
        "lng": 10.058863,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Menckesallee 24-26",
        "zip": "22089",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181784,
        "identifier": "DE024020",
        "googlePlaceId": "ChIJuz8sfxxSqEcRZruLEMdnfYo",
        "lat": 52.548971,
        "lng": 13.401618,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Schwedter Straße 83",
        "zip": "10437",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181785,
        "identifier": "DE031016",
        "googlePlaceId": "ChIJuTjmGaR8o0cRMZTyNnM65OQ",
        "lat": 50.811406,
        "lng": 10.338598,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schweina",
        "province": "Thüringen",
        "streetAndNumber": "Johann-Christian-von-Weiß-Straße 5",
        "zip": "36448",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181786,
        "identifier": "DE016004",
        "googlePlaceId": "ChIJJWhw3sqOsUcR0d7PU3xMZWk",
        "lat": 53.573344,
        "lng": 10.031542,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Hamburger Straße 23",
        "zip": "22083",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181787,
        "identifier": "DE036105",
        "googlePlaceId": "ChIJl0v4gIRIp0cRmLU9sDKQGyQ",
        "lat": 50.794343,
        "lng": 12.892477,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Chemnitz",
        "province": "Sachsen",
        "streetAndNumber": "Wladimir-Sagorski-Straße 22",
        "zip": "09122",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181788,
        "identifier": "DE036052",
        "googlePlaceId": "ChIJQaMG-J7OCUcRV31A1UbFjQA",
        "lat": 51.119972,
        "lng": 13.769646,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Travemünder Straße 1",
        "zip": "01109",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181789,
        "identifier": "DE006063",
        "googlePlaceId": "ChIJvb3ZSo10sEcRXZDvDxw4_m8",
        "lat": 52.368569,
        "lng": 9.704261,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Bardowicker Straße 10",
        "zip": "30449",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181790,
        "identifier": "DE006058",
        "googlePlaceId": "ChIJPRuRtO4MsEcRN_slE5uh--c",
        "lat": 52.40877,
        "lng": 9.801264,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Adolf-Emmelmann-Straße 5",
        "zip": "30659",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181791,
        "identifier": "DE001068",
        "googlePlaceId": "ChIJ0xy5hnTluEcREPx1KKjiIc8",
        "lat": 51.601469,
        "lng": 7.08144,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Zum Bahnhof 4",
        "zip": "45701",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181792,
        "identifier": "DE013098",
        "googlePlaceId": "ChIJoRbCu8JvvEcRx8MLVCKd0lk",
        "lat": 50.856563,
        "lng": 8.547813,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dautphe",
        "province": "Hessen",
        "streetAndNumber": "Gladenbacher Straße 38",
        "zip": "35232",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181793,
        "identifier": "DE020056",
        "googlePlaceId": "ChIJ5YNNc_pbqEcRHiythXK6m14",
        "lat": 52.395304,
        "lng": 13.238012,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Teltow",
        "province": "Brandenburg",
        "streetAndNumber": "Saganer Straße 9",
        "zip": "14513",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181794,
        "identifier": "DE006031",
        "googlePlaceId": "ChIJQ27Rq6D9r0cRrHLW1QuNQQE",
        "lat": 52.38575,
        "lng": 10.25688,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Edemissen",
        "province": "Niedersachsen",
        "streetAndNumber": "Wöhrbergweg 5",
        "zip": "31234",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181795,
        "identifier": "DE005132",
        "googlePlaceId": "ChIJrQlT_c70ukcReLw91xhnPkQ",
        "lat": 51.990906,
        "lng": 9.236314,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Pyrmont",
        "province": "Niedersachsen",
        "streetAndNumber": "Auf der Schanze 31",
        "zip": "31812",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181796,
        "identifier": "DE025011",
        "googlePlaceId": "ChIJp1KKpjQvuEcROZHUBfkI98o",
        "lat": 52.391415,
        "lng": 7.296531,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Emsbüren",
        "province": "Niedersachsen",
        "streetAndNumber": "In der Maate 6",
        "zip": "48488",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181797,
        "identifier": "DE029049",
        "googlePlaceId": "ChIJITE3SWGFq0cROEVHI-teivc",
        "lat": 53.904359,
        "lng": 13.038537,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Demmin",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Wollweberstraße 5a",
        "zip": "17109",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181798,
        "identifier": "DE020019",
        "googlePlaceId": "ChIJ7RS22jpQqEcRnWoWUdPqkBY",
        "lat": 52.488133,
        "lng": 13.373859,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Kreuzbergstraße 39",
        "zip": "10965",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181800,
        "identifier": "DE016075",
        "googlePlaceId": "ChIJZ5uIT6InskcR4gKIhY1HrmA",
        "lat": 53.68792,
        "lng": 10.040312,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Norderstedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Mittelstraße 76",
        "zip": "22851",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181801,
        "identifier": "DE003028",
        "googlePlaceId": "ChIJo4Lb9NjdsUcR5cyuv4tfP6Q",
        "lat": 53.25078,
        "lng": 10.42713,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lüneburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Bleckeder Landstraße 26-28",
        "zip": "21337",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181802,
        "identifier": "DE002107",
        "googlePlaceId": "ChIJr0ySLgcmuUcR4tf1IzIGO4U",
        "lat": 51.293569,
        "lng": 7.29814,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwelm",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Prinzenstraße 27",
        "zip": "58332",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181803,
        "identifier": "DE001060",
        "googlePlaceId": "ChIJY1-ZFE_muEcRdgj_YUGiPoc",
        "lat": 51.521803,
        "lng": 7.073169,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gelsenkirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Grothusstraße 21",
        "zip": "45881",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181804,
        "identifier": "DE025059",
        "googlePlaceId": "ChIJq6p6UekhuEcRXECl36bdc8c",
        "lat": 52.422591,
        "lng": 7.068679,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nordhorn",
        "province": "Niedersachsen",
        "streetAndNumber": "Friedrich-Ebert-Straße 80",
        "zip": "48529",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181805,
        "identifier": "DE005138",
        "googlePlaceId": "ChIJDY7gWVgKu0cRJAyQsVwJ_d4",
        "lat": 51.380739448124,
        "lng": 8.9992872989517,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Arolsen",
        "province": "Hessen",
        "streetAndNumber": "Korbacher Straße 5",
        "zip": "34454",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181806,
        "identifier": "DE004040",
        "googlePlaceId": "ChIJC2AnCwFDs0cRSSSdeNjuTts",
        "lat": 54.81484,
        "lng": 9.47121,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Flensburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Friedheim 8",
        "zip": "24944",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181807,
        "identifier": "DE006044",
        "googlePlaceId": "ChIJR7qZrTRdsEcRbjSb7uCVfVg",
        "lat": 52.680935,
        "lng": 9.618627,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwarmstedt",
        "province": "Niedersachsen",
        "streetAndNumber": "Celler Straße 31",
        "zip": "29690",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181808,
        "identifier": "DE020001",
        "googlePlaceId": "ChIJ0e6zGshPqEcRkklSs74O1SM",
        "lat": 52.486365,
        "lng": 13.421487,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Hasenheide 108",
        "zip": "10967",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181809,
        "identifier": "DE029082",
        "googlePlaceId": "ChIJ6YrT-g-4rUcRnWBPNbiwQg0",
        "lat": 53.890107,
        "lng": 11.532688,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hornstorf",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Karpendieck 3a",
        "zip": "23970",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181811,
        "identifier": "DE007042",
        "googlePlaceId": "ChIJ6a6NO7bksEcR-yTTigBTlGM",
        "lat": 52.93544,
        "lng": 9.23139,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Verden",
        "province": "Niedersachsen",
        "streetAndNumber": "Bremer Straße 48",
        "zip": "27283",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181812,
        "identifier": "DE031072",
        "googlePlaceId": "ChIJN1Yp-7bTpUcRhzOD11RS4vY",
        "lat": 51.511716,
        "lng": 11.569665,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eisleben",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Hallesche Straße 224 c",
        "zip": "06295",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181813,
        "identifier": "DE010119",
        "googlePlaceId": "ChIJo17SY3sQpUcR1KDMlxf9Umo",
        "lat": 51.720438,
        "lng": 10.615457,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Braunlage",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Buchholzplatz 8",
        "zip": "38700",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181814,
        "identifier": "DE026006",
        "googlePlaceId": "ChIJq-pbmZc8r0cRnPMFK1RWFzo",
        "lat": 52.601744,
        "lng": 11.836676,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stendal",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Dr.-Kurt-Schumacher-Straße 16",
        "zip": "39576",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181815,
        "identifier": "DE032120",
        "googlePlaceId": "ChIJB5IuTlK6uUcRufbFRPV4jUI",
        "lat": 51.994395,
        "lng": 7.648054,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Münster",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hamannplatz 29A",
        "zip": "48157",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181816,
        "identifier": "DE007084",
        "googlePlaceId": "ChIJnwNxR2D2sEcRN0MVKUkLzNY",
        "lat": 52.781442,
        "lng": 9.372188,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rethem",
        "province": "Niedersachsen",
        "streetAndNumber": "Stöckener Straße 12",
        "zip": "27336",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181817,
        "identifier": "DE016096",
        "googlePlaceId": "ChIJoX7uQm6GsUcRxfUzQfXdQXs",
        "lat": 53.599296,
        "lng": 9.914582,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Kieler Straße 577e",
        "zip": "22525",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181818,
        "identifier": "DE021016",
        "googlePlaceId": "ChIJ88mKZ_Qhp0cRKGJrkX-rIFw",
        "lat": 50.981271,
        "lng": 12.4843,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nobitz",
        "province": "Thüringen",
        "streetAndNumber": "Altenburger Straße 29",
        "zip": "04603",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181819,
        "identifier": "DE031001",
        "googlePlaceId": "ChIJIdhPQ_i9o0cRcljC1AhvQpY",
        "lat": 50.517013,
        "lng": 10.754372,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schleusingen",
        "province": "Thüringen",
        "streetAndNumber": "Suhler Straße 36-42",
        "zip": "98553",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181820,
        "identifier": "DE024033",
        "googlePlaceId": "ChIJw6l4909MqEcRe0FQf563AyM",
        "lat": 52.564709,
        "lng": 13.506388,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Prerower Platz 1",
        "zip": "13051",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181823,
        "identifier": "DE006062",
        "googlePlaceId": "ChIJG7zhqeEDsEcRXcaAFmCk2Vg",
        "lat": 52.357862,
        "lng": 10.118703,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lehrte",
        "province": "Niedersachsen",
        "streetAndNumber": "Hermesstraße 3",
        "zip": "31275",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181824,
        "identifier": "DE006165",
        "googlePlaceId": "ChIJ8zTXyht_ukcRl1Bl_cwjQ2M",
        "lat": 52.310069,
        "lng": 9.19146,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stadthagen",
        "province": "Niedersachsen",
        "streetAndNumber": "Jahnstraße 28",
        "zip": "31655",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181825,
        "identifier": "DE002015",
        "googlePlaceId": "ChIJg88kvH_TuEcRS1MHasjqWnU",
        "lat": 51.175384,
        "lng": 7.060136,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Solingen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Beethovenstraße 131",
        "zip": "42655",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181826,
        "identifier": "DE025029",
        "googlePlaceId": "ChIJUbCh8VHNuUcRQDJbS9A_XJ0",
        "lat": 52.286509,
        "lng": 7.463377,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rheine",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Windmühlenstraße 3",
        "zip": "48429",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181827,
        "identifier": "DE004057",
        "googlePlaceId": "ChIJU2qUhBX4skcRDZJQoU4KCUQ",
        "lat": 54.376742,
        "lng": 10.221615,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Heikendorf",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Tobringer 2",
        "zip": "24226",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181828,
        "identifier": "DE005059",
        "googlePlaceId": "ChIJlzTt0JWJuUcRhSBN1zHqbPE",
        "lat": 51.970042,
        "lng": 8.221069,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Harsewinkel",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Prozessionsweg 43",
        "zip": "33428",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181829,
        "identifier": "DE003001",
        "googlePlaceId": "ChIJaYAghLzvsUcRjYq6g5TOqw0",
        "lat": 53.433453,
        "lng": 10.341392,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Geesthacht",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Am Schleusenkanal 28",
        "zip": "21502",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181830,
        "identifier": "DE016143",
        "googlePlaceId": "ChIJ1ymwf6mHrUcR6EAZ7UmAWhs",
        "lat": 54.151109,
        "lng": 10.962013,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Grömitz",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Brookgang 21",
        "zip": "23743",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181831,
        "identifier": "DE025095",
        "googlePlaceId": "ChIJ073aSIzMuUcRsgveLk_porc",
        "lat": 52.226895,
        "lng": 7.485671,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rheine",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Dille 57",
        "zip": "48432",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181833,
        "identifier": "DE006144",
        "googlePlaceId": "ChIJBzP-F-NWpUcRMMaGjrazpNM",
        "lat": 52.19295,
        "lng": 10.32533,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lengede",
        "province": "Niedersachsen",
        "streetAndNumber": "Carl-Zeiss-Straße 4",
        "zip": "38268",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181835,
        "identifier": "DE004141",
        "googlePlaceId": "ChIJk57IGTN7rUcRnh9VwiEfBok",
        "lat": 54.479038,
        "lng": 11.072513,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Petersdorf",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Alte Bahnhofstraße 23",
        "zip": "23769",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181836,
        "identifier": "DE006077",
        "googlePlaceId": "ChIJc6SFHdEHsEcRq72j0MS3zJU",
        "lat": 52.316627,
        "lng": 9.971735,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sehnde",
        "province": "Niedersachsen",
        "streetAndNumber": "Bachstraße 9",
        "zip": "31319",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181837,
        "identifier": "DE002032",
        "googlePlaceId": "ChIJE7cXbunauEcR-pWqQOk4n0I",
        "lat": 51.332893,
        "lng": 7.022435,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Velbert",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Heiligenhauser Straße 60",
        "zip": "42549",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181838,
        "identifier": "DE015031",
        "googlePlaceId": "ChIJs9tQqaest0cRC1zVMDtatfI",
        "lat": 53.137093,
        "lng": 7.570091,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rhauderfehn",
        "province": "Niedersachsen",
        "streetAndNumber": "Rhauderwieke 9",
        "zip": "26817",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181839,
        "identifier": "DE005133",
        "googlePlaceId": "ChIJ_Rzv104QukcRlweCH4uvWRo",
        "lat": 52.191779,
        "lng": 8.593387,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bünde",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Haßkampstraße 94",
        "zip": "32257",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181840,
        "identifier": "DE001075",
        "googlePlaceId": "ChIJedyeLzfnuEcRsnYv7wHgSik",
        "lat": 51.492482,
        "lng": 7.124799,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gelsenkirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Dördelmannshof 6",
        "zip": "45886",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181841,
        "identifier": "DE016077",
        "googlePlaceId": "ChIJE7mKT4CJsUcR6qqnV2bsI-k",
        "lat": 53.618154,
        "lng": 10.082561,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Berner Chaussee 16",
        "zip": "22175",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181842,
        "identifier": "DE005123",
        "googlePlaceId": "ChIJtzc_dM9fukcR0_v7ITjV6vw",
        "lat": 51.994993,
        "lng": 9.118736,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Barntrup",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Alverdisser Straße 7",
        "zip": "32683",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181843,
        "identifier": "DE010009",
        "googlePlaceId": "ChIJ7eFj8Bxlu0cRy90oP0feBII",
        "lat": 51.119334,
        "lng": 9.137043,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Wildungen",
        "province": "Hessen",
        "streetAndNumber": "Bahnhof 3",
        "zip": "34537",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181844,
        "identifier": "DE005010",
        "googlePlaceId": "ChIJESd6WaNMukcRpT-CuuLYGtc",
        "lat": 51.712348,
        "lng": 8.746571,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Paderborn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Borchener Straße 25",
        "zip": "33098",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181846,
        "identifier": "DE005096",
        "googlePlaceId": "ChIJhYBLCZ5nukcRcHtkwgl7guI",
        "lat": 52.033501,
        "lng": 9.004329,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dörentrup",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lemgoer Straße 2 a",
        "zip": "32694",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181847,
        "identifier": "DE020075",
        "googlePlaceId": "ChIJwwTSTERFqEcRXLcstb0B8_4",
        "lat": 52.437173,
        "lng": 13.445927,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Fritz-Reuter-Allee 184",
        "zip": "12359",
        "businessId": 1312729,
        "addressExtra": "Gutschmidtstraße 32-36",
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181848,
        "identifier": "DE016127",
        "googlePlaceId": "ChIJzW9uHBYLskcR4SmBqiz_C7Y",
        "lat": 53.888204,
        "lng": 10.68638,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübeck",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Schwartauer Landstraße 4a",
        "zip": "23554",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181849,
        "identifier": "DE010112",
        "googlePlaceId": "ChIJCeP6A10wpUcRL2YcDhj9cjM",
        "lat": 51.783146,
        "lng": 10.196486,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Grund",
        "province": "Niedersachsen",
        "streetAndNumber": "Teichhütter Straße 2a",
        "zip": "37539",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181852,
        "identifier": "DE004101",
        "googlePlaceId": "ChIJ8Vh0hMz5skcRmMN6ysqckZ0",
        "lat": 54.396669,
        "lng": 10.233244,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Laboe",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Bullbrücke 1",
        "zip": "24235",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181853,
        "identifier": "DE002103",
        "googlePlaceId": "ChIJ0atJmhr_u0cRlNSFxt70RJo",
        "lat": 51.102965,
        "lng": 8.071437,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lennestadt",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hundemstraße 44",
        "zip": "57368",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181854,
        "identifier": "DE020111",
        "googlePlaceId": "ChIJ_8bYyMZBqEcR6CrGNiUbiHA",
        "lat": 52.295033,
        "lng": 13.458635,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rangsdorf",
        "province": "Brandenburg",
        "streetAndNumber": "Birkenweg 2",
        "zip": "15834",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181855,
        "identifier": "DE031027",
        "googlePlaceId": "ChIJB_tiijD8o0cRXJek2mUf4_o",
        "lat": 50.691346,
        "lng": 11.3246,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rudolstadt-Schwarza",
        "province": "Thüringen",
        "streetAndNumber": "Anne-Frank-Straße 1",
        "zip": "07407",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181856,
        "identifier": "DE003003",
        "googlePlaceId": "ChIJGSkNstjVsUcR9xHGBoBjiHI",
        "lat": 53.0193,
        "lng": 10.42286,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ebstorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Kiebitzkamp 3",
        "zip": "29574",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181857,
        "identifier": "DE005035",
        "googlePlaceId": "ChIJfxTRfDPSu0cRPVhi6YoNdOA",
        "lat": 51.656786,
        "lng": 8.330758,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lippstadt",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Otto-Hahn-Straße 17",
        "zip": "59557",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181858,
        "identifier": "DE032044",
        "googlePlaceId": "ChIJM8TMDIAIuUcRnlg8J5AlooY",
        "lat": 51.737667,
        "lng": 7.529117,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nordkirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "An der Post 2",
        "zip": "59394",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181859,
        "identifier": "DE003082",
        "googlePlaceId": "ChIJsfCMOtLdsUcRFJUlnyWJfYI",
        "lat": 53.242979,
        "lng": 10.413942,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lüneburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Willy-Brandt-Straße 10",
        "zip": "21335",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181860,
        "identifier": "DE013031",
        "googlePlaceId": "ChIJzcYza5vbu0cRtWK9kst_W1A",
        "lat": 51.487671,
        "lng": 8.269331,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Warstein",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Fritz-Josephs-Straße 4 a",
        "zip": "59581",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181861,
        "identifier": "DE010051",
        "googlePlaceId": "ChIJzWGUODKrpEcRRn5OZxNtpyo",
        "lat": 50.996087,
        "lng": 9.72292,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rotenburg an der Fulda",
        "province": "Hessen",
        "streetAndNumber": "Borngasse 6",
        "zip": "36199",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181862,
        "identifier": "DE025027",
        "googlePlaceId": "ChIJv78M2c6Vt0cR1UG3U-vrfOE",
        "lat": 52.790438,
        "lng": 7.235197,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Haren (Ems)",
        "province": "Niedersachsen",
        "streetAndNumber": "Lange Straße 73-75",
        "zip": "49733",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181863,
        "identifier": "DE015039",
        "googlePlaceId": "ChIJe8mkzAX4tkcRBwBI-zqeyf4",
        "lat": 53.304234,
        "lng": 7.74639,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Uplengen",
        "province": "Niedersachsen",
        "streetAndNumber": "Ostertorstraße 60",
        "zip": "26670",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181864,
        "identifier": "DE013022",
        "googlePlaceId": "ChIJ3VP6osgluUcR9HwRgWjnyM8",
        "lat": 51.317861,
        "lng": 7.328585,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gevelsberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Haßlinghauser Straße 21",
        "zip": "58285",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181865,
        "identifier": "DE001011",
        "googlePlaceId": "ChIJHSIT6JJcuEcR3tX5-Kvc56c",
        "lat": 51.9526,
        "lng": 7.013116,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gescher",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Fabrikstraße 46",
        "zip": "48712",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181866,
        "identifier": "DE006005",
        "googlePlaceId": "ChIJKzuqaJNysEcRsJPQ_FOpxrM",
        "lat": 52.453002,
        "lng": 9.741088,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Langenhagen",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Pferdemarkt 9 A",
        "zip": "30853",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181867,
        "identifier": "DE021114",
        "googlePlaceId": "ChIJIdIMTWd8pkcR05BvJRV3wVI",
        "lat": 51.479969,
        "lng": 11.895638,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Halle (Saale)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Bennstedter Straße 22",
        "zip": "06126",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181868,
        "identifier": "DE010021",
        "googlePlaceId": "ChIJo7xSbTziukcRAnoFIPaIyT4",
        "lat": 51.673194,
        "lng": 9.373843,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Beverungen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Blankenauer Straße 1a",
        "zip": "37688",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181869,
        "identifier": "DE024067",
        "googlePlaceId": "ChIJUaf5w3pOqEcRSHvnNO8S8j0",
        "lat": 52.527137,
        "lng": 13.458003,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Storkower Straße 176",
        "zip": "10369",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181871,
        "identifier": "DE013043",
        "googlePlaceId": "ChIJP22TjvpfuUcR30S71680_yc",
        "lat": 51.395837,
        "lng": 8.076436,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Arnsberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Zum Schützenhof 51",
        "zip": "59821",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181872,
        "identifier": "DE025054",
        "googlePlaceId": "ChIJS6T85nJpt0cRSeRg__R1KJk",
        "lat": 52.673532,
        "lng": 7.946189,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Quakenbrück",
        "province": "Niedersachsen",
        "streetAndNumber": "Friedrichstraße 24",
        "zip": "49610",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181873,
        "identifier": "DE036011",
        "googlePlaceId": "ChIJ-wJQSPjZCUcRqQN3MtM9ddA",
        "lat": 51.05698,
        "lng": 13.53166,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wilsdruff",
        "province": "Sachsen",
        "streetAndNumber": "Meißner Straße 30b",
        "zip": "01723",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181874,
        "identifier": "DE032021",
        "googlePlaceId": "ChIJKZCmOrIXuUcRp-yxHrKzXn0",
        "lat": 51.493691,
        "lng": 7.55146,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Rodenbergstraße 23",
        "zip": "44287",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181875,
        "identifier": "DE013087",
        "googlePlaceId": "ChIJv-zLyY08uUcRPCemqKu2Wto",
        "lat": 51.377994,
        "lng": 7.47371,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hagen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Boeler Straße 121",
        "zip": "58097",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181876,
        "identifier": "DE004092",
        "googlePlaceId": "ChIJQfJr7--ls0cRkl0zAuf89Bs",
        "lat": 54.295279,
        "lng": 9.707839,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Osterrönfeld",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Kieler Straße 21",
        "zip": "24783",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3181877,
        "identifier": "DE013104",
        "googlePlaceId": "ChIJEyTTz618vEcRbYzWEfNZq3c",
        "lat": 50.859789,
        "lng": 8.696679,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lahntal/Sterzhausen",
        "province": "Hessen",
        "streetAndNumber": "Wittgensteiner Straße 1a",
        "zip": "35094",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181878,
        "identifier": "DE002052",
        "googlePlaceId": "ChIJvwbN9JE3uUcRqM6E8Pq3JB8",
        "lat": 51.258048,
        "lng": 7.579882,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schalksmühle",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hülscheider Straße 31",
        "zip": "58579",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181879,
        "identifier": "DE007030",
        "googlePlaceId": "ChIJ14p7_o4nsUcRLblEr0X6Ep8",
        "lat": 53.068412,
        "lng": 8.865108,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Emil-von-Behring-Straße 4",
        "zip": "28207",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181880,
        "identifier": "DE036115",
        "googlePlaceId": "ChIJ_Zl7Udh-CEcRh9GmA5vzp1o",
        "lat": 51.727121,
        "lng": 14.630345,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Forst (Lausitz)",
        "province": "Brandenburg",
        "streetAndNumber": "Skurumer Straße 2A",
        "zip": "03149",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181881,
        "identifier": "DE032128",
        "googlePlaceId": "ChIJpzzfuPSkuUcRoOy483Gkpg4",
        "lat": 51.904166,
        "lng": 7.653398,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Münster",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bergiusstraße 8",
        "zip": "48165",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181882,
        "identifier": "DE002019",
        "googlePlaceId": "ChIJqToKeg3auEcRuCRqsY2zwG0",
        "lat": 51.312045,
        "lng": 7.067285,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Velbert",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wülfrather Straße 25",
        "zip": "42553",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181884,
        "identifier": "DE032095",
        "googlePlaceId": "ChIJKUPUsrvduEcRYdu7h4CrwLI",
        "lat": 51.441648,
        "lng": 7.087683,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Ruhrau 37",
        "zip": "45279",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181885,
        "identifier": "DE001007",
        "googlePlaceId": "ChIJO824aXD7uEcRwrJYDfNjlAo",
        "lat": 51.667686,
        "lng": 7.166089,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Marl",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bahnhofstraße 119",
        "zip": "45770",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181887,
        "identifier": "DE015035",
        "googlePlaceId": "ChIJu4AGqACyt0cR3vlH3mNF5Og",
        "lat": 53.076393,
        "lng": 7.44496,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Papenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Umländerwiek links 9-10",
        "zip": "26871",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181889,
        "identifier": "DE001087",
        "googlePlaceId": "ChIJc8wau6TEuEcRmCUSRkFns5A",
        "lat": 51.38156,
        "lng": 6.98273,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Ruhrtalstraße 99",
        "zip": "45239",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181890,
        "identifier": "DE015066",
        "googlePlaceId": "ChIJ02OGqa9BtkcRM6IW-8OYiKI",
        "lat": 53.473768,
        "lng": 7.393463,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Südbrookmerland",
        "province": "Niedersachsen",
        "streetAndNumber": "Ekelser Straße 11",
        "zip": "26624",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181891,
        "identifier": "DE032076",
        "googlePlaceId": "ChIJQ9vdTicfuUcRQ63pm0VSBWI",
        "lat": 51.49474,
        "lng": 7.334455,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lütgendortmunder Hellweg 206",
        "zip": "44894",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181893,
        "identifier": "DE010054",
        "googlePlaceId": "ChIJq-u_DAc9u0cROA2-zWWT6pI",
        "lat": 51.42943715,
        "lng": 9.46729454,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Immenhausen",
        "province": "Hessen",
        "streetAndNumber": "Grebensteiner Straße 13",
        "zip": "34376",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181894,
        "identifier": "DE021071",
        "googlePlaceId": "ChIJeSGaOD_2pkcRlFlKYHN8fzQ",
        "lat": 51.354691,
        "lng": 12.29345,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Heinrich-Heine-Straße 39",
        "zip": "04178",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181895,
        "identifier": "DE025057",
        "googlePlaceId": "ChIJy31Uae4yuEcRHgLcKSAsYts",
        "lat": 52.271534,
        "lng": 7.412165,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rheine",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Nienbergstraße 100",
        "zip": "48431",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181896,
        "identifier": "DE016067",
        "googlePlaceId": "ChIJp62nzNAZskcRG8CEYE8MXKA",
        "lat": 53.807156,
        "lng": 10.352118,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Oldesloe",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Helene-Stöcker-Straße 1",
        "zip": "23843",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181897,
        "identifier": "DE024075",
        "googlePlaceId": "ChIJFXBIj5tUqEcRFypgVQLQDBA",
        "lat": 52.610309,
        "lng": 13.318957,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Oraniendamm 46",
        "zip": "13469",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181898,
        "identifier": "DE007093",
        "googlePlaceId": "ChIJBeCjomLNsEcRiP_WC9kO2pE",
        "lat": 52.9057345,
        "lng": 8.5780672,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Harpstedt",
        "province": "Niedersachsen",
        "streetAndNumber": "Wildeshauser Straße 2",
        "zip": "27243",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181899,
        "identifier": "DE031003",
        "googlePlaceId": "ChIJL_i7TmrtpEcRJtPIUYdnNow",
        "lat": 51.23907,
        "lng": 10.456676,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Unstruttal",
        "province": "Thüringen",
        "streetAndNumber": "Am langen Rasen 9",
        "zip": "99974",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181900,
        "identifier": "DE020028",
        "googlePlaceId": "ChIJf6HahKRPqEcRHEpVIFEPeHA",
        "lat": 52.479877,
        "lng": 13.435877,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Karl-Marx-Straße 92-98",
        "zip": "12043",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181901,
        "identifier": "DE003107",
        "googlePlaceId": "ChIJ2fuGYF3YrUcRKgVosoGSCxk",
        "lat": 53.56649,
        "lng": 11.362692,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Pampow",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Ahornstraße 46",
        "zip": "19075",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181902,
        "identifier": "DE003026",
        "googlePlaceId": "ChIJWUaLserrsUcR93q8tK8SeUI",
        "lat": 53.366898,
        "lng": 10.202263,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Winsen (Luhe)",
        "province": "Niedersachsen",
        "streetAndNumber": "Altstadtring 100",
        "zip": "21423",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181903,
        "identifier": "DE025063",
        "googlePlaceId": "ChIJC1V6yglwt0cR50uTYE4ICII",
        "lat": 52.622451,
        "lng": 7.755223,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berge",
        "province": "Niedersachsen",
        "streetAndNumber": "Haupstraße 63",
        "zip": "49626",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181904,
        "identifier": "DE016050",
        "googlePlaceId": "ChIJP7iAHQwQskcRRXhDTh7iois",
        "lat": 53.821634,
        "lng": 10.501599,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Reinfeld",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Barnitzer Straße 1-7",
        "zip": "23858",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181905,
        "identifier": "DE025005",
        "googlePlaceId": "ChIJZV8jhvn1t0cRnxEmjDxzuco",
        "lat": 52.502506,
        "lng": 6.968198,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neuenhaus",
        "province": "Niedersachsen",
        "streetAndNumber": "Veldhausener Straße 59",
        "zip": "49828",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181906,
        "identifier": "DE026002",
        "googlePlaceId": "ChIJW51V-lQEpkcR4GnZmBT73_E",
        "lat": 51.953872,
        "lng": 12.101837,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zerbst (Anhalt)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Rosslauer Straße 29",
        "zip": "39261",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181907,
        "identifier": "DE004098",
        "googlePlaceId": "ChIJ2YaKQNFCs0cRBmvdaRQ_fQc",
        "lat": 54.809499,
        "lng": 9.421344,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Flensburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Apenrader Straße 111",
        "zip": "24939",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181908,
        "identifier": "DE003072",
        "googlePlaceId": "ChIJLZTUf6SRsUcRPpuzockku9c",
        "lat": 53.457832,
        "lng": 9.987031,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Seeveplatz 1",
        "zip": "21073",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181909,
        "identifier": "DE024004",
        "googlePlaceId": "ChIJ05YvROJNqEcRo1DwduaTEeA",
        "lat": 52.541348,
        "lng": 13.437127,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Greifswalder Straße 168",
        "zip": "10409",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181910,
        "identifier": "DE015052",
        "googlePlaceId": "ChIJ1VPMC8LetkcR34qJJEAVm1o",
        "lat": 53.16301,
        "lng": 8.244995,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oldenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Clausewitzstraße 3",
        "zip": "26125",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181912,
        "identifier": "DE020021",
        "googlePlaceId": "ChIJmVKte_pDqEcReDP4W4lgeZw",
        "lat": 52.358535,
        "lng": 13.434488,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Blankenfelde-Mahlow",
        "province": "Brandenburg",
        "streetAndNumber": "Am Lückefeld 88",
        "zip": "15831",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181913,
        "identifier": "DE026013",
        "googlePlaceId": "ChIJcePhlzlHr0cRZJFRMY2RtGA",
        "lat": 52.430267,
        "lng": 11.797088,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Tangerhütte",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Straße der Jugend 19",
        "zip": "39517",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181914,
        "identifier": "DE020119",
        "googlePlaceId": "ChIJT9tljqwACEcRVwGwJ6j4DJM",
        "lat": 51.866797,
        "lng": 13.938206,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübbenau",
        "province": "Brandenburg",
        "streetAndNumber": "Am Kaufland 3",
        "zip": "03222",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181915,
        "identifier": "DE036100",
        "googlePlaceId": "ChIJ9ZJbQFhJp0cRdiISXFpTyAY",
        "lat": 50.718573,
        "lng": 12.884427,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gornsdorf",
        "province": "Sachsen",
        "streetAndNumber": "Meinersdorfer Straße 6",
        "zip": "09390",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181916,
        "identifier": "DE032023",
        "googlePlaceId": "ChIJ7yfeWzoXuUcRY7TrLIAVHZI",
        "lat": 51.515442,
        "lng": 7.500159,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Körner Hellweg 20",
        "zip": "44143",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181917,
        "identifier": "DE026071",
        "googlePlaceId": "ChIJUxm6jqXgpUcRUi0f6rD05oo",
        "lat": 51.780978,
        "lng": 11.753289,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bernburg (Saale)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Zepziger Weg 4",
        "zip": "06406",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181918,
        "identifier": "DE032026",
        "googlePlaceId": "ChIJtXJRxSAZuUcRIGiHlFye5xc",
        "lat": 51.495883,
        "lng": 7.37469,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wulfshofstraße 5",
        "zip": "44149",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181919,
        "identifier": "DE015041",
        "googlePlaceId": "ChIJq6P1XjX-tkcRGAJSrwwWEBE",
        "lat": 53.159987,
        "lng": 7.755923,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Barßel",
        "province": "Niedersachsen",
        "streetAndNumber": "Krumme Kamp 1-11",
        "zip": "26676",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181920,
        "identifier": "DE003058",
        "googlePlaceId": "ChIJP59t3ly9sUcRZdr7kZh5p-I",
        "lat": 53.314853,
        "lng": 9.880094,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Buchholz in der Nordheide",
        "province": "Niedersachsen",
        "streetAndNumber": "Soltauer Straße 85-91",
        "zip": "21244",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181922,
        "identifier": "DE005053",
        "googlePlaceId": "ChIJi6G2mIRMukcRrQAdCrHHpbo",
        "lat": 51.723073,
        "lng": 8.738652,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Paderborn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Rathenaustraße 9",
        "zip": "33102",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181923,
        "identifier": "DE025021",
        "googlePlaceId": "ChIJmSwRcqdQt0cRLkS3_4oRdPM",
        "lat": 52.518786,
        "lng": 8.196021,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Damme",
        "province": "Niedersachsen",
        "streetAndNumber": "Wiesenstraße 5",
        "zip": "49401",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181925,
        "identifier": "DE020068",
        "googlePlaceId": "ChIJ6efPGmL2qEcRuA0ODWTlVs0",
        "lat": 52.425195,
        "lng": 13.053468,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Potsdam",
        "province": "Brandenburg",
        "streetAndNumber": "Georg-Hermann-Allee 145",
        "zip": "14469",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181926,
        "identifier": "DE006159",
        "googlePlaceId": "ChIJEfL8Afl7sEcR-hsPUyFkkig",
        "lat": 52.43005,
        "lng": 9.464286,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wunstorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Nienburger Straße 36",
        "zip": "31515",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181927,
        "identifier": "DE020034",
        "googlePlaceId": "ChIJMcw77ClWqEcR-OMIt3PAFEA",
        "lat": 52.533278,
        "lng": 13.16801,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Brunsbütteler Damm 201-203",
        "zip": "13581",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181928,
        "identifier": "DE016084",
        "googlePlaceId": "ChIJlUtTd7OGsUcRB38CY3mythA",
        "lat": 53.608665,
        "lng": 9.842724,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schenefeld",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Friedrich-Ebert-Allee 21",
        "zip": "22869",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181929,
        "identifier": "DE021027",
        "googlePlaceId": "ChIJ-_Cz8qaJpkcROXzxS0353bQ",
        "lat": 51.360713,
        "lng": 12.020388,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Merseburg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Kollenbeyer Weg 2e",
        "zip": "06217",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181930,
        "identifier": "DE025040",
        "googlePlaceId": "ChIJ-9z67mGRt0cRca2V1UcFDGQ",
        "lat": 52.68208,
        "lng": 7.298508,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Meppen",
        "province": "Niedersachsen",
        "streetAndNumber": "Fürstenbergstraße 15",
        "zip": "49716",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181931,
        "identifier": "DE020112",
        "googlePlaceId": "ChIJYQF3fW5rqEcRvolWU0bbaBo",
        "lat": 52.196654,
        "lng": 13.459291,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zossen",
        "province": "Brandenburg",
        "streetAndNumber": "Straße der Jugend 173",
        "zip": "15806",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181932,
        "identifier": "DE004023",
        "googlePlaceId": "ChIJn4-35KoKs0cRuyGXhCB07C0",
        "lat": 54.412463,
        "lng": 9.521083,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kropp",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Industriestraße 1",
        "zip": "24848",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181933,
        "identifier": "DE004131",
        "googlePlaceId": "ChIJnYwHMJ3Ws0cRDz_5753RaO8",
        "lat": 53.752144,
        "lng": 9.653325,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Elmshorn",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Wedenkamp 9b",
        "zip": "25335",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181934,
        "identifier": "DE020002",
        "googlePlaceId": "ChIJEU4RxJdPqEcRM42_fADSvXU",
        "lat": 52.47406,
        "lng": 13.42742,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Hermannstraße 72",
        "zip": "12049",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181935,
        "identifier": "DE024030",
        "googlePlaceId": "ChIJ0ZoHohExqEcRE0GaM0UeB_Y",
        "lat": 52.468909,
        "lng": 13.79585,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rüdersdorf",
        "province": "Brandenburg",
        "streetAndNumber": "Bergstraße 1",
        "zip": "15562",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181937,
        "identifier": "DE016043",
        "googlePlaceId": "ChIJc1zOmtuJsUcRB0c2trLbaeI",
        "lat": 53.654569,
        "lng": 10.060779,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Johannes-Büll-Weg 1a",
        "zip": "22399",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181938,
        "identifier": "DE036090",
        "googlePlaceId": "ChIJFe5NnOdFp0cR0uCzamRQw1Y",
        "lat": 50.81317,
        "lng": 12.957081,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Chemnitz",
        "province": "Sachsen",
        "streetAndNumber": "Zschopauer Straße 244",
        "zip": "09126",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181940,
        "identifier": "DE036019",
        "googlePlaceId": "ChIJp-KHCE6soEcRv03b7DxTxKQ",
        "lat": 50.564883,
        "lng": 13.011256,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Annaberg-Buchholz",
        "province": "Sachsen",
        "streetAndNumber": "Oberwiesenthaler Weg 6",
        "zip": "09456",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181941,
        "identifier": "DE032063",
        "googlePlaceId": "ChIJHbZBd4sXuUcRFGYNKkjmGjw",
        "lat": 51.470057,
        "lng": 7.461071,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hagener Straße 148",
        "zip": "44225",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181942,
        "identifier": "DE032067",
        "googlePlaceId": "ChIJGd7uBKwXuUcRIrKAwgP_wB0",
        "lat": 51.479735,
        "lng": 7.505579,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Benninghofer Straße 99",
        "zip": "44269",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181943,
        "identifier": "DE032003",
        "googlePlaceId": "ChIJcZDmACHfuEcRqapjReZ5eMM",
        "lat": 51.398112,
        "lng": 7.17084,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hattingen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Eickener Straße 48",
        "zip": "45525",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181944,
        "identifier": "DE021113",
        "googlePlaceId": "ChIJGT7IFTx5pkcRomwYLSJeaNA",
        "lat": 51.526155,
        "lng": 11.825511,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Salzatal",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Straße der Einheit 15",
        "zip": "06198",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181945,
        "identifier": "DE020051",
        "googlePlaceId": "ChIJIX-4bJlaqEcRX6A82MbU-lg",
        "lat": 52.456127,
        "lng": 13.338288,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Bismarckstraße 17",
        "zip": "12169",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181946,
        "identifier": "DE004048",
        "googlePlaceId": "ChIJf1SlIUtts0cRMyr5wxSKVnw",
        "lat": 54.600869,
        "lng": 9.586072,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Böklund",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hans-Christophersen-Allee 2",
        "zip": "24860",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181947,
        "identifier": "DE021034",
        "googlePlaceId": "ChIJAU3dDQD5pkcRwb1Vm0Y5hLE",
        "lat": 51.33259,
        "lng": 12.37874,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Windmühlenstraße 31",
        "zip": "04107",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181948,
        "identifier": "DE013053",
        "googlePlaceId": "ChIJ257uRvJ6uUcRozaeexFpP34",
        "lat": 51.615728,
        "lng": 7.964869,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Welver",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Ladestraße 34",
        "zip": "59514",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181949,
        "identifier": "DE036054",
        "googlePlaceId": "ChIJ-UXVHVxop0cRzeFCIsv6EwA",
        "lat": 50.971025540511,
        "lng": 13.119595624592,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hainichen",
        "province": "Sachsen",
        "streetAndNumber": "Bahnhofstraße 18",
        "zip": "09661",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181950,
        "identifier": "DE036127",
        "googlePlaceId": "ChIJNYSkxzt0CEcR3x9KJ9woOeo",
        "lat": 51.765438,
        "lng": 14.357842,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Cottbus",
        "province": "Brandenburg",
        "streetAndNumber": "Stadtring 8",
        "zip": "03042",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181951,
        "identifier": "DE005015",
        "googlePlaceId": "ChIJX6TIwNY9ukcRdpz3BGT97f0",
        "lat": 52.011479,
        "lng": 8.597985,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Oldentruper Straße 266",
        "zip": "33719",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181952,
        "identifier": "DE006176",
        "googlePlaceId": "ChIJY7ZA5N-DukcRAi3CLLi8wyY",
        "lat": 52.267263,
        "lng": 9.369221,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lauenau",
        "province": "Niedersachsen",
        "streetAndNumber": "Zum Mineralbad 1",
        "zip": "31867",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181953,
        "identifier": "DE004067",
        "googlePlaceId": "ChIJlZ0WrmQGs0cRTdBf-TmTqgM",
        "lat": 54.452681,
        "lng": 9.835538,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eckernförde",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Rendsburger Straße 119",
        "zip": "24340",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181954,
        "identifier": "DE007101",
        "googlePlaceId": "ChIJqYvpfRsrt0cRTqJqq1Jj9FU",
        "lat": 53.036272,
        "lng": 8.542236,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ganderkesee",
        "province": "Niedersachsen",
        "streetAndNumber": "Raiffeisenstraße 1",
        "zip": "27777",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181955,
        "identifier": "DE005126",
        "googlePlaceId": "ChIJESQKzQ8UukcR0Rse_DbEOoA",
        "lat": 52.118584,
        "lng": 8.654789,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herford",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Westring 64",
        "zip": "32051",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181957,
        "identifier": "DE004093",
        "googlePlaceId": "ChIJ1Sr0QwoZs0cRx0_Ky28pzzs",
        "lat": 54.668343,
        "lng": 9.92446,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kappeln",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Mehlbydiek 8",
        "zip": "24376",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181958,
        "identifier": "DE036085",
        "googlePlaceId": "ChIJ549yiH7_CEcR_qr3uZeobD4",
        "lat": 51.171154,
        "lng": 14.436316,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bautzen",
        "province": "Sachsen",
        "streetAndNumber": "Stieberstraße 53",
        "zip": "02625",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181960,
        "identifier": "DE010037",
        "googlePlaceId": "ChIJDZmqyJ-5pEcR8AXxBAZxKzI",
        "lat": 51.183755,
        "lng": 10.063678,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eschwege",
        "province": "Hessen",
        "streetAndNumber": "Dünzebacher Straße 2c",
        "zip": "37269",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181961,
        "identifier": "DE016064",
        "googlePlaceId": "ChIJ84i_5nOLsUcRCxqV5dUtIdw",
        "lat": 53.58434,
        "lng": 10.14232,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Berliner Platz 21",
        "zip": "22045",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181962,
        "identifier": "DE016037",
        "googlePlaceId": "ChIJU_cWAy75rUcRBC-YfZDkJ0s",
        "lat": 53.690729,
        "lng": 10.798659,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ratzeburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Kolberger Straße 2",
        "zip": "23909",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181964,
        "identifier": "DE016060",
        "googlePlaceId": "ChIJs7nMyr_3sUcRvc_z6_Imv1g",
        "lat": 53.605956,
        "lng": 10.2843,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Trittau",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Poststraße 30a",
        "zip": "22946",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181965,
        "identifier": "DE025008",
        "googlePlaceId": "ChIJq9eAgEuGt0cRqkdotsQl6aw",
        "lat": 52.521493,
        "lng": 7.331386,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lingen (Ems)",
        "province": "Niedersachsen",
        "streetAndNumber": "Friedrichstraße 15",
        "zip": "49809",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181966,
        "identifier": "DE013026",
        "googlePlaceId": "ChIJqSVc6hR2uUcRTUD3LsystU0",
        "lat": 51.738853,
        "lng": 7.880833,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ahlen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kleiwellenfeld 27",
        "zip": "59229",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181968,
        "identifier": "DE029085",
        "googlePlaceId": "ChIJu-b_zqfrrUcRgBG8iu-Uvwk",
        "lat": 53.857907,
        "lng": 11.188005,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Grevesmühlen",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Gebhartstraße 4",
        "zip": "23936",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181969,
        "identifier": "DE032025",
        "googlePlaceId": "ChIJNdX7KT4YuUcRYs7-edKIfVI",
        "lat": 51.477839,
        "lng": 7.434369,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Luisenglück 30",
        "zip": "44225",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181970,
        "identifier": "DE032064",
        "googlePlaceId": "ChIJBYuZ1_4MuUcRa3QcpgjHZfs",
        "lat": 51.649106,
        "lng": 7.670361,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bergkamen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Rünther Straße 151",
        "zip": "59192",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3181971,
        "identifier": "DE016013",
        "googlePlaceId": "ChIJS0m6ZQaKsUcRMNi1jARt9kk",
        "lat": 53.652845,
        "lng": 10.110773,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Kunaustraße 1",
        "zip": "22393",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181972,
        "identifier": "DE002014",
        "googlePlaceId": "ChIJe59hgpbUuEcRJsjS9zuuip0",
        "lat": 51.157469,
        "lng": 7.071119,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Solingen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Neuenhofer Straße 99",
        "zip": "42657",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181973,
        "identifier": "DE003021",
        "googlePlaceId": "ChIJY6rW1FrnsUcR1VjXO-b4wtc",
        "lat": 53.29226,
        "lng": 10.427144,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Adendorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Borgwardstraße 1",
        "zip": "21365",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181974,
        "identifier": "DE003084",
        "googlePlaceId": "ChIJCbyUYRuFsUcRimcrMJC1CdI",
        "lat": 53.533711,
        "lng": 9.882111,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Köhlfleet-Hauptdeich 7",
        "zip": "21129",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181975,
        "identifier": "DE036010",
        "googlePlaceId": "ChIJSSeSIJnICUcREXM1HonGB4c",
        "lat": 51.040864,
        "lng": 13.799182,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Glashütter Straße 87",
        "zip": "01277",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181976,
        "identifier": "DE005018",
        "googlePlaceId": "ChIJWbIL889MukcRRHYdaU7q6dc",
        "lat": 51.70338,
        "lng": 8.769811,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Paderborn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Pohlweg 110",
        "zip": "33100",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181977,
        "identifier": "DE003007",
        "googlePlaceId": "ChIJY81bpBtOrkcRkrHKJvfggCY",
        "lat": 52.967337996869,
        "lng": 11.146716376345,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lüchow",
        "province": "Niedersachsen",
        "streetAndNumber": "Dannenberger Straße 30",
        "zip": "29439",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181978,
        "identifier": "DE004087",
        "googlePlaceId": "ChIJQ_4IYbx_s0cREGj5TFwkpwU",
        "lat": 54.469522,
        "lng": 9.089632,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Husum",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Ostenfelder Straße 70",
        "zip": "25813",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181979,
        "identifier": "DE005131",
        "googlePlaceId": "ChIJJdBpzeQRukcR9_2490Fgv0M",
        "lat": 52.207322,
        "lng": 8.652841,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kirchlengern",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "In der Mark 90",
        "zip": "32278",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181981,
        "identifier": "DE003074",
        "googlePlaceId": "ChIJKXo6aa6isUcRZ7yusSMDD3U",
        "lat": 53.321523,
        "lng": 9.846533,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Buchholz in der Nordheide",
        "province": "Niedersachsen",
        "streetAndNumber": "Sprötzer Weg 31a",
        "zip": "21244",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181982,
        "identifier": "DE001091",
        "googlePlaceId": "ChIJa3bchlxguEcRRsNoo1XGZws",
        "lat": 51.855368,
        "lng": 6.871132,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Borken",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Otto-Hahn-Straße 18",
        "zip": "46325",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181983,
        "identifier": "DE032124",
        "googlePlaceId": "ChIJv8ljafe6uUcRLR9W407zPEo",
        "lat": 51.985639,
        "lng": 7.63293,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Münster",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Nevinghoff 12-16",
        "zip": "48147",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181984,
        "identifier": "DE029051",
        "googlePlaceId": "ChIJCdjo3DJXrEcR74MSaggvfU4",
        "lat": 54.089274,
        "lng": 12.097332,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rostock",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Hans-Sachs-Allee 13a",
        "zip": "18057",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181985,
        "identifier": "DE015043",
        "googlePlaceId": "ChIJhRnMfEXQtkcRnljAI4_AweU",
        "lat": 53.234114,
        "lng": 8.454238,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Elsfleth",
        "province": "Niedersachsen",
        "streetAndNumber": "Oberrege 12b",
        "zip": "26931",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181986,
        "identifier": "DE025055",
        "googlePlaceId": "ChIJxYErANQhuEcRXW1c300Xxao",
        "lat": 52.444488,
        "lng": 7.06043,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nordhorn",
        "province": "Niedersachsen",
        "streetAndNumber": "Kistemakerstraße 2-8",
        "zip": "48529",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181987,
        "identifier": "DE002079",
        "googlePlaceId": "ChIJSZgVBcDWuEcR4rcd9pteIGU",
        "lat": 51.237841,
        "lng": 7.098179,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Rutenbecker Weg 3",
        "zip": "42327",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181988,
        "identifier": "DE016066",
        "googlePlaceId": "ChIJU-BwkVOKsUcRWR6u8HoWenQ",
        "lat": 53.615926,
        "lng": 10.136339,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Bekassinenau 86",
        "zip": "22147",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181989,
        "identifier": "DE010104",
        "googlePlaceId": "ChIJ68n9XNW5ukcR9QSLxtazdUs",
        "lat": 51.993065,
        "lng": 9.844993,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Alfeld",
        "province": "Niedersachsen",
        "streetAndNumber": "August-Wegener-Straße 13",
        "zip": "31061",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181990,
        "identifier": "DE032052",
        "googlePlaceId": "ChIJhdUIMVobuUcRGcequ9Mog88",
        "lat": 51.607168,
        "lng": 7.392547,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Waltrop",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Zum Schacht 1",
        "zip": "45731",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181991,
        "identifier": "DE001080",
        "googlePlaceId": "ChIJLwtaFhjCuEcRh6DmdascFmg",
        "lat": 51.45903,
        "lng": 6.925505,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Aktienstraße 42",
        "zip": "45359",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181993,
        "identifier": "DE013025",
        "googlePlaceId": "ChIJSRHPfSlkuUcRPvauNQETJD4",
        "lat": 51.500922,
        "lng": 7.960231,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ense",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "An der Windmühle 2",
        "zip": "59469",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181994,
        "identifier": "DE003093",
        "googlePlaceId": "ChIJtxlQPjVyrkcRUg4_60EfkOE",
        "lat": 53.428421,
        "lng": 11.199528,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hagenow",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Rudolf-Tarnow-Straße 77",
        "zip": "19230",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181996,
        "identifier": "DE025108",
        "googlePlaceId": "ChIJpWK6-6IFukcRAHG36fr0MWM",
        "lat": 52.30427,
        "lng": 8.498176,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Preußisch Oldendorf",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Mindener Straße 24",
        "zip": "32361",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181997,
        "identifier": "DE016002",
        "googlePlaceId": "ChIJW6EQuWuPsUcRCerKQehiKvw",
        "lat": 53.556309,
        "lng": 9.967256,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Neuer Kamp 31",
        "zip": "20359",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3181999,
        "identifier": "DE002069",
        "googlePlaceId": "ChIJ4dxlR7TXuEcRbX1EN2YGRrU",
        "lat": 51.260023,
        "lng": 7.144788,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Klotzbahn 5",
        "zip": "42105",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182000,
        "identifier": "DE036118",
        "googlePlaceId": "ChIJwwAhOxV0CEcRYBnNnNKJ3Wg",
        "lat": 51.75826,
        "lng": 14.346123,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Cottbus",
        "province": "Brandenburg",
        "streetAndNumber": "Georg-Schlesinger-Straße 3",
        "zip": "03042",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182001,
        "identifier": "DE006133",
        "googlePlaceId": "ChIJtWM2LF9fpUcRY7oLkpvdx4c",
        "lat": 52.23016,
        "lng": 10.53453,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Braunschweig",
        "province": "Niedersachsen",
        "streetAndNumber": "Jenastieg 16",
        "zip": "38124",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182002,
        "identifier": "DE013032",
        "googlePlaceId": "ChIJYd_HNiTEu0cRZtnBY5nWrXE",
        "lat": 51.494708,
        "lng": 8.434479,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rüthen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lippstädter Straße 1-3",
        "zip": "59602",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182003,
        "identifier": "DE007083",
        "googlePlaceId": "ChIJHfll73fTtkcR6RoTqSumuOc",
        "lat": 53.180113,
        "lng": 8.568936,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Weserstrandstraße 17",
        "zip": "28779",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182004,
        "identifier": "DE016121",
        "googlePlaceId": "ChIJEfcWDzYLskcRrc34aDYiGPo",
        "lat": 53.948046,
        "lng": 10.734654,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ratekau",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Rosenstraße 1",
        "zip": "23626",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182005,
        "identifier": "DE024064",
        "googlePlaceId": "ChIJbwV3aA5SqEcRfMj1E2O2llI",
        "lat": 52.557344,
        "lng": 13.411866,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Esplanade 9",
        "zip": "13187",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182006,
        "identifier": "DE015080",
        "googlePlaceId": "ChIJVbVZs2hOtkcR0xgbQwZzgI0",
        "lat": 53.259896,
        "lng": 7.454305,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leer (Ostfriesland)",
        "province": "Niedersachsen",
        "streetAndNumber": "Nüttermoorer Straße 4",
        "zip": "26789",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182008,
        "identifier": "DE021036",
        "googlePlaceId": "ChIJ-2JlQhNWpkcRa5q9jogiezw",
        "lat": 51.375671,
        "lng": 12.481517,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Taucha",
        "province": "Sachsen",
        "streetAndNumber": "Leipziger Straße 104",
        "zip": "04425",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182009,
        "identifier": "DE003022",
        "googlePlaceId": "ChIJ995ZBHKUsUcR-AQoIRa1DXk",
        "lat": 53.391572,
        "lng": 10.037662,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Seevetal",
        "province": "Niedersachsen",
        "streetAndNumber": "Eichenallee 1B",
        "zip": "21220",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182010,
        "identifier": "DE010075",
        "googlePlaceId": "ChIJER_CZ_C-pEcRomcpZn-xGWA",
        "lat": 51.187496,
        "lng": 10.167056,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wanfried",
        "province": "Hessen",
        "streetAndNumber": "In der Werraaue 1",
        "zip": "37281",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182011,
        "identifier": "DE005070",
        "googlePlaceId": "ChIJNyT4Ak84ukcRNY2pesUK2t8",
        "lat": 51.903836,
        "lng": 8.637426,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schloß Holte-Stukenbrock",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Holter Straße 137-147",
        "zip": "33758",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182012,
        "identifier": "DE010063",
        "googlePlaceId": "ChIJg7LcDngUu0cRYpoiKJizKcQ",
        "lat": 51.367058,
        "lng": 9.290698,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zierenberg",
        "province": "Hessen",
        "streetAndNumber": "Vor Brakens Höhe 2",
        "zip": "34289",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182013,
        "identifier": "DE013036",
        "googlePlaceId": "ChIJHTBICvxAuUcRzL7DvmoOsL4",
        "lat": 51.382479,
        "lng": 7.695056,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Iserlohn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Baarstraße 47-49",
        "zip": "58636",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182014,
        "identifier": "DE024115",
        "googlePlaceId": "ChIJAY6ObzY5qEcRQ-lQp9GCkPM",
        "lat": 52.414113,
        "lng": 13.657896,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Müggelheimer Damm 244/252",
        "zip": "12559",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182015,
        "identifier": "DE010046",
        "googlePlaceId": "ChIJp2uknVDLpEcRhjEaqGXlFls",
        "lat": 51.345629,
        "lng": 9.856102,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Witzenhausen",
        "province": "Hessen",
        "streetAndNumber": "An der Bohlenbrücke 4",
        "zip": "37213",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182017,
        "identifier": "DE003078",
        "googlePlaceId": "ChIJlUrOg4OcsUcRt5YQoAeJ4ZA",
        "lat": 53.47491,
        "lng": 9.785994,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neu Wulmstorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Wulmstorfer Wiesen 4",
        "zip": "21629",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182018,
        "identifier": "DE003045",
        "googlePlaceId": "ChIJ0YOZISBKsUcRvqDCvd7ffEc",
        "lat": 53.433205,
        "lng": 8.823739,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Beverstedt",
        "province": "Niedersachsen",
        "streetAndNumber": "Logestraße 34",
        "zip": "27616",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182020,
        "identifier": "DE024074",
        "googlePlaceId": "ChIJg-p7FcdUqEcR4soTY4PaWwc",
        "lat": 52.626777,
        "lng": 13.301789,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Am Pfingstberg 25",
        "zip": "13465",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182022,
        "identifier": "DE005030",
        "googlePlaceId": "ChIJhb0sMrPzuUcRxwMK8N8jAuY",
        "lat": 52.137559,
        "lng": 8.138049,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hilter",
        "province": "Niedersachsen",
        "streetAndNumber": "Münsterstraße 32",
        "zip": "49176",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182023,
        "identifier": "DE036048",
        "googlePlaceId": "ChIJPVTamY3PCUcRMucWxCi5evQ",
        "lat": 51.057018,
        "lng": 13.687885,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Raimundstraße 1-3",
        "zip": "01157",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182024,
        "identifier": "DE021086",
        "googlePlaceId": "ChIJKVk2X-T2pkcRMI98YON9V5M",
        "lat": 51.320576,
        "lng": 12.289597,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Ludwigsburger Straße 9",
        "zip": "04209",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182025,
        "identifier": "DE016091",
        "googlePlaceId": "ChIJ__4yjgKJsUcRxvfkIVW4U_o",
        "lat": 53.612244,
        "lng": 10.024372,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Alsterdorfer Markt 4",
        "zip": "22297",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182027,
        "identifier": "DE029076",
        "googlePlaceId": "ChIJc5RXxVFaqUcR9UcWDlwuUaA",
        "lat": 53.274018,
        "lng": 12.823496,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Mirow",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Wesenberger Chaussee 2",
        "zip": "17252",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182028,
        "identifier": "DE005005",
        "googlePlaceId": "ChIJTReSlsQhukcRgptDaFfRKT8",
        "lat": 52.052845,
        "lng": 8.356118,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Halle (Westfalen)",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Künsebecker Weg 1",
        "zip": "33790",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182029,
        "identifier": "DE029026",
        "googlePlaceId": "ChIJaQynKjMLq0cRWUzsIGSp2bw",
        "lat": 54.091759,
        "lng": 13.427154,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Greifswald",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Fridtjof-Nansen-Straße 27",
        "zip": "17493",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182030,
        "identifier": "DE036112",
        "googlePlaceId": "ChIJwxKhymQ2p0cRK1ESthATXZo",
        "lat": 50.743434,
        "lng": 12.74908,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lugau",
        "province": "Sachsen",
        "streetAndNumber": "Chemnitzer Straße 1",
        "zip": "09385",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182031,
        "identifier": "DE010091",
        "googlePlaceId": "ChIJWT4KVaqMvEcR3F3NBHY6n8g",
        "lat": 50.679113,
        "lng": 8.848855,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rabenau",
        "province": "Hessen",
        "streetAndNumber": "An der Mühle 9",
        "zip": "35466",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182032,
        "identifier": "DE020064",
        "googlePlaceId": "ChIJe2N6ttD6qEcRCQ_XoNtGGA4",
        "lat": 52.54616,
        "lng": 12.939378,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wustermark",
        "province": "Brandenburg",
        "streetAndNumber": "Am Markt 3",
        "zip": "14641",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182033,
        "identifier": "DE003106",
        "googlePlaceId": "ChIJzd0zq9LUrUcRprZZfooGyQ8",
        "lat": 53.570592,
        "lng": 11.659999,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Crivitz",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Parchimer Straße 64",
        "zip": "19089",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182034,
        "identifier": "DE015078",
        "googlePlaceId": "ChIJU92caJi2tkcR0pplUzLTM14",
        "lat": 53.492303,
        "lng": 8.596046,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremerhaven",
        "province": "Bremen",
        "streetAndNumber": "Bohmsiel 12",
        "zip": "27572",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182035,
        "identifier": "DE010032",
        "googlePlaceId": "ChIJsaGuOaMnpUcRuc_yIP99QiE",
        "lat": 51.602884,
        "lng": 10.20558,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gieboldehausen",
        "province": "Niedersachsen",
        "streetAndNumber": "Ludwig-Erhard-Straße 2",
        "zip": "37434",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182036,
        "identifier": "DE016005",
        "googlePlaceId": "ChIJFc2WQlWPsUcRyjqa7nud0wE",
        "lat": 53.582428,
        "lng": 9.952869,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Eidelstedter Weg 44",
        "zip": "20255",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182037,
        "identifier": "DE024097",
        "googlePlaceId": "ChIJeYA0blhOqEcRbnem2s3Bb54",
        "lat": 52.50561,
        "lng": 13.459263,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Revaler Straße 33",
        "zip": "10245",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182038,
        "identifier": "DE025079",
        "googlePlaceId": "ChIJ6x8BYGTHuUcRJmEEjtRsTYI",
        "lat": 52.136883,
        "lng": 7.737381,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ladbergen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Tecklenburger Straße 2",
        "zip": "49549",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182039,
        "identifier": "DE029046",
        "googlePlaceId": "ChIJrbUuFh8Cq0cRkZ8jYRWTrGg",
        "lat": 54.071317,
        "lng": 13.909724,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zinnowitz",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Möskenweg 24B",
        "zip": "17454",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182040,
        "identifier": "DE003064",
        "googlePlaceId": "ChIJrxflz8TysUcRkHny3z7kwlk",
        "lat": 53.50871,
        "lng": 10.184789,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Weberade 21-23",
        "zip": "21031",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182041,
        "identifier": "DE025056",
        "googlePlaceId": "ChIJRSlri67WuUcRQqcoGo7K9Ig",
        "lat": 52.379516,
        "lng": 7.602562,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hopsten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bunte Straße 30",
        "zip": "48496",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182042,
        "identifier": "DE004105",
        "googlePlaceId": "ChIJDZ-XVWhWskcR2dwtbNtK8O8",
        "lat": 54.32931,
        "lng": 10.13367,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Preusserstraße 1-9",
        "zip": "24105",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182043,
        "identifier": "DE006175",
        "googlePlaceId": "ChIJD_eTNCuFukcRz-xCwOMmjJo",
        "lat": 52.196828,
        "lng": 9.448918,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Münder",
        "province": "Niedersachsen",
        "streetAndNumber": "Rahlmühler Straße 50",
        "zip": "31848",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182044,
        "identifier": "DE015068",
        "googlePlaceId": "ChIJ4bBm4wFDtkcRLBAQu_ya1og",
        "lat": 53.45811,
        "lng": 7.49874,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Aurich",
        "province": "Niedersachsen",
        "streetAndNumber": "Raiffeisenstraße 17",
        "zip": "26603",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182045,
        "identifier": "DE026012",
        "googlePlaceId": "ChIJNUhGW5imr0cRfk9_2TDIrpE",
        "lat": 52.629364,
        "lng": 11.155817,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Klötze",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Poppauer Straße 1",
        "zip": "38486",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182047,
        "identifier": "DE026019",
        "googlePlaceId": "ChIJsV56-uDrrkcR4Ep0ZDun1kw",
        "lat": 53.064215,
        "lng": 11.837759,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Perleberg",
        "province": "Brandenburg",
        "streetAndNumber": "Schwarzer Weg 9",
        "zip": "19348",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182048,
        "identifier": "DE036057",
        "googlePlaceId": "ChIJQQ57sjjGCUcRTkKXS8VriD0",
        "lat": 51.014734,
        "lng": 13.7893,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Reicker Straße 97",
        "zip": "01237",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182049,
        "identifier": "DE003103",
        "googlePlaceId": "ChIJDZLBxGUmsUcRLupoEBvfLq0",
        "lat": 53.128922,
        "lng": 8.896714,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Hamfhofsweg 59",
        "zip": "28357",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182050,
        "identifier": "DE032090",
        "googlePlaceId": "ChIJt51HECLeuEcRJrUrhQcEhdg",
        "lat": 51.459175,
        "lng": 7.157443,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Höntroper Straße 67",
        "zip": "44869",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182052,
        "identifier": "DE026024",
        "googlePlaceId": "ChIJURVeQpKHrkcRYa8ZJZDshPY",
        "lat": 53.3717,
        "lng": 11.59277,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neustadt-Glewe",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Laascher Straße 30b",
        "zip": "19306",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182053,
        "identifier": "DE029070",
        "googlePlaceId": "ChIJZ0i9IPwCrEcRnit-G-vCoPI",
        "lat": 53.479485,
        "lng": 12.423121,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Malchow",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Friedrich-Ebert-Straße 6",
        "zip": "17213",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182054,
        "identifier": "DE004066",
        "googlePlaceId": "ChIJ4-7amiFUskcRx-eGSnsU11k",
        "lat": 54.300211,
        "lng": 10.088087,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Rendsburger Landstraße 240",
        "zip": "24113",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182055,
        "identifier": "DE006087",
        "googlePlaceId": "ChIJsQprFdDor0cRdI9zn_5BvJY",
        "lat": 52.499172,
        "lng": 10.544527,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gifhorn",
        "province": "Niedersachsen",
        "streetAndNumber": "Hamburger Straße 71",
        "zip": "38518",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182056,
        "identifier": "DE026081",
        "googlePlaceId": "ChIJm9obkkOwpUcRGpwOfRF2jbE",
        "lat": 51.635693,
        "lng": 11.130109,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Harzgerode",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Stolberger Straße 25 A",
        "zip": "06493",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182057,
        "identifier": "DE020095",
        "googlePlaceId": "ChIJawWSnUpEqEcRcGEyX0duWck",
        "lat": 52.408911,
        "lng": 13.44112,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schönefeld",
        "province": "Brandenburg",
        "streetAndNumber": "Karl-Marx-Straße 36",
        "zip": "12529",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182058,
        "identifier": "DE025058",
        "googlePlaceId": "ChIJkdEY172Ht0cRgS84KCEihgs",
        "lat": 52.507249,
        "lng": 7.323208,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lingen (Ems)",
        "province": "Niedersachsen",
        "streetAndNumber": "Rheiner Straße 110",
        "zip": "49809",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182059,
        "identifier": "DE005085",
        "googlePlaceId": "ChIJMTYs-rXtuUcRgE3cJ9bwpTs",
        "lat": 52.150182,
        "lng": 8.036519,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Iburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Fuchsbreite 19-23",
        "zip": "49186",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182060,
        "identifier": "DE007082",
        "googlePlaceId": "ChIJKXSwEnAssUcR7vfoHsajIwE",
        "lat": 53.169244344177,
        "lng": 8.6982817131571,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Hindenburgstraße 13",
        "zip": "28717",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182061,
        "identifier": "DE029090",
        "googlePlaceId": "ChIJ3QaU9NSxrUcRbF_LJuUeXX8",
        "lat": 54.036425,
        "lng": 11.68111,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neubukow",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Am Stellwerk 13",
        "zip": "18233",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182062,
        "identifier": "DE024084",
        "googlePlaceId": "ChIJo4N26iFSqEcRQG4-7xfq-Uw",
        "lat": 52.549671,
        "lng": 13.387637,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Badstraße 4",
        "zip": "13357",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182063,
        "identifier": "DE001041",
        "googlePlaceId": "ChIJ59lKQnbjuEcRORu0L1ZJ330",
        "lat": 51.591401,
        "lng": 7.180261,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Recklinghausen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Friedrich-Ebert-Straße 106",
        "zip": "45659",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182064,
        "identifier": "DE003049",
        "googlePlaceId": "ChIJT5QMarNksUcRdvj1uUkfILo",
        "lat": 53.611116,
        "lng": 9.480778,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stade",
        "province": "Niedersachsen",
        "streetAndNumber": "Freiburger Straße 80",
        "zip": "21682",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182065,
        "identifier": "DE015018",
        "googlePlaceId": "ChIJlc1jDMqTtkcRKirzz9NmY6Y",
        "lat": 53.528255,
        "lng": 8.09897,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wilhelmshaven",
        "province": "Niedersachsen",
        "streetAndNumber": "Werftstraße 161",
        "zip": "26382",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182066,
        "identifier": "DE007060",
        "googlePlaceId": "ChIJPXg3G0o3t0cRKA7aKKY9AT0",
        "lat": 52.835939,
        "lng": 8.317367,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Visbek",
        "province": "Niedersachsen",
        "streetAndNumber": "Rechterfelder Straße 30",
        "zip": "49429",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182067,
        "identifier": "DE002067",
        "googlePlaceId": "ChIJLRjl_9nXuEcRGOG-wKvYMiI",
        "lat": 51.264194,
        "lng": 7.178823,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Friedrich-Engels-Allee 257",
        "zip": "42285",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182068,
        "identifier": "DE036018",
        "googlePlaceId": "ChIJfcoqjVRUp0cR5-DgLAcF7Ls",
        "lat": 50.647712,
        "lng": 13.157477,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Marienberg",
        "province": "Sachsen",
        "streetAndNumber": "Johann-Ehrenfried-Wagner-Straße 9",
        "zip": "09496",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182069,
        "identifier": "DE015055",
        "googlePlaceId": "ChIJ7aBKC3kVtkcR7dRzbksv6cE",
        "lat": 53.522752,
        "lng": 7.284271,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Marienhafe",
        "province": "Niedersachsen",
        "streetAndNumber": "Mühlenloog 1",
        "zip": "26529",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182070,
        "identifier": "DE001086",
        "googlePlaceId": "ChIJc7r_-XvduEcRsodZjSVjaBY",
        "lat": 51.445415,
        "lng": 7.057282,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Steeler Straße 466",
        "zip": "45138",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182071,
        "identifier": "DE015060",
        "googlePlaceId": "ChIJRVD96YZbtkcR8-odNY643eo",
        "lat": 53.405108,
        "lng": 7.603126,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Großefehn",
        "province": "Niedersachsen",
        "streetAndNumber": "Müllers Kamp 21-23",
        "zip": "26629",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182072,
        "identifier": "DE001084",
        "googlePlaceId": "ChIJb15iVVHEuEcR8KLKj0G-4vk",
        "lat": 51.357542,
        "lng": 6.93497,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Montebruchstraße 19",
        "zip": "45219",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182073,
        "identifier": "DE020057",
        "googlePlaceId": "ChIJ5w16EHhdqEcRxfB8W84ZO3w",
        "lat": 52.311062,
        "lng": 13.243906,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ludwigsfelde",
        "province": "Brandenburg",
        "streetAndNumber": "Brandenburgische Straße 1",
        "zip": "14974",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182074,
        "identifier": "DE026020",
        "googlePlaceId": "ChIJRebgsqaDr0cRX9UmRgbFuM8",
        "lat": 52.309104,
        "lng": 11.050582,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Weferlingen",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Wilhelm-Suder-Straße 1",
        "zip": "39356",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182075,
        "identifier": "DE006086",
        "googlePlaceId": "ChIJv54ai60NsEcRi-f7o80gneI",
        "lat": 52.425252,
        "lng": 9.841829,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Isernhagen",
        "province": "Niedersachsen",
        "streetAndNumber": "Krendelstraße 4",
        "zip": "30916",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182076,
        "identifier": "DE004149",
        "googlePlaceId": "ChIJ7TUOJys5skcRXquWqbybucU",
        "lat": 53.954474,
        "lng": 10.210199,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wahlstedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Neumünsterstraße 6c",
        "zip": "23812",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182077,
        "identifier": "DE007058",
        "googlePlaceId": "ChIJcxiE8RLVsEcR7doOPbn6o94",
        "lat": 53.055538,
        "lng": 8.630629,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Delmenhorst",
        "province": "Niedersachsen",
        "streetAndNumber": "Weberstraße 7",
        "zip": "27753",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182078,
        "identifier": "DE025009",
        "googlePlaceId": "ChIJd9bYBKuHt0cR2J2kiICyYiY",
        "lat": 52.515658,
        "lng": 7.34631,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lingen",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Laxtener Esch 7",
        "zip": "49811",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182079,
        "identifier": "DE005120",
        "googlePlaceId": "ChIJmwKiyRJhukcRM8b1oh2-hk4",
        "lat": 52.070752,
        "lng": 9.116552,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Extertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bruchweg 3b",
        "zip": "32699",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182080,
        "identifier": "DE029027",
        "googlePlaceId": "ChIJ10tOG4_Eq0cRGQWT2Ee3LwY",
        "lat": 53.553504,
        "lng": 13.307962,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neubrandenburg",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Markscheiderweg 1a",
        "zip": "17036",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182081,
        "identifier": "DE036125",
        "googlePlaceId": "ChIJs_4hcmJ0CEcRwEG3dVUGzfo",
        "lat": 51.75671,
        "lng": 14.31299,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Cottbus",
        "province": "Brandenburg",
        "streetAndNumber": "Karl-Liebknecht-Straße 81",
        "zip": "03046",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182082,
        "identifier": "DE007051",
        "googlePlaceId": "ChIJ97quqAoesUcRU6ykejHbcxo",
        "lat": 53.06033,
        "lng": 9.168354,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ottersberg",
        "province": "Niedersachsen",
        "streetAndNumber": "Posthausen 1",
        "zip": "28870",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182083,
        "identifier": "DE010020",
        "googlePlaceId": "ChIJb-UirFRDu0cR8V9CkxNQWrY",
        "lat": 51.134061,
        "lng": 9.427966,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Felsberg",
        "province": "Hessen",
        "streetAndNumber": "Zum Haintor 3",
        "zip": "34587",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182084,
        "identifier": "DE004007",
        "googlePlaceId": "ChIJHy4jBB82skcR6z-SOlE0A1o",
        "lat": 54.01307,
        "lng": 10.015072,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Boostedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Neumünsterstraße 49b",
        "zip": "24598",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182085,
        "identifier": "DE036123",
        "googlePlaceId": "ChIJD5XCwAEWCEcRi3hpo4rSJ5Q",
        "lat": 51.523165,
        "lng": 14.002844,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Senftenberg",
        "province": "Brandenburg",
        "streetAndNumber": "Bahnhofstraße 38",
        "zip": "01968",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182086,
        "identifier": "DE006055",
        "googlePlaceId": "ChIJJft_imULsEcR-oDgsafhvZc",
        "lat": 52.372141,
        "lng": 9.78909,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Kirchröder Straße 91-92",
        "zip": "30625",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182087,
        "identifier": "DE015045",
        "googlePlaceId": "ChIJj3ePWBAht0cRmx_i2y6bNsg",
        "lat": 53.052051,
        "lng": 8.200602,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wardenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Rheinstraße 6",
        "zip": "26203",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182088,
        "identifier": "DE004075",
        "googlePlaceId": "ChIJi8wb0ONNskcRDZi4iiu0K9Y",
        "lat": 54.178594,
        "lng": 10.045058,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bordesholm",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Mühlenstraße 12",
        "zip": "24582",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182089,
        "identifier": "DE031035",
        "googlePlaceId": "ChIJk25lowKbo0cRly8v1tp3b-E",
        "lat": 50.643695,
        "lng": 10.689453,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zella-Mehlis",
        "province": "Thüringen",
        "streetAndNumber": "Industriestraße 4-6",
        "zip": "98544",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182090,
        "identifier": "DE032093",
        "googlePlaceId": "ChIJubxOqOHcuEcRkpfguEmV8W8",
        "lat": 51.427428,
        "lng": 7.04421,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Eisenbahnstraße 20",
        "zip": "45134",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182091,
        "identifier": "DE024048",
        "googlePlaceId": "ChIJ40higm6qqUcRUgl4GU0FXjc",
        "lat": 52.705367,
        "lng": 13.268622,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Borgsdorf",
        "province": "Brandenburg",
        "streetAndNumber": "Berliner Chaussee 7",
        "zip": "16556",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182092,
        "identifier": "DE006075",
        "googlePlaceId": "ChIJmVz61TMLsEcRJw6PHY-XSkw",
        "lat": 52.356771,
        "lng": 9.752134,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Mozartstraße 14-16",
        "zip": "30173",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182094,
        "identifier": "DE013071",
        "googlePlaceId": "ChIJlZN2sX5luUcR4b20cGCOhr8",
        "lat": 51.547415,
        "lng": 7.917659,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Werl",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wulf-Hefe-Straße 2",
        "zip": "59457",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182095,
        "identifier": "DE024053",
        "googlePlaceId": "ChIJrzhg285RqEcRCrcEtu4XG5I",
        "lat": 52.51016,
        "lng": 13.379717,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Leipziger Platz 12",
        "zip": "10117",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182096,
        "identifier": "DE031060",
        "googlePlaceId": "ChIJ34ePJAZko0cRNGqMHGu8RfU",
        "lat": 50.810184,
        "lng": 10.221849,
        "name": "ALDI",
        "country": "DE",
        "city": "Bad Salzungen",
        "province": "Thüringen",
        "streetAndNumber": "Clara-Zetkin-Straße 9",
        "zip": "36433",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182097,
        "identifier": "DE004030",
        "googlePlaceId": "ChIJHY8WdLhbskcRj1yrjj3Pszs",
        "lat": 54.236789,
        "lng": 10.274548,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Preetz",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hufenweg 24",
        "zip": "24211",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182098,
        "identifier": "DE025105",
        "googlePlaceId": "ChIJlbOvuDoQukcRdfb3IzMjn1w",
        "lat": 52.207753,
        "lng": 8.593983,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bünde",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Dünner Straße 4",
        "zip": "32257",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182100,
        "identifier": "DE003019",
        "googlePlaceId": "ChIJ-T7FB2ZxsUcRnM42MYyXch0",
        "lat": 53.455944,
        "lng": 9.512957,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Harsefeld",
        "province": "Niedersachsen",
        "streetAndNumber": "Paschberg 22",
        "zip": "21698",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182101,
        "identifier": "DE016100",
        "googlePlaceId": "ChIJacls6nKPsUcR6kYEYnQSiXQ",
        "lat": 53.547702,
        "lng": 9.966112,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Zirkusweg 4-6",
        "zip": "20359",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182102,
        "identifier": "DE006046",
        "googlePlaceId": "ChIJaZCcv9cMsEcRSLN1mOtItJE",
        "lat": 52.425328,
        "lng": 9.781601,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Zur Stadtgärtnerei 1",
        "zip": "30657",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182103,
        "identifier": "DE036075",
        "googlePlaceId": "ChIJG2Qzn5XeCEcRzk24Aye8OXU",
        "lat": 50.839344269955,
        "lng": 12.929754042509,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Chemnitz",
        "province": "Sachsen",
        "streetAndNumber": "Dr.-Frieda-Freise Str. 3",
        "zip": "09111",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182104,
        "identifier": "DE021064",
        "googlePlaceId": "ChIJR1TNpyh-skcRRlhRY8DNc7Q",
        "lat": 51.30070313,
        "lng": 13.09290387,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oschatz",
        "province": "Sachsen",
        "streetAndNumber": "Filderstädter Straße 5 a",
        "zip": "04758",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182106,
        "identifier": "DE006107",
        "googlePlaceId": "ChIJEfBnKravukcRvvF58vwT0Xo",
        "lat": 52.133857,
        "lng": 9.943549,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hildesheim",
        "province": "Niedersachsen",
        "streetAndNumber": "Theodor-Storm-Str. 20",
        "zip": "31139",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182107,
        "identifier": "DE024041",
        "googlePlaceId": "ChIJyVd42fVMqEcRbUw3QUpnzHA",
        "lat": 52.575325,
        "lng": 13.519573,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Dorfstraße 22",
        "zip": "13059",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182108,
        "identifier": "DE010004",
        "googlePlaceId": "ChIJkRIAlbIqu0cRH79Pje4k87A",
        "lat": 51.589658,
        "lng": 9.927583,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bovenden",
        "province": "Niedersachsen",
        "streetAndNumber": "Göttinger Straße 23",
        "zip": "37120",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182109,
        "identifier": "DE036094",
        "googlePlaceId": "ChIJk02uxrDLoEcRMTWBv-_CRXo",
        "lat": 50.594051,
        "lng": 12.700538,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Aue-Bad Schlema",
        "province": "Sachsen",
        "streetAndNumber": "Lössnitzer Straße 20-22",
        "zip": "08280",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182110,
        "identifier": "DE010042",
        "googlePlaceId": "ChIJg12Xc33UpEcRwIoEx7mtMVQ",
        "lat": 51.521772,
        "lng": 9.962653,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Göttingen",
        "province": "Niedersachsen",
        "streetAndNumber": "Alfred-Delp-Weg 5",
        "zip": "37085",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182111,
        "identifier": "DE016099",
        "googlePlaceId": "ChIJGfebQjaEsUcRMtoRmL2jnOg",
        "lat": 53.56935,
        "lng": 9.877626,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Osdorfer Landstraße 1a",
        "zip": "22607",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182112,
        "identifier": "DE006168",
        "googlePlaceId": "ChIJIT7RO1uOukcRmTp4d0uLWK8",
        "lat": 52.101328,
        "lng": 9.382142,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hameln",
        "province": "Niedersachsen",
        "streetAndNumber": "Hastenbecker Weg 46",
        "zip": "31785",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182113,
        "identifier": "DE029035",
        "googlePlaceId": "ChIJdYd-y5tTqkcREytUSbcljlI",
        "lat": 53.875473,
        "lng": 13.918404,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Usedom",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Bäderstraße 3",
        "zip": "17406",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182114,
        "identifier": "DE029020",
        "googlePlaceId": "ChIJA7G-Tvp0q0cR9t8IQzUHXLQ",
        "lat": 54.092039,
        "lng": 13.373806,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Greifswald",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Bahnhofstraße 44",
        "zip": "17489",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182115,
        "identifier": "DE004029",
        "googlePlaceId": "ChIJhUqqIVOks0cRTkZj8-Pc-1Y",
        "lat": 54.27518,
        "lng": 9.655963,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Westerrönfeld",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Am Busbahnhof 20",
        "zip": "24784",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182116,
        "identifier": "DE020010",
        "googlePlaceId": "ChIJnyoHsmFZqEcRw_4R-4SayA4",
        "lat": 52.404419,
        "lng": 13.21963,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kleinmachnow",
        "province": "Brandenburg",
        "streetAndNumber": "Förster-Funke-Allee 104",
        "zip": "14532",
        "businessId": 1312729,
        "addressExtra": "Rathausmarkt",
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182117,
        "identifier": "DE004064",
        "googlePlaceId": "ChIJuZUOuzR-s0cRe9Niv0tgyM0",
        "lat": 54.48968,
        "lng": 9.083386,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Husum",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Flensburger Chaussee 52",
        "zip": "25813",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182118,
        "identifier": "DE002113",
        "googlePlaceId": "ChIJhbd7OhQouUcRB_VDhR8WSjo",
        "lat": 51.275101,
        "lng": 7.209374,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bredde 36",
        "zip": "42275",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182119,
        "identifier": "DE032082",
        "googlePlaceId": "ChIJeyOw-yfguEcR2iC0c5tE7Lw",
        "lat": 51.491078,
        "lng": 7.243125,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Castroper Straße 206",
        "zip": "44791",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182120,
        "identifier": "DE004006",
        "googlePlaceId": "ChIJMXGeaPV8s0cRrNv3_qwvlGQ",
        "lat": 54.570398,
        "lng": 9.172489,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Viöl",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Westermarkt 2",
        "zip": "25884",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182121,
        "identifier": "DE007048",
        "googlePlaceId": "ChIJ72cDl0EssUcRQB24fw7eVuw",
        "lat": 53.182389,
        "lng": 8.710932,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ritterhude",
        "province": "Niedersachsen",
        "streetAndNumber": "An der Ihle 5C",
        "zip": "27721",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182122,
        "identifier": "DE026052",
        "googlePlaceId": "ChIJwUYmHVhYr0cRrqZdOz8JX1Q",
        "lat": 52.146068,
        "lng": 11.722304,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Biederitz",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Heyrothsberger Straße 62",
        "zip": "39175",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182123,
        "identifier": "DE005025",
        "googlePlaceId": "ChIJCea_edeHuUcRAJcpKfyB_PM",
        "lat": 51.902967,
        "lng": 8.191901,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herzebrock-Clarholz",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Beelener Straße 86",
        "zip": "33442",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182124,
        "identifier": "DE007020",
        "googlePlaceId": "ChIJt9pAeYjXsEcR2kt3l91Ex18",
        "lat": 53.03228,
        "lng": 8.81022,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Kattenturmer Heerstraße 326",
        "zip": "28277",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182125,
        "identifier": "DE005068",
        "googlePlaceId": "ChIJawLhBICauUcRsoWd1JMPyxs",
        "lat": 51.922015,
        "lng": 7.964225,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Warendorf",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Industriestraße 5",
        "zip": "48231",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182126,
        "identifier": "DE020036",
        "googlePlaceId": "ChIJ_RobmplfqEcRoKQxviRQOcw",
        "lat": 52.351809,
        "lng": 13.10235,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nuthetal",
        "province": "Brandenburg",
        "streetAndNumber": "Arthur-Scheunert-Allee 69",
        "zip": "14558",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182127,
        "identifier": "DE021051",
        "googlePlaceId": "ChIJeWKGi6uTpkcR2YlujOwpr38",
        "lat": 51.198473,
        "lng": 11.99529,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Weißenfels",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Selauer Straße 91A",
        "zip": "06667",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182128,
        "identifier": "DE001027",
        "googlePlaceId": "ChIJLfh-7G7vuEcRTWRr9QQIkkA",
        "lat": 51.585068,
        "lng": 7.035479,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gelsenkirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Buschgrundstraße 33",
        "zip": "45894",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182129,
        "identifier": "DE021120",
        "googlePlaceId": "ChIJVzIPKQSSp0cR6r_gaDIk54A",
        "lat": 51.517309,
        "lng": 13.393606,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Liebenwerda",
        "province": "Brandenburg",
        "streetAndNumber": "Nordring 11 b",
        "zip": "04924",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182130,
        "identifier": "DE026090",
        "googlePlaceId": "ChIJBaaZIipopUcR_r1ifGtac6o",
        "lat": 52.020241,
        "lng": 10.55033,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schladen",
        "province": "Niedersachsen",
        "streetAndNumber": "Hermann-Müller-Straße 2",
        "zip": "38315",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182131,
        "identifier": "DE002001",
        "googlePlaceId": "ChIJ-wqGi27UuEcR97HsxgphxDs",
        "lat": 51.189568,
        "lng": 7.07768,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Solingen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Schlagbaumer Straße 126",
        "zip": "42653",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182132,
        "identifier": "DE003006",
        "googlePlaceId": "ChIJc_DnEiwlsUcR_bnZGs6e3rw",
        "lat": 53.22541,
        "lng": 8.925961,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Worpswede",
        "province": "Niedersachsen",
        "streetAndNumber": "Findorffstraße 39",
        "zip": "27726",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182133,
        "identifier": "DE036107",
        "googlePlaceId": "ChIJvZelirBHp0cRgHlYfN5f9Vg",
        "lat": 50.831209,
        "lng": 12.883287,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Chemnitz",
        "province": "Sachsen",
        "streetAndNumber": "Waldenburger Straße 33",
        "zip": "09116",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182134,
        "identifier": "DE024111",
        "googlePlaceId": "ChIJFUC8xCxGqEcRzZuz_jkVtEg",
        "lat": 52.43232,
        "lng": 13.54721,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Otto-Franke-Straße 98",
        "zip": "12489",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182135,
        "identifier": "DE032002",
        "googlePlaceId": "ChIJX8nYxvYZuUcReT5NfVESFpI",
        "lat": 51.526918,
        "lng": 7.451914,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Schützenstraße 144-146",
        "zip": "44147",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182136,
        "identifier": "DE015083",
        "googlePlaceId": "ChIJOStLiT_LtkcRNy5xMZszl4w",
        "lat": 53.358418,
        "lng": 8.657118,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hagen im Bremischen",
        "province": "Niedersachsen",
        "streetAndNumber": "Döhrenacker 3",
        "zip": "27628",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182137,
        "identifier": "DE013054",
        "googlePlaceId": "ChIJCf5Tf6xiuUcRrqfOGJErwms",
        "lat": 51.5703,
        "lng": 8.13032,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Soest",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Riga-Ring 11",
        "zip": "59494",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182138,
        "identifier": "DE025088",
        "googlePlaceId": "ChIJlWfxn2HluUcRp-Hph55ijrc",
        "lat": 52.257942,
        "lng": 8.08457,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Osnabrück",
        "province": "Niedersachsen",
        "streetAndNumber": "Hannoversche Straße 90",
        "zip": "49084",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182139,
        "identifier": "DE026051",
        "googlePlaceId": "ChIJpStRQTVfr0cRCY3_z7YtFWw",
        "lat": 52.148515,
        "lng": 11.655975,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Magdeburg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Rogätzer Straße 27",
        "zip": "39106",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182140,
        "identifier": "DE016010",
        "googlePlaceId": "ChIJV_91zaWFsUcRmeCALIM9jW8",
        "lat": 53.552341,
        "lng": 9.932603,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Ottenser Hauptstraße 10",
        "zip": "22765",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182141,
        "identifier": "DE006166",
        "googlePlaceId": "ChIJT_vZ9z9_ukcR0ZKZAplqTD0",
        "lat": 52.327476,
        "lng": 9.1989,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stadthagen",
        "province": "Niedersachsen",
        "streetAndNumber": "Bahnhofstraße 26",
        "zip": "31655",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182142,
        "identifier": "DE016089",
        "googlePlaceId": "ChIJbTTTdVqBsUcRvcyJnDWkRf8",
        "lat": 53.60158,
        "lng": 9.8222,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schenefeld",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hauptstraße 58",
        "zip": "22869",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182146,
        "identifier": "DE031068",
        "googlePlaceId": "ChIJqVG7xNorpEcR91q0VxkV8j8",
        "lat": 51.372659,
        "lng": 11.60335,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Querfurt",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Vor dem Nebraer Tor 5",
        "zip": "06268",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182147,
        "identifier": "DE029030",
        "googlePlaceId": "ChIJhySeJpXDq0cR3Cnatq-Zxxg",
        "lat": 53.584953,
        "lng": 13.272988,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neubrandenburg",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Am Eschenhof 5B",
        "zip": "17034",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182148,
        "identifier": "DE020115",
        "googlePlaceId": "ChIJTX9r8GF6qEcR0P90fPb0zQA",
        "lat": 52.091991,
        "lng": 13.172546,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Luckenwalde",
        "province": "Brandenburg",
        "streetAndNumber": "Beelitzer Straße 15-19",
        "zip": "14943",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182149,
        "identifier": "DE016055",
        "googlePlaceId": "ChIJI3KUbUWIsUcRUXXJlfnFV4c",
        "lat": 53.635186,
        "lng": 10.014624,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Erdkampsweg 134",
        "zip": "22335",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182150,
        "identifier": "DE013083",
        "googlePlaceId": "ChIJW1370vw8uUcRoggiT77pJQ0",
        "lat": 51.39984,
        "lng": 7.476902,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hagen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Schwerter Straße 192",
        "zip": "58099",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182153,
        "identifier": "DE006001",
        "googlePlaceId": "ChIJkfn-6qV0sEcREtyP8RVvowk",
        "lat": 52.380499528899,
        "lng": 9.7375503610687,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Rundestraße 6",
        "zip": "30161",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182154,
        "identifier": "DE016080",
        "googlePlaceId": "ChIJ--CysAQAskcR54s02LHs_bY",
        "lat": 53.614215,
        "lng": 10.678085,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Mölln",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Grambeker Weg 95-97",
        "zip": "23879",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182155,
        "identifier": "DE032033",
        "googlePlaceId": "ChIJv4dHIU79uEcRdWPBeTqPj5A",
        "lat": 51.642666,
        "lng": 7.260004,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oer-Erkenschwick",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Stimbergstraße 138",
        "zip": "45739",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182156,
        "identifier": "DE029043",
        "googlePlaceId": "ChIJJQ9pCB0_rEcRLUge-na9RYY",
        "lat": 53.773924,
        "lng": 12.16847,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Güstrow",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Goldberger Straße 65",
        "zip": "18273",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182157,
        "identifier": "DE002078",
        "googlePlaceId": "ChIJT7Z_qwwquUcRTB0CkB48OY4",
        "lat": 51.190275,
        "lng": 7.173819,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Remscheid",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hammesberger Straße 24",
        "zip": "42855",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182158,
        "identifier": "DE026034",
        "googlePlaceId": "ChIJbfKddkd_pUcRH5nc_qP4htk",
        "lat": 52.115102,
        "lng": 11.02354,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hötensleben",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Warslebener Straße 6",
        "zip": "39393",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182159,
        "identifier": "DE007108",
        "googlePlaceId": "ChIJl1p2716YsEcRm-KSJ7Jyksw",
        "lat": 52.499557,
        "lng": 8.905798,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Uchte",
        "province": "Niedersachsen",
        "streetAndNumber": "Burgstraße 4",
        "zip": "31600",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182160,
        "identifier": "DE021077",
        "googlePlaceId": "ChIJFV6GJINfpkcRTMyWaVVGdKU",
        "lat": 51.3929,
        "lng": 12.210968,
        "name": "ALDI",
        "country": "DE",
        "city": "Schkeuditz",
        "province": "Sachsen",
        "streetAndNumber": "Merseburger Straße 25",
        "zip": "04435",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182162,
        "identifier": "DE031053",
        "googlePlaceId": "ChIJywIrZiV4o0cRo5uzYmqHGLA",
        "lat": 50.718286,
        "lng": 10.429236,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schmalkalden",
        "province": "Thüringen",
        "streetAndNumber": "Kasseler Straße 42",
        "zip": "98574",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182164,
        "identifier": "DE021070",
        "googlePlaceId": "ChIJOZgqrPTfpkcRwX1iJUAqnFk",
        "lat": 50.998542,
        "lng": 12.44037,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Altenburg",
        "province": "Thüringen",
        "streetAndNumber": "Offenburger Allee 15",
        "zip": "04600",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182165,
        "identifier": "DE016039",
        "googlePlaceId": "ChIJodZlB6kvskcRlYrygGUwJZ8",
        "lat": 53.804673,
        "lng": 9.980184,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Henstedt-Ulzburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Gutenbergstraße 4",
        "zip": "24558",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182167,
        "identifier": "DE007036",
        "googlePlaceId": "ChIJBaAMXVnfsEcRc1aHO-k4YQQ",
        "lat": 53.049839,
        "lng": 8.957729,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Hans-Bredow-Straße 19",
        "zip": "28307",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182168,
        "identifier": "DE024102",
        "googlePlaceId": "ChIJz9AnHrhJqEcRaeE2JC8JhzY",
        "lat": 52.489656,
        "lng": 13.606723,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Hultschiner Damm 140-142",
        "zip": "12623",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182169,
        "identifier": "DE010024",
        "googlePlaceId": "ChIJUfdGPSdJo0cRZ9ab1rBPRR0",
        "lat": 50.671678,
        "lng": 9.768654,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hünfeld",
        "province": "Hessen",
        "streetAndNumber": "Josefstraße 3",
        "zip": "36088",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182170,
        "identifier": "DE016087",
        "googlePlaceId": "ChIJxa8t70mPsUcR1hS8AoFsVQc",
        "lat": 53.574469,
        "lng": 9.977023,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Grindelberg 27-31",
        "zip": "20144",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182171,
        "identifier": "DE006007",
        "googlePlaceId": "ChIJ2WL89j4LsEcRfhgnzqonZkE",
        "lat": 52.358857,
        "lng": 9.771711,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Lindemannallee 21",
        "zip": "30173",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182172,
        "identifier": "DE036030",
        "googlePlaceId": "ChIJj5Em8P7HCUcRnTAsn3AaJpc",
        "lat": 51.011732,
        "lng": 13.810085,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Wilhelm-Liebknecht-Straße 2",
        "zip": "01257",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182173,
        "identifier": "DE004004",
        "googlePlaceId": "ChIJsQVmc-9WskcRS3BV6SyHPoc",
        "lat": 54.300643,
        "lng": 10.141638,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Theodor-Heuss-Ring 136",
        "zip": "24143",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182174,
        "identifier": "DE005055",
        "googlePlaceId": "ChIJf6fPV2Squ0cRF47xXoP-Thc",
        "lat": 51.625074,
        "lng": 9.022909,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Willebadessen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Sportplatz 4",
        "zip": "34439",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182175,
        "identifier": "DE016083",
        "googlePlaceId": "ChIJb_QqVymJsUcRuYih2H4MSUA",
        "lat": 53.584381,
        "lng": 10.018501,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Barmbeker Straße 17-25",
        "zip": "22303",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182176,
        "identifier": "DE021098",
        "googlePlaceId": "ChIJwULcB5VupkcRsTGoXGFpu9g",
        "lat": 51.636269,
        "lng": 12.114032,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zörbig",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Radegaster Straße 61",
        "zip": "06780",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182177,
        "identifier": "DE010053",
        "googlePlaceId": "ChIJ22V3rSg5u0cR2o4HL6e7rTg",
        "lat": 51.344042,
        "lng": 9.518067,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Fuldatal",
        "province": "Hessen",
        "streetAndNumber": "Ziegelei 3",
        "zip": "34233",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182178,
        "identifier": "DE032122",
        "googlePlaceId": "ChIJBfUKoxWwuUcR6sZzmK92ODg",
        "lat": 51.966704,
        "lng": 7.563684,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Münster",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Dieckmannstraße 114",
        "zip": "48161",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182179,
        "identifier": "DE006089",
        "googlePlaceId": "ChIJfdsNB6KTr0cREMACKX1B11M",
        "lat": 52.446696,
        "lng": 10.78108,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wolfsburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Jembker Straße 1",
        "zip": "38448",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182181,
        "identifier": "DE006032",
        "googlePlaceId": "ChIJfwL_ak51sEcRefDA4U5ylhk",
        "lat": 52.314467,
        "lng": 9.721145,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hemmingen",
        "province": "Niedersachsen",
        "streetAndNumber": "Alfred-Bentz-Straße 2",
        "zip": "30966",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182182,
        "identifier": "DE024116",
        "googlePlaceId": "ChIJr8YvSiA6qEcR5oPJiX3TlJs",
        "lat": 52.395874,
        "lng": 13.7209,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gosen-Neu Zittau",
        "province": "Brandenburg",
        "streetAndNumber": "Am Müggelpark 41-45",
        "zip": "15537",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182183,
        "identifier": "DE029061",
        "googlePlaceId": "ChIJCXPFzaBUrEcR1FLGKenOuCs",
        "lat": 54.108736,
        "lng": 11.92053,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Doberan",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Am Handelspark 9",
        "zip": "18209",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182184,
        "identifier": "DE029075",
        "googlePlaceId": "ChIJ2xKdKhrgq0cRR2s0-RkN_SM",
        "lat": 53.376524,
        "lng": 13.051789,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neustrelitz",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Penzliner Straße 47",
        "zip": "17235",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182185,
        "identifier": "DE010049",
        "googlePlaceId": "ChIJVxFco9kepUcRxjVDcBQvXO4",
        "lat": 51.626733,
        "lng": 10.460644,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Lauterberg im Harz",
        "province": "Niedersachsen",
        "streetAndNumber": "Lutterstraße 1",
        "zip": "37431",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182187,
        "identifier": "DE024080",
        "googlePlaceId": "ChIJp-NyEb1TqEcRMXxvgH7SVDE",
        "lat": 52.580808,
        "lng": 13.346719,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Roedernallee 15-16",
        "zip": "13407",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182188,
        "identifier": "DE026092",
        "googlePlaceId": "ChIJyT-zQ3FepUcRYk3F4PPryQg",
        "lat": 52.148357,
        "lng": 10.557683,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wolfenbüttel",
        "province": "Niedersachsen",
        "streetAndNumber": "Neindorfer Straße 8a",
        "zip": "38300",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182189,
        "identifier": "DE010019",
        "googlePlaceId": "ChIJtR4e0AZIu0cRzesRLd5HyCE",
        "lat": 51.2838,
        "lng": 9.60052,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kaufungen",
        "province": "Hessen",
        "streetAndNumber": "Im Feldhof 10",
        "zip": "34260",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182190,
        "identifier": "DE015051",
        "googlePlaceId": "ChIJvdn4P9YZt0cRAwFXSMlAPDs",
        "lat": 52.965761,
        "lng": 8.070882,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Garrel",
        "province": "Niedersachsen",
        "streetAndNumber": "Nikolausdorfer Straße 3",
        "zip": "49681",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182191,
        "identifier": "DE005080",
        "googlePlaceId": "ChIJS1jc6xwlukcRy9BnTBlWEMY",
        "lat": 51.911284,
        "lng": 8.425003,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gütersloh",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Osnabrücker Landstraße 1",
        "zip": "33335",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182192,
        "identifier": "DE004130",
        "googlePlaceId": "ChIJhdzgffjLs0cRqKgvmXG7cGQ",
        "lat": 53.947959,
        "lng": 9.714145,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kellinghusen",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "An der Stör 2 a",
        "zip": "25548",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182193,
        "identifier": "DE032051",
        "googlePlaceId": "ChIJsXm3wEAMuUcRTXAlPR2Nh-4",
        "lat": 51.663541,
        "lng": 7.645813,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Werne",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Klöcknerstraße 3",
        "zip": "59368",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182194,
        "identifier": "DE031049",
        "googlePlaceId": "ChIJiezmzyippkcRHWv0KqiaiFc",
        "lat": 50.892421,
        "lng": 11.584037,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Jena",
        "province": "Thüringen",
        "streetAndNumber": "Ossmaritzer Straße 1a",
        "zip": "07745",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182196,
        "identifier": "DE005051",
        "googlePlaceId": "ChIJK6Vvadq0u0cRpDZKMO-YWSw",
        "lat": 51.688284,
        "lng": 8.681097,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Paderborn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wewersches Bruch 100",
        "zip": "33106",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182197,
        "identifier": "DE021005",
        "googlePlaceId": "ChIJA1wbC98Bp0cR9VGtazgkCMM",
        "lat": 51.27843,
        "lng": 12.5803,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Naunhof",
        "province": "Sachsen",
        "streetAndNumber": "Erdmannshainer Straße 58",
        "zip": "04683",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182198,
        "identifier": "DE020101",
        "googlePlaceId": "ChIJl6y8f0xGqEcR0DkvHaHQvHc",
        "lat": 52.424201,
        "lng": 13.526763,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Wegedornstraße 29",
        "zip": "12524",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182199,
        "identifier": "DE024107",
        "googlePlaceId": "ChIJc6q6SkpPqEcRpwIBr_hj4yk",
        "lat": 52.465047,
        "lng": 13.495998,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Köpenicker Landstraße 294",
        "zip": "12437",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182200,
        "identifier": "DE015049",
        "googlePlaceId": "ChIJsyDBhkWStkcRGqU6eCZPfbc",
        "lat": 53.529094,
        "lng": 8.069384,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wilhelmshaven",
        "province": "Niedersachsen",
        "streetAndNumber": "Hundertwasserallee 3",
        "zip": "26389",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182201,
        "identifier": "DE010118",
        "googlePlaceId": "ChIJ7zWcqM9ApUcRjms0G6r_FWU",
        "lat": 51.929569,
        "lng": 10.410267,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Goslar",
        "province": "Niedersachsen",
        "streetAndNumber": "Carl-Zeiss-Straße 4",
        "zip": "38644",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182202,
        "identifier": "DE004090",
        "googlePlaceId": "ChIJVf7NES20s0cRqATDPNJrYh4",
        "lat": 54.08197,
        "lng": 9.781322,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Aukrug",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Itzehoer Straße 4-6",
        "zip": "24613",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182203,
        "identifier": "DE003038",
        "googlePlaceId": "ChIJpZUYcJM4sUcR5BgP9vPeGdg",
        "lat": 53.377199,
        "lng": 9.003916,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gnarrenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Hindenburgstraße 29",
        "zip": "27442",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182204,
        "identifier": "DE013102",
        "googlePlaceId": "ChIJnRPEOyDxu0cRe69LO7PqBPs",
        "lat": 51.15803,
        "lng": 8.29166,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schmallenberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bahnhofstraße 42 a",
        "zip": "57392",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182206,
        "identifier": "DE020098",
        "googlePlaceId": "ChIJOaCaZA5GqEcRMhOqP6NFUA0",
        "lat": 52.430594,
        "lng": 13.495443,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Kanalstraße 8",
        "zip": "12357",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182207,
        "identifier": "DE032013",
        "googlePlaceId": "ChIJ_4S0h_gQuUcR4Wc2F7jatAs",
        "lat": 51.568435,
        "lng": 7.52539,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Altenderner Straße 18",
        "zip": "44329",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182208,
        "identifier": "DE036102",
        "googlePlaceId": "ChIJLR3k2OY-p0cRzw4t3SKWm2s",
        "lat": 50.918643,
        "lng": 12.809862,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Burgstädt",
        "province": "Sachsen",
        "streetAndNumber": "Straße der Deutschen Einheit 2-4",
        "zip": "09217",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182209,
        "identifier": "DE025066",
        "googlePlaceId": "ChIJBZBupmLJuUcRMHlQKk_PLKc",
        "lat": 52.17483,
        "lng": 7.53626,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Emsdetten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Im Hagenkamp 1",
        "zip": "48282",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182210,
        "identifier": "DE021039",
        "googlePlaceId": "ChIJSb2VCbJOpkcRfOUbFzK8Ra4",
        "lat": 51.59906,
        "lng": 12.591401,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Düben",
        "province": "Sachsen",
        "streetAndNumber": "Postweg 16",
        "zip": "04849",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182212,
        "identifier": "DE006039",
        "googlePlaceId": "ChIJb0OupkE9sEcRIv7U7xgiht4",
        "lat": 52.636335,
        "lng": 10.051749,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Celle",
        "province": "Niedersachsen",
        "streetAndNumber": "Bremer Weg 199",
        "zip": "29223",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182214,
        "identifier": "DE024005",
        "googlePlaceId": "ChIJLxY9qbCtqUcR4mscfNravLA",
        "lat": 52.6860022,
        "lng": 13.4404112,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wandlitz",
        "province": "Brandenburg",
        "streetAndNumber": "Hauptstraße 64",
        "zip": "16352",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182216,
        "identifier": "DE013084",
        "googlePlaceId": "ChIJr7bc9Mo8uUcRyHTb6bWoDPo",
        "lat": 51.386427,
        "lng": 7.4358217,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hagen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Ophauser Straße 36",
        "zip": "58089",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182217,
        "identifier": "DE016020",
        "googlePlaceId": "ChIJwTpOVPyLsUcRegckmJtLz0o",
        "lat": 53.581343,
        "lng": 10.075777,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Auf dem Königslande 21",
        "zip": "22041",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182218,
        "identifier": "DE010006",
        "googlePlaceId": "ChIJvS7SILU4u0cR4SBS2eM6uyw",
        "lat": 51.316564,
        "lng": 9.49643,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kassel",
        "province": "Hessen",
        "streetAndNumber": "Mauerstraße 11",
        "zip": "34117",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182219,
        "identifier": "DE010052",
        "googlePlaceId": "ChIJ6wQWiptUo0cRit7xJYs_DRc",
        "lat": 50.863998,
        "lng": 9.708445,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Hersfeld",
        "province": "Hessen",
        "streetAndNumber": "Heinrich-von-Stephan-Straße 2c",
        "zip": "36251",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182220,
        "identifier": "DE003069",
        "googlePlaceId": "ChIJN8qtEeajsUcRunoOdTOQWMM",
        "lat": 53.270000818061,
        "lng": 9.7341057292258,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Tostedt",
        "province": "Niedersachsen",
        "streetAndNumber": "Zinnhütte 13",
        "zip": "21255",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182221,
        "identifier": "DE002024",
        "googlePlaceId": "ChIJ02bvdeLauEcRaV8gzDH3qhs",
        "lat": 51.346167,
        "lng": 7.028241,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Velbert",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Buschberg 50",
        "zip": "42549",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182222,
        "identifier": "DE025053",
        "googlePlaceId": "ChIJQWEVLeYTt0cRnwevhDa0K_I",
        "lat": 52.856662,
        "lng": 7.92928,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Molbergen",
        "province": "Niedersachsen",
        "streetAndNumber": "Alter Schützenplatz 1",
        "zip": "49696",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182223,
        "identifier": "DE036114",
        "googlePlaceId": "ChIJlXJrLohzCEcR4Bw-5WbqdZI",
        "lat": 51.74008,
        "lng": 14.32374,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Cottbus",
        "province": "Brandenburg",
        "streetAndNumber": "Welzower Straße 26a",
        "zip": "03048",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182224,
        "identifier": "DE036032",
        "googlePlaceId": "ChIJdSk7IZ1kp0cR3c7w_1OMBzk",
        "lat": 51.062714,
        "lng": 13.296445,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nossen",
        "province": "Sachsen",
        "streetAndNumber": "Fabrikstraße 3",
        "zip": "01683",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182225,
        "identifier": "DE007031",
        "googlePlaceId": "ChIJ-QE4fvyMsEcRbszUYW8eXRM",
        "lat": 52.651848,
        "lng": 9.215814,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nienburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Verdener Landstraße 39a",
        "zip": "31582",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182226,
        "identifier": "DE015025",
        "googlePlaceId": "ChIJKRrBPz9ftkcRAvHen54G1Ms",
        "lat": 53.418963,
        "lng": 7.739029,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wiesmoor",
        "province": "Niedersachsen",
        "streetAndNumber": "Tulpenweg 4",
        "zip": "26639",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182227,
        "identifier": "DE001017",
        "googlePlaceId": "ChIJp30cz13duEcRt958quK70_0",
        "lat": 51.465658,
        "lng": 7.047882,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hubertstraße 20",
        "zip": "45139",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182228,
        "identifier": "DE003091",
        "googlePlaceId": "ChIJd8Kskczis0cRcIf8lak5S8U",
        "lat": 53.770182,
        "lng": 9.058296,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Cadenberge",
        "province": "Niedersachsen",
        "streetAndNumber": "Stader Straße 6",
        "zip": "21781",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182229,
        "identifier": "DE006011",
        "googlePlaceId": "ChIJKSaMer_ur0cR0tyUfR5XU8o",
        "lat": 52.467747,
        "lng": 10.575105,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gifhorn",
        "province": "Niedersachsen",
        "streetAndNumber": "Adam-Riese-Straße 2",
        "zip": "38518",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182230,
        "identifier": "DE004038",
        "googlePlaceId": "ChIJjcx3NWbEs0cRSIoh_2Wwpxo",
        "lat": 53.93167,
        "lng": 9.52759,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Itzehoe",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Langer Peter 27c",
        "zip": "25524",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182231,
        "identifier": "DE032043",
        "googlePlaceId": "ChIJsWzEeewAuUcRPkhqmGohZwg",
        "lat": 51.76491,
        "lng": 7.389437,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lüdinghausen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Dülmener Straße 28",
        "zip": "59348",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182232,
        "identifier": "DE005128",
        "googlePlaceId": "ChIJ_03ms7QQukcRoBk-WLouuM8",
        "lat": 52.137322,
        "lng": 8.554113,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Enger",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Ringstraße 32",
        "zip": "32130",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182233,
        "identifier": "DE005011",
        "googlePlaceId": "ChIJRZn8m6lGukcRZqIX35IYafM",
        "lat": 51.945594,
        "lng": 8.783841,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Detmold",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Oerlinghauser Straße 109",
        "zip": "32758",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182234,
        "identifier": "DE005012",
        "googlePlaceId": "ChIJF_xwG78YukcR_V4-QE8if8M",
        "lat": 52.079826,
        "lng": 8.423783,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Werther",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Engerstraße 61",
        "zip": "33824",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182235,
        "identifier": "DE004063",
        "googlePlaceId": "ChIJny4R04FJskcRLjWV4_QFCXs",
        "lat": 54.059565,
        "lng": 10.010914,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neumünster",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Haart 224",
        "zip": "24539",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182236,
        "identifier": "DE026032",
        "googlePlaceId": "ChIJ1Xif1CmBr0cRlE9z5EGv5Ic",
        "lat": 52.240524,
        "lng": 10.995805,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Helmstedt",
        "province": "Niedersachsen",
        "streetAndNumber": "Emmerstedter Straße 12",
        "zip": "38350",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182238,
        "identifier": "DE013066",
        "googlePlaceId": "ChIJrUs7pfQmuUcRVHgLDKL6BIA",
        "lat": 51.335681,
        "lng": 7.284623,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sprockhövel",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Rathausplatz 10",
        "zip": "45549",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182239,
        "identifier": "DE003088",
        "googlePlaceId": "ChIJWQoiUCQxsUcRKn0XwnyrhV0",
        "lat": 53.307672,
        "lng": 8.839134,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hambergen",
        "province": "Niedersachsen",
        "streetAndNumber": "Hauptstraße 35a",
        "zip": "27729",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182240,
        "identifier": "DE024013",
        "googlePlaceId": "ChIJka6bIdNLqEcR6HY_jB0z6VY",
        "lat": 52.529819,
        "lng": 13.59528,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Neue Grottkauer Straße 23",
        "zip": "12619",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182242,
        "identifier": "DE004123",
        "googlePlaceId": "ChIJTXFKOxN2tEcRqhYWsPv8flI",
        "lat": 54.205147,
        "lng": 8.930908,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wesselburen",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Bahnhofstraße 20a",
        "zip": "25764",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182243,
        "identifier": "DE001077",
        "googlePlaceId": "ChIJz_w3CBnnuEcRWSCZy03Y0c0",
        "lat": 51.504453,
        "lng": 7.112375,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gelsenkirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Dessauerstraße 61",
        "zip": "45886",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182244,
        "identifier": "DE005054",
        "googlePlaceId": "ChIJCTrTvYn0uUcRy4e4TRbqta8",
        "lat": 52.116764,
        "lng": 8.206944,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dissen",
        "province": "Niedersachsen",
        "streetAndNumber": "Teutoburger Straße 2",
        "zip": "49201",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182245,
        "identifier": "DE004054",
        "googlePlaceId": "ChIJH4wmE2oZs0cRGc5xnF9d84c",
        "lat": 54.659102,
        "lng": 9.948779,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kappeln",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Glücksburger Straße 1",
        "zip": "24376",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182246,
        "identifier": "DE036096",
        "googlePlaceId": "ChIJc9E586Qxp0cRsH0xkjxs3H4",
        "lat": 50.772831,
        "lng": 12.622841,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "St. Egidien",
        "province": "Sachsen",
        "streetAndNumber": "Platanenstraße 4",
        "zip": "09356",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182247,
        "identifier": "DE004096",
        "googlePlaceId": "ChIJR401stAMs0cRQtWiyMuEC-M",
        "lat": 54.531859,
        "lng": 9.575234,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schleswig",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hans-Jürgen-Klinker-Straße 1",
        "zip": "24837",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182248,
        "identifier": "DE004027",
        "googlePlaceId": "ChIJIdvs4-J0tEcR0X1GaHatiFU",
        "lat": 54.13849,
        "lng": 8.87424,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Büsum",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Heider Straße 2b",
        "zip": "25761",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182249,
        "identifier": "DE031006",
        "googlePlaceId": "ChIJNQGGJTpXpEcRF-LJp5vseWQ",
        "lat": 51.368489,
        "lng": 10.850243,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sondershausen",
        "province": "Thüringen",
        "streetAndNumber": "Erfurter Straße 12a",
        "zip": "99706",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182250,
        "identifier": "DE025085",
        "googlePlaceId": "ChIJh11qyYTluUcROmulxCM_ojU",
        "lat": 52.267457,
        "lng": 8.055182,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Osnabrück",
        "province": "Niedersachsen",
        "streetAndNumber": "Petersburger Wall 9",
        "zip": "49074",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182251,
        "identifier": "DE007091",
        "googlePlaceId": "ChIJUViQY8extkcRN83XwRVCGx4",
        "lat": 53.580453,
        "lng": 8.598675,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremerhaven",
        "province": "Bremen",
        "streetAndNumber": "Langener Landstraße 160",
        "zip": "27580",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182252,
        "identifier": "DE004010",
        "googlePlaceId": "ChIJ38y78rzAs0cR8T3aqn-edDk",
        "lat": 54.04731,
        "lng": 9.48868,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schenefeld",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Marktstraße 1-3",
        "zip": "25560",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182253,
        "identifier": "DE002036",
        "googlePlaceId": "ChIJa_ujoubZuEcRfHcmIaO4xDc",
        "lat": 51.304456,
        "lng": 7.10572,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Velbert",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Rosenhügel 40-42",
        "zip": "42553",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182254,
        "identifier": "DE013078",
        "googlePlaceId": "ChIJf41v758VuUcRVfE4mDPpN2g",
        "lat": 51.456352,
        "lng": 7.612889,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwerte",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Zwischen den Wegen 4",
        "zip": "58239",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182256,
        "identifier": "DE021021",
        "googlePlaceId": "ChIJXRYeHnT3pkcRwx_J5sN_yZI",
        "lat": 51.30678,
        "lng": 12.259405,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Straße am See 1",
        "zip": "04207",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182257,
        "identifier": "DE024018",
        "googlePlaceId": "ChIJx-k48dkGqUcRm8JKSZejwYY",
        "lat": 52.752119,
        "lng": 13.202756,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oranienburg",
        "province": "Brandenburg",
        "streetAndNumber": "Germendorfer Allee 20",
        "zip": "16515",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182258,
        "identifier": "DE021059",
        "googlePlaceId": "ChIJZY8a4_34pkcRu0EYooZhZ3A",
        "lat": 51.319351,
        "lng": 12.424704,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Holzhäuser Straße 108",
        "zip": "04299",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182259,
        "identifier": "DE025107",
        "googlePlaceId": "ChIJhaQxyWQdukcR2wINdMco3hY",
        "lat": 52.205802,
        "lng": 8.335408,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Melle",
        "province": "Niedersachsen",
        "streetAndNumber": "Weststraße 9",
        "zip": "49324",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182261,
        "identifier": "DE020060",
        "googlePlaceId": "ChIJX8vM9lxfqEcR5rcmCrq0wB8",
        "lat": 52.385404,
        "lng": 13.106267,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Potsdam",
        "province": "Brandenburg",
        "streetAndNumber": "Weidendamm 2",
        "zip": "14482",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182262,
        "identifier": "DE004046",
        "googlePlaceId": "ChIJZXjjHIUMs0cRWMrWyfSz6TM",
        "lat": 54.500047,
        "lng": 9.5982668,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Fahrdorf",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Mühlenberg 18 a",
        "zip": "24857",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182264,
        "identifier": "DE007028",
        "googlePlaceId": "ChIJmbWcUbhNt0cR6W7qWFnX39Y",
        "lat": 52.608185,
        "lng": 8.366665,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Diepholz",
        "province": "Niedersachsen",
        "streetAndNumber": "Flöthestraße 41",
        "zip": "49356",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182267,
        "identifier": "DE002075",
        "googlePlaceId": "ChIJgw6aiUrRuEcRrBytsa7zTPI",
        "lat": 51.232835,
        "lng": 7.07233,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kaiserstraße 33",
        "zip": "42327",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182268,
        "identifier": "DE013065",
        "googlePlaceId": "ChIJf_ogQzcnuUcRroI-sar_46g",
        "lat": 51.365605,
        "lng": 7.24394,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sprockhövel",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bahnhofstraße 7",
        "zip": "45549",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182269,
        "identifier": "DE006037",
        "googlePlaceId": "ChIJFT__APQSsEcRPjhdiroEbys",
        "lat": 52.491176,
        "lng": 9.844164,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Großburgwedel",
        "province": "Niedersachsen",
        "streetAndNumber": "In der Meineworth 25",
        "zip": "30938",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182270,
        "identifier": "DE026042",
        "googlePlaceId": "ChIJWV2HJd7opUcR9Op9kiAqTzQ",
        "lat": 51.851443,
        "lng": 11.597908,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Staßfurt",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "An der Salzrinne 2",
        "zip": "39418",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182271,
        "identifier": "DE013041",
        "googlePlaceId": "ChIJrfxYYPxmuUcRTimuh1mJucM",
        "lat": 51.460152,
        "lng": 7.951186,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Arnsberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Im Ohl 16B",
        "zip": "59757",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182272,
        "identifier": "DE025001",
        "googlePlaceId": "ChIJ5S-k576Ot0cR6xOlGlkQp-w",
        "lat": 52.59224,
        "lng": 7.23484,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Geeste Dalum",
        "province": "Niedersachsen",
        "streetAndNumber": "Meppener Straße 22",
        "zip": "49744",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182274,
        "identifier": "DE006023",
        "googlePlaceId": "ChIJBVtcHkIZsEcRdUbIR2NKG1s",
        "lat": 52.53966,
        "lng": 10.14442,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wathlingen",
        "province": "Niedersachsen",
        "streetAndNumber": "Nienhagener Straße 3",
        "zip": "29339",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182275,
        "identifier": "DE015073",
        "googlePlaceId": "ChIJLzizAPhrtkcRYCkySFy3NcU",
        "lat": 53.586396,
        "lng": 7.459221,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Westerholt",
        "province": "Niedersachsen",
        "streetAndNumber": "Auricher Straße 14b",
        "zip": "26556",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182276,
        "identifier": "DE021061",
        "googlePlaceId": "ChIJM6g50oZXpkcRG2VkZzf_UDA",
        "lat": 51.401834,
        "lng": 12.397884,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Handelsstraße 4-8",
        "zip": "04356",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182277,
        "identifier": "DE032092",
        "googlePlaceId": "ChIJj-rod8XduEcRHAAqTKJQF7s",
        "lat": 51.437216,
        "lng": 7.105486,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Dahlhauser Straße 177-179",
        "zip": "45279",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182278,
        "identifier": "DE004014",
        "googlePlaceId": "ChIJGVJsHsn4skcRTahcUbZPD7g",
        "lat": 54.402978,
        "lng": 10.155747,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Altenholz",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Friedrichsruher Weg 4",
        "zip": "24161",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182279,
        "identifier": "DE004056",
        "googlePlaceId": "ChIJb9_69MVWskcRuM_DnXLLQ5c",
        "lat": 54.282667971662,
        "lng": 10.133712238289,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Grot Steenbusch 35",
        "zip": "24145",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182280,
        "identifier": "DE025106",
        "googlePlaceId": "ChIJe_uAW6AdukcRunaBd-ESYGw",
        "lat": 52.191754,
        "lng": 8.352834,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Melle",
        "province": "Niedersachsen",
        "streetAndNumber": "Nachtigallenstraße 87",
        "zip": "49324",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182282,
        "identifier": "DE002098",
        "googlePlaceId": "ChIJ4WCXweICvEcRTV-KOYtN66s",
        "lat": 50.935163,
        "lng": 8.00503,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kreuztal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Alte Schulstraße 2",
        "zip": "57223",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182283,
        "identifier": "DE015008",
        "googlePlaceId": "ChIJI-yA0r4WtkcREObiFXiuyks",
        "lat": 53.590244,
        "lng": 7.215927,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Norden",
        "province": "Niedersachsen",
        "streetAndNumber": "Bahnhofstraße 1A",
        "zip": "26506",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182284,
        "identifier": "DE003061",
        "googlePlaceId": "ChIJG6Ct82DlsUcRpUyeBxqCAWk",
        "lat": 53.435435,
        "lng": 10.383216,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Geesthacht",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Berliner Straße 83-87",
        "zip": "21502",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182285,
        "identifier": "DE025024",
        "googlePlaceId": "ChIJEzX7kKkyuEcR-GdK81yDKQY",
        "lat": 52.295133,
        "lng": 7.450623,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rheine",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Friedrich-Ebert-Ring 184",
        "zip": "48429",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182286,
        "identifier": "DE029058",
        "googlePlaceId": "ChIJI0l2KfBWrEcRL4k6EIuZBaI",
        "lat": 54.10881,
        "lng": 12.085735,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rostock",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Am Fischereihafen 3",
        "zip": "18069",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182287,
        "identifier": "DE031019",
        "googlePlaceId": "ChIJS8-XoZAapEcRbWevRIuYUv4",
        "lat": 50.994062,
        "lng": 11.31676,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Weimar",
        "province": "Thüringen",
        "streetAndNumber": "Marcel-Paul-Straße 48-50",
        "zip": "99427",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182288,
        "identifier": "DE002013",
        "googlePlaceId": "ChIJw6DLknBWuUcRK2laTof_hk0",
        "lat": 51.163736,
        "lng": 7.987422,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Finnentrop",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bamenohler Straße 26",
        "zip": "57413",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182289,
        "identifier": "DE010016",
        "googlePlaceId": "ChIJlWLQLI04u0cRO3X3MEkPTcU",
        "lat": 51.315838,
        "lng": 9.540893,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Niestetal",
        "province": "Hessen",
        "streetAndNumber": "Hannoversche Straße 13",
        "zip": "34266",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182290,
        "identifier": "DE021055",
        "googlePlaceId": "ChIJV9pFRoUop0cRQ0C_8lcQKMg",
        "lat": 50.838552,
        "lng": 12.44702,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Meerane",
        "province": "Sachsen",
        "streetAndNumber": "Guteborner Allee 3",
        "zip": "08393",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182291,
        "identifier": "DE005121",
        "googlePlaceId": "ChIJ50gS1n9CukcRSxXaJQYFy-Q",
        "lat": 52.024008,
        "lng": 8.887736,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lemgo",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Steinweg 66",
        "zip": "32657",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182292,
        "identifier": "DE003075",
        "googlePlaceId": "ChIJtWUdF5qPsUcRS5od4uKERUE",
        "lat": 53.57294,
        "lng": 10.06809,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Wandsbeker Marktstraße 103-107",
        "zip": "22041",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182293,
        "identifier": "DE029014",
        "googlePlaceId": "ChIJu33X5j9Gq0cRpegodjrbJNE",
        "lat": 54.527987,
        "lng": 13.546817,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sagard",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Schulstraße 21",
        "zip": "18551",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182294,
        "identifier": "DE016085",
        "googlePlaceId": "ChIJaZHwxquHsUcR3oIFAXu6Jww",
        "lat": 53.634372,
        "lng": 9.914832,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Oldesloer Straße 50",
        "zip": "22457",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182296,
        "identifier": "DE007033",
        "googlePlaceId": "ChIJVVkTgBMyt0cR6n6L4ofRE1M",
        "lat": 52.901525,
        "lng": 8.449894,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wildeshausen",
        "province": "Niedersachsen",
        "streetAndNumber": "Harpstedter Straße 34c",
        "zip": "27793",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182297,
        "identifier": "DE001032",
        "googlePlaceId": "ChIJ3anjgHDnuEcRwmIKuB5Xz-4",
        "lat": 51.497363,
        "lng": 7.048271,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Katernberger Straße 48-50",
        "zip": "45327",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182298,
        "identifier": "DE021013",
        "googlePlaceId": "ChIJ_6_12y_4pkcRsOA-BPxUz9I",
        "lat": 51.273173,
        "lng": 12.356521,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Markkleeberg",
        "province": "Sachsen",
        "streetAndNumber": "Koburger Straße 181",
        "zip": "04416",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182299,
        "identifier": "DE024001",
        "googlePlaceId": "ChIJMxkZtZszqEcRaCZlbh9oi-M",
        "lat": 52.53152777,
        "lng": 13.80583923,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Petershagen-Eggersdorf",
        "province": "Brandenburg",
        "streetAndNumber": "Am Fuchsbau 4",
        "zip": "15345",
        "businessId": 1312729,
        "addressExtra": "wird DESEF093, mit neuer Adresse, Karl-Marx-Str. 22, 15345",
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182301,
        "identifier": "DE010067",
        "googlePlaceId": "ChIJVSxdnT_opEcROlJUXadZxFk",
        "lat": 51.383856,
        "lng": 10.330639,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leinefelde-Worbis",
        "province": "Thüringen",
        "streetAndNumber": "Birkunger Straße 27",
        "zip": "37327",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182302,
        "identifier": "DE006024",
        "googlePlaceId": "ChIJ5cl5P05zsEcRYq_8Znjl1O8",
        "lat": 52.398417,
        "lng": 9.75023,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Wöhlerstraße 48",
        "zip": "30163",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182306,
        "identifier": "DE015015",
        "googlePlaceId": "ChIJ4xi05r2RtkcRSQ_t-ZaLark",
        "lat": 53.574006,
        "lng": 8.084726,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wilhelmshaven",
        "province": "Niedersachsen",
        "streetAndNumber": "Posener Straße 91",
        "zip": "26388",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182307,
        "identifier": "DE005071",
        "googlePlaceId": "ChIJfXO4CGVOukcRbQ-NMAqCy1U",
        "lat": 51.788949,
        "lng": 8.825489,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Lippspringe",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Detmolder Straße 221-225",
        "zip": "33175",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182308,
        "identifier": "DE029005",
        "googlePlaceId": "ChIJFVF84zFiq0cRnTCF4vIXuo0",
        "lat": 54.328561,
        "lng": 13.079587,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stralsund",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Grosse Parower Straße 54",
        "zip": "18435",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182309,
        "identifier": "DE032045",
        "googlePlaceId": "ChIJlSlBE88FuUcRKZU996sY_nI",
        "lat": 51.686070779211,
        "lng": 7.4676768920711,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Selm",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kreisstraße 92",
        "zip": "59379",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182310,
        "identifier": "DE007110",
        "googlePlaceId": "ChIJlWrXwCSusEcR3QAXjgatqXY",
        "lat": 52.553823,
        "lng": 8.585722,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wagenfeld",
        "province": "Niedersachsen",
        "streetAndNumber": "Meiersfeld 18",
        "zip": "49419",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182311,
        "identifier": "DE007067",
        "googlePlaceId": "ChIJg4Y5izkGsUcRJPRDoVMAzJ0",
        "lat": 53.169009,
        "lng": 9.487681,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Scheeßel",
        "province": "Niedersachsen",
        "streetAndNumber": "Vahlder Weg 1a",
        "zip": "27383",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182312,
        "identifier": "DE002012",
        "googlePlaceId": "ChIJNycD-s9JuUcRItm3Vtl8_U8",
        "lat": 51.215029,
        "lng": 7.615899,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lüdenscheid",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kölner Straße 90",
        "zip": "58509",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182313,
        "identifier": "DE005077",
        "googlePlaceId": "ChIJYfQKrKG9uUcRhsRPf6WZuik",
        "lat": 51.9796,
        "lng": 7.78286,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Telgte",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Orkotten 11",
        "zip": "48291",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182314,
        "identifier": "DE010082",
        "googlePlaceId": "ChIJuxgZ5IoVu0cRT2iO3UkSGL4",
        "lat": 51.368204,
        "lng": 9.398335,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ahnatal",
        "province": "Hessen",
        "streetAndNumber": "Heckershäuser Straße 27",
        "zip": "34292",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182315,
        "identifier": "DE025007",
        "googlePlaceId": "ChIJga5DQLkzuEcRijPdl0Rzgio",
        "lat": 52.242174,
        "lng": 7.370164,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neuenkirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Industriestraße 19",
        "zip": "48485",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182316,
        "identifier": "DE036113",
        "googlePlaceId": "ChIJn2rpOlKKCEcRkiny_C2VgVQ",
        "lat": 51.508306,
        "lng": 14.619888,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Weißwasser",
        "province": "Sachsen",
        "streetAndNumber": "Berliner Straße 106",
        "zip": "02943",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182317,
        "identifier": "DE016048",
        "googlePlaceId": "ChIJLwkDOXsfskcR2eaxTIi5qrw",
        "lat": 53.699861,
        "lng": 10.247267,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Delingsdorf",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Poggensiek 2",
        "zip": "22941",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182318,
        "identifier": "DE004011",
        "googlePlaceId": "ChIJu6LNtS-AtEcRbR0Xk4tw0K4",
        "lat": 54.48249,
        "lng": 9.039489,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Husum",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Nordhusumer Straße 90",
        "zip": "25813",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182319,
        "identifier": "DE032081",
        "googlePlaceId": "ChIJwcjcl23guEcR_uIkraNcUOs",
        "lat": 51.474799,
        "lng": 7.210547,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bessemerstraße 85",
        "zip": "44793",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182320,
        "identifier": "DE002040",
        "googlePlaceId": "ChIJ5e7SwnPFuEcRxlJM2DMh-8U",
        "lat": 51.324982,
        "lng": 6.943767,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Heiligenhaus",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Höseler Straße 65",
        "zip": "42579",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182322,
        "identifier": "DE025048",
        "googlePlaceId": "ChIJravWQxg-uEcR4wYSTBFYjl0",
        "lat": 52.217233,
        "lng": 7.009148,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gronau",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Königstraße 58",
        "zip": "48599",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182323,
        "identifier": "DE013057",
        "googlePlaceId": "ChIJhSeD4SgTuUcRJgVQmyx62_M",
        "lat": 51.554728,
        "lng": 7.684839,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Unna",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kamener Straße 11",
        "zip": "59425",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182324,
        "identifier": "DE002055",
        "googlePlaceId": "ChIJNdk8yJpKuUcR4HXKwY0KhWM",
        "lat": 51.131837,
        "lng": 7.590758,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kierspe",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Friedrich-Ebert-Straße 294-296",
        "zip": "58566",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182325,
        "identifier": "DE032053",
        "googlePlaceId": "ChIJ3TMVvpMeuUcRK0p3U6T8K9A",
        "lat": 51.521743,
        "lng": 7.325813,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Provinzialstraße 417",
        "zip": "44388",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182326,
        "identifier": "DE036056",
        "googlePlaceId": "ChIJIWj6SkO5CUcRUe0Mugffcp4",
        "lat": 50.949493,
        "lng": 13.942965,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Pirna",
        "province": "Sachsen",
        "streetAndNumber": "Rottwerndorfer Straße 41",
        "zip": "01796",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182327,
        "identifier": "DE036093",
        "googlePlaceId": "ChIJGW8cFhg0p0cR98j5qAdMGQk",
        "lat": 50.727943,
        "lng": 12.700435,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oelsnitz",
        "province": "Sachsen",
        "streetAndNumber": "Hedwigschachtstraße 1",
        "zip": "09376",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182328,
        "identifier": "DE001039",
        "googlePlaceId": "ChIJLeI_9PrpuEcR2XG-mIOzn2o",
        "lat": 51.48801,
        "lng": 6.93099,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Donnerstraße 228-240",
        "zip": "45359",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182329,
        "identifier": "DE010076",
        "googlePlaceId": "ChIJrRmn8RUWu0cRGL83uemYXas",
        "lat": 51.411604,
        "lng": 9.393922,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Calden",
        "province": "Hessen",
        "streetAndNumber": "Görlitzer Straße 1",
        "zip": "34379",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182330,
        "identifier": "DE003065",
        "googlePlaceId": "ChIJjf9AQ-yasUcRs9ncuasrSHQ",
        "lat": 53.473389,
        "lng": 9.877052,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Striepenweg 37",
        "zip": "21147",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182331,
        "identifier": "DE006125",
        "googlePlaceId": "ChIJmRt0XB70r0cRYFCZkGeegLA",
        "lat": 52.302161,
        "lng": 10.539904,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Braunschweig",
        "province": "Niedersachsen",
        "streetAndNumber": "Bienroder Weg 53",
        "zip": "38108",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182333,
        "identifier": "DE015072",
        "googlePlaceId": "ChIJp6GEZZF_Y0ERIQpOiBK6tWI",
        "lat": 53.219495,
        "lng": 7.475587,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leer",
        "province": "Niedersachsen",
        "streetAndNumber": "Osseweg 87",
        "zip": "26789",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182334,
        "identifier": "DE025096",
        "googlePlaceId": "ChIJMfejpZbIuUcRayzJiww4eAY",
        "lat": 52.175058,
        "lng": 7.626089,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Saerbeck",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Industriestraße 8",
        "zip": "48369",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182335,
        "identifier": "DE010096",
        "googlePlaceId": "ChIJf6PPHzG8vEcR9uAUOyZVf7Y",
        "lat": 50.742518,
        "lng": 9.256853,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Alsfeld",
        "province": "Hessen",
        "streetAndNumber": "Grünberger Str. 82",
        "zip": "36304",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182336,
        "identifier": "DE002062",
        "googlePlaceId": "ChIJE6bjFF0ouUcRK4tAEuQ5S_s",
        "lat": 51.269257,
        "lng": 7.22944,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Rübenstraße 60",
        "zip": "42289",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182338,
        "identifier": "DE021074",
        "googlePlaceId": "ChIJQdo3tC0Ep0cRXLenjn3659s",
        "lat": 51.2342,
        "lng": 12.72559,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Grimma",
        "province": "Sachsen",
        "streetAndNumber": "Weberstraße 15",
        "zip": "04668",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182340,
        "identifier": "DE026058",
        "googlePlaceId": "ChIJmc0CVVE7r0cRNwJ_tdqGuEs",
        "lat": 52.616303,
        "lng": 11.868266,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stendal",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Arneburger Straße 30",
        "zip": "39576",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182341,
        "identifier": "DE021112",
        "googlePlaceId": "ChIJQ2qETIlqpkcRikdb3U6fgAU",
        "lat": 51.682051,
        "lng": 12.262215,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bitterfeld-Wolfen",
        "province": "Saxony-Anhalt",
        "streetAndNumber": "Dessauer Allee 53",
        "zip": "06766",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182342,
        "identifier": "DE015058",
        "googlePlaceId": "ChIJud76uUC6t0cREUlpZ87E45Q",
        "lat": 52.966044,
        "lng": 7.330423,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dörpen",
        "province": "Niedersachsen",
        "streetAndNumber": "Hauptstraße 34-38",
        "zip": "26892",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182343,
        "identifier": "DE024094",
        "googlePlaceId": "ChIJ76lpgBVRqEcRTAE7ZrhTqUc",
        "lat": 52.527882,
        "lng": 13.317752,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Huttenstraße 41-44",
        "zip": "10553",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182344,
        "identifier": "DE031039",
        "googlePlaceId": "ChIJIbJ1t9aco0cRAilctagVaO0",
        "lat": 50.693719884951,
        "lng": 10.560995182774,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Steinbach-Hallenberg",
        "province": "Thüringen",
        "streetAndNumber": "Bahnhofstraße 16",
        "zip": "98587",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182346,
        "identifier": "DE007070",
        "googlePlaceId": "ChIJ-zeL7sFUsEcRgf42liJSzl0",
        "lat": 52.98354,
        "lng": 9.580198,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Visselhövede",
        "province": "Niedersachsen",
        "streetAndNumber": "Süderstraße 18",
        "zip": "27374",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182347,
        "identifier": "DE002054",
        "googlePlaceId": "ChIJbfViWAwtuUcRwvMW-Q7ZZPU",
        "lat": 51.15178,
        "lng": 7.342456,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hückeswagen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bahnhofsplatz 24",
        "zip": "42499",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182348,
        "identifier": "DE021093",
        "googlePlaceId": "ChIJx4579_HBp0cReYo7tVDszLc",
        "lat": 51.69598,
        "lng": 13.24945,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herzberg (Elster)",
        "province": "Brandenburg",
        "streetAndNumber": "Dresdener Straße 1",
        "zip": "04916",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182349,
        "identifier": "DE004116",
        "googlePlaceId": "ChIJD4ai2d6GsUcR-zpokU53AeQ",
        "lat": 53.632922,
        "lng": 9.871805,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rellingen",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Krupunder Heide 2",
        "zip": "25462",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182350,
        "identifier": "DE024096",
        "googlePlaceId": "ChIJ7aQcR2pPqEcRZ9kCpkFmZzw",
        "lat": 52.505085,
        "lng": 13.444859,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Tamara-Danz-Straße 11",
        "zip": "10243",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "09:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182351,
        "identifier": "DE024025",
        "googlePlaceId": "ChIJfQE4oDv7qUcRfiAASch8bO8",
        "lat": 53.066672,
        "lng": 14.27224,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwedt",
        "province": "Brandenburg",
        "streetAndNumber": "Landgrabenpark 2",
        "zip": "16303",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182352,
        "identifier": "DE025092",
        "googlePlaceId": "ChIJnaLYFu7luUcRu_Vuvob0Kis",
        "lat": 52.270382,
        "lng": 8.028519,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Osnabrück",
        "province": "Niedersachsen",
        "streetAndNumber": "Martinistraße 93",
        "zip": "49080",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182353,
        "identifier": "DE029031",
        "googlePlaceId": "ChIJy8bWrqHDq0cRHLoP5OU2OgU",
        "lat": 53.569031,
        "lng": 13.262264,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neubrandenburg",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Traberallee 11",
        "zip": "17034",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182354,
        "identifier": "DE015002",
        "googlePlaceId": "ChIJKXZlXvnetkcR1FiWWWn38hE",
        "lat": 53.15704,
        "lng": 8.221337,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oldenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Nadorster Straße 150",
        "zip": "26123",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182355,
        "identifier": "DE026078",
        "googlePlaceId": "ChIJNZkeqM_YpUcRI7hT-OkvzSk",
        "lat": 51.676744,
        "lng": 11.771271,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Könnern",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Bernburger Straße 18",
        "zip": "06420",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182356,
        "identifier": "DE026098",
        "googlePlaceId": "ChIJ83GtqkFepUcRC5lhRYsVTHc",
        "lat": 52.168338,
        "lng": 10.574117,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wolfenbüttel",
        "province": "Niedersachsen",
        "streetAndNumber": "Schweigerstraße 7",
        "zip": "38300",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182357,
        "identifier": "DE002023",
        "googlePlaceId": "ChIJUXkO5wpJuUcRljIUaYMGOP4",
        "lat": 51.206815,
        "lng": 7.655665,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lüdenscheid",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Herscheider Landstraße 91",
        "zip": "58515",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182358,
        "identifier": "DE013040",
        "googlePlaceId": "ChIJ_QADa2Z8vEcRwckIUYcsR14",
        "lat": 50.904806,
        "lng": 8.723703,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wetter (Hessen)",
        "province": "Hessen",
        "streetAndNumber": "Am Untertor 8",
        "zip": "35083",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182359,
        "identifier": "DE020066",
        "googlePlaceId": "ChIJJ9lJiZ72qEcRdV96JPb8-po",
        "lat": 52.414804,
        "lng": 13.02287,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Potsdam",
        "province": "Brandenburg",
        "streetAndNumber": "Potsdamer Straße 177",
        "zip": "14469",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182360,
        "identifier": "DE004143",
        "googlePlaceId": "ChIJIW35eG2BrUcRZ4OrY2a5hGI",
        "lat": 54.223768,
        "lng": 11.036112,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Grube",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Bürgermeister-Höppner-Straße 1",
        "zip": "23749",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182361,
        "identifier": "DE007072",
        "googlePlaceId": "ChIJ2RWNdBSxtkcRp9XHjQT1alk",
        "lat": 53.541816,
        "lng": 8.59015,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremerhaven",
        "province": "Bremen",
        "streetAndNumber": "Elbestraße 95",
        "zip": "27570",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182362,
        "identifier": "DE025035",
        "googlePlaceId": "ChIJ-d4MQL0yuEcRrp4BmKo3LkU",
        "lat": 52.286672901416,
        "lng": 7.430353656445,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rheine",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Salzbergener Straße 72-86",
        "zip": "48431",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182363,
        "identifier": "DE003020",
        "googlePlaceId": "ChIJhUdGdhOfsUcRMYnGPOU4W88",
        "lat": 53.366309,
        "lng": 9.714889,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hollenstedt",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Stinnberg 11a",
        "zip": "21279",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182365,
        "identifier": "DE031020",
        "googlePlaceId": "ChIJWyc4Ud2upkcRaXMFh_cC_I0",
        "lat": 50.884276,
        "lng": 11.617439,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Jena",
        "province": "Thüringen",
        "streetAndNumber": "Ebereschenstraße 5-9",
        "zip": "07747",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182366,
        "identifier": "DE026062",
        "googlePlaceId": "ChIJva3d3VURpkcREdGhSVHPis4",
        "lat": 51.817751,
        "lng": 12.216822,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dessau-Roßlau",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Zunftstraße 17",
        "zip": "06847",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182367,
        "identifier": "DE032129",
        "googlePlaceId": "ChIJl6rU9FekuUcRJHfmQ93PpE4",
        "lat": 51.89964,
        "lng": 7.63998,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Münster",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Westfalenstraße 218-224",
        "zip": "48165",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182369,
        "identifier": "DE010028",
        "googlePlaceId": "ChIJqUSfrs9nu0cRDwy3pP2WDfg",
        "lat": 51.133781,
        "lng": 9.278846,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Fritzlar",
        "province": "Hessen",
        "streetAndNumber": "Am Hospital 21",
        "zip": "34560",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182371,
        "identifier": "DE020110",
        "googlePlaceId": "ChIJiQPtoeMVqEcR3oxEJVRKDWA",
        "lat": 52.24219,
        "lng": 13.632866,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bestensee",
        "province": "Brandenburg",
        "streetAndNumber": "Hauptstraße 45",
        "zip": "15741",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182372,
        "identifier": "DE004070",
        "googlePlaceId": "ChIJG2vr0V6DtEcRg6QfjZtKmQc",
        "lat": 54.611456,
        "lng": 8.97858,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bredstedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Husumer Straße 79",
        "zip": "25821",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182373,
        "identifier": "DE016053",
        "googlePlaceId": "ChIJdetcfxmEsUcRwK6Hh4ZYJjk",
        "lat": 53.587815,
        "lng": 9.850364,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Bornheide 55 k-p",
        "zip": "22549",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182374,
        "identifier": "DE032048",
        "googlePlaceId": "ChIJdf3nhKZVuEcR-bYTpk05vbY",
        "lat": 51.825369,
        "lng": 7.271882,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dülmen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hüttenweg 5",
        "zip": "48249",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182375,
        "identifier": "DE003041",
        "googlePlaceId": "ChIJCc1cduy9sUcR1CfZ0PA0zYo",
        "lat": 53.306721,
        "lng": 9.944804,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Jesteburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Allerbeek 2",
        "zip": "21266",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182376,
        "identifier": "DE013063",
        "googlePlaceId": "ChIJKSu9OxlzuUcR1TO5axxVRg4",
        "lat": 51.645507,
        "lng": 7.754837,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamm",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kamener Straße 148",
        "zip": "59077",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182377,
        "identifier": "DE032130",
        "googlePlaceId": "ChIJhbgftSyluUcRhW-8XfMeXJ0",
        "lat": 51.944284,
        "lng": 7.630839,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Münster",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Friedrich-Ebert-Straße 143",
        "zip": "48153",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182378,
        "identifier": "DE020032",
        "googlePlaceId": "ChIJFcyRA2AOqUcR_PWUmAiGn7A",
        "lat": 52.898269,
        "lng": 13.157808,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Löwenberg",
        "province": "Brandenburg",
        "streetAndNumber": "Eberswalder Straße 6",
        "zip": "16775",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182379,
        "identifier": "DE003099",
        "googlePlaceId": "ChIJnUAwYSkVsUcRQMJ6WiumcHw",
        "lat": 53.376477,
        "lng": 9.216026,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Selsingen",
        "province": "Niedersachsen",
        "streetAndNumber": "Hauptstraße 10a",
        "zip": "27446",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182380,
        "identifier": "DE004050",
        "googlePlaceId": "ChIJXQVjC4C3s0cR-1U6kueRzO0",
        "lat": 54.089167,
        "lng": 9.649948,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hohenwestedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Am Markt 2",
        "zip": "24594",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182381,
        "identifier": "DE029032",
        "googlePlaceId": "ChIJ1cGJomXDq0cRKcUcqu6UpxM",
        "lat": 53.550576,
        "lng": 13.272321,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neubrandenburg",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Wilhelm-Külz-Straße 40",
        "zip": "17033",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182382,
        "identifier": "DE029045",
        "googlePlaceId": "ChIJ4XhTo0r3rEcR6DG1kki1Wlw",
        "lat": 54.249846,
        "lng": 12.248052,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Graal-Müritz",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Bahnhofstraße 12",
        "zip": "18181",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182383,
        "identifier": "DE004132",
        "googlePlaceId": "ChIJbzizxjbUs0cRGYM3yNIycxI",
        "lat": 53.745245,
        "lng": 9.672256,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Elmshorn",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hainholzer Damm 9A",
        "zip": "25337",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182384,
        "identifier": "DE021003",
        "googlePlaceId": "ChIJr6gY5SD3pkcR05hjICgxQuQ",
        "lat": 51.345734,
        "lng": 12.318512,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Georg-Schwarz-Straße 92-96",
        "zip": "04179",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182385,
        "identifier": "DE024059",
        "googlePlaceId": "ChIJycsT4veuqUcRPTNVr2ibsxU",
        "lat": 52.74322,
        "lng": 13.45486,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wandlitz",
        "province": "Brandenburg",
        "streetAndNumber": "Berliner Weg 7",
        "zip": "16348",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182386,
        "identifier": "DE016035",
        "googlePlaceId": "ChIJkTPW_brzsUcRCvx-EJb7nlg",
        "lat": 53.528002,
        "lng": 10.251221,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Reinbek",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Sachsenwaldstraße 20",
        "zip": "21465",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182387,
        "identifier": "DE006130",
        "googlePlaceId": "ChIJVZnVzUH2r0cRRF2Hb60MEkU",
        "lat": 52.259854,
        "lng": 10.493839,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Braunschweig",
        "province": "Niedersachsen",
        "streetAndNumber": "Madamenweg 48",
        "zip": "38118",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182388,
        "identifier": "DE024110",
        "googlePlaceId": "ChIJqz0EuAxIqEcRw-9TwKoxF78",
        "lat": 52.442275,
        "lng": 13.58561,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Müggelheimer Straße 36",
        "zip": "12555",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182389,
        "identifier": "DE015009",
        "googlePlaceId": "ChIJCzHLCkbmtkcRJCY2nyaW7bU",
        "lat": 53.260665,
        "lng": 8.113657,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wiefelstede",
        "province": "Niedersachsen",
        "streetAndNumber": "Oldenburger Landstraße 32",
        "zip": "26215",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182390,
        "identifier": "DE025022",
        "googlePlaceId": "ChIJsSXJPMAyuEcRGntmZZw68UI",
        "lat": 52.270653,
        "lng": 7.431264,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rheine",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Pfarrer-Bergmannshoff-Platz 4",
        "zip": "48431",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182391,
        "identifier": "DE029047",
        "googlePlaceId": "ChIJCaQxqnQXrEcRTJRiswpvTw4",
        "lat": 53.652488,
        "lng": 12.266343,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Krakow am See",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Bahnhofsplatz 5",
        "zip": "18292",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182392,
        "identifier": "DE015033",
        "googlePlaceId": "ChIJGyUrLzart0cRkvbsUZAorqw",
        "lat": 53.13938,
        "lng": 7.606553,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ostrhauderfehn",
        "province": "Niedersachsen",
        "streetAndNumber": "Im Gewerbegebiet 22a",
        "zip": "26842",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182393,
        "identifier": "DE032072",
        "googlePlaceId": "ChIJpQ_8qhgMuUcRxJwFzXAvKfQ",
        "lat": 51.669766,
        "lng": 7.625315,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Werne",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Bahnhof 6",
        "zip": "59368",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182394,
        "identifier": "DE036082",
        "googlePlaceId": "ChIJBYTvnibcCEcRTBw7xgPrJps",
        "lat": 51.1464,
        "lng": 14.98749,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Görlitz",
        "province": "Sachsen",
        "streetAndNumber": "Emmerichstraße 33/35",
        "zip": "02826",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182395,
        "identifier": "DE004037",
        "googlePlaceId": "ChIJi7mhqX6ms0cRHXoRyxYaHKs",
        "lat": 54.314603,
        "lng": 9.675735,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Büdelsdorf",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hollerstraße 74",
        "zip": "24782",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182396,
        "identifier": "DE004112",
        "googlePlaceId": "ChIJc-mxqmbVs0cRFHnpooTh1DA",
        "lat": 53.696772,
        "lng": 9.71372,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Tornesch",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Tornescher Hof 1-5",
        "zip": "25436",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182397,
        "identifier": "DE007018",
        "googlePlaceId": "ChIJhfAyXfSxtkcRPJ60Q60wE6c",
        "lat": 53.583594,
        "lng": 8.62653,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schiffdorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Neufelder Weg 3-5",
        "zip": "27619",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182398,
        "identifier": "DE007039",
        "googlePlaceId": "ChIJH1lfVQsnsUcRAdksI29bEUI",
        "lat": 53.08011,
        "lng": 8.893643,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Berliner Freiheit 14",
        "zip": "28327",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182399,
        "identifier": "DE024105",
        "googlePlaceId": "ChIJHTaX7thIqEcR718RkUVaUdE",
        "lat": 52.476764,
        "lng": 13.536902,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Verlängerte Waldowallee 44",
        "zip": "10318",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182400,
        "identifier": "DE013055",
        "googlePlaceId": "ChIJI3FRCJxzuUcR8k6ilcK3wgo",
        "lat": 51.664667,
        "lng": 7.784553,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamm",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lohauserholzstraße 4b",
        "zip": "59067",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182401,
        "identifier": "DE013080",
        "googlePlaceId": "ChIJYVBUfEw7uUcRMln5iQNzCz4",
        "lat": 51.347058,
        "lng": 7.491653,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hagen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Eilper Straße 69",
        "zip": "58095",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182402,
        "identifier": "DE020070",
        "googlePlaceId": "ChIJC0RQpz9fqEcR8uM2UYLUcq8",
        "lat": 52.381769,
        "lng": 13.125304,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Potsdam",
        "province": "Brandenburg",
        "streetAndNumber": "Grossbeerenstraße 215/219",
        "zip": "14480",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182403,
        "identifier": "DE016097",
        "googlePlaceId": "ChIJQc8MKOqDsUcRD37Qio6mjzQ",
        "lat": 53.579965,
        "lng": 9.802155,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Sülldorfer Landstraße 158-162",
        "zip": "22589",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182404,
        "identifier": "DE031008",
        "googlePlaceId": "ChIJw_UEW1pLoUcRstiejRJsX-Y",
        "lat": 50.736132,
        "lng": 11.761348,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neustadt an der Orla",
        "province": "Thüringen",
        "streetAndNumber": "Triptiser Straße 12a",
        "zip": "07806",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182405,
        "identifier": "DE001069",
        "googlePlaceId": "ChIJQ7B2jYr0uEcRdF6MHiijbyI",
        "lat": 51.751993,
        "lng": 6.932606,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dorsten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Erler Straße 28",
        "zip": "46286",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182407,
        "identifier": "DE036076",
        "googlePlaceId": "ChIJQfHZOG00CEcR5-KfHiHdH6I",
        "lat": 51.257045,
        "lng": 13.89057,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Königsbrück",
        "province": "Sachsen",
        "streetAndNumber": "Birkenweg 2",
        "zip": "01936",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182408,
        "identifier": "DE013068",
        "googlePlaceId": "ChIJI9rj-YYkuUcRXY2IclFokuA",
        "lat": 51.359575,
        "lng": 7.375883,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wetter (Ruhr)",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Schöllinger Feld 1",
        "zip": "58300",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182410,
        "identifier": "DE005122",
        "googlePlaceId": "ChIJS-SVD9EUukcRtw0ML65A00I",
        "lat": 52.088418,
        "lng": 8.731234,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Salzuflen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Herforder Straße 93-95",
        "zip": "32105",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182411,
        "identifier": "DE031065",
        "googlePlaceId": "ChIJu9-am0GDpEcR8hblXMFHJ9c",
        "lat": 50.951169,
        "lng": 10.397404,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wutha-Farnroda",
        "province": "Thüringen",
        "streetAndNumber": "Am Rotberg 50",
        "zip": "99848",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182412,
        "identifier": "DE010072",
        "googlePlaceId": "ChIJp3su5Gm8vEcRta7KL4GLaaw",
        "lat": 50.753805,
        "lng": 9.27795,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Alsfeld",
        "province": "Hessen",
        "streetAndNumber": "An der Au 14",
        "zip": "36304",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182413,
        "identifier": "DE021001",
        "googlePlaceId": "ChIJgVBImRj4pkcRf_-vtrvRJ10",
        "lat": 51.343858,
        "lng": 12.382626,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Willy-Brandt-Platz 7",
        "zip": "04109",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "from1": "12:00",
            "to1": "18:00"
          }
        ]
      },
      {
        "id": 3182414,
        "identifier": "DE004013",
        "googlePlaceId": "ChIJWa4PCfdDs0cRG6C_LjqspBI",
        "lat": 54.799781,
        "lng": 9.425621,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Flensburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Werftstraße 29",
        "zip": "24939",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182415,
        "identifier": "DE006085",
        "googlePlaceId": "ChIJ39aUFwU_sEcRhm15jYT7BPA",
        "lat": 52.683049044182,
        "lng": 9.910904646314,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Winsen - Aller",
        "province": "Niedersachsen",
        "streetAndNumber": "Poststraße 32",
        "zip": "29308",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182416,
        "identifier": "DE001079",
        "googlePlaceId": "ChIJOVCaUJdBuEcRAUKIU7gzfdQ",
        "lat": 52.085453,
        "lng": 7.003128,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ahaus",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Fuistingstraße 66",
        "zip": "48683",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182418,
        "identifier": "DE032119",
        "googlePlaceId": "ChIJYw6pMnS0uUcRAYlGLI7lSSc",
        "lat": 52.040581,
        "lng": 7.469679,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Altenberge",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lütke Berg 3",
        "zip": "48341",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182419,
        "identifier": "DE003017",
        "googlePlaceId": "ChIJ03OkXKWRsUcRl__6-88z5cQ",
        "lat": 53.460056,
        "lng": 9.981535,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Lüneburger Straße 39",
        "zip": "21073",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182420,
        "identifier": "DE005130",
        "googlePlaceId": "ChIJYTgrb7xyukcR7c4y34yg7Bs",
        "lat": 52.217611,
        "lng": 8.804115,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Oeynhausen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Werrestraße 15",
        "zip": "32549",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182421,
        "identifier": "DE024038",
        "googlePlaceId": "ChIJi3BS51RJqEcR6vfRawYyiqs",
        "lat": 52.525065,
        "lng": 13.534886,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Marzahner Chaussee 218",
        "zip": "12681",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182422,
        "identifier": "DE032094",
        "googlePlaceId": "ChIJMwrqsCfduEcRgVBwrnpaIvo",
        "lat": 51.432563,
        "lng": 7.030302,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Schürmannstraße 43b",
        "zip": "45136",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182423,
        "identifier": "DE036110",
        "googlePlaceId": "ChIJ1y9P1_g1p0cRoq95ZU0VV0k",
        "lat": 50.710048,
        "lng": 12.777605,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stollberg",
        "province": "Sachsen",
        "streetAndNumber": "Lutherstraße 15",
        "zip": "09366",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182424,
        "identifier": "DE025044",
        "googlePlaceId": "ChIJ17TU5ay9t0cRRNQ22QxREXw",
        "lat": 52.861869,
        "lng": 7.320967,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lathen",
        "province": "Niedersachsen",
        "streetAndNumber": "Kreuzstraße 6-8",
        "zip": "49762",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182425,
        "identifier": "DE015059",
        "googlePlaceId": "ChIJMd62zU9NtkcRWpf9Bbg1-Co",
        "lat": 53.165816,
        "lng": 7.456052,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Westoverledingen",
        "province": "Niedersachsen",
        "streetAndNumber": "Ihrener Straße 7-9",
        "zip": "26810",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182428,
        "identifier": "DE036062",
        "googlePlaceId": "ChIJX1bVmW9Np0cR1S2IM4BEK2Y",
        "lat": 50.652401,
        "lng": 12.971387,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ehrenfriedersdorf",
        "province": "Sachsen",
        "streetAndNumber": "Chemnitzer Straße 52",
        "zip": "09427",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182429,
        "identifier": "DE006012",
        "googlePlaceId": "ChIJCzFozcshsEcRAicSsxmzxn8",
        "lat": 52.621191,
        "lng": 10.244238,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lachendorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Oppershäuserstraße 6",
        "zip": "29331",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182430,
        "identifier": "DE005024",
        "googlePlaceId": "ChIJq9Y_p3IWukcRchXD-tcFPw8",
        "lat": 52.069439,
        "lng": 8.607559,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Braker Straße 34",
        "zip": "33729",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182431,
        "identifier": "DE026089",
        "googlePlaceId": "ChIJhY0EXp5jpUcRdQZZh0DMZ7E",
        "lat": 52.14308,
        "lng": 10.767657,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schöppenstedt",
        "province": "Niedersachsen",
        "streetAndNumber": "Neue Straße 1d",
        "zip": "38170",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182432,
        "identifier": "DE013047",
        "googlePlaceId": "ChIJ7z_vKbm_u0cRkd8Zpcm0yUM",
        "lat": 51.394991,
        "lng": 8.557882,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Brilon",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Mühlenweg 7",
        "zip": "59929",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182433,
        "identifier": "DE021065",
        "googlePlaceId": "ChIJsfl-rTQop0cRP6LOkwRLvDg",
        "lat": 50.81376,
        "lng": 12.3875,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Crimmitschau",
        "province": "Sachsen",
        "streetAndNumber": "Parkhausstraße 2",
        "zip": "08451",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182435,
        "identifier": "DE026027",
        "googlePlaceId": "ChIJ6wSzbXI7r0cRQnjwGL92RGE",
        "lat": 52.588575,
        "lng": 11.872963,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stendal",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Heerener Straße 53",
        "zip": "39576",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182436,
        "identifier": "DE003051",
        "googlePlaceId": "ChIJS1wLhgh4sUcRSLz9e5Ddi9Y",
        "lat": 53.529141,
        "lng": 9.687566,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Jork",
        "province": "Niedersachsen",
        "streetAndNumber": "Ostfeld 1",
        "zip": "21635",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182437,
        "identifier": "DE007089",
        "googlePlaceId": "ChIJDXBCXBvwsEcREYfTIuA86AI",
        "lat": 52.847533,
        "lng": 9.226169,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dörverden",
        "province": "Niedersachsen",
        "streetAndNumber": "Wulfers Hoff 8",
        "zip": "27313",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182438,
        "identifier": "DE007052",
        "googlePlaceId": "ChIJ2zE0cdoesUcRI-cUEj-pd7c",
        "lat": 53.114741,
        "lng": 9.142314,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ottersberg",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Damm 10",
        "zip": "28870",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182439,
        "identifier": "DE006040",
        "googlePlaceId": "ChIJIy2-uNqSr0cRIOATZabVGis",
        "lat": 52.421198,
        "lng": 10.718482,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wolfsburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Mühlenkamp 15",
        "zip": "38442",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182440,
        "identifier": "DE020053",
        "googlePlaceId": "ChIJp9oetHJWqEcR0AF1sPaUOrI",
        "lat": 52.556907,
        "lng": 13.209134,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Streitstraße 5-19",
        "zip": "13587",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182441,
        "identifier": "DE005073",
        "googlePlaceId": "ChIJc8Mxa9ZJukcRZ9cjUf3p3MM",
        "lat": 51.823192,
        "lng": 8.658405,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hövelhof",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Westfalenstraße 14",
        "zip": "33161",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182442,
        "identifier": "DE025026",
        "googlePlaceId": "ChIJwQpxQ7ILt0cRDCvOHfX26BQ",
        "lat": 52.85369,
        "lng": 7.672818,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Werlte",
        "province": "Niedersachsen",
        "streetAndNumber": "Harrenstätter Straße 5",
        "zip": "49757",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182444,
        "identifier": "DE032098",
        "googlePlaceId": "ChIJEWlgWqveuEcRc9ljbk5oDvI",
        "lat": 51.384093,
        "lng": 7.115614,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Nierenhofer Straße 76",
        "zip": "45257",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182445,
        "identifier": "DE002064",
        "googlePlaceId": "ChIJGRKytdYpuUcRm59oEpJFYv0",
        "lat": 51.246562,
        "lng": 7.187422,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Oberbergische Straße 180",
        "zip": "42285",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182447,
        "identifier": "DE015024",
        "googlePlaceId": "ChIJCTQN32-JtkcRG06wrYdiAsA",
        "lat": 53.576124,
        "lng": 7.886723,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Jever",
        "province": "Niedersachsen",
        "streetAndNumber": "Wittmunder Straße 7",
        "zip": "26441",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182448,
        "identifier": "DE025086",
        "googlePlaceId": "ChIJNzhDqFLkuUcRohKnZHeYSQM",
        "lat": 52.300636,
        "lng": 8.060163,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Osnabrück",
        "province": "Niedersachsen",
        "streetAndNumber": "Mönkedieckstraße 3-9",
        "zip": "49088",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182449,
        "identifier": "DE032027",
        "googlePlaceId": "ChIJPSGpSikiuUcRir1B6tZRzg0",
        "lat": 51.418682,
        "lng": 7.339642,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Witten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bommerfelder Ring 108",
        "zip": "58452",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182450,
        "identifier": "DE002073",
        "googlePlaceId": "ChIJc4wlH_zTuEcRFIUtNUpPXJ0",
        "lat": 51.214518,
        "lng": 7.058628,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Westring 320",
        "zip": "42329",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182451,
        "identifier": "DE026037",
        "googlePlaceId": "ChIJtxw2Mqhlr0cRPLuec50NX-M",
        "lat": 52.28672,
        "lng": 11.420024,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Haldensleben",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Magdeburger Straße 81",
        "zip": "39340",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182452,
        "identifier": "DE006142",
        "googlePlaceId": "ChIJPXR4h5ZQpUcR4TSiOCIp8L4",
        "lat": 52.139963,
        "lng": 10.340518,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Salzgitter",
        "province": "Niedersachsen",
        "streetAndNumber": "Watenstedter Weg 8",
        "zip": "38229",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182453,
        "identifier": "DE016027",
        "googlePlaceId": "ChIJp2FjFFCPsUcRy89-OJ-uCV8",
        "lat": 53.573138,
        "lng": 9.961467,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Bismarckstraße 24",
        "zip": "20259",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182455,
        "identifier": "DE031057",
        "googlePlaceId": "ChIJsTerVDPBo0cR2LM9e7XZIqQ",
        "lat": 50.415676,
        "lng": 10.913656,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eisfeld",
        "province": "Thüringen",
        "streetAndNumber": "Coburger Straße 76",
        "zip": "98673",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182456,
        "identifier": "DE016036",
        "googlePlaceId": "ChIJ47lZ_q_4rUcRArPDl1S3M7c",
        "lat": 53.701201,
        "lng": 10.742351,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ratzeburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Max-Planck-Straße 13",
        "zip": "23909",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182457,
        "identifier": "DE016057",
        "googlePlaceId": "ChIJq2iG6gGIsUcRPpJGTpEvLuc",
        "lat": 53.667,
        "lng": 9.989293,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Norderstedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Rugenbarg 84-90",
        "zip": "22848",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182459,
        "identifier": "DE025052",
        "googlePlaceId": "ChIJr7sAlwJct0cRZBxrIwF56pU",
        "lat": 52.514448,
        "lng": 8.068469,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neuenkirchen-Vörden",
        "province": "Niedersachsen",
        "streetAndNumber": "Holdorfer Straße 11",
        "zip": "49434",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182460,
        "identifier": "DE026091",
        "googlePlaceId": "ChIJ6WwpOsyKr0cRYn5cT8mOdEU",
        "lat": 52.251132,
        "lng": 10.643031,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Cremlingen",
        "province": "Niedersachsen",
        "streetAndNumber": "Im Moorbusche 4",
        "zip": "38162",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182461,
        "identifier": "DE006015",
        "googlePlaceId": "ChIJ28wlC04FsEcRg2wtG6ZqGho",
        "lat": 52.443263,
        "lng": 10.025637,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Burgdorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Ostlandring 4",
        "zip": "31303",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182462,
        "identifier": "DE024009",
        "googlePlaceId": "ChIJ6cIM96M2qEcR_dzRVp5mqeA",
        "lat": 52.496922,
        "lng": 13.743686,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Fredersdorf-Vogelsdorf",
        "province": "Brandenburg",
        "streetAndNumber": "Frankfurter Chaussee 52",
        "zip": "15370",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182463,
        "identifier": "DE031022",
        "googlePlaceId": "ChIJmxeBMiQkoUcR36UU1Fdcy_c",
        "lat": 50.494376,
        "lng": 12.10039,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Plauen",
        "province": "Sachsen",
        "streetAndNumber": "Neundorfer Straße 188",
        "zip": "08523",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182464,
        "identifier": "DE010097",
        "googlePlaceId": "ChIJDXpN7Jr0ukcRyqNeW_YPlmk",
        "lat": 51.967606,
        "lng": 9.254641,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lügde",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Siemensstraße 39",
        "zip": "32676",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182465,
        "identifier": "DE007003",
        "googlePlaceId": "ChIJnRfOCynVsEcRbS-bABtNC4M",
        "lat": 53.04007,
        "lng": 8.59294,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Delmenhorst",
        "province": "Niedersachsen",
        "streetAndNumber": "Wildeshauser Straße 50",
        "zip": "27753",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182467,
        "identifier": "DE013027",
        "googlePlaceId": "ChIJy2kBZIoYcEER1fYkLwQgbRI",
        "lat": 51.745289,
        "lng": 7.661825,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ascheberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Münsterstraße 29",
        "zip": "59387",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182468,
        "identifier": "DE006054",
        "googlePlaceId": "ChIJox9urlq8r0cRWtcrAJdsP5w",
        "lat": 52.594611,
        "lng": 10.935799,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Brome",
        "province": "Niedersachsen",
        "streetAndNumber": "Braunschweiger Straße 50",
        "zip": "38465",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182470,
        "identifier": "DE029011",
        "googlePlaceId": "ChIJod1CYMqDrEcRMJfMGNoKk6w",
        "lat": 54.203649,
        "lng": 12.903362,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Richtenberg",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Am Gewerbering 2",
        "zip": "18461",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182471,
        "identifier": "DE013034",
        "googlePlaceId": "ChIJDfdGWgATuUcRGfvN7KcFANE",
        "lat": 51.535697,
        "lng": 7.648885,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Unna",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kleistraße 18",
        "zip": "59427",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182472,
        "identifier": "DE004097",
        "googlePlaceId": "ChIJs9hxzan4skcRqcd-I9tLT34",
        "lat": 54.360714,
        "lng": 10.131677,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Prinz-Heinrich-Straße 20",
        "zip": "24106",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182473,
        "identifier": "DE021047",
        "googlePlaceId": "ChIJyySEj56JpkcRN5j4_XBZ8U4",
        "lat": 51.371805,
        "lng": 11.983286,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Merseburg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Querfurter Straße 4",
        "zip": "06217",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182475,
        "identifier": "DE025076",
        "googlePlaceId": "ChIJQWNwcsbauUcRHfdiD7wGgHo",
        "lat": 52.293473,
        "lng": 7.706434,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ibbenbüren",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Rheiner Straße 29",
        "zip": "49477",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182476,
        "identifier": "DE003086",
        "googlePlaceId": "ChIJGUPUlyF7sUcREB9eKU2kmHk",
        "lat": 53.581441,
        "lng": 9.49743,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stade",
        "province": "Niedersachsen",
        "streetAndNumber": "Carl-Benz-Straße 4",
        "zip": "21684",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182477,
        "identifier": "DE016071",
        "googlePlaceId": "ChIJiwPXBXwoskcRH9-a2WMP66c",
        "lat": 53.706748,
        "lng": 9.988606,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Norderstedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Buckhörner Moor 110-112",
        "zip": "22846",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182478,
        "identifier": "DE020055",
        "googlePlaceId": "ChIJm7R9VU70qEcRxRDJod8xueg",
        "lat": 52.383159,
        "lng": 13.022368,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Potsdam",
        "province": "Brandenburg",
        "streetAndNumber": "Zeppelinstraße 119/120",
        "zip": "14471",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182479,
        "identifier": "DE036069",
        "googlePlaceId": "ChIJNcV_-EU9CUcRay9SE0OCN34",
        "lat": 50.899761,
        "lng": 14.794225,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zittau",
        "province": "Sachsen",
        "streetAndNumber": "Dresdner Straße 42",
        "zip": "02763",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182480,
        "identifier": "DE015042",
        "googlePlaceId": "ChIJB_v6_HBltkcRWRQX-2SjN7o",
        "lat": 53.632414,
        "lng": 7.617251,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Esens",
        "province": "Niedersachsen",
        "streetAndNumber": "Wittmunder Straße 6",
        "zip": "26427",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182481,
        "identifier": "DE004047",
        "googlePlaceId": "ChIJw4IvOY2Os0cRY_qmb747538",
        "lat": 54.198087,
        "lng": 9.120413,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Heide",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hamburger Straße 143",
        "zip": "25746",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182482,
        "identifier": "DE006128",
        "googlePlaceId": "ChIJ1dsWEVz2r0cRTc0eQhs8AmU",
        "lat": 52.273479,
        "lng": 10.493519,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Braunschweig",
        "province": "Niedersachsen",
        "streetAndNumber": "Hannoversche Straße 59",
        "zip": "38114",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182484,
        "identifier": "DE015004",
        "googlePlaceId": "ChIJhWfe6a-TtkcRnx3PijPZtB0",
        "lat": 53.515781,
        "lng": 8.101403,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wilhelmshaven",
        "province": "Niedersachsen",
        "streetAndNumber": "Rüderstraße 3A",
        "zip": "26382",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182485,
        "identifier": "DE007054",
        "googlePlaceId": "ChIJ1_Dw085QsEcRDVneYJzluH8",
        "lat": 52.858628,
        "lng": 9.582947,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Walsrode",
        "province": "Niedersachsen",
        "streetAndNumber": "Sudetenstraße 2",
        "zip": "29664",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182486,
        "identifier": "DE005139",
        "googlePlaceId": "ChIJ0cl_qa4Su0cRqWRYhG6PFYg",
        "lat": 51.329517,
        "lng": 9.173207,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wolfhagen",
        "province": "Hessen",
        "streetAndNumber": "Schützeberger Straße 91b",
        "zip": "34466",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182487,
        "identifier": "DE005032",
        "googlePlaceId": "ChIJiyUn4XwsukcRUwM7HAJixwQ",
        "lat": 51.77158,
        "lng": 8.319659,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Langenberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bentelerstraße 40",
        "zip": "33449",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182488,
        "identifier": "DE024101",
        "googlePlaceId": "ChIJjQPi5gdJqEcRQhUv91cxThk",
        "lat": 52.490185,
        "lng": 13.576799,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Chemnitzer Straße 177",
        "zip": "12621",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182489,
        "identifier": "DE025091",
        "googlePlaceId": "ChIJoboJ6wbmuUcR44xL4hpq3Mo",
        "lat": 52.268075,
        "lng": 8.002455,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Osnabrück",
        "province": "Niedersachsen",
        "streetAndNumber": "Otto-Vesper-Straße 1",
        "zip": "49078",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182490,
        "identifier": "DE029013",
        "googlePlaceId": "ChIJHwUIOZZFrEcRMD7Yh7gC2P0",
        "lat": 53.940733,
        "lng": 12.106612,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwaan",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Mühlenteichplatz 2",
        "zip": "18258",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182491,
        "identifier": "DE002046",
        "googlePlaceId": "ChIJQf2eA-HLvkcRJQs7dlqGtkQ",
        "lat": 51.027818,
        "lng": 7.4672,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gummersbach",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Gelpestraße 49",
        "zip": "51647",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182492,
        "identifier": "DE036068",
        "googlePlaceId": "ChIJvzBROXgqCEcRk7zelGJjG1o",
        "lat": 51.288874,
        "lng": 13.532606,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Großenhain",
        "province": "Sachsen",
        "streetAndNumber": "Dresdner Straße 33",
        "zip": "01558",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182494,
        "identifier": "DE024070",
        "googlePlaceId": "ChIJvVZS_B6rqUcRj3defv57jSA",
        "lat": 52.66705,
        "lng": 13.29718,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hohen Neuendorf",
        "province": "Brandenburg",
        "streetAndNumber": "Schönfliesser Straße 25e",
        "zip": "16540",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182495,
        "identifier": "DE036064",
        "googlePlaceId": "ChIJA2ANkujHCUcRYCIh7eh3Yjo",
        "lat": 51.017827,
        "lng": 13.844945,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Kleinzschachwitzer Ufer 3",
        "zip": "01259",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182496,
        "identifier": "DE032020",
        "googlePlaceId": "ChIJo-2lAsMhuUcRumsWrb8GWco",
        "lat": 51.442949,
        "lng": 7.309342,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Witten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hellweg 46a",
        "zip": "58455",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182497,
        "identifier": "DE031012",
        "googlePlaceId": "ChIJeZz88fNoo0cRbe3pu_jbcRo",
        "lat": 50.714748,
        "lng": 10.124026,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dermbach",
        "province": "Thüringen",
        "streetAndNumber": "An der Zehnt 4",
        "zip": "36466",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182498,
        "identifier": "DE007012",
        "googlePlaceId": "ChIJWWu6xf6wtkcRNf0Xf52ci5I",
        "lat": 53.557057,
        "lng": 8.564739,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremerhaven",
        "province": "Bremen",
        "streetAndNumber": "Barkhausenstraße 107",
        "zip": "27568",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182499,
        "identifier": "DE026026",
        "googlePlaceId": "ChIJwyr-VVJgr0cRf2H8nkYKodU",
        "lat": 52.17647,
        "lng": 11.494508,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hohenwarsleben",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Irxleber Straße 7",
        "zip": "39326",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182501,
        "identifier": "DE020008",
        "googlePlaceId": "ChIJxy_jmVdEqEcRJpLbL6JenuI",
        "lat": 52.40177,
        "lng": 13.413055,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Töpchiner Weg 193",
        "zip": "12309",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182502,
        "identifier": "DE029008",
        "googlePlaceId": "ChIJm-0yPGZjq0cRGBHG1ErrYqc",
        "lat": 54.271871,
        "lng": 13.113661,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stralsund",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Gustower Weg 3",
        "zip": "18439",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182503,
        "identifier": "DE003092",
        "googlePlaceId": "ChIJIwIp18hDsUcRz3-TKmUKe_Q",
        "lat": 53.492142,
        "lng": 9.129701,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremervörde",
        "province": "Niedersachsen",
        "streetAndNumber": "Wesermünder Straße 70",
        "zip": "27432",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182504,
        "identifier": "DE002043",
        "googlePlaceId": "ChIJjVbFCVbauEcRL_SPsj_IlUo",
        "lat": 51.331311,
        "lng": 7.055534,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Velbert",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Friedrichstraße 305",
        "zip": "42551",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182506,
        "identifier": "DE021106",
        "googlePlaceId": "ChIJpbzTeM1ipkcR7k1a2tqUzPU",
        "lat": 51.442556,
        "lng": 11.947746,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Halle (Saale)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Kaiserslauterer Straße 65",
        "zip": "06128",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182507,
        "identifier": "DE032110",
        "googlePlaceId": "ChIJfS6wUiytuUcRVLj7H7Hvo1A",
        "lat": 51.926384,
        "lng": 7.363312,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nottuln",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Appelhülsener Straße 24",
        "zip": "48301",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182508,
        "identifier": "DE029083",
        "googlePlaceId": "ChIJG8KEz_e1rUcRkwXlTRxQGbk",
        "lat": 53.866892,
        "lng": 11.682485,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neukloster",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Burgstraße 1",
        "zip": "23992",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182509,
        "identifier": "DE020102",
        "googlePlaceId": "ChIJQ599PFFGqEcR0wkuwamz7CE",
        "lat": 52.405508,
        "lng": 13.523855,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Schönefelder Chaussee 174",
        "zip": "12524",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182510,
        "identifier": "DE002100",
        "googlePlaceId": "ChIJRTbHyiEavEcR08UvnA0L_ps",
        "lat": 50.817311,
        "lng": 8.105567,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wilnsdorf",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hagener Straße 13",
        "zip": "57234",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182513,
        "identifier": "DE006059",
        "googlePlaceId": "ChIJHXIvuE7zr0cRbVLqyepCnuo",
        "lat": 52.324141,
        "lng": 10.659612,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lehre",
        "province": "Niedersachsen",
        "streetAndNumber": "Berliner Straße 4a",
        "zip": "38165",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182514,
        "identifier": "DE004079",
        "googlePlaceId": "ChIJNwH-4NP-skcRvBKgDuhimL4",
        "lat": 54.410278,
        "lng": 10.13007,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Altenholz",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Erdbeerfeld 2",
        "zip": "24161",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182516,
        "identifier": "DE031028",
        "googlePlaceId": "ChIJ06zD1-ibpEcR_WDwgWtD0R8",
        "lat": 50.992601,
        "lng": 10.292867,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eisenach",
        "province": "Thüringen",
        "streetAndNumber": "An der Karlskuppe 9",
        "zip": "99817",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182517,
        "identifier": "DE007081",
        "googlePlaceId": "ChIJIYpLZj0usUcRWjovwEq2XmI",
        "lat": 53.227196,
        "lng": 8.78864,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Osterholz-Scharmbeck",
        "province": "Niedersachsen",
        "streetAndNumber": "Bahnhofstraße 99-105",
        "zip": "27711",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182518,
        "identifier": "DE004144",
        "googlePlaceId": "ChIJi31e8vxnskcRD75R09hUbh0",
        "lat": 54.16155,
        "lng": 10.42599,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Plön",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Lütjenburger Straße 9-10",
        "zip": "24306",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182520,
        "identifier": "DE024052",
        "googlePlaceId": "ChIJ09kZPRVKqEcRlwXkyo4pShM",
        "lat": 52.536614,
        "lng": 13.635284,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hönow",
        "province": "Brandenburg",
        "streetAndNumber": "Mahlsdorfer Straße 56",
        "zip": "15366",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182521,
        "identifier": "DE001090",
        "googlePlaceId": "ChIJpWxFNaDCuEcRztNqm1d55pg",
        "lat": 51.472195,
        "lng": 6.999447,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Feilenstraße 3",
        "zip": "45141",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182522,
        "identifier": "DE006167",
        "googlePlaceId": "ChIJgW06_-N_sEcR8w3XDgqQ5o0",
        "lat": 52.353396,
        "lng": 9.289688,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lindhorst",
        "province": "Niedersachsen",
        "streetAndNumber": "Gewerbestraße 3",
        "zip": "31698",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182523,
        "identifier": "DE007080",
        "googlePlaceId": "ChIJR3v9164ssUcRfeLIn_FLuss",
        "lat": 53.170234,
        "lng": 8.63529,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Hermann-Fortmann-Straße 21",
        "zip": "28759",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182524,
        "identifier": "DE032069",
        "googlePlaceId": "ChIJEVC0_V8SuUcRpqDhyauZkqQ",
        "lat": 51.582166,
        "lng": 7.647691,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kamen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hemsack 6",
        "zip": "59174",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182525,
        "identifier": "DE031077",
        "googlePlaceId": "ChIJ6cOZa-bOpkcRH-ylVA26Rsg",
        "lat": 50.839008,
        "lng": 12.064959,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gera",
        "province": "Thüringen",
        "streetAndNumber": "Otto-Rothe-Straße 26",
        "zip": "07549",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182526,
        "identifier": "DE005042",
        "googlePlaceId": "ChIJTf5G4vckukcRnOAsUfHWKa8",
        "lat": 51.94489,
        "lng": 8.41569,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gütersloh",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Isselhorster Straße 416",
        "zip": "33334",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182527,
        "identifier": "DE036017",
        "googlePlaceId": "ChIJVeEm0E_ICUcRKAUB_DoXMF0",
        "lat": 51.062211,
        "lng": 13.850998,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Bautzner Landstraße 149",
        "zip": "01324",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182528,
        "identifier": "DE016130",
        "googlePlaceId": "ChIJLycdUYMKskcRQ3BaEdooV1o",
        "lat": 53.914441,
        "lng": 10.80532,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübeck",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Solmitzstraße 18-24",
        "zip": "23569",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182530,
        "identifier": "DE001043",
        "googlePlaceId": "ChIJT3lcpThguEcRedQhLj-iCLA",
        "lat": 51.8419,
        "lng": 6.86712,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Borken",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Heidener Straße 65",
        "zip": "46325",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182531,
        "identifier": "DE036109",
        "googlePlaceId": "ChIJmxjFk0M3p0cR2767heILP2I",
        "lat": 50.804157,
        "lng": 12.73077,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hohenstein-Ernstthal",
        "province": "Sachsen",
        "streetAndNumber": "Dresdner Straße 151",
        "zip": "09337",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182532,
        "identifier": "DE020107",
        "googlePlaceId": "ChIJfT1UQRo_qEcRCwvjwxdWAf8",
        "lat": 52.317674,
        "lng": 13.601834,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wildau",
        "province": "Brandenburg",
        "streetAndNumber": "Gewerbepark 4",
        "zip": "15745",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182534,
        "identifier": "DE010007",
        "googlePlaceId": "ChIJ_WY6HvNUo0cRUk8N3bnIqXk",
        "lat": 50.88013,
        "lng": 9.7231,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Hersfeld",
        "province": "Hessen",
        "streetAndNumber": "Friedloser Straße 29",
        "zip": "36251",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182535,
        "identifier": "DE026036",
        "googlePlaceId": "ChIJC1GpQu2JrkcR60nNCq_GDb4",
        "lat": 53.273678,
        "lng": 11.562545,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Grabow",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Fliederweg 5",
        "zip": "19300",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182536,
        "identifier": "DE032132",
        "googlePlaceId": "ChIJK_h67CmluUcRtIfiLLuaeyQ",
        "lat": 51.93751,
        "lng": 7.635609,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Münster",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Robert-Bosch-Straße 21",
        "zip": "48153",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182537,
        "identifier": "DE001074",
        "googlePlaceId": "ChIJe-U35C3DuEcRInKqGGg2FCc",
        "lat": 51.422279,
        "lng": 7.005025,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Heinrich-Held-Straße 39",
        "zip": "45133",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182538,
        "identifier": "DE016146",
        "googlePlaceId": "ChIJzbW5ZVV0skcRwWIVvBxAMwY",
        "lat": 53.994387,
        "lng": 10.779723,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Timmendorfer Strand",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Höppnerweg 14",
        "zip": "23669",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182539,
        "identifier": "DE021085",
        "googlePlaceId": "ChIJ6T-6Mwz3pkcRih0ROUDO_Gw",
        "lat": 51.321255,
        "lng": 12.322755,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Klingenstraße 38a",
        "zip": "04229",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182540,
        "identifier": "DE013004",
        "googlePlaceId": "ChIJbVH503OCuUcReBXaRe0AXig",
        "lat": 51.752946,
        "lng": 8.048574,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Beckum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lippweg 16",
        "zip": "59269",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182541,
        "identifier": "DE032031",
        "googlePlaceId": "ChIJR9wzoGISuUcR9butWRU5L1E",
        "lat": 51.591047,
        "lng": 7.651014,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kamen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lünener Straße 225",
        "zip": "59174",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182542,
        "identifier": "DE010098",
        "googlePlaceId": "ChIJzyA7t6jlukcRSJlduyOaJXA",
        "lat": 51.783957,
        "lng": 9.380996,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Höxter",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Küsterweg 1",
        "zip": "37671",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182543,
        "identifier": "DE016042",
        "googlePlaceId": "ChIJO8GaIGGPsUcRc8HSmv_c4Tw",
        "lat": 53.559177,
        "lng": 9.948473,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Holstenstraße 156",
        "zip": "22765",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182545,
        "identifier": "DE001057",
        "googlePlaceId": "ChIJd36xGKPhuEcR594MrR0KiEE",
        "lat": 51.522569,
        "lng": 7.210165,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herne",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Riemker Straße 102",
        "zip": "44625",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182546,
        "identifier": "DE021022",
        "googlePlaceId": "ChIJLeod3WjOp0cR_NE0dhuvj3U",
        "lat": 51.78553,
        "lng": 12.955115,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Jessen (Elster)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Hospitalplatz 10",
        "zip": "06917",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182548,
        "identifier": "DE021075",
        "googlePlaceId": "ChIJHz7zFnD2pkcRQqpP_jZlee4",
        "lat": 51.34739,
        "lng": 12.267208,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Miltitzer Straße 13",
        "zip": "04178",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182549,
        "identifier": "DE036106",
        "googlePlaceId": "ChIJVQz7w8hHp0cR5sLxzUdXa-o",
        "lat": 50.81898,
        "lng": 12.878147,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Chemnitz",
        "province": "Sachsen",
        "streetAndNumber": "Zwickauer Straße 247",
        "zip": "09116",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182550,
        "identifier": "DE001063",
        "googlePlaceId": "ChIJk04IrVNEuEcRQdHZF2O9MWg",
        "lat": 52.027206,
        "lng": 7.107853,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Legden",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Friedrich-Castelle-Straße 7",
        "zip": "48739",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182551,
        "identifier": "DE021056",
        "googlePlaceId": "ChIJK5GcLKcvp0cROlUbdbPMqrU",
        "lat": 50.812665,
        "lng": 12.541394,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Glauchau",
        "province": "Sachsen",
        "streetAndNumber": "Goetheweg 30",
        "zip": "08371",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182552,
        "identifier": "DE015063",
        "googlePlaceId": "ChIJ-X8yvjHetkcRNJLbU83n-pg",
        "lat": 53.158203,
        "lng": 8.173921,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oldenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Posthalterweg 10",
        "zip": "26129",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182553,
        "identifier": "DE013097",
        "googlePlaceId": "ChIJn0jeqxNyvEcRXVS8p0ATL44",
        "lat": 50.891928,
        "lng": 8.451683,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Breidenbach",
        "province": "Hessen",
        "streetAndNumber": "Hauptstraße 99",
        "zip": "35236",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182554,
        "identifier": "DE003097",
        "googlePlaceId": "ChIJ_Wg79kgjrkcR5f5ozKJ9dBE",
        "lat": 53.185568,
        "lng": 10.745095,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dahlenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Dannenberger Landstraße 24",
        "zip": "21368",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182555,
        "identifier": "DE020006",
        "googlePlaceId": "ChIJ48aryqpaqEcRK7-bOv4eZR8",
        "lat": 52.451839,
        "lng": 13.362092,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Röblingstraße 124",
        "zip": "12105",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182556,
        "identifier": "DE004073",
        "googlePlaceId": "ChIJ0wGH2wlos0cRAjtTkz0cKUA",
        "lat": 54.75675,
        "lng": 9.387854,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Flensburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Holzkrugweg 2",
        "zip": "24941",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182557,
        "identifier": "DE032117",
        "googlePlaceId": "ChIJ8b0CsgdPuEcRTUrS2WRU6dE",
        "lat": 52.015288,
        "lng": 7.207927,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rosendahl",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hauptstraße 39",
        "zip": "48720",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182558,
        "identifier": "DE007077",
        "googlePlaceId": "ChIJqylNuU2vtkcRs_ysOtbg7cY",
        "lat": 53.688115,
        "lng": 8.57077,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wurster Nordseeküste",
        "province": "Niedersachsen",
        "streetAndNumber": "Speckenstraße 15",
        "zip": "27639",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182559,
        "identifier": "DE013067",
        "googlePlaceId": "ChIJd6K3A3zgu0cRwwCKbcm6nEQ",
        "lat": 51.395996,
        "lng": 8.133383,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Arnsberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Widayweg 2-4",
        "zip": "59823",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182560,
        "identifier": "DE005141",
        "googlePlaceId": "ChIJVZIGK74Hu0cRPnCpTgv7oMc",
        "lat": 51.528119,
        "lng": 9.037027,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Warburg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kasseler Tor 40 a",
        "zip": "34414",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182561,
        "identifier": "DE003112",
        "googlePlaceId": "ChIJQQLO4Py-sUcRgxiYQ07Qfco",
        "lat": 53.263733158747,
        "lng": 10.009565770012,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hanstedt",
        "province": "Niedersachsen",
        "streetAndNumber": "Harburger Straße 51-53",
        "zip": "21271",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182563,
        "identifier": "DE025101",
        "googlePlaceId": "ChIJx-U_GKfduUcRounSZ9d7ocQ",
        "lat": 52.314127,
        "lng": 7.87226,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Westerkappeln",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Heerstraße 1",
        "zip": "49492",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182564,
        "identifier": "DE006043",
        "googlePlaceId": "ChIJkUj7fssLsEcRFQI6EXBwLd8",
        "lat": 52.338996,
        "lng": 9.833107,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Wülferoder Straße 51",
        "zip": "30539",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182565,
        "identifier": "DE004021",
        "googlePlaceId": "ChIJr3BHgGxWskcRTMhzuUNuFCs",
        "lat": 54.335099,
        "lng": 10.132247,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Droysenstraße 5",
        "zip": "24105",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182566,
        "identifier": "DE003109",
        "googlePlaceId": "ChIJX_9sx_PbrUcRVfiSAfcYo9s",
        "lat": 53.652838,
        "lng": 11.331821,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwerin",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Lärchenallee 32",
        "zip": "19057",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182567,
        "identifier": "DE013075",
        "googlePlaceId": "ChIJzXxTsfRDuUcRpQySl-35wsE",
        "lat": 51.394772,
        "lng": 7.767813,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hemer",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Mendener Straße 42",
        "zip": "58675",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182568,
        "identifier": "DE002035",
        "googlePlaceId": "ChIJOZ1VHUsquUcR0ixXaN5PFkQ",
        "lat": 51.183831,
        "lng": 7.218531,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Remscheid",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hohenhagener Straße 45",
        "zip": "42855",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182569,
        "identifier": "DE024039",
        "googlePlaceId": "ChIJyzrtJOM1qEcRry0NuLNKB3Q",
        "lat": 52.520719,
        "lng": 13.672917,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dahlwitz-Hoppegarten",
        "province": "Brandenburg",
        "streetAndNumber": "Lindenallee 2",
        "zip": "15366",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182570,
        "identifier": "DE006010",
        "googlePlaceId": "ChIJ6RA4V6N1sEcRqiOpoxjOhis",
        "lat": 52.333907,
        "lng": 9.663841,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ronnenberg",
        "province": "Niedersachsen",
        "streetAndNumber": "Ronnenberger Straße 20",
        "zip": "30952",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182571,
        "identifier": "DE003108",
        "googlePlaceId": "ChIJObk33wTXrUcRCS9nsnazrug",
        "lat": 53.60265,
        "lng": 11.444943,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwerin",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Pilaer Straße 3",
        "zip": "19063",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182572,
        "identifier": "DE003073",
        "googlePlaceId": "ChIJLzJ5Gtp1sUcRr1VvmxQkUs0",
        "lat": 53.430834,
        "lng": 9.612805,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Apensen",
        "province": "Niedersachsen",
        "streetAndNumber": "Beckdorfer Straße 14",
        "zip": "21641",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182573,
        "identifier": "DE005003",
        "googlePlaceId": "ChIJn_ZtbyorukcRGcodPUAYZbY",
        "lat": 51.736013,
        "lng": 8.242417,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wadersloh",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Mühlenfeldstraße 3",
        "zip": "59329",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182574,
        "identifier": "DE024072",
        "googlePlaceId": "ChIJ_-ULDND_qEcRKQpYEws4Lbg",
        "lat": 52.637253299903,
        "lng": 13.200304670174,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hennigsdorf",
        "province": "Brandenburg",
        "streetAndNumber": "Havelplatz 10",
        "zip": "16761",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182575,
        "identifier": "DE024042",
        "googlePlaceId": "ChIJdfLulDVKqEcRtgUyi6J0Gas",
        "lat": 52.540068,
        "lng": 13.608559,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Tangermünder Straße 125",
        "zip": "12627",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182576,
        "identifier": "DE002041",
        "googlePlaceId": "ChIJRV57_ImtvkcRJPa9NvTf5XA",
        "lat": 51.031981,
        "lng": 7.766529,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Drolshagen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "In der Hützenau 2",
        "zip": "57489",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182577,
        "identifier": "DE013059",
        "googlePlaceId": "ChIJLaxTY1hbuUcRmH-9Z7cNpQ8",
        "lat": 51.333853,
        "lng": 7.867765,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Balve",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hönnetalstraße 34-36",
        "zip": "58802",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182578,
        "identifier": "DE020073",
        "googlePlaceId": "ChIJOy9AaTpFqEcRbZZjxXi0Kjg",
        "lat": 52.429871,
        "lng": 13.379102,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Wilhelm-von-Siemens-Straße 13",
        "zip": "12277",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182579,
        "identifier": "DE029024",
        "googlePlaceId": "ChIJOyzaDed0q0cRucYtndkdNFs",
        "lat": 54.089357,
        "lng": 13.392558,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Greifswald",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Peter-Warschow-Straße 19",
        "zip": "17489",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182580,
        "identifier": "DE020117",
        "googlePlaceId": "ChIJOXn6S4b-p0cRZfgzBqwY74I",
        "lat": 51.85603632,
        "lng": 13.70245078,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Luckau",
        "province": "Brandenburg",
        "streetAndNumber": "Berliner Straße 19",
        "zip": "15926",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182581,
        "identifier": "DE005033",
        "googlePlaceId": "ChIJdz5OZg0_ukcRzDhU6sCBr2A",
        "lat": 51.987688,
        "lng": 8.674799,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leopoldshöhe",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hauptstraße 260c",
        "zip": "33818",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182582,
        "identifier": "DE031062",
        "googlePlaceId": "ChIJi2BzhcIapEcRT6zv86Zzu0s",
        "lat": 50.985178,
        "lng": 11.32853,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Weimar",
        "province": "Thüringen",
        "streetAndNumber": "Friedensstraße 1",
        "zip": "99423",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182583,
        "identifier": "DE004076",
        "googlePlaceId": "ChIJ8xvznjZKskcRha3m0ENfl1A",
        "lat": 54.058131,
        "lng": 9.980052,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neumünster",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Altonaer Straße 164",
        "zip": "24539",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182584,
        "identifier": "DE026045",
        "googlePlaceId": "ChIJr0WDHveAr0cR_V2AlfwDNWM",
        "lat": 52.216321,
        "lng": 11.029896,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Helmstedt",
        "province": "Niedersachsen",
        "streetAndNumber": "Magdeburger Berg 5",
        "zip": "38350",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182587,
        "identifier": "DE026035",
        "googlePlaceId": "ChIJERhI_6L1pUcRH1tWdVBSRgI",
        "lat": 52.107946,
        "lng": 11.593121,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Magdeburg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Bergstraße 27",
        "zip": "39116",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182588,
        "identifier": "DE010062",
        "googlePlaceId": "ChIJ-7NkXtHJpEcRkshwh4i3SKI",
        "lat": 51.264314,
        "lng": 9.973482,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Sooden-Allendorf",
        "province": "Hessen",
        "streetAndNumber": "Werrastraße 6",
        "zip": "37242",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182589,
        "identifier": "DE010101",
        "googlePlaceId": "ChIJ6Xq2IIjBukcRc0VUFryNrRw",
        "lat": 51.883119,
        "lng": 9.618622,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stadtoldendorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Deenser Straße 26",
        "zip": "32676",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182590,
        "identifier": "DE004018",
        "googlePlaceId": "ChIJxeS3-gU-s0cRr581qFe8TRg",
        "lat": 54.754552,
        "lng": 9.760573,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Steinbergkirche",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Meiereistraße 10",
        "zip": "24972",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182591,
        "identifier": "DE032091",
        "googlePlaceId": "ChIJ-xGxnCXcuEcRJKPiJgsMSqc",
        "lat": 51.41714,
        "lng": 7.12171,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Alte Hauptstraße 111",
        "zip": "45289",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182592,
        "identifier": "DE032057",
        "googlePlaceId": "ChIJvYALhp0NuUcRlw472em-GGg",
        "lat": 51.617426,
        "lng": 7.655582,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bergkamen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Geschwister-Scholl-Straße 2",
        "zip": "59192",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182593,
        "identifier": "DE020061",
        "googlePlaceId": "ChIJJ621BM9XqEcRjfvQMOH7aYg",
        "lat": 52.517898,
        "lng": 13.178465,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Heerstraße 332",
        "zip": "13593",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182594,
        "identifier": "DE025046",
        "googlePlaceId": "ChIJ17TFeqdmt0cR1d9_K8qx_I8",
        "lat": 52.542051,
        "lng": 7.863912,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ankum",
        "province": "Niedersachsen",
        "streetAndNumber": "Alfons-Schulte-Straße 3",
        "zip": "49577",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182595,
        "identifier": "DE003113",
        "googlePlaceId": "ChIJ08QOQovZrUcRQ_PMCEvDeXc",
        "lat": 53.623899,
        "lng": 11.40241,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwerin",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Wallstraße 68",
        "zip": "19053",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182596,
        "identifier": "DE021041",
        "googlePlaceId": "ChIJY9Sqoo7spkcRhAdxtn97c5o",
        "lat": 51.16345,
        "lng": 12.09932,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hohenmölsen",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Lützener Straße 16",
        "zip": "06679",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182597,
        "identifier": "DE020020",
        "googlePlaceId": "ChIJU2WiV51bqEcRSDwgWs9whvA",
        "lat": 52.391369,
        "lng": 13.291465,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Teltow",
        "province": "Brandenburg",
        "streetAndNumber": "Mahlower Straße 179",
        "zip": "14513",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182598,
        "identifier": "DE006025",
        "googlePlaceId": "ChIJTyU1fvkwsEcRX55mF-b5mj4",
        "lat": 52.824762,
        "lng": 10.082578,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hermannsburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Celler Straße 45",
        "zip": "29320",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182600,
        "identifier": "DE010027",
        "googlePlaceId": "ChIJr2rpXcwZu0cRHFHR3IhOeSI",
        "lat": 51.491286,
        "lng": 9.384518,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hofgeismar",
        "province": "Hessen",
        "streetAndNumber": "Garnisons-Galerie 4",
        "zip": "34369",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182601,
        "identifier": "DE013052",
        "googlePlaceId": "ChIJJ2idccTRu0cR0iZEb5SL9rA",
        "lat": 51.613821,
        "lng": 8.352328,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Erwitte",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wemberweg 2",
        "zip": "59597",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182602,
        "identifier": "DE031045",
        "googlePlaceId": "ChIJ2U6JfsSxpkcRlPG4W6I6uBk",
        "lat": 50.867246,
        "lng": 11.716781,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stadtroda",
        "province": "Thüringen",
        "streetAndNumber": "Jenaer Straße 11",
        "zip": "07646",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182604,
        "identifier": "DE025018",
        "googlePlaceId": "ChIJf6ms_U4luEcRs4e3XOVetBY",
        "lat": 52.318909,
        "lng": 7.225146,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schüttorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Graf-Egbert-Straße 29",
        "zip": "48465",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182605,
        "identifier": "DE025102",
        "googlePlaceId": "ChIJCfc97qg2uEcRAlZpBwo3UF0",
        "lat": 52.210767,
        "lng": 7.320243,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wettringen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Gnoiener Platz 10",
        "zip": "48493",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182606,
        "identifier": "DE031005",
        "googlePlaceId": "ChIJUdpBFFq3pkcRpwG1wplMXIY",
        "lat": 50.90687,
        "lng": 11.84602,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hermsdorf",
        "province": "Thüringen",
        "streetAndNumber": "Erich-Weinert-Straße 45",
        "zip": "07629",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182608,
        "identifier": "DE024062",
        "googlePlaceId": "ChIJq_A3B0DNqUcRZF83-cCuyUI",
        "lat": 52.592172,
        "lng": 13.909762,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Strausberg",
        "province": "Brandenburg",
        "streetAndNumber": "Akazienstraße 1",
        "zip": "15344",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182609,
        "identifier": "DE007106",
        "googlePlaceId": "ChIJ-RpOSKCdsEcRqJfxwPwkJxc",
        "lat": 52.382645,
        "lng": 9.002861,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Petershagen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Industriestraße 1",
        "zip": "32469",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182610,
        "identifier": "DE005014",
        "googlePlaceId": "ChIJI-O_wlDSu0cRV61e-_wyhPw",
        "lat": 51.676385,
        "lng": 8.345385,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lippstadt",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Marktstraße 5",
        "zip": "59555",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182611,
        "identifier": "DE025094",
        "googlePlaceId": "ChIJpxpKVPHZuUcRoq6mTSZ68KI",
        "lat": 52.366067,
        "lng": 7.717974,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Recke",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Verfarths Hof 2",
        "zip": "49509",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182612,
        "identifier": "DE032096",
        "googlePlaceId": "ChIJY9LEPK3duEcR-l-PlxNRuY4",
        "lat": 51.42861,
        "lng": 7.07829,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Nockwinkel 98-100",
        "zip": "45277",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182613,
        "identifier": "DE006158",
        "googlePlaceId": "ChIJIbH3_gh8sEcRYHg22iqjNk0",
        "lat": 52.425125,
        "lng": 9.418051,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wunstorf",
        "province": "Niedersachsen",
        "streetAndNumber": "In den Ellern 5",
        "zip": "31515",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182614,
        "identifier": "DE026050",
        "googlePlaceId": "ChIJFwUslvhUr0cRD4cBWRnIseM",
        "lat": 52.143994892889,
        "lng": 11.956809902496,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Möckern",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Burger Straße 23b",
        "zip": "39291",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182615,
        "identifier": "DE001046",
        "googlePlaceId": "ChIJNyBmAijvuEcRUFoSIQDHSfI",
        "lat": 51.569638,
        "lng": 6.995886,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gladbeck",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Horster Straße 55b",
        "zip": "45964",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182616,
        "identifier": "DE036128",
        "googlePlaceId": "ChIJZ49X18YWCEcRqh7djnTTUHU",
        "lat": 51.587976,
        "lng": 14.010968,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Großräschen",
        "province": "Brandenburg",
        "streetAndNumber": "IFA-Park 2",
        "zip": "01983",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182617,
        "identifier": "DE020047",
        "googlePlaceId": "ChIJB1y7uI9QqEcRlmnr4HYNhd4",
        "lat": 52.479611,
        "lng": 13.310942,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Mecklenburgische Straße 23a-24",
        "zip": "14197",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182618,
        "identifier": "DE010018",
        "googlePlaceId": "ChIJ-xltmoM4u0cRlPCx044wNTs",
        "lat": 51.305089,
        "lng": 9.52681,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kassel",
        "province": "Hessen",
        "streetAndNumber": "Leipziger Straße 124",
        "zip": "34123",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182620,
        "identifier": "DE032014",
        "googlePlaceId": "ChIJpcwty_YbuUcRLyibbU-bv7g",
        "lat": 51.55054,
        "lng": 7.37509,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bodelschwingher Straße 142",
        "zip": "44357",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182621,
        "identifier": "DE003071",
        "googlePlaceId": "ChIJ-7lJvpeOsUcRPHUmd3nRzmo",
        "lat": 53.552136,
        "lng": 10.043654,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Eiffestraße 406-418",
        "zip": "20537",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182622,
        "identifier": "DE020092",
        "googlePlaceId": "ChIJ4zi5YdJWqEcRMtLJIbKbZak",
        "lat": 52.523635,
        "lng": 13.280388,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Fürstenbrunner Weg 50",
        "zip": "14059",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182623,
        "identifier": "DE002017",
        "googlePlaceId": "ChIJa5cCm_TQuEcRBAVk2SmQjro",
        "lat": 51.28066,
        "lng": 7.035632,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wülfrath",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Parkstraße 2",
        "zip": "42489",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182624,
        "identifier": "DE016095",
        "googlePlaceId": "ChIJDc4IjpaIsUcREIa_M41dIrc",
        "lat": 53.606296,
        "lng": 9.981221,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Borsteler Chaussee 86",
        "zip": "22453",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182625,
        "identifier": "DE021026",
        "googlePlaceId": "ChIJ8zvxyvz3pkcR6hEBYjkVfXo",
        "lat": 51.363245,
        "lng": 12.364312,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Elsbethstraße 25",
        "zip": "04155",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182626,
        "identifier": "DE025075",
        "googlePlaceId": "ChIJ51rZpRDQuUcRQeY6nEEG0Ws",
        "lat": 52.294623,
        "lng": 7.661576,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ibbenbüren",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Püsselbürener Damm 335",
        "zip": "49479",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182627,
        "identifier": "DE029060",
        "googlePlaceId": "ChIJI1F8a6VWrEcR0aTP0Zv-28U",
        "lat": 54.107294,
        "lng": 12.035743,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rostock",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Ostsee-Park-Straße 1A",
        "zip": "18069",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182628,
        "identifier": "DE013079",
        "googlePlaceId": "ChIJDfrkKqXYu0cRn-EK3ovQLLA",
        "lat": 51.499068,
        "lng": 8.132223,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Möhnesee",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Berlingser Weg 6",
        "zip": "59519",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182629,
        "identifier": "DE021107",
        "googlePlaceId": "ChIJbVKLlJJ8pkcR9BIQBMKAHaE",
        "lat": 51.479551,
        "lng": 11.920233,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Halle (Saale)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Neustädter Passage 17",
        "zip": "06122",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182630,
        "identifier": "DE007087",
        "googlePlaceId": "ChIJWfurB_PusEcRwmrfqy0-Ygo",
        "lat": 52.804167,
        "lng": 9.134674,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hoya",
        "province": "Niedersachsen",
        "streetAndNumber": "Bücker Straße 4-12",
        "zip": "27318",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182631,
        "identifier": "DE001034",
        "googlePlaceId": "ChIJD4U0DMHuuEcRgF0zn--7Qew",
        "lat": 51.578757,
        "lng": 6.976045,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gladbeck",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Schultenstraße 10",
        "zip": "45966",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182633,
        "identifier": "DE026017",
        "googlePlaceId": "ChIJT0OnCEfppUcRTd98wNsMxhI",
        "lat": 51.863101,
        "lng": 11.563577,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Staßfurt",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Löderburger Straße 97a",
        "zip": "39418",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182634,
        "identifier": "DE024079",
        "googlePlaceId": "ChIJL1-Yw3JUqEcReJ2EpF0-cSQ",
        "lat": 52.577837,
        "lng": 13.298821,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Holzhauser Straße 26",
        "zip": "13509",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182635,
        "identifier": "DE016090",
        "googlePlaceId": "ChIJp9s7z9GHsUcRpoNiEsK2vLI",
        "lat": 53.634659,
        "lng": 9.956588,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Schippelsweg 51",
        "zip": "22455",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182636,
        "identifier": "DE032065",
        "googlePlaceId": "ChIJuwZUUXAYuUcRPfHTH9GXCOA",
        "lat": 51.457487,
        "lng": 7.414162,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kruckeler Str. 266",
        "zip": "44227",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182637,
        "identifier": "DE003116",
        "googlePlaceId": "ChIJWSCPObGcrkcRGyGcdVGrpAY",
        "lat": 53.424618,
        "lng": 11.855713,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Parchim",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Ostring 16",
        "zip": "19370",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182638,
        "identifier": "DE004052",
        "googlePlaceId": "ChIJz4zRq49LskcRwgFAsPMcAaY",
        "lat": 54.100235,
        "lng": 9.976363,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neumünster",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Stoverweg 40",
        "zip": "24536",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182639,
        "identifier": "DE004086",
        "googlePlaceId": "ChIJUZVyGqzIs0cRCCTHjy3saKY",
        "lat": 53.975899,
        "lng": 9.619113,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hohenlockstedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Deutsch-Ordens-Straße 2",
        "zip": "25551",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182640,
        "identifier": "DE005017",
        "googlePlaceId": "ChIJrbXsMXRBukcRAtgt-mRYVMc",
        "lat": 51.987228,
        "lng": 8.798748,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lage",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Lange Straße 136-140",
        "zip": "32791",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182642,
        "identifier": "DE013042",
        "googlePlaceId": "ChIJ57sTFzZnuUcRVvxTjbI7VDc",
        "lat": 51.433652,
        "lng": 7.979832,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Arnsberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Eichendorffstraße 2",
        "zip": "59759",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182643,
        "identifier": "DE016032",
        "googlePlaceId": "ChIJQyNqYb6MsUcRabXFA5X-OHg",
        "lat": 53.549346,
        "lng": 10.154911,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oststeinbek",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Im Hegen 2-4",
        "zip": "22113",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182644,
        "identifier": "DE004094",
        "googlePlaceId": "ChIJe_Ks_HOXtEcR4gRhG6GEtvQ",
        "lat": 54.762363,
        "lng": 8.877029,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Risum-Lindholm",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Dorfstraße 226",
        "zip": "25920",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182645,
        "identifier": "DE007009",
        "googlePlaceId": "ChIJ4RDxgjjWsEcREzzdaw5SxoI",
        "lat": 53.048226,
        "lng": 8.744131,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Alter Dorfweg 30-50",
        "zip": "28259",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182646,
        "identifier": "DE020097",
        "googlePlaceId": "ChIJZZZyIdxFqEcRqMYptNThCk8",
        "lat": 52.422967,
        "lng": 13.47572,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Joachim-Gottschalk-Weg 5",
        "zip": "12353",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182647,
        "identifier": "DE029048",
        "googlePlaceId": "ChIJ7TzsXWN0q0cRnCsuR1O6h0c",
        "lat": 54.120691,
        "lng": 13.358848,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neuenkirchen",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Marktflecken 18",
        "zip": "17498",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182648,
        "identifier": "DE026068",
        "googlePlaceId": "ChIJce9aZvKepUcRKeQvaQ9wOLE",
        "lat": 51.904205,
        "lng": 11.039666,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Halberstadt",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Wolfsburger Straße 1",
        "zip": "38820",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182649,
        "identifier": "DE006021",
        "googlePlaceId": "ChIJyTVBDFZzsEcRZyiLPZWnR5Q",
        "lat": 52.387416,
        "lng": 9.748379,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Bürgerstraße 2-3",
        "zip": "30161",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182650,
        "identifier": "DE024068",
        "googlePlaceId": "ChIJ6ZxRBHZLqEcR4n3CjIh9KTk",
        "lat": 52.566694,
        "lng": 13.578386,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Havemannstraße 33",
        "zip": "12689",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182651,
        "identifier": "DE002003",
        "googlePlaceId": "ChIJV9wHi2y2vkcRIdtictTAh7s",
        "lat": 51.00326,
        "lng": 7.573622,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gummersbach",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Krummenohler Straße 2",
        "zip": "51645",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182652,
        "identifier": "DE029004",
        "googlePlaceId": "ChIJBQD2Mt6QrEcRqNJ77xuUzN0",
        "lat": 54.356582,
        "lng": 12.719303,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Barth",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Blaue Wiese 20",
        "zip": "18356",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182653,
        "identifier": "DE010087",
        "googlePlaceId": "ChIJJ-DIaxzFpEcRV_qR85EpKkk",
        "lat": 51.385775,
        "lng": 10.131923,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Heilbad Heiligenstadt",
        "province": "Thüringen",
        "streetAndNumber": "Brüsseler Straße 1a",
        "zip": "37308",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182654,
        "identifier": "DE005039",
        "googlePlaceId": "ChIJqbZZlWlKukcRpP4JiYuUmaI",
        "lat": 51.759198,
        "lng": 8.663093,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Paderborn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Weisgutstraße 20",
        "zip": "33106",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182655,
        "identifier": "DE004145",
        "googlePlaceId": "ChIJ_9I3K8VlskcRqfUTzPycS5M",
        "lat": 54.176712,
        "lng": 10.559473,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Malente",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Lütjenburger Straße 1",
        "zip": "23714",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182656,
        "identifier": "DE020005",
        "googlePlaceId": "ChIJvbdsKPtWqEcRoBnxhB6wGww",
        "lat": 52.526944,
        "lng": 13.238071,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Charlottenburger Chaussee 30",
        "zip": "13597",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182657,
        "identifier": "DE005113",
        "googlePlaceId": "ChIJacwZnkFYukcRjNA0lf0SsvM",
        "lat": 51.865337,
        "lng": 9.08714,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Steinheim",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Anton-Spilker-Straße 33",
        "zip": "32839",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182658,
        "identifier": "DE021023",
        "googlePlaceId": "ChIJP3s07bL4pkcR0Bh7JYUlNyw",
        "lat": 51.341952,
        "lng": 12.485365,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Hugo-Aurig-Straße 7a",
        "zip": "04319",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182659,
        "identifier": "DE020113",
        "googlePlaceId": "ChIJqQVEHyURqEcRjusDO2TxUAw",
        "lat": 52.155936,
        "lng": 13.642154,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwerin",
        "province": "Brandenburg",
        "streetAndNumber": "Teupitzer Straße 1",
        "zip": "15755",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182660,
        "identifier": "DE032086",
        "googlePlaceId": "ChIJ-f2U7GnnuEcRh-ECTYhOsyo",
        "lat": 51.483154,
        "lng": 7.107047,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Krayer Straße 44",
        "zip": "44866",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182661,
        "identifier": "DE032017",
        "googlePlaceId": "ChIJBVqPi5ITuUcRQS2q2MVr2eE",
        "lat": 51.532967,
        "lng": 7.610888,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bremmenstraße 7",
        "zip": "44319",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182662,
        "identifier": "DE024120",
        "googlePlaceId": "ChIJx0r-s2WYB0cR-F8yra2Q7ts",
        "lat": 52.353343,
        "lng": 14.546844,
        "name": "ALDI",
        "country": "DE",
        "city": "Frankfurt (Oder)",
        "province": "Brandenburg",
        "streetAndNumber": "Bergstraße 2",
        "zip": "15230",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182663,
        "identifier": "DE021052",
        "googlePlaceId": "ChIJW7yL-Cz4pkcRaLK6h65JQZI",
        "lat": 51.326202,
        "lng": 12.372041,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Braustraße 26",
        "zip": "04107",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182664,
        "identifier": "DE013089",
        "googlePlaceId": "ChIJASmaDoY7uUcRKp_T7PiIxT4",
        "lat": 51.355304,
        "lng": 7.490906,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hagen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wasserloses Tal 29",
        "zip": "58093",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182665,
        "identifier": "DE005001",
        "googlePlaceId": "ChIJASi8_As9ukcRDGv8-VfHWhY",
        "lat": 52.025106,
        "lng": 8.550703,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Werner-Bock-Straße 38",
        "zip": "33602",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182667,
        "identifier": "DE016056",
        "googlePlaceId": "ChIJ14BHlQwoskcRCYsLRB0lq_k",
        "lat": 53.689192,
        "lng": 9.981498,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Norderstedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Kösliner Weg 6",
        "zip": "22850",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182669,
        "identifier": "DE001021",
        "googlePlaceId": "ChIJz_LEge3ouEcR47f4U6ekxaE",
        "lat": 51.529156,
        "lng": 7.01055,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Karnaper Straße 177",
        "zip": "45329",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182670,
        "identifier": "DE003034",
        "googlePlaceId": "ChIJX48nr0HcsUcRIRKAPGbc-UI",
        "lat": 53.221499,
        "lng": 10.384867,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lüneburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Häcklinger Weg 66",
        "zip": "21335",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182671,
        "identifier": "DE005016",
        "googlePlaceId": "ChIJoQhu5yFNukcRCK0NBOQfJmc",
        "lat": 51.713203,
        "lng": 8.79485,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Paderborn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hardehauser Weg 2",
        "zip": "33100",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182672,
        "identifier": "DE004068",
        "googlePlaceId": "ChIJ464ABndWskcRPJCnE1Dik1g",
        "lat": 54.332519,
        "lng": 10.110471,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Eichkamp 24",
        "zip": "24116",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182673,
        "identifier": "DE002070",
        "googlePlaceId": "ChIJ5S961ZTXuEcRfuOPtQmc3Ls",
        "lat": 51.277824,
        "lng": 7.162446,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Weinberg 107",
        "zip": "42109",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182674,
        "identifier": "DE032009",
        "googlePlaceId": "ChIJ3WYJ54sauUcR7_DovbXxRF8",
        "lat": 51.579217,
        "lng": 7.463789,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Evinger Straße 583",
        "zip": "44339",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182675,
        "identifier": "DE004128",
        "googlePlaceId": "ChIJKQPryPBltEcR4R_uDLLX8XE",
        "lat": 54.324107,
        "lng": 8.612718,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sankt Peter-Ording",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Dreilanden 7a",
        "zip": "25826",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182676,
        "identifier": "DE005069",
        "googlePlaceId": "ChIJI3WvbfiQuUcRIDUYi_PhAGY",
        "lat": 51.95134,
        "lng": 7.98331,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Warendorf",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "August-Wessing-Damm 86",
        "zip": "48231",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182677,
        "identifier": "DE013060",
        "googlePlaceId": "ChIJYXt2_mIUuUcRHzVIVcMquDM",
        "lat": 51.50736,
        "lng": 7.625387,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Holzwickede",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Stehfenstraße 8",
        "zip": "59439",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182678,
        "identifier": "DE016129",
        "googlePlaceId": "ChIJf0iedA4JskcRU1QWHInPJ5I",
        "lat": 53.84147,
        "lng": 10.707118,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübeck",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Weidentrift 2",
        "zip": "23562",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182680,
        "identifier": "DE020118",
        "googlePlaceId": "ChIJoWduM2n_B0cRPhcHlMqzCVA",
        "lat": 51.941667,
        "lng": 13.875031,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübben",
        "province": "Brandenburg",
        "streetAndNumber": "Parkstraße 2",
        "zip": "15907",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182681,
        "identifier": "DE025033",
        "googlePlaceId": "ChIJb4jRdI0huEcR3QtVvxK67Is",
        "lat": 52.41508,
        "lng": 7.077354,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nordhorn",
        "province": "Niedersachsen",
        "streetAndNumber": "Westfalenstraße 15",
        "zip": "48529",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182682,
        "identifier": "DE001096",
        "googlePlaceId": "ChIJxTmzNdlnuEcRyfTMcA3-4TU",
        "lat": 51.991012,
        "lng": 6.899332,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stadtlohn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Schützenweg 1",
        "zip": "48703",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182683,
        "identifier": "DE003094",
        "googlePlaceId": "ChIJr9klx5corkcRGlFt-9pfo8w",
        "lat": 53.081322,
        "lng": 10.572464,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Bevensen",
        "province": "Niedersachsen",
        "streetAndNumber": "Medinger Straße 32",
        "zip": "29549",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182684,
        "identifier": "DE004111",
        "googlePlaceId": "ChIJdVVh8_bEs0cRUEzbzLwOYn0",
        "lat": 53.92349,
        "lng": 9.50897,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Itzehoe",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Rotenbrook 6",
        "zip": "25524",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182685,
        "identifier": "DE032085",
        "googlePlaceId": "ChIJR1y-n2TeuEcRE97mG-t0Nmk",
        "lat": 51.429247,
        "lng": 7.137716,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Dr.-C.-Otto-Straße 182",
        "zip": "44879",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182686,
        "identifier": "DE016015",
        "googlePlaceId": "ChIJt47JPDmIsUcRPQcB_IP8xMw",
        "lat": 53.672741,
        "lng": 10.00172,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Langenhorner Chaussee 579",
        "zip": "22419",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182687,
        "identifier": "DE024057",
        "googlePlaceId": "ChIJEcqHYUNOqEcRaM9LBl-lTG0",
        "lat": 52.511138,
        "lng": 13.445602,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Rüdersdorfer Straße 65",
        "zip": "10243",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182688,
        "identifier": "DE026080",
        "googlePlaceId": "ChIJDVyc8hnFpUcRD9i9LHACWwI",
        "lat": 51.655597,
        "lng": 11.49249,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hettstedt",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Über der Heckerlingsbreite 19",
        "zip": "06333",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182689,
        "identifier": "DE036066",
        "googlePlaceId": "ChIJ854ppOHuCEcRcipSiFl6DT0",
        "lat": 51.292881,
        "lng": 14.828905,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Niesky",
        "province": "Sachsen",
        "streetAndNumber": "Horkaer Straße 17",
        "zip": "02906",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182690,
        "identifier": "DE020059",
        "googlePlaceId": "ChIJZdGAI3n7qEcRETUgH7oaJzg",
        "lat": 52.582395,
        "lng": 12.998744,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Brieselang",
        "province": "Brandenburg",
        "streetAndNumber": "Hans-Klakow-Straße 4",
        "zip": "14656",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182691,
        "identifier": "DE020087",
        "googlePlaceId": "ChIJvfooa8VQqEcRS05fBbl7v34",
        "lat": 52.50035,
        "lng": 13.29031,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Heilbronner Straße 26a",
        "zip": "10711",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182692,
        "identifier": "DE004053",
        "googlePlaceId": "ChIJV5Vq5VCys0cRJ2h-6Wu_S8M",
        "lat": 54.171402,
        "lng": 9.852362,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nortorf",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Niedernstraße 9c",
        "zip": "24589",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182693,
        "identifier": "DE020009",
        "googlePlaceId": "ChIJSWmIqvhPqEcRzLc3guQToFI",
        "lat": 52.458768,
        "lng": 13.384026,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Tempelhofer Damm 198-200",
        "zip": "12099",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182694,
        "identifier": "DE021024",
        "googlePlaceId": "ChIJc5HFfy6ep0cRr_j_ROWAY1I",
        "lat": 51.29093,
        "lng": 13.123519,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oschatz",
        "province": "Sachsen",
        "streetAndNumber": "Nossener Straße 5",
        "zip": "04758",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182695,
        "identifier": "DE025072",
        "googlePlaceId": "ChIJuerWhjpHuEcRbR3eiPpcQfQ",
        "lat": 52.118613,
        "lng": 7.095999,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Heek",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Im Stroot 35",
        "zip": "48619",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182696,
        "identifier": "DE031004",
        "googlePlaceId": "ChIJdbTBRu42pEcR1OC7v9RVd3M",
        "lat": 51.363396,
        "lng": 11.288286,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Artern",
        "province": "Thüringen",
        "streetAndNumber": "Schönfelder Straße 4a",
        "zip": "06556",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182697,
        "identifier": "DE007002",
        "googlePlaceId": "ChIJC7gi77vVsEcR7tNlVkvNVPw",
        "lat": 53.04737,
        "lng": 8.66432,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Delmenhorst",
        "province": "Niedersachsen",
        "streetAndNumber": "Syker Straße 174",
        "zip": "27751",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182698,
        "identifier": "DE013035",
        "googlePlaceId": "ChIJWYPy3dJBuUcR2CGprFy8_dY",
        "lat": 51.422082,
        "lng": 7.715901,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Iserlohn",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Sümmerner Straße 91",
        "zip": "58640",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182699,
        "identifier": "DE020091",
        "googlePlaceId": "ChIJ_04IbyxXqEcRTdA3J_BAnuY",
        "lat": 52.508491,
        "lng": 13.271753,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Theodor-Heuss-Platz 7",
        "zip": "14052",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182700,
        "identifier": "DE006153",
        "googlePlaceId": "ChIJpaTpADudukcR5osLV9ioXmc",
        "lat": 52.290311,
        "lng": 9.509413,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Barsinghausen",
        "province": "Niedersachsen",
        "streetAndNumber": "Egestorfer Warte 1",
        "zip": "30890",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182701,
        "identifier": "DE006092",
        "googlePlaceId": "ChIJI2RKg6aSr0cRJZenGvVBylU",
        "lat": 52.394581,
        "lng": 10.712207,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wolfsburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Mörser Straße 53",
        "zip": "38442",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182702,
        "identifier": "DE005072",
        "googlePlaceId": "ChIJ4xVMqmnzuUcRrETrEEGVMDA",
        "lat": 52.103112,
        "lng": 8.1658,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Rothenfelde",
        "province": "Niedersachsen",
        "streetAndNumber": "Westfalendamm 1",
        "zip": "49214",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182704,
        "identifier": "DE004114",
        "googlePlaceId": "ChIJl6niTX2AsUcRS6rzw3UQdQY",
        "lat": 53.672369,
        "lng": 9.801421,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Pinneberg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Flensburger Straße 3",
        "zip": "25421",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182705,
        "identifier": "DE001026",
        "googlePlaceId": "ChIJ27Z_3o3xuEcR9P-D2CQ_uUI",
        "lat": 51.671856,
        "lng": 6.981225,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dorsten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Zechenstraße 1",
        "zip": "46284",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182706,
        "identifier": "DE013090",
        "googlePlaceId": "ChIJyzFHKBYJvEcR1WulONgUf0I",
        "lat": 50.99238,
        "lng": 8.257259,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Erndtebrück",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Mühlenweg 18",
        "zip": "57339",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182707,
        "identifier": "DE010029",
        "googlePlaceId": "ChIJtwRi3_FAu0cRlhUdJEXDNRc",
        "lat": 51.275017,
        "lng": 9.439655,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kassel",
        "province": "Hessen",
        "streetAndNumber": "Mattenbergstraße 62",
        "zip": "34132",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182708,
        "identifier": "DE036020",
        "googlePlaceId": "ChIJDy_k1z_PCUcRGT0dxQGziTY",
        "lat": 51.064071,
        "lng": 13.746462,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Antonstraße 2a",
        "zip": "01097",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182709,
        "identifier": "DE031067",
        "googlePlaceId": "ChIJlayE1hD9o0cRQLyPrecLJ3Y",
        "lat": 50.652886,
        "lng": 11.34271,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Saalfeld",
        "province": "Thüringen",
        "streetAndNumber": "Mittlerer Watzenbach 27",
        "zip": "07318",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182711,
        "identifier": "DE004129",
        "googlePlaceId": "ChIJuxgLTPh4tEcRIsk7iy5uk7k",
        "lat": 54.324099,
        "lng": 8.95155,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Tönning",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Friedrichstädter Chaussee 36",
        "zip": "25832",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182712,
        "identifier": "DE036121",
        "googlePlaceId": "ChIJ4X57275zCEcRjvRhZAqEHzc",
        "lat": 51.715764,
        "lng": 14.317329,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Cottbus",
        "province": "Brandenburg",
        "streetAndNumber": "Sachsendorfer Straße 5",
        "zip": "03051",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182713,
        "identifier": "DE026021",
        "googlePlaceId": "ChIJ8xWqXm2HpUcRGlN-ViF95h8",
        "lat": 52.146946,
        "lng": 11.226532,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eilsleben",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Ovelgünner Straße 34",
        "zip": "39365",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182714,
        "identifier": "DE024022",
        "googlePlaceId": "ChIJn6raJwtSqEcRtolH5E8kuOg",
        "lat": 52.5612,
        "lng": 13.422841,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Neumannstraße 13",
        "zip": "13189",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182715,
        "identifier": "DE026088",
        "googlePlaceId": "ChIJPWG5jr4MpUcRZVo8UuwQqJA",
        "lat": 51.845431,
        "lng": 10.805726,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wernigerode",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Theodor-Fontane-Straße 34",
        "zip": "38855",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182716,
        "identifier": "DE003037",
        "googlePlaceId": "ChIJ3VC8iAcbrkcRsF1RW5VzxZ8",
        "lat": 53.381415,
        "lng": 10.77123,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Boizenburg",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Berliner Straße 30",
        "zip": "19258",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182717,
        "identifier": "DE016001",
        "googlePlaceId": "ChIJUd2Ga_CLsUcRTNpI0MuVk4g",
        "lat": 53.581569,
        "lng": 10.087203,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Stephanstraße 6",
        "zip": "22047",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182718,
        "identifier": "DE031078",
        "googlePlaceId": "ChIJIx6AeWLPpkcRUXuPzlt0rac",
        "lat": 50.886829,
        "lng": 12.090024,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gera",
        "province": "Thüringen",
        "streetAndNumber": "Dornaer Straße 4",
        "zip": "07545",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182719,
        "identifier": "DE026075",
        "googlePlaceId": "ChIJCeUGyDGjpUcRav8Xe3Y4hHo",
        "lat": 51.778258,
        "lng": 11.140921,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Quedlinburg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Neinstedter Feldweg 1",
        "zip": "06484",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182720,
        "identifier": "DE006174",
        "googlePlaceId": "ChIJNW8zeOKHukcRHRwaBv3GhPE",
        "lat": 52.169391,
        "lng": 9.239749,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hessisch Oldendorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Welseder Straße 6",
        "zip": "31840",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182721,
        "identifier": "DE006090",
        "googlePlaceId": "ChIJU01CVHvur0cRdwvdiWMZHkI",
        "lat": 52.440339,
        "lng": 10.566015,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Isenbüttel",
        "province": "Niedersachsen",
        "streetAndNumber": "Reuteranger 4",
        "zip": "38550",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182722,
        "identifier": "DE013051",
        "googlePlaceId": "ChIJyyebRmzDu0cRZqsnji-vk-8",
        "lat": 51.452575,
        "lng": 8.358337,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Warstein",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Alte Kreisstraße 15",
        "zip": "59581",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182723,
        "identifier": "DE021009",
        "googlePlaceId": "ChIJMcBIi1r4pkcRT7DK1rDzWv0",
        "lat": 51.33185,
        "lng": 12.410912,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Eilenburger Straße 55",
        "zip": "04317",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182726,
        "identifier": "DE004025",
        "googlePlaceId": "ChIJIQOK0IP2skcRyCRPx0XoCWA",
        "lat": 54.389795,
        "lng": 10.368314,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schönberg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Kuhlenkamp 1 a",
        "zip": "24217",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182727,
        "identifier": "DE032001",
        "googlePlaceId": "ChIJJxmpnQTfuEcRXzFN-u2SCRc",
        "lat": 51.41319,
        "lng": 7.177177,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hattingen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Rauendahlstraße 2",
        "zip": "45529",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182728,
        "identifier": "DE016115",
        "googlePlaceId": "ChIJpVoPTUgIskcRagFQfGSLyAQ",
        "lat": 53.813346,
        "lng": 10.739607,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Groß Grönau",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Grönauer Heide 1",
        "zip": "23627",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182729,
        "identifier": "DE020083",
        "googlePlaceId": "ChIJXdOh_xsWqUcRk31hadQNs1s",
        "lat": 52.939912,
        "lng": 12.860294,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neuruppin",
        "province": "Brandenburg",
        "streetAndNumber": "Wulkower Chaussee 12",
        "zip": "16827",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182730,
        "identifier": "DE001066",
        "googlePlaceId": "ChIJx5fxZ8VhuEcRsldn2wuaf4o",
        "lat": 51.83469,
        "lng": 6.831871,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Borken",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Nina-Winkel-Straße 2",
        "zip": "46325",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182731,
        "identifier": "DE025002",
        "googlePlaceId": "ChIJZW-rghT6t0cRSswt0rVOsOI",
        "lat": 52.609741,
        "lng": 6.853176,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Emlichheim",
        "province": "Niedersachsen",
        "streetAndNumber": "Mühlenstraße 1",
        "zip": "49824",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182732,
        "identifier": "DE024006",
        "googlePlaceId": "ChIJ80lkAydMqEcRSpKiUJ1wWy4",
        "lat": 52.535379,
        "lng": 13.496505,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Landsberger Allee 277",
        "zip": "13055",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182733,
        "identifier": "DE032127",
        "googlePlaceId": "ChIJgQ1S4QS7uUcRt55Pqug9mLs",
        "lat": 51.975905,
        "lng": 7.657342,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Münster",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Dieckstraße 79",
        "zip": "48145",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182734,
        "identifier": "DE024069",
        "googlePlaceId": "ChIJ_6sD_7UBqUcRI9JVDGpPTJg",
        "lat": 52.678836,
        "lng": 13.1665,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Velten",
        "province": "Brandenburg",
        "streetAndNumber": "Rosa-Luxemburg-Straße 22",
        "zip": "16727",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182735,
        "identifier": "DE025025",
        "googlePlaceId": "ChIJfU9a1mk-uEcRbAS-J9ThxSE",
        "lat": 52.21643,
        "lng": 7.033399,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gronau",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Gildehauser Straße 85",
        "zip": "48599",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182736,
        "identifier": "DE016152",
        "googlePlaceId": "ChIJ680IqZYLskcRYkib_5BBpvg",
        "lat": 53.896468,
        "lng": 10.70561,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lübeck",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Glashüttenweg 31",
        "zip": "23568",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182738,
        "identifier": "DE005008",
        "googlePlaceId": "ChIJFZDVh_sXukcRv6ERVk11WlU",
        "lat": 52.059531,
        "lng": 8.515553,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bielefeld",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Babenhauser Straße 20",
        "zip": "33613",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182739,
        "identifier": "DE004069",
        "googlePlaceId": "ChIJ_V1wIPrrs0cRKnAoIZDp3DU",
        "lat": 53.99938,
        "lng": 9.260949,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Burg (Dithmarschen)",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Bahnhofstraße 9a",
        "zip": "25712",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182740,
        "identifier": "DE024076",
        "googlePlaceId": "ChIJeW8e929TqEcReBznPNgdVjg",
        "lat": 52.605161,
        "lng": 13.339847,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Wittenauer Straße 88",
        "zip": "13435",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182741,
        "identifier": "DE032125",
        "googlePlaceId": "ChIJoZ2EUuC6uUcRSBVQu8TvVHo",
        "lat": 51.966797,
        "lng": 7.642789,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Münster",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Bohlweg 66-68",
        "zip": "48147",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182742,
        "identifier": "DE006156",
        "googlePlaceId": "ChIJuTfxahl2sEcRyJfQ4_th4B8",
        "lat": 52.320112,
        "lng": 9.593127,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gehrden",
        "province": "Niedersachsen",
        "streetAndNumber": "Everloher Straße 1",
        "zip": "30989",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182743,
        "identifier": "DE036031",
        "googlePlaceId": "ChIJg4x3W67PCUcRJYhlr4bX8Bk",
        "lat": 51.080341,
        "lng": 13.712403,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Lommatzscher Straße 1c",
        "zip": "01139",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182744,
        "identifier": "DE020050",
        "googlePlaceId": "ChIJqS9Gvb1bqEcRDhU9xHF_cRM",
        "lat": 52.40828,
        "lng": 13.268694,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Teltower Damm 281",
        "zip": "14167",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182745,
        "identifier": "DE004033",
        "googlePlaceId": "ChIJC3q9PvKYtEcRdSBVnvZnqBI",
        "lat": 54.777117187558,
        "lng": 8.9811661020741,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leck",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Industriestraße 11",
        "zip": "25917",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182746,
        "identifier": "DE032022",
        "googlePlaceId": "ChIJFdU9VE4ZuUcROuic5nmgZ4A",
        "lat": 51.522935,
        "lng": 7.369944,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Frohlinder Straße 12",
        "zip": "44379",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182747,
        "identifier": "DE026097",
        "googlePlaceId": "ChIJXTKskttqpUcRPMK_0CO_Hi8",
        "lat": 51.902802,
        "lng": 10.551108,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Harzburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Schlewecker Straße 2",
        "zip": "38667",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182748,
        "identifier": "DE004012",
        "googlePlaceId": "ChIJXSeN6KVXskcRFJGcvDemrG4",
        "lat": 54.31824,
        "lng": 10.18147,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kiel",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Philipp-Reis-Weg 4",
        "zip": "24148",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182749,
        "identifier": "DE013056",
        "googlePlaceId": "ChIJkReZ53fou0cR-Y_o6wgawk8",
        "lat": 51.357634,
        "lng": 8.289727,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Meschede",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Im Schwarzen Bruch 14",
        "zip": "59872",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182750,
        "identifier": "DE032062",
        "googlePlaceId": "ChIJtXTEKuMWuUcRbXo2A2oLwmo",
        "lat": 51.495349,
        "lng": 7.51952,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Freie-Vogel-Straße 9",
        "zip": "44263",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182751,
        "identifier": "DE029034",
        "googlePlaceId": "ChIJ4bR81u0Gq0cR8DoX0mnOVR0",
        "lat": 54.049042,
        "lng": 13.756796,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wolgast",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Robert-Koch-Straße 1",
        "zip": "17438",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182752,
        "identifier": "DE020078",
        "googlePlaceId": "ChIJDdC0TdoKqUcRfJNZWAmk1_g",
        "lat": 52.970277,
        "lng": 13.324871,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zehdenick",
        "province": "Brandenburg",
        "streetAndNumber": "Falkenthaler Chaussee 57",
        "zip": "16792",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182753,
        "identifier": "DE007025",
        "googlePlaceId": "ChIJkcKl3vtFt0cRyJElUVp6jss",
        "lat": 52.674985,
        "lng": 8.253815,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lohne",
        "province": "Niedersachsen",
        "streetAndNumber": "Lindenstraße 113",
        "zip": "49393",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182754,
        "identifier": "DE002038",
        "googlePlaceId": "ChIJ_XWN54lFuUcRSGscV4dLxpc",
        "lat": 51.259117,
        "lng": 7.757053,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Werdohl",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Heinrichstraße 6",
        "zip": "58791",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182755,
        "identifier": "DE002005",
        "googlePlaceId": "ChIJS_awFT0ruUcRqC4n7f0JQxk",
        "lat": 51.143917,
        "lng": 7.220558,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wermelskirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Thomas-Mann-Straße 39",
        "zip": "42929",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182757,
        "identifier": "DE036014",
        "googlePlaceId": "ChIJSbOy8bDaCUcRj-ZBvdXPqX0",
        "lat": 51.039955,
        "lng": 13.629953,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Gompitzer Höhe 5a",
        "zip": "01156",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182761,
        "identifier": "DE021042",
        "googlePlaceId": "ChIJ42__iXLCpkcRa_hE4-hQBTo",
        "lat": 51.040497,
        "lng": 12.151345,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zeitz",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Käthe-Niederkirchner-Straße 60",
        "zip": "06712",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182762,
        "identifier": "DE007035",
        "googlePlaceId": "ChIJV7AbZM8kt0cRvSRmPagWwL4",
        "lat": 52.942337,
        "lng": 8.245363,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Großenkneten",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Rieskamp 2",
        "zip": "26197",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182763,
        "identifier": "DE025098",
        "googlePlaceId": "ChIJm6JFxKRKuEcRjCjoXF8JR9U",
        "lat": 52.120363,
        "lng": 7.391811,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Steinfurt",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Gantenstraße 8",
        "zip": "48565",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182764,
        "identifier": "DE001035",
        "googlePlaceId": "ChIJ2fg95W_kuEcRtbYbDifw8k8",
        "lat": 51.581502,
        "lng": 7.145854,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Ewaldstraße 182",
        "zip": "45699",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182765,
        "identifier": "DE002044",
        "googlePlaceId": "ChIJtxnT1joruUcRwoMeVLGjtCg",
        "lat": 51.190726,
        "lng": 7.257023,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Remscheid",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kölner Straße 38",
        "zip": "42897",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182766,
        "identifier": "DE001076",
        "googlePlaceId": "ChIJm-wP2tDCuEcR0pS0ZrFByII",
        "lat": 51.43807,
        "lng": 7.005228,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Rüttenscheider Straße 62-64",
        "zip": "45130",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182767,
        "identifier": "DE002045",
        "googlePlaceId": "ChIJM_TUj5IluUcRVIllPoUUwAY",
        "lat": 51.297743,
        "lng": 7.312621,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ennepetal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kölner Straße 317",
        "zip": "58256",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182768,
        "identifier": "DE007109",
        "googlePlaceId": "ChIJ88PYLxBVt0cREMRI9jokxAs",
        "lat": 52.470512,
        "lng": 8.372949,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lemförde",
        "province": "Niedersachsen",
        "streetAndNumber": "Pommernstraße 7",
        "zip": "49448",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182769,
        "identifier": "DE006061",
        "googlePlaceId": "ChIJD5afoUZ0sEcR6HndylZKqsc",
        "lat": 52.364902,
        "lng": 9.668084,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Davenstedter Straße 234-240",
        "zip": "30455",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182770,
        "identifier": "DE001024",
        "googlePlaceId": "ChIJS85EiDHyuEcR4bgo-rwoYdI",
        "lat": 51.683723,
        "lng": 6.954859,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dorsten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Borkener Str. 170",
        "zip": "46284",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182771,
        "identifier": "DE005145",
        "googlePlaceId": "ChIJK33NMwtivEcRw9ZRM_7QvnQ",
        "lat": 50.787014,
        "lng": 8.767133,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Marburg",
        "province": "Hessen",
        "streetAndNumber": "Marburger Straße 100",
        "zip": "35043",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182772,
        "identifier": "DE016046",
        "googlePlaceId": "ChIJ35EBJSUfskcRvb_8f7MEmLM",
        "lat": 53.716777391098,
        "lng": 10.290552601889,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bargteheide",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Otto-Hahn-Straße 2",
        "zip": "22941",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182773,
        "identifier": "DE002065",
        "googlePlaceId": "ChIJPQ0YAJUpuUcRISyfxLux-_o",
        "lat": 51.228549,
        "lng": 7.206919,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Kraftwerk 13",
        "zip": "42369",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182774,
        "identifier": "DE024021",
        "googlePlaceId": "ChIJTaTHm-xLqEcR4pRH2wLCRrs",
        "lat": 52.543799,
        "lng": 13.565101,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Landsberger Allee 494",
        "zip": "12685",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182775,
        "identifier": "DE003095",
        "googlePlaceId": "ChIJK4jwtd9msUcRXL74C9_J7Ik",
        "lat": 53.615301,
        "lng": 9.305072,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Himmelpforten",
        "province": "Niedersachsen",
        "streetAndNumber": "Bahnhofstraße 9",
        "zip": "21709",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182778,
        "identifier": "DE004115",
        "googlePlaceId": "ChIJOxJBDkyAsUcRg0UnlpvYcWY",
        "lat": 53.646682,
        "lng": 9.771861,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Pinneberg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Westring 8",
        "zip": "25421",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182779,
        "identifier": "DE015076",
        "googlePlaceId": "ChIJY00VboMgt0cRI8GCpxSZxqE",
        "lat": 53.102503,
        "lng": 8.2109,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oldenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Alter Postweg 125",
        "zip": "26133",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182780,
        "identifier": "DE002112",
        "googlePlaceId": "ChIJtZh933AouUcRpY-G_76Kw-Y",
        "lat": 51.28605,
        "lng": 7.228136,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Weiherstraße 7",
        "zip": "42277",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182781,
        "identifier": "DE005031",
        "googlePlaceId": "ChIJXzV1BkL4ukcR4lhBIJeo_Vo",
        "lat": 51.807764,
        "lng": 9.129753,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nieheim",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Alersfelde 28",
        "zip": "33039",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182782,
        "identifier": "DE024103",
        "googlePlaceId": "ChIJM6KCjwZPqEcR8ZZxdjZtmJM",
        "lat": 52.485925,
        "lng": 13.456948,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Kiefholzstraße 49",
        "zip": "12435",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182783,
        "identifier": "DE001092",
        "googlePlaceId": "ChIJlzPKwnfduEcRBFjtYD4GHWI",
        "lat": 51.461255,
        "lng": 7.065632,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Luftschacht 20",
        "zip": "45307",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182784,
        "identifier": "DE024046",
        "googlePlaceId": "ChIJE3pVHnZPqEcRu886HWC0lO4",
        "lat": 52.514249,
        "lng": 13.47582,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Frankfurter Allee 117",
        "zip": "10365",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182785,
        "identifier": "DE010057",
        "googlePlaceId": "ChIJT-N4svgcpUcRVwhMNdkS_hE",
        "lat": 51.593618,
        "lng": 10.559123,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bad Sachsa",
        "province": "Niedersachsen",
        "streetAndNumber": "Aldi Passage Marktstraße 43/44",
        "zip": "37441",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182786,
        "identifier": "DE004088",
        "googlePlaceId": "ChIJY0YKazBxs0cRIeffamxdFAw",
        "lat": 54.519056,
        "lng": 9.386725,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Silberstedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Tükeslih 2",
        "zip": "24887",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182787,
        "identifier": "DE003111",
        "googlePlaceId": "ChIJc-cNd77brUcRAUMCtTjvMdw",
        "lat": 53.66164,
        "lng": 11.35912,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwerin",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Am Margaretenhof 12",
        "zip": "19057",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182788,
        "identifier": "DE003053",
        "googlePlaceId": "ChIJ4YT3fkB3sUcRp06nkHEf0sA",
        "lat": 53.504511,
        "lng": 9.589116,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Horneburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Am Poggenpohl 3",
        "zip": "21640",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182789,
        "identifier": "DE015061",
        "googlePlaceId": "ChIJSaXitvfetkcR40OQlcVrSAc",
        "lat": 53.16344,
        "lng": 8.21823,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oldenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Scheideweg 56-58",
        "zip": "26121",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182790,
        "identifier": "DE005065",
        "googlePlaceId": "ChIJsQS7UgIuukcRuKQeHJmdPig",
        "lat": 51.811992,
        "lng": 8.435737,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rietberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Westerwieher Straße 44-48",
        "zip": "33397",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182791,
        "identifier": "DE004127",
        "googlePlaceId": "ChIJ9X1d9omVs0cROLfiXfbKGwI",
        "lat": 54.126285,
        "lng": 9.416308,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hanerau-Hademarschen",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Theodor-Storm-Straße 11-13",
        "zip": "25557",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182792,
        "identifier": "DE016051",
        "googlePlaceId": "ChIJB3iKnb0oskcRklr1wA06Hkw",
        "lat": 53.734899,
        "lng": 9.988501,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Norderstedt",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Quickborner Straße 54",
        "zip": "22844",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182793,
        "identifier": "DE021097",
        "googlePlaceId": "ChIJS2JFp-R8pkcRUt1Q3elxw1I",
        "lat": 51.463778,
        "lng": 11.908624,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Teutschenthal",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "An der Lauchstädter Straße 3",
        "zip": "06179",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182794,
        "identifier": "DE021025",
        "googlePlaceId": "ChIJJx4wljaJpkcRg62Jzvpfiro",
        "lat": 51.329318,
        "lng": 11.97873,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Merseburg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Straße des Friedens 100",
        "zip": "06217",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182795,
        "identifier": "DE003054",
        "googlePlaceId": "ChIJwzQlfTQ9sUcRqZh1DpxYnkE",
        "lat": 53.221002,
        "lng": 9.075043,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Tarmstedt",
        "province": "Niedersachsen",
        "streetAndNumber": "Bremer Landstraße 3c",
        "zip": "27412",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182796,
        "identifier": "DE013048",
        "googlePlaceId": "ChIJRxe3hJTqu0cRXDjh6aSvyF8",
        "lat": 51.357902,
        "lng": 8.479508,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Olsberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Fruges Straße 2",
        "zip": "59939",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182797,
        "identifier": "DE003048",
        "googlePlaceId": "ChIJc1XFnJydsUcR6r45M-cha0M",
        "lat": 53.469536,
        "lng": 9.687272,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Buxtehude",
        "province": "Niedersachsen",
        "streetAndNumber": "Stader Straße 10",
        "zip": "21614",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182799,
        "identifier": "DE003030",
        "googlePlaceId": "ChIJVZunLjfisUcR1mW0DUgrLBU",
        "lat": 53.373437,
        "lng": 10.549492,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lauenburg",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hamburger Straße 35-37",
        "zip": "21481",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182800,
        "identifier": "DE016059",
        "googlePlaceId": "ChIJC1vY9IIYskcRvnPRJSZXEXg",
        "lat": 53.76651,
        "lng": 10.265639,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Elmenhorst",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Bundesstraße 7",
        "zip": "23869",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182801,
        "identifier": "DE020103",
        "googlePlaceId": "ChIJmYQidNlFqEcR4gm6kpcdi5U",
        "lat": 52.396982,
        "lng": 13.541057,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Alexander-Meissner-Straße 1",
        "zip": "12526",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182802,
        "identifier": "DE005129",
        "googlePlaceId": "ChIJt7jFDHJ0ukcRi8PWLwokM14",
        "lat": 52.293128,
        "lng": 8.885534,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Minden",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Gesellenweg 21a",
        "zip": "32427",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182803,
        "identifier": "DE015069",
        "googlePlaceId": "ChIJFRA6vXU5tkcRd_jYxsW_DbI",
        "lat": 53.390957,
        "lng": 7.211816,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Emden",
        "province": "Niedersachsen",
        "streetAndNumber": "Fritz-Reuter-Straße 11",
        "zip": "26721",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182804,
        "identifier": "DE031064",
        "googlePlaceId": "ChIJfVHpbDwfpEcRk6ibeN3i8jM",
        "lat": 51.03872,
        "lng": 11.51345,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Apolda",
        "province": "Thüringen",
        "streetAndNumber": "Am Weimarer Berg 1",
        "zip": "99510",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182805,
        "identifier": "DE002072",
        "googlePlaceId": "ChIJ9bqsukrWuEcR0FbW5pmsojQ",
        "lat": 51.253574,
        "lng": 7.154902,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wuppertal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Ronsdorfer Straße 2",
        "zip": "42119",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182806,
        "identifier": "DE001053",
        "googlePlaceId": "ChIJzVxMNr3iuEcRxfY5fTV_8Cw",
        "lat": 51.608086,
        "lng": 7.261711,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Recklinghausen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Schulstraße 47",
        "zip": "45665",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182807,
        "identifier": "DE015071",
        "googlePlaceId": "ChIJ20PAM7pKtkcRXNwjNqPGXmM",
        "lat": 53.182332,
        "lng": 7.267049,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bunde",
        "province": "Niedersachsen",
        "streetAndNumber": "Neuschanzer Straße 19",
        "zip": "26831",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182808,
        "identifier": "DE007041",
        "googlePlaceId": "ChIJn-3UhbvjsEcRSdosrUVkpSk",
        "lat": 52.97601,
        "lng": 9.18429,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Langwedel",
        "province": "Niedersachsen",
        "streetAndNumber": "Große Straße 2",
        "zip": "27299",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182809,
        "identifier": "DE029041",
        "googlePlaceId": "ChIJAdyKB6hFqkcRogGWlE5eELw",
        "lat": 53.732331,
        "lng": 14.062395,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ueckermünde",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Belliner Straße 9",
        "zip": "17373",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182810,
        "identifier": "DE031031",
        "googlePlaceId": "ChIJUwrYCfmZo0cRjLzU7gAV2Zo",
        "lat": 50.602552,
        "lng": 10.675826,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Suhl",
        "province": "Thüringen",
        "streetAndNumber": "Würzburger Straße 35",
        "zip": "98529",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182811,
        "identifier": "DE024017",
        "googlePlaceId": "ChIJIf-qkVk0qEcRieVao_GNX40",
        "lat": 52.542604,
        "lng": 13.746597,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Fredersdorf",
        "province": "Brandenburg",
        "streetAndNumber": "Fredersdorfer Chaussee 75-77",
        "zip": "15370",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182812,
        "identifier": "DE002101",
        "googlePlaceId": "ChIJi5EtyqcEvEcR2-7WpvqCpjA",
        "lat": 50.91292,
        "lng": 8.057097,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Netphen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Im Grunde 5",
        "zip": "57250",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182813,
        "identifier": "DE020063",
        "googlePlaceId": "ChIJhzb4KLJDqEcRzW-maXXiXi8",
        "lat": 52.337258,
        "lng": 13.398407,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Blankenfelde-Mahlow",
        "province": "Brandenburg",
        "streetAndNumber": "Blankenfelder Dorfstraße 65",
        "zip": "15827",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182814,
        "identifier": "DE032079",
        "googlePlaceId": "ChIJCSGZs-zfuEcR_qLzzcHiU40",
        "lat": 51.44136,
        "lng": 7.212423,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Markstraße 416",
        "zip": "44795",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182815,
        "identifier": "DE001094",
        "googlePlaceId": "ChIJF9vW2QRruEcRWg56N0zy2r8",
        "lat": 52.126641,
        "lng": 6.908643,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ahaus",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Haaksbergener Straße 24",
        "zip": "48683",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182816,
        "identifier": "DE016082",
        "googlePlaceId": "ChIJF8jLzsSIsUcR_0xkoca7bFk",
        "lat": 53.59418,
        "lng": 10.00052,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Winterhuder Marktplatz 6 7 a",
        "zip": "22299",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182817,
        "identifier": "DE024012",
        "googlePlaceId": "ChIJ2fJISggHqUcRwWWTxTwBGWE",
        "lat": 52.778959,
        "lng": 13.239926,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oranienburg",
        "province": "Brandenburg",
        "streetAndNumber": "Granseer Straße 12",
        "zip": "16515",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182818,
        "identifier": "DE013017",
        "googlePlaceId": "ChIJXTusQoByuUcRrLJDpfg8e3w",
        "lat": 51.597823,
        "lng": 7.760361,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bönen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Marmelinghöfener Weg 3",
        "zip": "59199",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182820,
        "identifier": "DE006169",
        "googlePlaceId": "ChIJ7eTupd-OukcRM156I1pALic",
        "lat": 52.123348,
        "lng": 9.346401,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hameln",
        "province": "Niedersachsen",
        "streetAndNumber": "Bertholdsweg 1",
        "zip": "31787",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182821,
        "identifier": "DE020084",
        "googlePlaceId": "ChIJ_78NDJwnqUcRRQXOxygeNWs",
        "lat": 52.736581,
        "lng": 12.577845,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Friesack",
        "province": "Brandenburg",
        "streetAndNumber": "Klessener Straße 36",
        "zip": "14662",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 3182822,
        "identifier": "DE026029",
        "googlePlaceId": "ChIJq6OjqDatr0cRd_ZLcCul0e0",
        "lat": 52.845013,
        "lng": 11.152423,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Salzwedel",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Neutorstraße 63+65",
        "zip": "29410",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182823,
        "identifier": "DE002094",
        "googlePlaceId": "ChIJyaLx7vypvkcRUMvznuZ0Xyw",
        "lat": 50.983752,
        "lng": 7.962213,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kreuztal",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hagener Straße 193",
        "zip": "57223",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182824,
        "identifier": "DE029018",
        "googlePlaceId": "ChIJ7WFKj5-cq0cRw2MsbvcgKrY",
        "lat": 53.97814,
        "lng": 13.146379,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Loitz",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Goethestraße 66a",
        "zip": "17121",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182825,
        "identifier": "DE026041",
        "googlePlaceId": "ChIJO02T7of1pUcRGGtASb7KE1w",
        "lat": 52.129842,
        "lng": 11.604364,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Magdeburg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Große Diesdorfer Straße 41",
        "zip": "39110",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182826,
        "identifier": "DE015056",
        "googlePlaceId": "ChIJ6ZpXJyz_tkcRD5WrXHze2Z0",
        "lat": 53.219088,
        "lng": 7.761677,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Apen",
        "province": "Niedersachsen",
        "streetAndNumber": "Stahlwerkstraße 15a",
        "zip": "26689",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182828,
        "identifier": "DE004140",
        "googlePlaceId": "ChIJRR7QngZ-rUcRRDYJZGXBQV0",
        "lat": 54.365896,
        "lng": 11.004423,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Heiligenhafen",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Tollbrettkoppel 4",
        "zip": "23774",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182829,
        "identifier": "DE029050",
        "googlePlaceId": "ChIJ-VlFGd9mrEcRXwF1DNI-ud0",
        "lat": 54.031717169967,
        "lng": 12.447053455553,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Amt Tessin",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Am Recknitzpark 4",
        "zip": "18195",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182830,
        "identifier": "DE032029",
        "googlePlaceId": "ChIJl_01FAYOuUcRqb0zGG-it9Y",
        "lat": 51.615565,
        "lng": 7.599088,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bergkamen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Jahnstraße 90c",
        "zip": "59192",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182831,
        "identifier": "DE016062",
        "googlePlaceId": "ChIJxZh6FGCGsUcRXtblsbtd-_I",
        "lat": 53.608665,
        "lng": 9.902408,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Lohkampstraße 11-25",
        "zip": "22523",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182832,
        "identifier": "DE024050",
        "googlePlaceId": "ChIJm8nV6JNNqEcR7OU2ErRvOus",
        "lat": 52.564367,
        "lng": 13.449876,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Rennbahnstraße 65",
        "zip": "13086",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182833,
        "identifier": "DE026033",
        "googlePlaceId": "ChIJh9x_Yu1-pUcRTwYW-mGrLTc",
        "lat": 52.14139,
        "lng": 10.96015,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schöningen",
        "province": "Niedersachsen",
        "streetAndNumber": "Elmstraße 8a",
        "zip": "38364",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182834,
        "identifier": "DE032070",
        "googlePlaceId": "ChIJQ66EHmMZuUcR7yQl8pGvAs4",
        "lat": 51.531637,
        "lng": 7.402165,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dortmund",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Aspeystraße 75",
        "zip": "44369",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182836,
        "identifier": "DE036055",
        "googlePlaceId": "ChIJ3Q92kE0tCEcR0X6DHW62T8I",
        "lat": 51.217343,
        "lng": 13.717404,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Radeburg",
        "province": "Sachsen",
        "streetAndNumber": "Großenhainer Straße 39a",
        "zip": "01471",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182837,
        "identifier": "DE021078",
        "googlePlaceId": "ChIJKUQHHsz5pkcRWpLhO8GON2M",
        "lat": 51.317881,
        "lng": 12.37873,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Arthur-Hoffmann-Straße 113",
        "zip": "04275",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182838,
        "identifier": "DE024036",
        "googlePlaceId": "ChIJmT9bdQNTqEcRovcUn42Gv88",
        "lat": 52.598083,
        "lng": 13.377337,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Hauptstraße 119",
        "zip": "13158",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182839,
        "identifier": "DE029056",
        "googlePlaceId": "ChIJDXHP1epWrEcRm8QGNvzXVto",
        "lat": 54.123032,
        "lng": 12.059477,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rostock",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Bertolt-Brecht-Straße 23",
        "zip": "18106",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182840,
        "identifier": "DE016141",
        "googlePlaceId": "ChIJC4v2uHVtskcRhhuhfH64WfQ",
        "lat": 54.010226,
        "lng": 10.577413,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ahrensbök",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Bökenbarg 8",
        "zip": "23623",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182842,
        "identifier": "DE004034",
        "googlePlaceId": "ChIJOfmcADMuskcROeQ1RfSYnr0",
        "lat": 53.830803,
        "lng": 9.977503,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Kaltenkirchen",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Kisdorfer Weg 11",
        "zip": "24568",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182843,
        "identifier": "DE024023",
        "googlePlaceId": "ChIJr44bkJ5JqEcRYmwdz6CrC0A",
        "lat": 52.504532,
        "lng": 13.590524,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Alt-Kaulsdorf 64",
        "zip": "12621",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182844,
        "identifier": "DE025032",
        "googlePlaceId": "ChIJfexuiv4huEcRdZFh5q8BOdI",
        "lat": 52.428496,
        "lng": 7.063265,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Nordhorn",
        "province": "Niedersachsen",
        "streetAndNumber": "Friedrich-Ebert-Straße 9",
        "zip": "48529",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182845,
        "identifier": "DE026061",
        "googlePlaceId": "ChIJmQcrQ3b0pUcR6fw11UHwXh4",
        "lat": 52.052793,
        "lng": 11.576685,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Osterweddingen",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Bahnhofstraße 46",
        "zip": "39171",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182846,
        "identifier": "DE025068",
        "googlePlaceId": "ChIJvQtJrU7uuUcRiHVp2XqUpWQ",
        "lat": 52.20782,
        "lng": 8.067723,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Georgsmarienhütte",
        "province": "Niedersachsen",
        "streetAndNumber": "Alte Seilerei 2",
        "zip": "49124",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182847,
        "identifier": "DE036073",
        "googlePlaceId": "ChIJh92cvKwJCUcRWYgLlJ0KmW8",
        "lat": 50.965889,
        "lng": 14.250335,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sebnitz",
        "province": "Sachsen",
        "streetAndNumber": "Schandauer Straße 86",
        "zip": "01855",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182848,
        "identifier": "DE002086",
        "googlePlaceId": "ChIJR2_OOg0WvEcRsVzZbxB5ObE",
        "lat": 50.743439,
        "lng": 8.209486,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Haiger",
        "province": "Hessen",
        "streetAndNumber": "Lohwiese 5",
        "zip": "35708",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182849,
        "identifier": "DE020077",
        "googlePlaceId": "ChIJC_9Vu-ctqUcRQiCzACf8g10",
        "lat": 52.889797,
        "lng": 12.45688,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wusterhausen",
        "province": "Brandenburg",
        "streetAndNumber": "Bahnhofstraße 17",
        "zip": "16868",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182850,
        "identifier": "DE006143",
        "googlePlaceId": "ChIJQR2foB1ZpUcRHiZy4oO2QP4",
        "lat": 52.19395,
        "lng": 10.459033,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Salzgitter",
        "province": "Niedersachsen",
        "streetAndNumber": "Schäferwiese 8A",
        "zip": "38239",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182851,
        "identifier": "DE031024",
        "googlePlaceId": "ChIJV7EaX-kloUcRygaz_l4B5IE",
        "lat": 50.532338,
        "lng": 12.104886,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Plauen",
        "province": "Sachsen",
        "streetAndNumber": "Alte Jößnitzer Straße 30",
        "zip": "08525",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182852,
        "identifier": "DE025077",
        "googlePlaceId": "ChIJCcS3gy_FuUcRzqDGfEP9LkE",
        "lat": 52.269452,
        "lng": 7.71941,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ibbenbüren",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Am Heidenturm 1",
        "zip": "49477",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182853,
        "identifier": "DE006124",
        "googlePlaceId": "ChIJ0d1irjj0r0cRskIr48pA90E",
        "lat": 52.288638,
        "lng": 10.564106,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Braunschweig",
        "province": "Niedersachsen",
        "streetAndNumber": "Bevenroder Straße 149",
        "zip": "38108",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182854,
        "identifier": "DE036013",
        "googlePlaceId": "ChIJ-xSGMZu4CUcRCUhpzYWwOO4",
        "lat": 50.981617,
        "lng": 13.859896,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Heidenau",
        "province": "Sachsen",
        "streetAndNumber": "Siegfried-Rädel-Straße 3",
        "zip": "01809",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182855,
        "identifier": "DE036077",
        "googlePlaceId": "ChIJXWgQgdWuCUcRJ8Qjwra1AVs",
        "lat": 51.024631,
        "lng": 14.231476,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neustadt in Sachsen",
        "province": "Sachsen",
        "streetAndNumber": "Sebnitzer Straße 41",
        "zip": "01844",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182856,
        "identifier": "DE010050",
        "googlePlaceId": "ChIJw0f6SeU-u0cR3NBdn8Pewi4",
        "lat": 51.352359,
        "lng": 9.466828,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Vellmar",
        "province": "Hessen",
        "streetAndNumber": "Zum Feldlager 119",
        "zip": "34246",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182857,
        "identifier": "DE016019",
        "googlePlaceId": "ChIJVQWY27SOsUcRJad1SMYgCXk",
        "lat": 53.575306,
        "lng": 10.043187,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Holsteinischer Kamp 65",
        "zip": "22081",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182858,
        "identifier": "DE016081",
        "googlePlaceId": "ChIJq0X58C2GsUcRi049f9PlC9A",
        "lat": 53.622375,
        "lng": 9.952094,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Tibarg 41-43",
        "zip": "22459",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182859,
        "identifier": "DE026055",
        "googlePlaceId": "ChIJC7-VR3KFpUcRNvxgu0lfNGQ",
        "lat": 52.030487,
        "lng": 11.22695,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oschersleben",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Lüneburger Straße 4",
        "zip": "39387",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3182860,
        "identifier": "DE007074",
        "googlePlaceId": "ChIJGWKmOGgnsUcRMfXBOfPBbDg",
        "lat": 53.104519,
        "lng": 8.853872,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Enrique-Schmidt-Straße 1",
        "zip": "28359",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3297740,
        "identifier": "DE024089",
        "googlePlaceId": "ChIJJ6Op0xVRqEcRKEsXNuuKvGE",
        "lat": 52.519102,
        "lng": 13.388163,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Friedrichstraße 149",
        "zip": "10117",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3451722,
        "identifier": "DE013007",
        "googlePlaceId": "ChIJS5NHTe2duUcRIJ-Sv3HON88",
        "lat": 51.770973,
        "lng": 7.895061,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ahlen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Warendorfer Straße 79",
        "zip": "59227",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3490241,
        "identifier": "DE024002",
        "googlePlaceId": "ChIJX6Tu7QHaqUcR9xMLOp3Xr68",
        "lat": 52.713003,
        "lng": 14.131823,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wriezen",
        "province": "Brandenburg",
        "streetAndNumber": "Frankfurter Straße 8",
        "zip": "16269",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3493620,
        "identifier": "DE004022",
        "googlePlaceId": "ChIJN4YvvrqOs0cRDNEXH2TYWcs",
        "lat": 54.191885907462,
        "lng": 9.0914987411904,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Heide",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hafenstraße 10-30",
        "zip": "25746",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3534169,
        "identifier": "DE001029",
        "googlePlaceId": "ChIJ3etljmfjuEcRLiu_wHV17ZU",
        "lat": 51.614084774159,
        "lng": 7.1987775107945,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Recklinghausen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Markt 16",
        "zip": "45657",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3572327,
        "identifier": "DE032105",
        "googlePlaceId": "ChIJl1xqobjduEcRER1tcKix43k",
        "lat": 51.40316,
        "lng": 7.06842,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Königsiepen 9",
        "zip": "45259",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3585106,
        "identifier": "DE036080",
        "googlePlaceId": "ChIJaxK6fomtCUcRBLoXdi2JUEk",
        "lat": 51.134945,
        "lng": 14.189861,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bischofswerda",
        "province": "Sachsen",
        "streetAndNumber": "Bautzener Straße 78",
        "zip": "01877",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3610296,
        "identifier": "DE024090",
        "googlePlaceId": "ChIJGQSj-2RVqEcROmgEmLqtvRY",
        "lat": 52.5849347,
        "lng": 13.2863053,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Am Borsigturm 2",
        "zip": "13507",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3614415,
        "identifier": "DE002057",
        "googlePlaceId": "ChIJB92UeuoruUcRWhJH8yMpOpY",
        "lat": 51.18333,
        "lng": 7.18748,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Remscheid",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Theodor-Heuss-Platz 7",
        "zip": "42853",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3623669,
        "identifier": "DE006123",
        "googlePlaceId": "ChIJbbcTX_X0r0cRQ0FxJDu1PCI",
        "lat": 52.290323,
        "lng": 10.59451,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Braunschweig",
        "province": "Niedersachsen",
        "streetAndNumber": "Ziegelkamp 57",
        "zip": "38104",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3630615,
        "identifier": "DE031030",
        "googlePlaceId": "ChIJ8aTj9P9HoUcRzBF8_hiMxW8",
        "lat": 50.580502,
        "lng": 11.806385,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schleiz",
        "province": "Thüringen",
        "streetAndNumber": "Nikolaistraße 39",
        "zip": "07907",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3640543,
        "identifier": "DE005143",
        "googlePlaceId": "ChIJF9NMKgNjvEcRi0x0429mN_4",
        "lat": 50.806507,
        "lng": 8.76938,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Marburg",
        "province": "Hessen",
        "streetAndNumber": "Universitätsstraße 8",
        "zip": "35037",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3641877,
        "identifier": "DE015007",
        "googlePlaceId": "ChIJzy8zzGZCtkcR2JV4xMh3NEI",
        "lat": 53.484288,
        "lng": 7.491937,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Aurich",
        "province": "Niedersachsen",
        "streetAndNumber": "Wiesenstraße 123-125",
        "zip": "26603",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3662794,
        "identifier": "DE036065",
        "googlePlaceId": "ChIJnQBNo8UbCUcRLER4NgesFcY",
        "lat": 50.98107,
        "lng": 14.609701,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neugersdorf",
        "province": "Sachsen",
        "streetAndNumber": "Bleichenstraße 3",
        "zip": "02727",
        "businessId": 1312729,
        "addressExtra": "Rudolf-Breitscheid-Straße 2a",
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3708451,
        "identifier": "DE007073",
        "googlePlaceId": "ChIJ1zI-mbInsUcRpVCMStQ4cYY",
        "lat": 53.100564,
        "lng": 8.878993,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Leher Heerstraße 105-107",
        "zip": "28359",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3782808,
        "identifier": "DE024043",
        "googlePlaceId": "ChIJeSnppHxTqEcRP7fHfORacwk",
        "lat": 52.5836,
        "lng": 13.41858,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Blankenburger Straße 86-92",
        "zip": "13156",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3803004,
        "identifier": "DE001009",
        "googlePlaceId": "ChIJb3JLpcD6uEcRySQCI_9J7dw",
        "lat": 51.65418,
        "lng": 7.09551,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Marl",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Marler Stern 1",
        "zip": "45768",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3803303,
        "identifier": "DE021111",
        "googlePlaceId": "ChIJcys4IT97pkcRP2MQsB5WTkM",
        "lat": 51.519935,
        "lng": 11.954047,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Halle (Saale)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Trothaer Straße 42",
        "zip": "06118",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3807117,
        "identifier": "DE001040",
        "googlePlaceId": "ChIJB6PMS3fCuEcR-qWzXGAOWL0",
        "lat": 51.472105,
        "lng": 6.956704,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wolfsbankring 30",
        "zip": "45355",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3810988,
        "identifier": "DE006100",
        "googlePlaceId": "ChIJhZbotg6vukcRcVNbXqCYsnI",
        "lat": 52.154374,
        "lng": 9.949889,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hildesheim",
        "province": "Niedersachsen",
        "streetAndNumber": "Arnekenstraße 18",
        "zip": "31134",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3815813,
        "identifier": "DE036046",
        "googlePlaceId": "ChIJhdecnurFCUcRCB0AwziRhuE",
        "lat": 51.00051,
        "lng": 13.72,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bannewitz",
        "province": "Sachsen",
        "streetAndNumber": "An der Zschauke 4",
        "zip": "01728",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3815826,
        "identifier": "DE036049",
        "googlePlaceId": "ChIJ1xazNCo9p0cR_LXLutysVJo",
        "lat": 50.925371,
        "lng": 12.714128,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Penig",
        "province": "Sachsen",
        "streetAndNumber": "Chemnitzer Straße 105",
        "zip": "09322",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3853842,
        "identifier": "DE001028",
        "googlePlaceId": "ChIJbxqWu_XkuEcR4Lwe_mWgyPs",
        "lat": 51.6077,
        "lng": 7.125662,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Herten",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Westerholter Straße 615",
        "zip": "45701",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3859964,
        "identifier": "DE001038",
        "googlePlaceId": "ChIJkSPzXd3luEcR79uwYI1i1q4",
        "lat": 51.563525,
        "lng": 7.074921,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Gelsenkirchen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Heistraße 109",
        "zip": "45891",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3872077,
        "identifier": "DE020085",
        "googlePlaceId": "ChIJ74mWzbK5rkcR3J6EvJcyTec",
        "lat": 53.156841,
        "lng": 12.178463,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Pritzwalk",
        "province": "Brandenburg",
        "streetAndNumber": "Kietz 41b",
        "zip": "16928",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3874482,
        "identifier": "DE026085",
        "googlePlaceId": "ChIJyc-fBfmIr0cRkwevG6XY7M8",
        "lat": 52.252098,
        "lng": 10.824492,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Königslutter",
        "province": "Niedersachsen",
        "streetAndNumber": "Rottorfer Straße 4a",
        "zip": "38154",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3910787,
        "identifier": "DE004095",
        "googlePlaceId": "ChIJG232L-gFs0cReFNYOoFmsXo",
        "lat": 54.486957,
        "lng": 9.823046,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eckernförde",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Ostlandstraße 99",
        "zip": "24340",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3919118,
        "identifier": "DE024037",
        "googlePlaceId": "ChIJRYmoMnZTqEcRuDme5O-kDOc",
        "lat": 52.588485,
        "lng": 13.402146,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Dietzgenstraße 82",
        "zip": "13156",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3924115,
        "identifier": "DE007071",
        "googlePlaceId": "ChIJIzToq35RsEcRV9Lq64NquR0",
        "lat": 52.907841,
        "lng": 9.641473,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Walsrode",
        "province": "Niedersachsen",
        "streetAndNumber": "Cordinger Straße 59",
        "zip": "29699",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3924207,
        "identifier": "DE024086",
        "googlePlaceId": "ChIJL7vLPF1RqEcRVIuFRLZ_7_g",
        "lat": 52.538988,
        "lng": 13.327275,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Saatwinkler Damm 8",
        "zip": "13627",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 3926922,
        "identifier": "DE020069",
        "googlePlaceId": "ChIJxbmzzKHBqEcRzdOqxBK9z2I",
        "lat": 52.420661,
        "lng": 12.54492,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Brandenburg a. d. Havel",
        "province": "Brandenburg",
        "streetAndNumber": "Willi-Sänger-Straße 66",
        "zip": "14770",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4041012,
        "identifier": "DE036037",
        "googlePlaceId": "ChIJfwblecFtp0cR9mKCFvD17KM",
        "lat": 51.091586,
        "lng": 12.975065,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hartha",
        "province": "Sachsen",
        "streetAndNumber": "Dresdener Straße 76",
        "zip": "04746",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4077699,
        "identifier": "DE024114",
        "googlePlaceId": "ChIJH8kdZ01HqEcRrnX5cnROok4",
        "lat": 52.4236052,
        "lng": 13.577003,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Regattastraße 51-53",
        "zip": "12527",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4125540,
        "identifier": "DE025062",
        "googlePlaceId": "ChIJqzfK8DrfuUcRd1l08pMIWqQ",
        "lat": 52.412714,
        "lng": 7.842401,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Neuenkirchen",
        "province": "Niedersachsen",
        "streetAndNumber": "Bramscher Straße 7",
        "zip": "49586",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4141267,
        "identifier": "DE021002",
        "googlePlaceId": "ChIJF6clKXf5pkcRB8bNJ9L7NIA",
        "lat": 51.33989,
        "lng": 12.37776,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Grimmaische Straße 13-15",
        "zip": "04109",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4167033,
        "identifier": "DE024032",
        "googlePlaceId": "ChIJuSZ83L6zqUcRBY7dxS9iICU",
        "lat": 52.68821,
        "lng": 13.600771,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bernau",
        "province": "Brandenburg",
        "streetAndNumber": "Rüdnitzer Chaussee 48-50",
        "zip": "16321",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4167696,
        "identifier": "DE013001",
        "googlePlaceId": "ChIJ3VweSdJvuUcRgAyRvwFeJr4",
        "lat": 51.558375,
        "lng": 7.913639,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Werl",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "An der Bundesbahn 5",
        "zip": "59457",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4188910,
        "identifier": "DE032087",
        "googlePlaceId": "ChIJhZWuCz3guEcR6O8wYclYuy0",
        "lat": 51.483675,
        "lng": 7.22416,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Blumenstraße 7",
        "zip": "44791",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4189968,
        "identifier": "DE026094",
        "googlePlaceId": "ChIJWRQ6_MgSpUcRnFO9hM1MqgY",
        "lat": 51.87255,
        "lng": 10.69141,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Ilsenburg (Harz)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Apfelweg 1",
        "zip": "38871",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4226358,
        "identifier": "DE036029",
        "googlePlaceId": "ChIJaaNPhE_RCUcRv810nii3yCY",
        "lat": 51.132391,
        "lng": 13.584552,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Coswig",
        "province": "Sachsen",
        "streetAndNumber": "Salzstraße 9",
        "zip": "01640",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4301329,
        "identifier": "DE024035",
        "googlePlaceId": "ChIJC0hOuIxTqEcRsLWsfrLK01o",
        "lat": 52.599368,
        "lng": 13.355199,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Senftenberger Ring 17",
        "zip": "13439",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4333150,
        "identifier": "DE032134",
        "googlePlaceId": "ChIJrQ-HCAC7uUcRxNb7HNkAA_8",
        "lat": 51.953286,
        "lng": 7.64407,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Münster",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hafenweg 21",
        "zip": "48155",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4385427,
        "identifier": "DE025065",
        "googlePlaceId": "ChIJH7OltZb6uUcRWDf2_YREqlU",
        "lat": 52.261633,
        "lng": 8.211249,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bissendorf",
        "province": "Niedersachsen",
        "streetAndNumber": "Mindener Straße 81",
        "zip": "49143",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4399026,
        "identifier": "DE036045",
        "googlePlaceId": "ChIJYXfYzlTPCUcRQAJRPtk7qRI",
        "lat": 51.044378,
        "lng": 13.734823,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Prager Straße 11",
        "zip": "01069",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4399061,
        "identifier": "DE005002",
        "googlePlaceId": "ChIJMbPvd6pHukcR-Xf2bxdLDCU",
        "lat": 51.909555,
        "lng": 8.735458,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Augustdorf",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Rosenstraße 8",
        "zip": "32832",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4399279,
        "identifier": "DE036108",
        "googlePlaceId": "ChIJ5ye7UzlGp0cRpuLstjpEHCI",
        "lat": 51.08003,
        "lng": 13.05472,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Döbeln",
        "province": "Sachsen",
        "streetAndNumber": "Grimmaische Str. 69",
        "zip": "04720",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4405279,
        "identifier": "DE005048",
        "googlePlaceId": "ChIJ3ReuU8GPuUcRoDa-UPrMVp8",
        "lat": 51.989612,
        "lng": 8.039042,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Sassenberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Von-Galen-Straße 21",
        "zip": "48336",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4430478,
        "identifier": "DE015074",
        "googlePlaceId": "ChIJxd-iESD1tkcRJGkzfCIhWyg",
        "lat": 53.458994,
        "lng": 7.838679,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Friedeburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Friedeburger Hauptstraße 119",
        "zip": "26446",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4435978,
        "identifier": "DE002031",
        "googlePlaceId": "ChIJo8nEJSW1vkcRjJ0F5Dc9MbY",
        "lat": 51.020308722025,
        "lng": 7.6496839532846,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bergneustadt",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kölner Straße 222",
        "zip": "51702",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4436033,
        "identifier": "DE024122",
        "googlePlaceId": "ChIJ6W8eNyqXB0cRdQzFgii2UTY",
        "lat": 52.29074,
        "lng": 14.469283,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Frankfurt (Oder)",
        "province": "Brandenburg",
        "streetAndNumber": "Gerhard-Neumann-Straße 14",
        "zip": "15236",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4438036,
        "identifier": "DE002106",
        "googlePlaceId": "ChIJ4ebijx4muUcRInr7YT_wzLM",
        "lat": 51.288302,
        "lng": 7.282901,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schwelm",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Viktoriastrasse 34",
        "zip": "58332",
        "businessId": 1312729,
        "addressExtra": "Carl - vom - Hagen - Straße",
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4442018,
        "identifier": "DE002002",
        "googlePlaceId": "ChIJb35usfrUuEcRD2veNdDT9N8",
        "lat": 51.164228,
        "lng": 7.095641,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Solingen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Schützenstraße 64",
        "zip": "42659",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4478112,
        "identifier": "DE024092",
        "googlePlaceId": "ChIJd3igo_VTqEcRLCN-Ye5d3n4",
        "lat": 52.570035,
        "lng": 13.404298,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Breite Strasse 20",
        "zip": "13187",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4542968,
        "identifier": "DE021089",
        "googlePlaceId": "ChIJrbtKfBL3pkcRoMjdooD73O8",
        "lat": 51.321577,
        "lng": 12.270902,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Jupiterstraße 44",
        "zip": "04205",
        "businessId": 1312729,
        "addressExtra": "Jupiter Center",
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4542974,
        "identifier": "DE021087",
        "googlePlaceId": "ChIJNaO9N5j3pkcRwYjA0TTFGSM",
        "lat": 51.332442,
        "lng": 12.320268,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Lützner Straße 148-158",
        "zip": "04179",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4568282,
        "identifier": "DE004120",
        "googlePlaceId": "ChIJzyvcOZbEs0cRYCsDPIHw_NI",
        "lat": 53.91115,
        "lng": 9.4863,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Itzehoe",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Kamper Weg 92",
        "zip": "25524",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4578244,
        "identifier": "DE001100",
        "googlePlaceId": "ChIJQ01J3YzDuEcReFlRzlAS5Wg",
        "lat": 51.45269,
        "lng": 7.012334,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Essen",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Willy-Brandt-Platz 7",
        "zip": "45127",
        "businessId": 1312729,
        "addressExtra": "Königshof",
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "06:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "06:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "06:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "06:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "06:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "06:00",
            "to1": "22:00"
          },
          {
            "dayOfWeek": 7,
            "from1": "09:00",
            "to1": "20:00"
          }
        ]
      },
      {
        "id": 4578251,
        "identifier": "DE016012",
        "googlePlaceId": "ChIJYwX4_1cnskcRm4Ati5Rn2vs",
        "lat": 53.659957,
        "lng": 10.085554,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hamburg",
        "province": "Hamburg",
        "streetAndNumber": "Poppenbüttler Hauptstraße 1",
        "zip": "22399",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4578254,
        "identifier": "DE025014",
        "googlePlaceId": "ChIJxUYSlnMzuEcRAJJRzij_w2U",
        "lat": 52.282639,
        "lng": 7.44004,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Rheine",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Humboldtplatz 4",
        "zip": "48429",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4594261,
        "identifier": "DE021020",
        "googlePlaceId": "ChIJ31hSHFpVpkcRig-rabD4RMU",
        "lat": 52.47168,
        "lng": 13.33487,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Borsdorf",
        "province": "Sachsen",
        "streetAndNumber": "Panitzscher Straße 27",
        "zip": "04451",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4609228,
        "identifier": "DE024082",
        "googlePlaceId": "ChIJ_3BYqTRSqEcRbH0dQ3b9h_0",
        "lat": 52.564234,
        "lng": 13.366743,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Pankower Allee 17-19",
        "zip": "13409",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4619084,
        "identifier": "DE005061",
        "googlePlaceId": "ChIJj--hxHrTu0cRtim5tISxnNU",
        "lat": 51.68852548345,
        "lng": 8.3416796751983,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Lippstadt",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Wiedenbrücker Straße 45",
        "zip": "59555",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4619086,
        "identifier": "DE006095",
        "googlePlaceId": "ChIJE8WBawALsEcR3Lv10ghg5vw",
        "lat": 52.321548,
        "lng": 9.822914,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Iris-Runge-Platz 4",
        "zip": "30539",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4619087,
        "identifier": "DE015027",
        "googlePlaceId": "ChIJTcG7C1RLtkcRkckRwljFWpQ",
        "lat": 53.168885,
        "lng": 7.349568,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Weener",
        "province": "Niedersachsen",
        "streetAndNumber": "Neue Feldstraße 4",
        "zip": "26826",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4619089,
        "identifier": "DE015029",
        "googlePlaceId": "ChIJtYB6jUPetkcRFjau8SXGS8E",
        "lat": 53.169297,
        "lng": 8.200115,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oldenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Alexanderstraße 322",
        "zip": "26127",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4619090,
        "identifier": "DE015030",
        "googlePlaceId": "ChIJI7x8lPdRtkcR6bioN5HWitY",
        "lat": 53.241984082486,
        "lng": 7.5065853983124,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leer (Ostfriesland)",
        "province": "Niedersachsen",
        "streetAndNumber": "Hohe Loga 76",
        "zip": "26789",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4619092,
        "identifier": "DE015028",
        "googlePlaceId": "ChIJI04LB9PhtkcRQs4ql_mlrCw",
        "lat": 53.123797,
        "lng": 8.084574,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Edewecht",
        "province": "Niedersachsen",
        "streetAndNumber": "Friedrichsfehner Straße 1",
        "zip": "26188",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4619098,
        "identifier": "DE021082",
        "googlePlaceId": "ChIJY9a8fQAtp0cR0YUWyBPBDu8",
        "lat": 50.71898,
        "lng": 12.49383,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Zwickau",
        "province": "Sachsen",
        "streetAndNumber": "Innere Plauensche Straße 14",
        "zip": "08056",
        "businessId": 1312729,
        "addressExtra": "Zwickau Arcaden",
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4619100,
        "identifier": "DE024014",
        "googlePlaceId": "ChIJL9ZnPChPqEcRfKro_tj5kfk",
        "lat": 52.511967,
        "lng": 13.481607,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Frankfurter Allee 144",
        "zip": "10365",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4619105,
        "identifier": "DE031015",
        "googlePlaceId": "ChIJhcdWoA71pEcR7XAA_q4eE6A",
        "lat": 51.244517,
        "lng": 10.659772,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Schlotheim Nottertal",
        "province": "Thüringen",
        "streetAndNumber": "Oststraße 2",
        "zip": "99994",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4619117,
        "identifier": "DE036023",
        "googlePlaceId": "ChIJUcMbLcfECUcRv7LmL8CWwfQ",
        "lat": 50.991632,
        "lng": 13.642243,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Freital",
        "province": "Sachsen",
        "streetAndNumber": "Dresdner Straße 258",
        "zip": "01705",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4619120,
        "identifier": "DE020012",
        "googlePlaceId": "ChIJ1eyBueNRqEcRTjQgzVJlQwQ",
        "lat": 52.49389,
        "lng": 13.360392,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Potsdamer Straße 180",
        "zip": "10783",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4619122,
        "identifier": "DE032108",
        "googlePlaceId": "ChIJHYieRQDhuEcR2FD8dJWfqbE",
        "lat": 51.481426,
        "lng": 7.209633,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Alleestraße 38-40",
        "zip": "44793",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4619124,
        "identifier": "DE029016",
        "googlePlaceId": "ChIJLQYV0j9iq0cRXovmfDIqsLo",
        "lat": 54.321777,
        "lng": 13.055082,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Stralsund",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Carl-Loewe-Ring 1",
        "zip": "18435",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4697737,
        "identifier": "DE032107",
        "googlePlaceId": "ChIJf-3KfFffuEcR-0BaNiB3TA8",
        "lat": 51.435916,
        "lng": 7.179619,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Hattinger Straße 620-632",
        "zip": "44879",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4738708,
        "identifier": "DE003063",
        "googlePlaceId": "ChIJCcCvb3MLrkcRuw97L1KBTyQ",
        "lat": 53.503686,
        "lng": 11.085409,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wittenburg",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Hagenower Chaussee 29",
        "zip": "19243",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4855923,
        "identifier": "DE002033",
        "googlePlaceId": "ChIJnXGc8v9QuUcRt2T77XLOHpw",
        "lat": 51.209844,
        "lng": 7.870337,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Plettenberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Herscheider Straße 14-16",
        "zip": "58840",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4880505,
        "identifier": "DE007045",
        "googlePlaceId": "ChIJwVPdHWDXsEcRRrN8hxx-Zd0",
        "lat": 53.062469,
        "lng": 8.770459,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bremen",
        "province": "Bremen",
        "streetAndNumber": "Duckwitzstraße 55",
        "zip": "28199",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4884596,
        "identifier": "DE015023",
        "googlePlaceId": "ChIJLa5iBBPftkcRE4M8wTLzrlg",
        "lat": 53.13048,
        "lng": 8.224789,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Oldenburg",
        "province": "Niedersachsen",
        "streetAndNumber": "Bremer Straße 53",
        "zip": "26135",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4920960,
        "identifier": "DE024047",
        "googlePlaceId": "ChIJyb5VFmlNqEcRBBijy0Z1KYc",
        "lat": 52.597051,
        "lng": 13.464912,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Treseburger Straße 26",
        "zip": "13129",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 4925311,
        "identifier": "DE026057",
        "googlePlaceId": "ChIJ76PwMQBfr0cRWj_pAsrBmoo",
        "lat": 52.1304,
        "lng": 11.62808,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Magdeburg",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Willy-Brandt-Platz 1",
        "zip": "39104",
        "businessId": 1312729,
        "addressExtra": "Bahnhofstraße 69",
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "06:30",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "06:30",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "06:30",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "06:30",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "06:30",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "06:30",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "from1": "06:30",
            "to1": "20:00"
          }
        ]
      },
      {
        "id": 4942130,
        "identifier": "DE021110",
        "googlePlaceId": "ChIJ0de-7jpjpkcRjb1Yjz1VLyE",
        "lat": 51.46447,
        "lng": 11.969153,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Halle (Saale)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Beesener Straße 225",
        "zip": "06110",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 5096417,
        "identifier": "DE006009",
        "googlePlaceId": "ChIJxaOalBFzsEcRPIqTDPpKwGc",
        "lat": 52.4002998,
        "lng": 9.7133993,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Hannover",
        "province": "Niedersachsen",
        "streetAndNumber": "Schulenburger Landstraße 66-70",
        "zip": "30165",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      },
      {
        "id": 5096439,
        "identifier": "DE024087",
        "googlePlaceId": "ChIJoQmIdABJqEcRjLIKGICOt7g",
        "lat": 52.52114,
        "lng": 13.54079,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Berlin",
        "province": "Berlin",
        "streetAndNumber": "Märkische Spitze 21",
        "zip": "12681",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 5096442,
        "identifier": "DE029059",
        "googlePlaceId": "ChIJS_XKM35WrEcRzjFLKZYRlB0",
        "lat": 53.98969984,
        "lng": 11.89979366,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Satow",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Fritz-Reuter-Straße 24B",
        "zip": "18239",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 5096443,
        "identifier": "DE029062",
        "googlePlaceId": "ChIJd4JNkaUjrEcR5wgUNSX2lnw",
        "lat": 53.594994,
        "lng": 12.08881,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Goldberg",
        "province": "Mecklenburg-Vorpommern",
        "streetAndNumber": "Güstrower Straße 4",
        "zip": "19399",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [
          {
            "date": "2026-03-08",
            "closed": true
          }
        ],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 5108592,
        "identifier": "DE005150",
        "googlePlaceId": "ChIJ0ce6LPRaukcR9XllEE5-Fqc",
        "lat": 51.87436,
        "lng": 8.94829,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Horn-Bad Meinberg",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Kampstraße 11",
        "zip": "32805",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 5131843,
        "identifier": "DE031048",
        "googlePlaceId": "ChIJj2W7UgCbpEcRQgfV9QmbLfQ",
        "lat": 50.978035,
        "lng": 10.307681,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Eisenach",
        "province": "Thüringen",
        "streetAndNumber": "Bleichrasen 41",
        "zip": "99817",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 5259242,
        "identifier": "DE006098",
        "googlePlaceId": "ChIJn9AqgMKRr0cRhZzjcOkCHf4",
        "lat": 52.440438917053,
        "lng": 10.841399942139,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Wolfsburg",
        "province": "Niedersachsen",
        "streetAndNumber": "An der Meine 10",
        "zip": "38448",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 5618395,
        "identifier": "DE021083",
        "googlePlaceId": "ChIJR80eNbH5pkcRSSrtHJ8AITU",
        "lat": 51.333318,
        "lng": 12.393242,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Leipzig",
        "province": "Sachsen",
        "streetAndNumber": "Prager Straße 30c",
        "zip": "04103",
        "businessId": 1312729,
        "addressExtra": "Ostplatz",
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "08:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 5660713,
        "identifier": "DE026063",
        "googlePlaceId": "ChIJIcV5ndcfr0cRgxGDLjms9JU",
        "lat": 52.786761,
        "lng": 11.742468,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Osterburg (Altmark)",
        "province": "Sachsen-Anhalt",
        "streetAndNumber": "Karl-Marx-Straße 41",
        "zip": "39606",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 5758826,
        "identifier": "DE020120",
        "googlePlaceId": "ChIJ399XyUL_p0cRrMJqFwAx_q0",
        "lat": 51.853303,
        "lng": 13.725775,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Luckau",
        "province": "Brandenburg",
        "streetAndNumber": "Lübbener Straße 7",
        "zip": "15926",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 5826201,
        "identifier": "DE005151",
        "googlePlaceId": "ChIJ2-wXwF51ukcRVbNudDTRgqo",
        "lat": 52.29209,
        "lng": 8.88341,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Minden",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Königstraße 172",
        "zip": "32427",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 5826731,
        "identifier": "DE004151",
        "googlePlaceId": "ChIJ0ZpJsO6js0cROJhG55aNazE",
        "lat": 54.3058811,
        "lng": 9.58396136,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Fockbek",
        "province": "Schleswig-Holstein",
        "streetAndNumber": "Hohner Straße 46",
        "zip": "24787",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 5827839,
        "identifier": "DE032104",
        "googlePlaceId": "ChIJ5Xq27bykuUcRhMjM-XIvEu8",
        "lat": 51.9246971,
        "lng": 7.6724179,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Münster",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Albersloher Weg 539",
        "zip": "48167",
        "businessId": 1312729,
        "addressExtra": "Albersloher Weg 539",
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 5828459,
        "identifier": "DE024093",
        "googlePlaceId": "ChIJjTXrneIzqEcRTTPbFhN_VJo",
        "lat": 52.539567,
        "lng": 13.819971,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Petershagen-Eggersdorf",
        "province": "Brandenburg",
        "streetAndNumber": "Karl-Marx-Straße 21",
        "zip": "15345",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "21:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 5847039,
        "identifier": "DE036044",
        "googlePlaceId": "ChIJx6qgZADLCUcRK_C5SGs82eA",
        "lat": 50.557997,
        "lng": 12.734601,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Dresden",
        "province": "Sachsen",
        "streetAndNumber": "Liegauer Straße 11",
        "zip": "01465",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": [
          {
            "dayOfWeek": 1,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 2,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 3,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 4,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 5,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 6,
            "from1": "07:00",
            "to1": "20:00"
          },
          {
            "dayOfWeek": 7,
            "closed": true
          }
        ]
      },
      {
        "id": 5848732,
        "identifier": "DE032106",
        "googlePlaceId": "ChIJmT1l44nhuEcRAzB5FOfB6Lk",
        "lat": 51.48916131,
        "lng": 7.21360571,
        "name": "ALDI Nord",
        "country": "DE",
        "city": "Bochum",
        "province": "Nordrhein-Westfalen",
        "streetAndNumber": "Herner Straße 55",
        "zip": "44787",
        "businessId": 1312729,
        "addressExtra": null,
        "specialOpeningHours": [],
        "openingHours": []
      }
    ]
